var _view, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _view2, _path10, _path11, _path12, _path13, _path14, _path15, _view3, _g, _view4, _path16, _circle, _circle2, _circle3, _circle4, _rect, _circle5, _rect2, _path17, _view5, _path18, _path19, _view6, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _view7, _path33, _path34, _path35, _path36, _path37, _view8, _path38, _path39, _path40, _path41, _defs, _clipPath, _g2, _view9, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _view10, _rect3, _path49, _path50, _circle6, _circle7, _circle8, _path51, _path52, _circle9, _path53, _path54, _path55, _circle10, _view11, _path56, _path57, _path58, _path59, _view12, _path60, _path61, _path62, _defs2, _clipPath2, _g3, _view13, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _view14, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _view15, _rect4, _path103, _rect5, _circle11, _circle12, _path104, _path105, _rect6, _path106, _rect7, _rect8, _rect9, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _view16, _path107, _path108, _path109, _path110, _rect10, _rect11, _rect12, _circle22, _rect13, _rect14, _g4, _view17, _path111, _path112, _path113, _view18, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _view19, _path121, _path122, _path123, _rect15, _path124, _path125, _path126, _rect16, _view20, _path127, _path128, _rect17, _rect18, _path129, _path130, _rect19, _view21, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _circle23, _circle24, _path142, _view22, _path143, _path144, _path145, _defs3, _clipPath3, _g5, _view23, _path146, _path147, _path148, _path149, _path150, _view24, _path151, _path152, _path153, _view25, _path154, _path155, _path156, _view26, _path157, _path158, _path159, _path160, _view27, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _ellipse, _ellipse2, _view28, _path161, _path162, _view29, _path163, _path164, _path165, _path166, _path167, _path168, _circle31, _circle32, _path169, _view30, _g6, _view31, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _view32, _rect20, _path189, _path190, _rect21, _path191, _path192, _rect22, _path193, _circle33, _rect23, _path194, _rect24, _path195, _view33, _path196, _circle34, _path197, _path198, _path199, _view34, _path200, _path201, _path202, _path203, _path204, _path205, _view35, _path206, _path207, _rect25, _circle35, _g7, _view36, _path208, _path209, _path210, _path211, _view37, _path212, _path213, _path214, _path215, _path216, _view38, _path217, _path218, _path219, _path220, _path221, _path222, _defs4, _clipPath4, _g8, _view39, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _view40, _rect26, _path234, _path235, _path236, _circle36, _path237, _rect27, _rect28, _view41, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _view42, _path245, _path246, _path247, _view43, _path248, _path249, _path250, _path251, _view44, _path252, _path253, _rect29, _rect30, _rect31, _path254, _view45, _path255, _path256, _path257, _path258, _view46, _path259, _path260, _path261, _view47, _g9, _path262, _path263, _ellipse3, _ellipse4, _path264, _circle37, _path265, _path266, _view48, _path267, _path268, _path269, _path270, _path271, _path272, _view49, _path273, _path274, _path275, _path276, _path277, _view50, _rect32, _rect33, _rect34, _rect35, _rect36, _path278, _circle38, _rect37, _view51, _path279, _path280, _path281, _rect38, _view52, _path282, _path283, _path284, _path285, _view53, _path286, _path287, _path288, _path289, _circle39, _rect39, _rect40, _circle40, _rect41, _view54, _rect42, _path290, _path291, _path292, _rect43, _circle41, _rect44, _path293, _path294, _path295, _path296, _circle42, _view55, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _view56, _path305, _ellipse5, _ellipse6, _ellipse7, _path306, _circle43, _circle44, _circle45, _circle46, _path307, _rect45, _rect46, _rect47, _rect48, _rect49, _path308, _path309, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _rect50, _rect51, _circle54, _circle55, _circle56, _circle57, _path310, _rect52, _view57, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _view58, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _circle58, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _view59, _path332, _path333, _path334, _path335, _view60, _path336, _path337, _path338, _circle59, _path339, _path340, _path341, _circle60, _path342, _path343, _path344, _circle61, _view61, _path345, _path346, _path347, _view62, _path348, _path349, _view63, _rect53, _path350, _ellipse8, _ellipse9, _circle62, _rect54, _g10, _view64, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _circle63, _circle64, _path362, _view65, _path363, _path364, _path365, _path366, _path367, _path368, _view66, _rect55, _circle65, _circle66, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _path369, _path370, _path371, _rect62, _rect63, _circle67, _circle68, _rect64, _path372, _view67, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _view68, _path382, _path383, _path384, _view69, _g11, _view70, _path385, _path386, _view71, _path387, _path388, _path389, _path390, _view72, _path391, _path392, _path393, _path394, _path395, _path396, _view73, _circle69, _circle70, _circle71, _circle72, _circle73, _rect65, _path397, _rect66, _path398, _view74, _path399, _path400, _path401, _path402, _path403, _view75, _rect67, _rect68, _path404, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _circle74, _rect78, _rect79, _rect80, _rect81, _path405, _view76, _path406, _rect82, _ellipse10, _ellipse11, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _path407, _path408, _path409, _path410, _rect83, _rect84, _path411, _rect85, _rect86, _path412, _rect87, _rect88, _path413, _rect89, _rect90, _rect91, _path414, _rect92, _rect93, _path415, _view77, _rect94, _rect95, _rect96, _path416, _rect97, _rect98, _rect99, _path417, _rect100, _rect101, _path418, _circle82, _rect102, _rect103, _circle83, _rect104, _rect105, _path419, _path420, _path421, _rect106, _rect107, _view78, _path422, _path423, _path424, _path425, _path426, _view79, _path427, _path428, _path429, _path430, _view80, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _view81, _g12, _circle84, _g13, _view82, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _view83, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _circle85, _circle86, _path460, _view84, _path461, _circle87, _path462, _view85, _path463, _path464, _path465, _path466, _view86, _g14, _view87, _path467, _path468, _path469, _path470, _path471, _path472, _view88, _path473, _path474, _path475, _path476, _path477, _path478, _view89, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _path479, _rect115, _rect116, _rect117, _rect118, _view90, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _view91, _rect119, _path497, _path498, _circle88, _rect120, _rect121, _view92, _rect122, _path499, _path500, _path501, _path502, _path503, _g15, _view93, _path504, _path505, _path506, _view94, _path507, _path508, _path509, _path510, _path511, _path512, _view95, _rect123, _rect124, _rect125, _path513, _rect126, _rect127, _rect128, _path514, _rect129, _path515, _rect130, _g16, _g17, _view96, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _view97, _path525, _path526, _path527, _path528, _path529, _path530, _view98, _path531, _path532, _path533, _path534, _ellipse12, _view99, _path535, _path536, _circle89, _circle90, _path537, _view100, _g18, _view101, _path538, _path539, _path540, _path541, _view102, _rect131, _rect132, _path542, _rect133, _rect134, _rect135, _path543, _circle91, _circle92, _path544, _rect136, _rect137, _rect138, _path545, _path546, _path547, _circle93, _path548, _rect139, _rect140, _circle94, _rect141, _rect142, _rect143, _path549, _path550, _circle95, _path551, _path552, _view103, _rect144, _rect145, _path553, _path554, _rect146, _rect147, _path555, _rect148, _rect149, _path556, _rect150, _path557, _view104, _g19, _view105, _circle96, _path558, _circle97, _circle98, _circle99, _path559, _rect151, _rect152, _path560, _rect153, _view106, _g20, _path561, _path562, _rect154, _path563, _path564, _rect155, _view107, _path565, _view108, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _view109, _path573, _path574, _path575, _path576, _view110, _path577, _path578, _path579, _path580, _path581, _view111, _path582, _path583, _path584, _view112, _path585, _path586, _path587, _path588, _path589, _view113, _rect156, _rect157, _rect158, _path590, _path591, _path592, _circle100, _rect159, _circle101, _view114, _path593, _path594, _path595, _path596, _path597, _path598, _view115, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _view116, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _view117, _path620, _path621, _path622, _view118, _path623, _path624, _path625, _path626, _view119, _g21, _view120, _g22, _view121, _path627, _path628, _path629, _view122, _rect160, _rect161, _rect162, _path630, _circle102, _path631, _path632, _view123, _rect163, _rect164, _rect165, _g23, _circle103, _path633, _path634, _view124, _path635, _rect166, _rect167, _rect168, _path636, _path637, _rect169, _circle104, _path638, _path639, _view125, _ellipse13, _path640, _path641, _circle105, _path642, _path643, _view126, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _view127, _rect170, _path654, _path655, _circle106, _path656, _rect171, _rect172, _path657, _path658, _rect173, _path659, _path660, _view128, _path661, _path662, _path663, _path664, _path665, _view129, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _view130, _path673, _path674, _view131, _path675, _path676, _path677, _view132, _path678, _rect174, _circle107, _view133, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _view134, _path686, _path687, _view135, _rect175, _rect176, _rect177, _rect178, _rect179, _path688, _rect180, _rect181, _path689, _path690, _circle108, _circle109, _circle110, _circle111, _path691, _view136, _rect182, _rect183, _path692, _path693, _rect184, _g24, _rect185, _rect186, _circle112, _path694, _circle113, _circle114, _circle115, _view137, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _view138, _path705, _path706, _path707, _path708, _path709, _view139, _rect187, _circle116, _circle117, _circle118, _circle119, _path710, _g25, _path711, _path712, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _circle120, _circle121, _circle122, _circle123, _view140, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _view141, _path722, _path723, _path724, _path725, _path726, _path727, _circle124, _view142, _path728, _path729, _path730, _circle125, _view143, _g26, _view144, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _view145, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _view146, _path745, _rect194, _rect195, _rect196, _rect197, _path746, _circle126, _rect198, _path747, _circle127, _circle128, _circle129, _view147, _path748, _path749, _path750, _circle130, _circle131, _circle132, _path751, _path752, _path753, _view148, _defs5, _path754, _path755, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _rect199, _path756, _view149, _path757, _path758, _path759, _path760, _view150, _path761, _path762, _path763, _path764, _path765, _path766, _view151, _path767, _path768, _path769, _path770, _view152, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _view153, _path778, _view154, _rect200, _path779, _path780, _path781, _circle133, _g27, _view155, _path782, _path783, _path784, _path785, _path786, _view156, _path787, _rect201, _path788, _path789, _rect202, _path790, _path791, _path792, _rect203, _view157, _path793, _path794, _path795, _path796, _path797, _path798, _view158, _path799, _path800, _path801, _path802, _path803, _path804, _view159, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _view160, _path817, _path818, _path819, _path820, _view161, _path821, _path822, _path823, _view162, _g28, _view163, _path824, _path825, _path826, _view164, _rect204, _rect205, _path827, _path828, _path829, _path830, _path831, _path832, _circle134, _view165, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _view166, _path840, _path841, _path842;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 585,
    height: 585,
    viewBox: "0 0 585 585",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _view || (_view = /*#__PURE__*/React.createElement("view", {
    id: "access_control",
    viewBox: "0 0 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26 12.3h3.7v-.9c0-.7-.3-1.3-.9-1.6-.6-.3-1.3-.3-1.9 0-.5.4-.9 1-.9 1.6v.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M5.6 30.2c-.1.2-.1.4 0 .6.2.1.4.1.6 0l2.9-3 6 5.9-3 3c-.1.2-.1.4 0 .6.2.1.4.1.6 0l2.9-3 .6.5c0 .1.1.1.3.1.2 0 .2 0 .2-.1l2.5-2.4c.1-.2.1-.4 0-.6l-1-.9 1.3-1.2h9.4c1 0 1.9-.4 2.6-1.1L39 21c.7-.6.8-1.7.2-2.4l-.2-.2c-.7-.7-1.9-.7-2.6 0l-5.5 5.5c-.3-.7-1-1.1-1.7-1.1h-6.1l-.7-.5c-2.6-1.8-6.2-1.5-8.5.7L12 24.6l-.9-.9h-.6L8 26.1c0 .1-.1.2-.1.3s.1.2.1.3l.6.5-3 3zm8.9-6.6c2-1.9 5.1-2.2 7.4-.6l.8.5h6.5c.6 0 1 .4 1 1s-.4 1-1 1h-6.7c-.2 0-.4.2-.4.4s.2.4.4.4h6.7c.9 0 1.6-.6 1.8-1.4l6-6c.5-.4 1.2-.3 1.5.2.3.4.3 1 0 1.4L30.9 28c-.5.6-1.2.9-2 .9H19l-1.3 1.3-5.1-5 1.9-1.6zm-3.7 1 7.5 7.5-1.8 1.9-7.6-7.6 1.9-1.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45.001 13.576 29.27)",
    fill: "#C9C9C9",
    d: "M12.3 23.9h2.6v10.7h-2.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19 29h9.9c.8 0 1.5-.3 2-.9l7.6-7.6c.3-.5.1-1.2-.4-1.5-.3-.2-.8-.2-1.1 0l-6 6c-.2.8-.9 1.4-1.8 1.4h-6.7c-.2 0-.4-.2-.4-.4s.2-.4.4-.4h6.7c.6 0 1-.4 1-1s-.4-1-1-1h-6.5l-.8-.5c-2.3-1.6-5.4-1.4-7.4.5l-1.9 1.6 5.1 5.1L19 29z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M24.2 11.1v1.6c-.9.5-1.4 1.4-1.4 2.4V18c0 1.6 1.2 2.8 2.8 2.9H30c1.5 0 2.8-1.3 2.8-2.8v-3c0-1-.5-1.9-1.4-2.4v-1.6c-.3-2-2.2-3.3-4.1-3-1.6.3-2.8 1.5-3.1 3zm6.8 2c.7.4 1.2 1.2 1.2 2V18c.1 1.2-.9 2.2-2.1 2.3H25.7c-1.2 0-2.2-1-2.2-2.2v-3c0-.8.5-1.6 1.2-2l1-.2H30c.3 0 .6 0 1 .2zm-4.1-3.3c.6-.3 1.3-.3 1.9 0 .6.3.9.9.9 1.6v.9H26v-.9c0-.6.3-1.2.9-1.6zm3.9 1.3v1.3h-.5v-1c0-.9-.5-1.7-1.2-2.1-.8-.4-1.7-.4-2.5 0-.7.5-1.2 1.2-1.2 2.1v.9h-.5v-1.2c.3-1.6 1.9-2.7 3.5-2.4 1.2.2 2.1 1.2 2.4 2.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M24.9 11.1v1.3h.5v-1c0-.9.5-1.6 1.2-2.1.8-.4 1.7-.4 2.5 0 .7.4 1.2 1.2 1.2 2.1v.9h.5v-1.2c-.3-1.6-1.9-2.7-3.5-2.4-1.3.2-2.2 1.2-2.4 2.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M27.9 16.2c.2 0 .4-.3.4-.5s-.1-.4-.3-.4-.3-.1-.5.1c-.1.1-.1.3-.1.5.1.2.3.3.5.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m25.7 12.9-1 .2c-.7.4-1.2 1.2-1.2 2V18c-.1 1.2.9 2.2 2.1 2.3H30c1.2 0 2.2-1 2.2-2.2v-3c0-.8-.5-1.6-1.2-2-.3-.2-.7-.2-1-.2h-4.3zm2.5 5.3c0 .2-.1.3-.3.3s-.3-.1-.3-.3v-1.5c-.5-.1-.9-.6-.8-1.2.1-.5.6-.9 1.1-.9.5 0 .9.4 1 .9.1.5-.2 1.1-.7 1.2v1.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M28.9 15.5c-.1-.5-.5-.9-1-.9s-1 .4-1.1.9c-.1.5.2 1.1.8 1.2v1.5c0 .2.1.3.3.3s.3-.1.3-.3v-1.5c.5-.1.8-.7.7-1.2zm-1.5.4c0-.2 0-.4.1-.5.2-.2.4-.2.5-.1.1.1.3.2.3.4s-.2.5-.4.5-.4-.1-.5-.3z"
  }))), _view2 || (_view2 = /*#__PURE__*/React.createElement("view", {
    id: "acoustics",
    viewBox: "45 0 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 45,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M21.8 37.3h3.3c.4 0 .7-.3.7-.7V8.3c0-.4-.3-.7-.7-.7h-3.3c-.3.1-.6.3-.6.7v2.1l-4.4 1.5c-1.9.6-3.3 2.3-3.5 4.3h-2v-1.3c0-.4-.3-.7-.7-.7H6c-.4 0-.7.3-.7.7v1l-2.4 2.5c-.1.1-.2.2-.2.4v7.9c0 .2.1.4.2.5l2.4 2.5v1c0 .4.3.7.7.7h4.6c.4 0 .7-.3.7-.7v-1.3h2c.2 2 1.6 3.7 3.5 4.3l4.4 1.4v1.5c0 .4.3.7.6.7zM10 30H6.7V15.5H10V30zm7.3 2.4c-1.6-.5-2.7-2-2.7-3.7V16.8c.1-1.7 1.1-3.1 2.7-3.7l3.9-1.3v22l-3.9-1.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M6.7 15.5H10V30H6.7zM21.2 11.8l-3.9 1.3c-1.6.6-2.6 2-2.7 3.7v11.9c0 1.7 1.1 3.2 2.7 3.7l3.9 1.4v-22z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M28.3 24.8c1-1 1.1-2.6.1-3.7l-.1-.1-.9 1c.5.5.5 1.3 0 1.8l.9 1zM29.7 26.1l1 .9c2.3-2.3 2.3-6.1 0-8.4l-1 .9c1.8 1.9 1.8 4.8 0 6.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "m33 16.2-.9 1c3 3.1 3 8.1 0 11.2l.9.9c1.7-1.7 2.7-4.1 2.7-6.5 0-2.4-1-4.8-2.7-6.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "m35.3 13.9-.9.9c2.1 2.1 3.3 5 3.3 8s-1.2 5.8-3.3 7.9l.9 1c4.9-4.9 4.9-12.8 0-17.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "m37.7 11.6-1 .9C39.5 15.3 41 19 41 22.9c0 3.9-1.5 7.6-4.3 10.3l1 .9c2.9-3 4.6-7 4.6-11.2 0-4.2-1.7-8.3-4.6-11.3z"
  }))), _view3 || (_view3 = /*#__PURE__*/React.createElement("view", {
    id: "air",
    viewBox: "0 45 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    y: 45,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4AB8DC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5 21.7c3.9 0 7-3.1 7-7s-3.1-7-7-7-7 3.1-7 7h.8c0-3.4 2.8-6.2 6.2-6.2 3.4 0 6.2 2.8 6.2 6.2 0 3.4-2.8 6.2-6.2 6.2h-31v.8h31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1 16.2H3.5v.9h14.6c2.4-.1 4.3-2 4.3-4.4 0-2.4-1.9-4.3-4.3-4.3s-4.3 1.9-4.4 4.3h.9c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5-1.5 3.5-3.5 3.5zM22.3 36.7c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5H3.5v.8h18.7c1.9.1 3.6 1.2 4.4 2.9.7 1.8.3 3.8-1.1 5.2-1.4 1.3-3.4 1.7-5.1 1-1.8-.7-2.9-2.5-2.9-4.4h-.8c.1 3 2.5 5.5 5.6 5.5z"
  })))), _view4 || (_view4 = /*#__PURE__*/React.createElement("view", {
    id: "alarm",
    viewBox: "45 45 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 45,
    y: 45,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 5V1.8M13.3 8.8l-2.5-2.5M31.7 8.8l2.5-2.5M9.5 18H6M35.5 18H39",
    fill: "none",
    stroke: "#f2c14e",
    strokeWidth: 1.9,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 18,
    r: 11.5,
    fill: "#a8352a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 18,
    r: 9.8,
    fill: "#d84338"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 18,
    r: 3.1,
    fill: "#a8352a"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 18,
    r: 1.2,
    fill: "#dfe6ec"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.6,
    y: 28,
    width: 1.8,
    height: 3.2,
    rx: 0.9,
    fill: "#5c6870"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 32,
    r: 1.9,
    fill: "#5c6870"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 35,
    width: 13,
    height: 2.6,
    rx: 1.3,
    fill: "#8f9ba3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#8f9ba3",
    d: "M20.9 33.5h3.2v2h-3.2z"
  }))), _view5 || (_view5 = /*#__PURE__*/React.createElement("view", {
    id: "ant",
    viewBox: "90 0 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 90,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M7.9 21.9v1.3h3.7l5.4-2.7h2.3v.5c0 .3 0 .5.1.8h-2.3L12 30.9l-3.2.6.2 1.2 3.8-.7 5-8.9h1.8c.1.4.2.8.4 1.2-.6.1-1.2.4-1.7.8-.9 1-1.3 2.4-1.2 3.7 0 3.2 2.6 8.7 5.2 8.7 1-.1 1.9-.6 2.5-1.4 1.9-2 3-4.6 3.2-7.3-.1-3-1.4-4.1-2.9-4.5.2-.4.3-.8.5-1.3h1.6l5.1 8.9 3.8.7.2-1.2-3.2-.6-5.2-9h-2.2c.1-.3.1-.6.1-.9v-.4h2.3l5.4 2.7h3.7v-1.3h-3.4l-5.4-2.6h-2.7l-.3-.9h2.4l5.2-5.1 3.3-.6-.2-1.2-3.8.5-5.1 5h-2.3c1.1-.4 1.8-1.5 1.7-2.7-.1-1.1-.5-2.2-1.3-3 .4-1.3.1-2.7-.8-3.7l-.9.8c.3.5.5 1.1.6 1.7-.5-.3-1-.5-1.6-.6-.7.1-1.4.3-1.9.8 0-.7.2-1.4.7-1.9l-.9-.9c-.9 1-1.3 2.5-.9 3.8-.8.8-1.2 1.9-1.3 3 0 1.2.7 2.2 1.8 2.7h-2.5l-5-5-3.7-.7-.3 1.3 3.4.6 5.1 5h2.5l-.3 1h-2.7l-5.5 2.6H7.9zm18.7 7c-.1 2.4-1.1 4.7-2.8 6.4-.4.5-1 .9-1.6 1-1.4 0-3.9-4.3-3.9-7.4-.1-1 .2-2.1.8-2.9.7-.5 1.5-.7 2.3-.6h1.2c2 0 4 0 4 3.5zm-3-4.9-1 .1h-1.3c-.6-1-.8-2.1-.8-3.2 0-1.3.4-2.6 1.2-3.6h1.6c.8 1 1.3 2.2 1.2 3.5.1 1.2-.2 2.3-.9 3.2zm-4-9.6c.1-.9.5-1.8 1.2-2.4.5-.6 1.1-.9 1.8-1.1 1.1 0 2.8 2.1 2.8 3.5s-1 1.8-2.8 1.8-3-.5-3-1.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M25.4 14.4c0-1.4-1.7-3.5-2.8-3.5-.7.2-1.3.5-1.8 1.1-.7.6-1.1 1.5-1.2 2.4 0 1.3 1.2 1.8 3 1.8s2.8-.5 2.8-1.8zM21.4 25.4c-.8-.1-1.6.1-2.3.6-.6.8-.9 1.9-.8 2.9 0 3.1 2.5 7.4 3.9 7.4.6-.1 1.2-.5 1.6-1 1.7-1.7 2.7-4 2.8-6.4-.1-3.5-2-3.5-4-3.5h-1.2zM23.4 17.4h-1.6c-.8 1-1.2 2.3-1.2 3.6 0 1.1.2 2.2.8 3.2h1.3l1-.1c.6-.9 1-2.1.9-3.2 0-1.3-.4-2.6-1.2-3.5z"
  }))), _view6 || (_view6 = /*#__PURE__*/React.createElement("view", {
    id: "appliances",
    viewBox: "90 45 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 90,
    y: 45,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20.5 9.1v-.3c0-.2-.2-.4-.4-.4h-7.6c-.2 0-.3.2-.3.4v.4h8.3zM32.9 9.1v-.3c0-.2-.2-.4-.4-.4H25c-.2 0-.4.2-.4.4v.4h8.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M9.3 37.2h26.4c.2 0 .3-.1.3-.3V9.4c0-.2-.1-.3-.3-.3h-2.2v-.3c0-.6-.4-1-1-1H25c-.5-.1-.9.3-1 .8V9.2h-2.9v-.4c0-.6-.4-1-1-1h-7.6c-.5 0-.9.4-.9.9v.5H9.3c-.2-.1-.3.1-.3.2V37c0 .1.1.2.3.2zM24.6 8.8c0-.2.2-.4.4-.4h7.5c.2 0 .4.2.4.4v.4h-8.3v-.4zm-12.4 0c0-.2.1-.4.3-.4h7.6c.2 0 .4.2.4.4v.4h-8.3v-.4zM9.6 9.9h25.8v4.6H9.6V9.9zm0 5.1h25.8v21.6H9.6V15z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M35.4 14.4V9.9H9.6v4.6h25.8zm-20.6-.8c-.8 0-1.4-.6-1.5-1.4 0-.8.7-1.5 1.5-1.5.8.1 1.4.7 1.4 1.5 0 .7-.6 1.4-1.4 1.4zm3.7 0c-.8.1-1.4-.5-1.5-1.3v-.1c0-.8.7-1.5 1.5-1.5.8.1 1.4.7 1.4 1.5 0 .7-.6 1.4-1.4 1.4zm4 .4c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.9c1 .1 1.8.9 1.9 1.9-.1 1-.9 1.8-1.9 1.8zm4.1-.4c-.8 0-1.4-.6-1.5-1.4 0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5c-.1.7-.7 1.4-1.5 1.4zm3.7 0c-.8 0-1.4-.6-1.5-1.4 0-.8.7-1.5 1.5-1.5.8.1 1.4.7 1.4 1.5 0 .7-.6 1.4-1.4 1.4z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M35.4 36.7V15.1H9.6v21.6h25.8zM13.9 17.2h17.2c.5-.1.9.3 1 .8v15.6c0 .6-.4 1-1 1H13.9c-.5 0-1-.5-1-1V18.2c0-.5.4-1 1-1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M12.9 18.2v15.4c0 .5.5 1 1 1h17.2c.6 0 1-.4 1-1V18.2c.1-.5-.3-.9-.8-1H13.9c-.6 0-1 .5-1 1zm1-.3h17.2c.2 0 .4.2.4.4v15.4c0 .2-.2.4-.4.4H13.9c-.2 0-.3-.2-.3-.4V18.2c0-.2.1-.3.3-.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M13.6 18.2v15.4c0 .2.1.4.3.4h17.2c.2 0 .4-.2.4-.4V18.2c0-.2-.2-.4-.4-.4H13.9c-.2.1-.3.2-.3.4zM26.1 21c0 .5-.5 1-1 1h-5.2c-.5-.1-.9-.5-.9-1v-.2c0-.5.4-.9.9-1h5.2c.5 0 1 .5 1 1v.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M20 19.8h5.1c.6 0 1 .4 1 1v.1c0 .6-.4 1-1 1H20c-.6 0-1-.4-1-1v-.1c0-.6.4-1 1-1zM24.4 12.1c-.1-1-.9-1.8-1.9-1.9-1 .1-1.8.9-1.8 1.9 0 1 .8 1.8 1.8 1.8 1 .1 1.8-.7 1.9-1.8zm-1.9 1.3c-.7 0-1.2-.5-1.2-1.2-.1-.7.4-1.2 1.1-1.3h.1c.7 0 1.3.6 1.3 1.3 0 .7-.5 1.2-1.2 1.2h-.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.8 12.1c0-.7-.6-1.3-1.3-1.3-.7 0-1.2.5-1.2 1.2v.1c0 .7.5 1.2 1.2 1.2.7.1 1.2-.4 1.3-1.1v-.1zm-1.6.5v-.9l.3-.3c.2 0 .3.1.3.3v.9c0 .2-.1.3-.3.3-.2 0-.3-.2-.3-.3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M31.7 12.1c0-.8-.6-1.4-1.4-1.5-.8 0-1.5.7-1.5 1.5.1.8.7 1.4 1.5 1.4.8.1 1.4-.6 1.4-1.4z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M28.1 12.1c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5.7 1.5 1.5 1.5 1.5-.6 1.5-1.5z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M19.9 12.1c0-.8-.6-1.4-1.4-1.5-.8 0-1.5.7-1.5 1.5s.6 1.4 1.4 1.4h.1c.8.1 1.4-.6 1.4-1.4z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M16.2 12.1c0-.8-.6-1.4-1.4-1.5-.8 0-1.5.7-1.5 1.5.1.8.7 1.4 1.5 1.4.8.1 1.4-.6 1.4-1.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.8 12.6v-.9c0-.2-.1-.3-.3-.3l-.3.3v.9c0 .2.1.3.3.3.2 0 .3-.2.3-.3z"
  }))), _view7 || (_view7 = /*#__PURE__*/React.createElement("view", {
    id: "audio",
    viewBox: "0 90 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    y: 90,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M26.1 16.4v-6.2c.1-.9-.4-1.7-1.1-2.2-.8-.4-1.7-.4-2.5.1l-9.9 5.6h-6c-1.9.1-3.5 1.7-3.5 3.6v10.5c0 1.9 1.6 3.5 3.5 3.5h5.9l9.9 5.7c.4.2.9.3 1.4.4.4 0 .8-.1 1.1-.3.7-.5 1.2-1.3 1.1-2.2v-6.3c3-.4 5.3-3 5.3-6.1 0-3.1-2.2-5.7-5.2-6.1zM9.4 29.6v-7.1c0-.5-.4-.9-.9-.9s-.9.4-.9.8v7.1h-1c-1-.1-1.7-.8-1.7-1.8V17.3c0-1 .7-1.7 1.7-1.8h5.3v14.1H9.4zm14.8 5.2c0 .3 0 .5-.2.7-.2 0-.5-.1-.7-.2l-9.6-5.4V15.1l6.1-3.5v13.6c0 .5.4.9.9.9s.9-.4.9-.9V10.6l1.7-.9c.3-.3.6-.3.7-.2.2.2.2.4.2.7v24.6zm1.9-7.9v-8.7c2 .4 3.5 2.2 3.5 4.3 0 2.1-1.5 3.9-3.5 4.4zM35.6 9.4c-.1-.1-.1-.1 0 0-.5-.3-1-.2-1.3.2l-.1.1c-.2.4-.1.9.3 1.1 3.6 2.8 5.7 7.1 5.7 11.7s-2.1 8.9-5.7 11.8c0 0-.1 0-.1.1-.3.3-.4.8-.1 1.1.2.2.4.4.7.4l.6-.2c4-3.2 6.3-8.1 6.3-13.2s-2.4-10-6.3-13.1z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M36.7 22.4c0-3.7-1.9-7.2-5-9.3-.1-.1-.3-.3-.4-.3a.8.8 0 0 0-1.1.6c-.2.5.1 1 .6 1.1 1 .7 1.9 1.6 2.6 2.6 3 4.4 1.8 10.4-2.6 13.3 0 0-.1 0-.1.1-.3.3-.4.8-.1 1.1.2.2.4.4.7.4l.5-.2c3-2.1 4.8-5.6 4.9-9.4z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M24.2 10.1c0-.3 0-.5-.2-.7-.1-.1-.4-.1-.7.2l-1.7.9v14.6c0 .5-.4.9-.9.9s-.9-.4-.9-.9V11.6l-6.1 3.5V30l9.6 5.4c.2.1.5.2.7.2.2-.2.2-.4.2-.7V10.1zm-4.3 19.5v-1.8c0-.5.4-.9.9-.9s.9.4.9.9v1.8c0 .5-.4.9-.9.9s-.9-.5-.9-.9zM11.9 15.4H6.6c-1 .1-1.7.8-1.7 1.8v10.5c0 1 .7 1.7 1.7 1.8h.9v-7.1c0-.5.4-.9.9-.9s.9.4.9.9v7.1h2.6V15.4zm-3.5 5.4c-.5 0-.9-.4-.9-.9v-1.8c0-.5.4-.9.9-.9s.9.4.9.9v1.8c.1.4-.4.9-.9.9z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M21.6 29.6v-1.8c0-.5-.4-.9-.9-.9s-.9.4-.9.9v1.8c0 .5.4.9.9.9s1-.5.9-.9zM9.4 18.1c0-.5-.4-.9-.9-.9s-.9.4-.9.9v1.8c0 .5.4.9.9.9s.9-.4.9-.9v-1.8z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M26.1 18.1v8.7c2.1-.5 3.5-2.3 3.5-4.4-.1-2-1.5-3.8-3.5-4.3z"
  }))), _view8 || (_view8 = /*#__PURE__*/React.createElement("view", {
    id: "av",
    viewBox: "45 90 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 45,
    y: 90,
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-287.1-169.1h612v1185h-612z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-287.1-169.1h612v1185h-612z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-287.1-169.1h612v1185h-612z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-287.1-169.1h612v1185h-612z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M-287.1-169.1h612v1185h-612z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137854953025136919990000006616947692161711295_"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000137854953025136919990000006616947692161711295_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M37.2 34.5c1.2-.1 2.2-1.2 2.1-2.4V9.3c.1-1.2-.9-2.3-2.1-2.4H7.8C6.6 7 5.6 8.1 5.7 9.3v22.8c-.1 1.2.9 2.3 2.1 2.4h12.6v2.4h-4.2V38h12.6v-1.1h-4.2v-2.4h12.6zM6.7 9.3c-.1-.6.4-1.1 1-1.2h29.5c.6.1 1.1.6 1 1.2v22.8c0 .6-.4 1.1-1 1.2H7.8c-.6-.1-1.1-.6-1.1-1.2V9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M36.1 27.3V10.5H8.8v16.8h27.3zM25.4 16.2l1.1 3.4c0 .1 0 .2.1.3 0 .2.1.3.1.5s.1.3.1.4c0-.1 0-.3.1-.4 0-.2.1-.3.1-.5s.1-.3.1-.3l1.1-3.4h1.2l-1.9 5.7h-1.3l-1.9-5.7h1.1zm-2.3 0h1.1l-2.1 5.7H21l2.1-5.7zm-5.7 0h1.5l2 5.7h-1.3l-.4-1.4h-2.1l-.4 1.4h-1.3l2-5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.8 33.3h29.4c.6-.1 1-.6 1-1.2V9.3c.1-.6-.4-1.1-1-1.2H7.7c-.6.1-1.1.6-1 1.2v22.8c0 .6.5 1.1 1.1 1.2zm14.7-1.2c-.6 0-1-.5-1-1.2s.4-1.2 1-1.2 1 .5 1 1.2-.4 1.2-1 1.2zM7.8 9.3h29.4v19.2H7.8V9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.5 18.2c0-.1-.1-.2-.1-.3s-.1-.3-.1-.4-.1-.3-.1-.4c0 .1-.1.2-.1.4s-.1.3-.1.4-.1.2-.1.3l-.4 1.3H19l-.5-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M17.1 20.5h2.1l.4 1.4h1.3l-2-5.7h-1.5l-2 5.7h1.3l.4-1.4zm.7-2.3c0-.1 0-.2.1-.3s.1-.3.1-.4.1-.3.1-.4c0 .1.1.2.1.4s.1.3.1.4.1.3.1.3l.4 1.3h-1.5l.5-1.3zM24.2 16.2h-1.1L21 21.9h1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "m27.5 21.9 1.9-5.7h-1.2l-1.1 3.4c0 .1 0 .2-.1.3 0 .2-.1.3-.1.5s-.1.3-.1.4c0-.1 0-.3-.1-.4s-.1-.3-.1-.5-.1-.3-.1-.3l-1.1-3.4h-1.2l1.9 5.7h1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M37.2 28.5V9.3H7.8v19.2h29.4zm-28.4-18h27.3v16.8H8.8V10.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#28B557",
    cx: 22.5,
    cy: 30.9,
    rx: 1,
    ry: 1.2
  })))), _view9 || (_view9 = /*#__PURE__*/React.createElement("view", {
    id: "badge",
    viewBox: "90 90 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 90,
    y: 90,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M14.2 11.3c-.3 0-.6.3-.6.6v24.9c0 .3.3.6.6.6h16.6c.3 0 .6-.3.6-.6V11.9c0-.3-.3-.6-.6-.6h-5.3v-3c0-.3-.3-.6-.6-.6h-4.8c-.3 0-.6.3-.6.6v3h-5.3zm16 24.8H14.8V12.4h4.7v1.8h-1.7c-.3 0-.6.3-.6.6s.3.6.6.6h9.4c.3 0 .6-.3.6-.6s-.3-.6-.6-.6h-1.7v-1.8h4.7v23.7zM24.3 8.9v5.3h-3.6V8.9h3.6z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M20.7 14.2h3.6V8.9h-3.6v5.3zm1.8-4.8c.7 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2-1.2-.5-1.2-1.2c0-.6.5-1.2 1.2-1.2z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M25.5 12.4v1.8h1.7c.3 0 .6.3.6.6s-.3.6-.6.6h-9.4c-.3 0-.6-.3-.6-.6s.3-.6.6-.6h1.7v-1.8h-4.7v23.8h15.4V12.4h-4.7zm-8.9 19h-.2c-.3-.1-.4-.3-.4-.6s.3-.6.6-.6h11.8c.3 0 .6.3.6.6v.2c-.1.3-.3.4-.6.4H16.6zm8.9 1.7c0 .3-.3.6-.6.6h-8.3c-.3 0-.6-.3-.6-.6s.3-.6.6-.6h8.3c.3.1.6.3.6.6zm1.7-4.7c0 .3-.2.6-.5.6s-.6-.3-.6-.6v-1.9c0-1.9-1.6-3.5-3.5-3.5h-.2c-1.9 0-3.5 1.6-3.5 3.5v1.9c0 .3-.3.6-.6.6s-.5-.3-.5-.6v-1.9c0-1.8 1-3.5 2.7-4.3-.9-.8-1.2-2.1-.8-3.2.3-.8.9-1.4 1.7-1.7 1.5-.6 3.3.2 3.9 1.7.4 1.1.1 2.4-.8 3.2 1.7.8 2.7 2.5 2.7 4.3v1.9z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22.5 18.4c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8-.8-1.8-1.8-1.8z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M24.5 22.3c.9-.8 1.2-2.1.8-3.2-.6-1.5-2.3-2.3-3.9-1.7-.8.3-1.4.9-1.7 1.7-.4 1.1-.1 2.4.8 3.2-1.7.8-2.7 2.5-2.7 4.3v1.9c0 .3.2.6.5.6s.6-.3.6-.6v-1.9c0-1.9 1.6-3.5 3.5-3.5h.2c1.9 0 3.5 1.6 3.5 3.5v1.9c0 .3.3.6.6.6s.5-.3.5-.6v-1.9c0-1.9-1-3.6-2.7-4.3zm-2-.4c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8 1.8.8 1.8 1.8-.8 1.8-1.8 1.8z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M29 31v-.2c0-.3-.3-.6-.6-.6H16.6c-.3 0-.6.3-.6.6-.1.3.1.5.4.6h12c.3 0 .5-.2.6-.4zM16.6 32.6c-.3 0-.6.3-.6.6s.3.6.6.6h8.3c.3 0 .6-.3.6-.6s-.3-.6-.6-.6h-8.3z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M22.5 11.9c.7 0 1.2-.5 1.2-1.2s-.5-1.2-1.2-1.2-1.2.5-1.2 1.2c0 .6.5 1.2 1.2 1.2z"
  }))), _view10 || (_view10 = /*#__PURE__*/React.createElement("view", {
    id: "bbq-grill-patio",
    viewBox: "135 0 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 135,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 36,
    width: 39,
    height: 1.5,
    rx: 0.75,
    fill: "#c3ccd2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15.5a9.8 9.8 0 0 1 19.6 0z",
    fill: "#e0704f"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15.5a9.8 9.8 0 0 1 19.6 0z",
    fill: "none"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8,
    cy: 15.5,
    r: 1.6,
    fill: "#e0704f"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.3,
    cy: 15.5,
    r: 1.6,
    fill: "#e0704f"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.8,
    cy: 15.5,
    r: 1.6,
    fill: "#e0704f"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#8a6238",
    d: "M32.6 15.5H34V36h-1.4z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5c-.9-1.4.9-2.2 0-3.6M14.5 12.5c-.9-1.4.9-2.2 0-3.6",
    fill: "none",
    stroke: "#c3ccd2",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3,
    cy: 14.6,
    r: 1,
    fill: "#5c6870"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1 22a7.2 7.2 0 0 1 14.4 0z",
    fill: "#3f4a54"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1 22h14.4c0 4-3.1 6.6-7.2 6.6S5.1 26 5.1 22z",
    fill: "#333a40"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 28.5 7.7 36M15.1 28.5l1.8 7.5",
    fill: "none",
    stroke: "#5c6870",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.4,
    cy: 36,
    r: 1.6,
    fill: "#5c6870"
  }))), _view11 || (_view11 = /*#__PURE__*/React.createElement("view", {
    id: "bed",
    viewBox: "135 45 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 135,
    y: 45,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M6.7 7.6H4.1c-.3 0-.6.3-.6.6v28.5c0 .4.3.6.6.7h2.6c.3-.1.6-.3.6-.7v-6.9h30.4v6.9c0 .4.3.6.6.7h2.6c.3-.1.6-.3.6-.7v-12c0-.3-.3-.6-.6-.6h-.7V19c0-.3-.3-.6-.6-.6H25v-1.3c0-.3-.3-.6-.6-.6h-5.7c-.3 0-.6.3-.6.6v1.3h-1.6c.2-.3.3-.7.3-1.1v-.4c0-1.3-1-2.3-2.3-2.3H10.3c-1.3-.1-2.3.9-2.4 2.2v.5c0 .4.1.8.3 1.1h-.9V8.2c0-.3-.3-.6-.6-.6zm32.2 12V24H25v-4.4h13.9zm-15.2-1.9V24h-4.4v-6.3h4.4zm-14.5-.8c0-.6.5-1.1 1.1-1.1h4.1c.6 0 1.1.5 1.1 1.1v.3c0 .6-.5 1.1-1.1 1.1h-4.1c-.6 0-1.1-.5-1.1-1.1v-.3zm1.1 2.7h7.8v4.5H7.3v-4.5h3z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.3 18.3h4.1c.6 0 1.1-.5 1.1-1.1v-.3c0-.6-.5-1.1-1.1-1.1h-4.1c-.6 0-1.1.5-1.1 1.1v.3c0 .6.5 1.1 1.1 1.1z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M25 19.6h13.9V24H25zM19.3 17.7h4.4V24h-4.4z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M7.3 24.1h10.8v-4.5H7.3z"
  }))), _view12 || (_view12 = /*#__PURE__*/React.createElement("view", {
    id: "broom",
    viewBox: "135 90 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 135,
    y: 90,
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-406.1-169.8h612v1185h-612z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-406.1-169.8h612v1185h-612z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-406.1-169.8h612v1185h-612z"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M-406.1-169.8h612v1185h-612z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106107048690205286000000018352664977446084270_"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000106107048690205286000000018352664977446084270_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M20 39.8h9.5c.2 0 .5-.1.6-.3.2-.3.1-.7-.2-.8-2.3-2.1-1.8-4.5-1.3-6.8s.9-4.3-1.1-5.8c.2-.4.2-.9.2-1.4 0-1-.8-1.8-1.8-1.9V7.5c0-1.3-1-2.3-2.3-2.3h-1c-1.2.1-2.2 1.1-2.1 2.3v15.3c-1 .1-1.8.9-1.8 1.9 0 .4 0 .8.2 1.2-2.5 1.5-4 5.4-4 8.6s1.7 5.3 5.1 5.3zm1.7-32.3c0-.6.4-1 1-1.1h.9c.6 0 1.1.5 1.1 1.1v15.3h-3V7.5zm-2 19.4h6.8c1.7 1.1 1.4 2.5.9 4.7s-1 4.6.7 7h-.9c-.9-.8-1.5-1.8-1.8-3-.3-1.4-.2-2.9.3-4.2.3-.8-.8-1.3-1.1-.5-.7 1.6-.8 3.3-.4 5 .2 1 .6 1.9 1.3 2.7h-2.8c-.7-1.4-1-3-1-4.6 0-2 .8-4.1 1.3-4.7s.2-1.9-.9-.8c-1.1 1.1-1.7 3.3-1.6 5.5-.1 1.6.2 3.2.9 4.6h-1.8c-.7-.9-1.1-1.9-1.2-3 0-1.5.2-2.9.7-4.3.3-.7-.9-1.1-1.2-.3-.5 1.5-.7 3.1-.7 4.7.1.8.3 1.6.6 2.4-1.2-.8-1.8-2.2-1.7-3.6 0-2.3 1.4-6.9 3.6-7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M16.1 34.5c-.1 1.4.5 2.8 1.7 3.6-.3-.8-.5-1.6-.6-2.4 0-1.6.2-3.2.7-4.7.3-.8 1.5-.4 1.2.3-.5 1.4-.7 2.8-.7 4.3.1 1.1.5 2.1 1.2 3h1.8c-.7-1.4-1-3-.9-4.6-.1-2.2.5-4.4 1.6-5.5 1.1-1.1 1.4.2.9.8S21.7 32 21.7 34c0 1.6.3 3.2 1 4.6h2.8c-.7-.8-1.1-1.7-1.3-2.7-.4-1.7-.3-3.4.4-5 .3-.8 1.4-.3 1.1.5-.5 1.3-.6 2.8-.3 4.2.3 1.2.9 2.2 1.8 3h.9c-1.7-2.4-1.2-4.8-.7-7s.8-3.6-.9-4.7h-6.8c-2.2.7-3.6 5.3-3.6 7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M24.7 22.8V7.5c0-.6-.5-1.1-1.1-1.1h-.9c-.6.1-1 .5-1 1.1v15.3h3z"
  })))), _view13 || (_view13 = /*#__PURE__*/React.createElement("view", {
    id: "building",
    viewBox: "0 135 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    y: 135,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M4.2 37.2h36.5v-1h-2.4V7.8H15v4.7H6.8v23.8H4.2v.9zm20.6-.9v-5.8h3.8v5.8h-3.8zM16 8.7h21.4v27.6h-7.9v-6.7h-5.6v6.7H16V8.7zm-8.3 4.8H15v22.9H7.7V13.5z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M24.8 30.5h3.8v5.8h-3.8z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M33 25.8h1.4v1.5H33zM28.2 25.8h1.5v1.5h-1.5z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M16 36.2h7.9v-6.7h5.6v6.7h7.9V8.7H16v27.5zm6.7-25.4H26V14h-3.3v-3.2zm4.6 0h3.3V14h-3.3v-3.2zm4.7 0h3.3V14H32v-3.2zm3.3 22H32v-3.3h3.3v3.3zm-14.1 0H18v-3.3h3.3v3.3zm1.5-14v-3.3H26v3.3h-3.3zm4.6 0v-3.3h3.3v3.3h-3.3zM18 28.2v-3.3h3.3v3.3H18zm8-4.7h-3.3v-3.3H26v3.3zm-4.8-3.3v3.3H18v-3.3h3.2zm9.5 3.3h-3.3v-3.3h3.3v3.3zm-9.5-8v3.3H18v-3.3h3.2zm1.5 12.7v-3.3H26v3.3h-3.3zm4.6-3.4h3.3v3.3h-3.3v-3.3zm8 3.4H32v-3.3h3.3v3.3zm0-4.7H32v-3.3h3.3v3.3zm0-4.7H32v-3.3h3.3v3.3zM21.2 14H18v-3.3h3.3V14z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M18.8 11.7h1.4v1.4h-1.4zM33 16.3h1.4v1.4H33zM33 21h1.4v1.4H33zM23.5 11.7h1.4v1.4h-1.4zM28.2 11.7h1.5v1.4h-1.5zM23.5 25.8h1.4v1.5h-1.4zM33 11.7h1.4v1.4H33zM18.8 30.5h1.4V32h-1.4zM23.5 16.3h1.4v1.4h-1.4zM18.8 25.8h1.4v1.5h-1.4zM33 30.5h1.4V32H33zM28.2 21h1.5v1.4h-1.5zM18.8 16.3h1.4v1.4h-1.4zM23.5 21h1.4v1.4h-1.4zM18.8 21h1.4v1.4h-1.4zM28.2 16.3h1.5v1.4h-1.5zM10.5 21H12v1.4h-1.5zM10.5 16.3H12v1.4h-1.5zM10.5 30.5H12V32h-1.5z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M15 36.3V13.5H7.7v22.9H15zm-5.3-3.5v-3.3H13v3.3H9.7zm0-4.6v-3.3H13v3.3H9.7zm0-4.7v-3.3H13v3.3H9.7zm0-4.7v-3.3H13v3.3H9.7z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M10.5 25.8H12v1.5h-1.5z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M18 10.8V14h3.3v-3.3H18zm2.2 2.2h-1.4v-1.4h1.4V13zM26 10.8h-3.3V14H26v-3.2zM25 13h-1.4v-1.4H25V13zM30.7 10.8h-3.3V14h3.3v-3.2zm-.9 2.2h-1.5v-1.4h1.5V13zM35.3 10.8H32V14h3.3v-3.2zm-.8 2.2H33v-1.4h1.4V13zM18 18.8h3.3v-3.3H18v3.3zm.8-2.5h1.4v1.4h-1.4v-1.4zM22.7 15.5v3.3H26v-3.3h-3.3zm2.3 2.3h-1.4v-1.4H25v1.4zM27.3 15.5v3.3h3.3v-3.3h-3.3zm2.5 2.3h-1.5v-1.4h1.5v1.4zM32 18.8h3.3v-3.3H32v3.3zm1-2.5h1.4v1.4H33v-1.4zM18 23.5h3.3v-3.3H18v3.3zm.8-2.5h1.4v1.4h-1.4V21zM22.7 23.5H26v-3.3h-3.3v3.3zm.8-2.5H25v1.4h-1.4V21zM27.3 23.5h3.3v-3.3h-3.3v3.3zm.9-2.5h1.5v1.4h-1.5V21zM32 23.5h3.3v-3.3H32v3.3zm1-2.5h1.4v1.4H33V21zM21.2 28.2v-3.3H18v3.3h3.2zm-2.4-1v-1.5h1.4v1.5h-1.4zM26 24.8h-3.3v3.3H26v-3.3zm-1 2.4h-1.4v-1.5H25v1.5zM30.7 24.8h-3.3v3.3h3.3v-3.3zm-.9 2.4h-1.5v-1.5h1.5v1.5zM32 28.2h3.3v-3.3H32v3.3zm2.5-1H33v-1.5h1.4v1.5zM18 29.5v3.3h3.3v-3.3H18zm2.2 2.5h-1.4v-1.5h1.4V32zM32 29.5v3.3h3.3v-3.3H32zm2.5 2.5H33v-1.5h1.4V32zM13 15.5H9.7v3.3H13v-3.3zm-1 2.3h-1.5v-1.4H12v1.4zM9.7 20.2v3.3H13v-3.3H9.7zm2.3 2.3h-1.5V21H12v1.5zM9.7 24.8v3.3H13v-3.3H9.7zm2.3 2.4h-1.5v-1.5H12v1.5zM13 29.5H9.7v3.3H13v-3.3zM12 32h-1.5v-1.5H12V32z"
  }))), _view14 || (_view14 = /*#__PURE__*/React.createElement("view", {
    id: "calendar",
    viewBox: "45 135 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 45,
    y: 135,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M13.6 9.9H9.5c-.3 0-.6.3-.6.6v2.9h-.6c-.3 0-.6.2-.6.5v20.7c0 .3.3.6.6.6h1.8v1.7c0 .3.3.6.6.6h26c.3 0 .6-.3.6-.6V16.2c0-.3-.3-.5-.6-.5h-1.8v-1.8c0-.3-.3-.5-.6-.5h-.6v-2.9c0-.3-.3-.6-.6-.6H29V8.2c0-.3-.3-.6-.6-.6H26c-.3 0-.6.3-.6.6v1.7h-2.3V8.2c0-.3-.3-.6-.6-.6h-2.4c-.3 0-.6.3-.6.6v1.7h-2.3V8.2c0-.3-.3-.6-.6-.6h-2.4c-.3 0-.6.3-.6.6v1.7zm22.5 26.5H11.2v-1.2h18.4l.4-.2 4.7-4.6c.1-.1.2-.2.2-.4V16.7h1.2v19.7zm-5.9-5.9h2.7l-2.7 2.6v-2.6zm3.5-1h-4.1c-.3 0-.6.2-.6.5v4H8.9V14.5h24.8v15zM26.6 8.7h1.2V11h-1.2V8.7zm-5.9 0h1.2V11h-1.2V8.7zM19.5 11v.5c0 .3.3.6.6.6h2.4c.3 0 .6-.3.6-.6V11h2.3v.5c0 .3.3.6.6.6h2.4c.3 0 .6-.3.6-.6V11h3.5v2.3H10.1V11h3.5v.5c0 .3.3.6.6.6h2.4c.3 0 .6-.3.6-.6V11h2.3zM16 8.7V11h-1.2V8.7H16z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M36.1 16.7h-1.2V30c0 .2-.1.3-.2.4L30 35l-.4.2H11.2v1.2h24.9V16.7zM26.6 8.7h1.2V11h-1.2zM20.7 8.7h1.2V11h-1.2zM14.8 8.7H16V11h-1.2zM17.2 11.5c0 .3-.3.6-.6.6h-2.4c-.3 0-.6-.3-.6-.6V11h-3.5v2.3h22.4V11H29v.5c0 .3-.3.6-.6.6H26c-.3 0-.6-.3-.6-.6V11h-2.3v.5c0 .3-.3.6-.6.6h-2.4c-.3 0-.6-.3-.6-.6V11h-2.3v.5z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.9 14.5V34H29v-4c0-.3.3-.5.6-.5h4.1v-15H8.9zm23.6 1.7v2.3c0 .3-.3.6-.6.6h-2.3c-.3 0-.6-.3-.6-.6v-2.3c0-.3.3-.5.6-.5h2.3c.4 0 .6.2.6.5zm0 6.8c0 .3-.3.6-.6.6h-2.3c-.3 0-.6-.3-.6-.6v-2.3c0-.3.3-.5.6-.5h2.3c.4 0 .6.2.6.5V23zm0 4.7c0 .3-.3.6-.6.6h-2.3c-.3 0-.6-.3-.6-.6v-2.3c0-.3.3-.6.6-.6h2.3c.3 0 .6.3.6.6v2.3zm-14.7 5.2h-2.4c-.3 0-.6-.3-.6-.6V30c0-.3.3-.5.6-.5h2.4c.3 0 .5.2.5.5v2.3c0 .2-.2.5-.5.6zm-4.8 0h-2.3c-.3 0-.6-.3-.6-.6V30c0-.3.3-.6.6-.6H13c.3 0 .6.3.6.6v2.2c0 .4-.3.7-.6.7zm-2.9-7.5c0-.3.3-.6.6-.6H13c.3 0 .6.3.6.6v2.3c0 .3-.3.6-.6.6h-2.3c-.3 0-.6-.3-.6-.6v-2.3zm0-4.7c0-.3.2-.5.6-.5H13c.3 0 .6.2.6.5V23c0 .3-.3.6-.6.6h-2.3c-.3 0-.6-.3-.6-.6v-2.3zm14.8-5h2.3c.3 0 .6.2.6.5v2.3c0 .3-.3.6-.6.6h-2.3c-.3 0-.6-.3-.6-.6v-2.3c0-.3.2-.5.6-.5zm2.9 7.3c0 .3-.3.6-.6.6h-2.3c-.3 0-.6-.3-.6-.6v-2.3c0-.3.2-.5.6-.5h2.3c.3 0 .6.2.6.5V23zm-13 2.4c0-.3.3-.6.6-.6h2.4c.3 0 .5.3.5.6v2.3c0 .3-.2.6-.5.6h-2.4c-.3 0-.6-.3-.6-.6v-2.3zm0-4.7c0-.3.3-.5.6-.5h2.4c.3 0 .5.2.5.5V23c0 .3-.2.6-.5.6h-2.4c-.3 0-.6-.3-.6-.6v-2.3zm8.3 2.3c0 .3-.3.6-.6.6h-2.4c-.3 0-.6-.3-.6-.6v-2.3c0-.3.3-.5.6-.5h2.4c.3 0 .6.2.6.5V23zm-3.6 2.4c0-.3.3-.6.6-.6h2.4c.3 0 .6.3.6.6v2.3c0 .3-.3.6-.6.6h-2.4c-.3 0-.6-.3-.6-.6v-2.3zm5.4 2.8c-.3 0-.6-.3-.6-.6v-2.3c0-.3.3-.6.6-.6h2.3c.3 0 .6.3.6.6v2.3c0 .3-.3.6-.6.6h-2.3z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M32.9 30.5h-2.7v2.7z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M10.7 23.7H13c.3 0 .6-.3.6-.6v-2.3c0-.3-.3-.5-.6-.5h-2.3c-.4 0-.6.2-.6.5V23c0 .4.3.7.6.7zm1.7-1.2h-1.2v-1.1h1.2v1.1z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.2 21.4h1.2v1.1h-1.2z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M15.4 23.7h2.4c.3 0 .5-.3.5-.6v-2.3c0-.3-.2-.5-.5-.5h-2.4c-.3 0-.6.2-.6.5V23c0 .4.3.7.6.7zm1.8-1.2H16v-1.1h1.2v1.1z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16 21.4h1.2v1.1H16z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.5 20.2h-2.4c-.3 0-.6.2-.6.5V23c0 .3.3.6.6.6h2.4c.3 0 .6-.3.6-.6v-2.3c0-.2-.3-.5-.6-.5zm-.6 2.3h-1.2v-1.1h1.2v1.1z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.7 21.4h1.2v1.1h-1.2z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M27.2 20.2h-2.3c-.4 0-.6.2-.6.5V23c0 .3.3.6.6.6h2.3c.3 0 .6-.3.6-.6v-2.3c0-.2-.3-.5-.6-.5zm-.6 2.3h-1.2v-1.1h1.2v1.1z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M25.4 21.4h1.2v1.1h-1.2z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M31.9 20.2h-2.3c-.3 0-.6.2-.6.5V23c0 .3.3.6.6.6h2.3c.3 0 .6-.3.6-.6v-2.3c0-.2-.2-.5-.6-.5zm-.5 1.2v1.1h-1.2v-1.1h1.2z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M30.2 21.4h1.2v1.1h-1.2z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M24.3 16.2v2.3c0 .3.3.6.6.6h2.3c.3 0 .6-.3.6-.6v-2.3c0-.3-.3-.5-.6-.5h-2.3c-.4 0-.6.2-.6.5zm2.3 1.7h-1.2v-1.2h1.2v1.2z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M25.4 16.7h1.2v1.2h-1.2z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M31.9 15.7h-2.3c-.3 0-.6.2-.6.5v2.3c0 .3.3.6.6.6h2.3c.3 0 .6-.3.6-.6v-2.3c0-.3-.2-.5-.6-.5zm-.5 1v1.2h-1.2v-1.2h1.2z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M30.2 16.7h1.2v1.2h-1.2z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M10.7 28.2H13c.3 0 .6-.3.6-.6v-2.3c0-.3-.3-.6-.6-.6h-2.3c-.3 0-.6.3-.6.6v2.3c0 .4.3.6.6.6zm.5-1.1V26h1.2v1.2h-1.2z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.2 26h1.2v1.2h-1.2z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M15.4 28.2h2.4c.3 0 .5-.3.5-.6v-2.3c0-.3-.2-.6-.5-.6h-2.4c-.3 0-.6.3-.6.6v2.3c0 .4.3.6.6.6zM16 26h1.2v1.2H16V26z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16 26h1.2v1.2H16z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M13.6 30c0-.3-.3-.6-.6-.6h-2.3c-.3 0-.6.3-.6.6v2.2c0 .3.3.6.6.6H13c.3 0 .6-.3.6-.6V30zm-2.4.5h1.2v1.2h-1.2v-1.2z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.2 30.5h1.2v1.2h-1.2z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M18.3 30c0-.3-.2-.5-.5-.5h-2.4c-.3 0-.6.2-.6.5v2.3c0 .3.3.6.6.6h2.4c.3 0 .5-.3.5-.6V30zm-2.3.5h1.2v1.2H16v-1.2z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16 30.5h1.2v1.2H16z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M20.1 28.2h2.4c.3 0 .6-.3.6-.6v-2.3c0-.3-.3-.6-.6-.6h-2.4c-.3 0-.6.3-.6.6v2.3c0 .4.3.6.6.6zm.6-2.2h1.2v1.2h-1.2V26z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.7 26h1.2v1.2h-1.2z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M27.2 28.2c.3 0 .6-.3.6-.6v-2.3c0-.3-.3-.6-.6-.6h-2.3c-.3 0-.6.3-.6.6v2.3c0 .3.3.6.6.6h2.3zM25.4 26h1.2v1.2h-1.2V26z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M25.4 26h1.2v1.2h-1.2z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M31.9 24.7h-2.3c-.3 0-.6.3-.6.6v2.3c0 .3.3.6.6.6h2.3c.3 0 .6-.3.6-.6v-2.3c0-.3-.3-.6-.6-.6zm-.5 1.3v1.2h-1.2V26h1.2z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M30.2 26h1.2v1.2h-1.2z"
  }))), _view15 || (_view15 = /*#__PURE__*/React.createElement("view", {
    id: "can-usb-adapter",
    viewBox: "90 135 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 90,
    y: 135,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 19,
    width: 8.5,
    height: 7,
    rx: 0.9,
    fill: "#b9c2c9"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#71808a",
    d: "M4.8 20.7h3.6v3.6H4.8z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 15.5,
    width: 18.5,
    height: 14,
    rx: 2.5,
    fill: "#c8503f"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.6,
    cy: 18.7,
    r: 1.15,
    fill: "#58c47a"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.7,
    cy: 18.7,
    r: 1.15,
    fill: "#f2c14e"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 24.5h13.7",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 24.5v-2.4",
    fill: "none",
    stroke: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3,
    y: 19.9,
    width: 2.4,
    height: 2.4,
    rx: 0.5,
    fill: "#fff"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M23 24.5v2.2",
    fill: "none",
    stroke: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 21.8,
    y: 26.1,
    width: 2.4,
    height: 2.4,
    rx: 0.5,
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2,
    y: 16.8,
    width: 2.6,
    height: 11.4,
    rx: 0.8,
    fill: "#8f9ba3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 32.6,
    y: 18.6,
    width: 8,
    height: 7.8,
    rx: 2.7,
    fill: "#b9c2c9"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.2,
    cy: 21.3,
    r: 0.5,
    fill: "#5c676e"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 21.3,
    r: 0.5,
    fill: "#5c676e"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.8,
    cy: 21.3,
    r: 0.5,
    fill: "#5c676e"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1,
    cy: 21.3,
    r: 0.5,
    fill: "#5c676e"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.4,
    cy: 21.3,
    r: 0.5,
    fill: "#5c676e"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.85,
    cy: 23.8,
    r: 0.5,
    fill: "#5c676e"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.15,
    cy: 23.8,
    r: 0.5,
    fill: "#5c676e"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.45,
    cy: 23.8,
    r: 0.5,
    fill: "#5c676e"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.75,
    cy: 23.8,
    r: 0.5,
    fill: "#5c676e"
  }))), _view16 || (_view16 = /*#__PURE__*/React.createElement("view", {
    id: "card-reader-door-issue",
    viewBox: "135 135 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 135,
    y: 135,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.5h17c.8 0 1.5.7 1.5 1.5v33H7V7c0-.8.7-1.5 1.5-1.5z",
    fill: "#c7d3dc"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#5a7d9a",
    d: "M9.8 8.2h7.1V40H9.8zM17.3 8.2h7.1V40h-7.1z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#aecfdf",
    d: "M10.9 9.4h4.9v29.4h-4.9zM18.4 9.4h4.9v29.4h-4.9z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m10.9 17.8 4.9-4.9v2.8l-4.9 4.9zM10.9 23.4l4.9-4.9V20l-4.9 4.9zM18.4 17.8l4.9-4.9v2.8l-4.9 4.9zM18.4 23.4l4.9-4.9V20l-4.9 4.9z",
    fill: "#dcebf3"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9,
    y: 16.5,
    width: 1.5,
    height: 14.5,
    rx: 0.75,
    fill: "#3f4a54"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6,
    y: 16.5,
    width: 1.5,
    height: 14.5,
    rx: 0.75,
    fill: "#3f4a54"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 15.5,
    width: 9,
    height: 14,
    rx: 1.6,
    fill: "#3f4a54"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 19,
    r: 1.4,
    fill: "#e05c4b"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 32.4,
    y: 22.4,
    width: 5.2,
    height: 1.4,
    rx: 0.7,
    fill: "#8fa0ad"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 32.4,
    y: 25.2,
    width: 5.2,
    height: 1.4,
    rx: 0.7,
    fill: "#8fa0ad"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-14 34 34.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 31,
    width: 11,
    height: 7,
    rx: 1.2,
    fill: "#eef3f6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a7d9a",
    d: "M28.5 32.6h11v1.8h-11z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 35.6,
    width: 4.2,
    height: 1.1,
    rx: 0.55,
    fill: "#c7d3dc"
  })))), _view17 || (_view17 = /*#__PURE__*/React.createElement("view", {
    id: "carpentry-tools",
    viewBox: "180 0 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 180,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "m17.692 13.077 18.676 14.298-4.62 3.113-17.612-12.332z",
    fill: "#b9c2c9"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "m14.136 18.156.024 2.58 2.433-.86zM17.822 20.737l.024 2.58 2.433-.86zM21.508 23.318l.024 2.58 2.433-.86zM25.194 25.899l.024 2.58 2.434-.86zM28.88 28.48l.025 2.58 2.433-.86z",
    fill: "#b9c2c9"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m13.81 8.161 4.095 2.868c1.393.975 1.712 2.785.737 4.178l-2.581 3.686c-.975 1.393-2.786 1.712-4.178.737l-4.096-2.868c-1.393-.975-1.712-2.786-.737-4.178l2.581-3.686c.975-1.393 2.786-1.712 4.178-.737zm-1.082 2.417a1.58 1.58 0 0 0-2.229.392L9.352 12.61a1.58 1.58 0 0 0 .393 2.228l2.949 2.065a1.58 1.58 0 0 0 2.228-.393l1.147-1.638a1.58 1.58 0 0 0-.392-2.229z",
    fill: "#b07845"
  }))), _view18 || (_view18 = /*#__PURE__*/React.createElement("view", {
    id: "catering",
    viewBox: "180 45 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 180,
    y: 45,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23 25.3c1 .8 2.5.8 2.9-.6l.7-2.1c0-.1.1-.2.1-.4h-7.6l3.9 3.1z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M24.6 10.6V9.4c0-1-.8-1.8-1.8-1.8h-.1c-1 0-1.8.8-1.8 1.8v1c-5.5.6-9.8 5.2-10 10.8H9.2c-.3 0-.5.2-.5.5 0 .2.3.4.5.4h4.4c-.1.2-.2.4-.2.6.1.4.2.7.5 1l5.5 4.4c1.6 1.3 3 2.8 4.2 4.4l.4.6-.3.2c-.1.1-.2.2-.2.3 0 .1 0 .3.1.4l2.6 3.2h.7l5.4-4c.2-.2.2-.5.1-.7l-2.3-3.1c-.1-.2-.4-.3-.5-.1h-.4c-.5-2-.5-4 .1-6 .1-.4 0-.9-.2-1.3h6.7c.2 0 .5-.2.5-.4s-.3-.4-.5-.4h-1.6c-.3-5.3-4.3-9.8-9.6-10.6zm-2.8-1.2c0-.5.4-.9.9-.9s.9.4 1 .9v1h-1.9v-1zm7.8 21 1.8 2.4-4.7 3.5-2.1-2.4 5-3.5zm-1.2-.3-3.6 2.6-.4-.6c-1.3-1.7-2.7-3.3-4.4-4.6l-5.5-4.4c-.2-.2-.2-.5 0-.6.1-.1.4-.1.5 0l6.2 5.3c.2.2.5.2.6 0 .2-.2.2-.5 0-.7l-4.7-4c-.2-.2-.2-.5 0-.7l.1-.1h.6l4.6 3.8c1.4 1.1 3.8 1 4.4-1.1l.7-2.1c0-.2.3-.4.5-.4.3.1.5.4.4.7-.7 2.2-.7 4.6 0 6.9zm-1.8-7.5-.7 2.1c-.4 1.4-1.9 1.4-2.9.6l-3.9-3.1h7.6c0 .2-.1.2-.1.4zm6.6-1.3H11.8c.1-2.6 1.2-5 3-6.9 2.1-2.1 5-3.1 8-3 5.6-.1 10.1 4.3 10.4 9.9z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "m26.7 36.3 4.7-3.5-1.8-2.4-5 3.5 2.1 2.4zm.1-2.7c.4 0 .6.2.6.5v.2c-.1.3-.3.4-.6.4s-.5-.2-.5-.6c0-.2.2-.5.5-.5z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M28 22.4c-.2 0-.5.2-.5.4l-.7 2.1c-.6 2.1-3 2.2-4.4 1.1l-4.6-3.8h-.6l-.1.1c-.2.2-.2.5 0 .7l4.7 4c.2.2.2.5 0 .7-.1.2-.4.2-.6 0L15 22.4c-.1-.1-.4-.1-.5 0-.2.1-.2.4 0 .6l5.5 4.4c1.7 1.3 3.1 2.9 4.4 4.6l.4.6 3.6-2.6c-.7-2.3-.7-4.6 0-6.9.1-.3-.1-.6-.4-.7z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M23.7 9.4c-.1-.5-.5-.9-1-.9s-.9.4-.9.9v1h1.9v-1z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M22.8 11.4c-3-.1-5.9.9-8 3-1.8 1.9-2.9 4.3-3 6.9h21.4c-.3-5.6-4.8-10-10.4-9.9zm-9.3 8.7c-.3-.1-.5-.3-.4-.6 1-4 4.5-6.9 8.6-7.1.2 0 .5.2.5.4 0 .3-.2.5-.5.5-3.7.2-6.8 2.8-7.7 6.4 0 .4-.3.4-.5.4z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M21.7 13.4c.3 0 .5-.2.5-.5 0-.2-.3-.4-.5-.4-4.1.2-7.6 3.1-8.6 7.1-.1.3.1.5.4.6.2 0 .5-.1.5-.4.9-3.6 4-6.2 7.7-6.4zM26.8 34.8c.3.1.5-.1.6-.4v-.2c0-.3-.2-.5-.6-.5-.3 0-.5.2-.5.5 0 .4.2.6.5.6z"
  }))), _view19 || (_view19 = /*#__PURE__*/React.createElement("view", {
    id: "ceiling-repairs",
    viewBox: "180 90 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 180,
    y: 90,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfe6ec",
    d: "M4 5.5h37V11H4z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.5V11m22-5.5V11",
    fill: "none",
    stroke: "#b4bfc6"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c6870",
    d: "M18 5.5h8V11h-8z"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 10.5,
    width: 8.5,
    height: 5.5,
    rx: 0.5,
    fill: "#eef1f5",
    transform: "rotate(18 18 11)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 36 19 13.5",
    fill: "none",
    stroke: "#e8923a",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 36 20 13.5",
    fill: "none",
    stroke: "#d0731f",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M15 30h8.3M16.2 25h6.2M17.4 20h4.1",
    fill: "none",
    stroke: "#e8923a",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 36,
    width: 39,
    height: 1.5,
    rx: 0.75,
    fill: "#c3ccd2"
  }))), _view20 || (_view20 = /*#__PURE__*/React.createElement("view", {
    id: "ceiling-roof",
    viewBox: "180 135 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 180,
    y: 135,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#c3ccd2",
    d: "M8 17h29v23H8z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#8fb6c9",
    d: "M11 20.5h4.2v3.8H11zM17.4 20.5h4.2v3.8h-4.2zM23.8 20.5H28v3.8h-4.2zM30.2 20.5h4.2v3.8h-4.2zM11 27h4.2v3.8H11zM17.4 27h4.2v3.8h-4.2zM23.8 27H28v3.8h-4.2zM30.2 27h4.2v3.8h-4.2zM11 33.5h4.2v3.8H11zM17.4 33.5h4.2v3.8h-4.2zM23.8 33.5H28v3.8h-4.2zM30.2 33.5h4.2v3.8h-4.2z"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 14.5,
    width: 32,
    height: 2.6,
    rx: 1,
    fill: "#5f7d95"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 8.5,
    width: 10.5,
    height: 6,
    rx: 1,
    fill: "#dfe6ec"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 10v3M15.7 10v3M18.2 10v3",
    fill: "none",
    stroke: "#9aa7b0"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#8f9ba3",
    d: "M27.5 9.8h2.6v4.7h-2.6z"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 8.6,
    width: 4.8,
    height: 1.6,
    rx: 0.8,
    fill: "#8f9ba3"
  }))), _view21 || (_view21 = /*#__PURE__*/React.createElement("view", {
    id: "chemicals",
    viewBox: "0 180 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    y: 180,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M7.3 35c-.3.5-.3 1 0 1.5s.8.8 1.4.8H20c.3 0 .6-.1.9-.3.4.2.8.3 1.3.3 1.1 0 2.1-.5 2.8-1.3.6.5 1.3 1 2.1 1.3h6.1c3.8-1.4 5.7-5.6 4.3-9.4-.8-2-2.3-3.6-4.4-4.3v-7.4c.6-.1 1-.6 1-1.2.1-.7-.5-1.3-1.2-1.4H27.5c-.7 0-1.3.6-1.3 1.3v.1c0 .6.4 1.1 1 1.2v7.4l-1.3.7v-14c.5-.2.8-.7.8-1.3 0-.7-.6-1.3-1.3-1.3h-6.5c-.7 0-1.3.6-1.3 1.3 0 .6.3 1.1.8 1.3v17.1l-1.6-4.1v-3.7c.6-.1 1.1-.6 1.1-1.2 0-.7-.6-1.3-1.3-1.3h-4.5c-.7 0-1.3.6-1.3 1.3 0 .7.5 1.2 1.2 1.2v3.7L7.3 35zm.6.3 2.2-5.5c.7 0 1.4-.2 2-.6l1.2-.5c1.2-.2 2.3.6 3.6 1l1.8.4 2.1 5.2c.2.2.2.6 0 .8-.2.3-.5.5-.8.5H8.7c-.3 0-.6-.2-.8-.5-.1-.3-.1-.5 0-.8zM33 36.6h-5.7c-2.2-.9-3.8-2.9-4.1-5.3 4.9 1.9 5.5-3.7 14-1.6.3 3-1.4 5.8-4.2 6.9zm-9.5-8.3c2.2-.2 4.3.2 6.2 1.3-1.4.6-3.6 2.6-6.5 1.3-.1-.9 0-1.8.3-2.6zM26.9 15c0-.4.3-.6.6-.7h5.3c.4 0 .6.3.6.7 0 .3-.3.6-.6.6h-5.3c-.3 0-.6-.3-.6-.6zm1 1.3h4.5v7.5c0 .2.1.3.3.3 2.3.9 4 2.9 4.4 5.3-2.3-.7-4.7-.6-7 .1-2-1.2-4.2-1.7-6.5-1.6.8-1.8 2.3-3.1 4.1-3.8.1 0 .2-.1.2-.3v-7.5zm-2.7 8.5c-3.1 2.4-3.7 6.8-1.4 9.9.2.3.4.5.7.8-.6.7-1.4 1-2.3 1.1h-.8c.3-.5.3-1 .1-1.5l-2.4-5.9v-9.3c1 .4 2 .5 3.1.5 1 0 2-.1 3-.5v4.9zm-3-6.1c1 0 2 .1 3 .5v.3c-1 .4-2 .5-3 .5-1.1.1-2.1-.1-3.1-.5v-.3c1-.4 2-.6 3.1-.5zm3 .1c-1-.3-2-.4-3-.4s-2.1.1-3.1.4v-8.4h6.1v8.4zM18.3 9c0-.3.3-.6.6-.6h6.5c.3 0 .6.3.6.6 0 .4-.3.6-.6.7h-6.5c-.3-.1-.6-.3-.6-.7zm-2.2 14.4 2.5 6.3c-.5 0-1.1-.1-1.6-.3-1.2-.4-2.5-1.3-3.8-1l-1.2.5c-.6.3-1.2.5-1.8.6l2.4-6v-3.9h3.5v3.8zm-4.6-5c0-.3.3-.6.6-.6h4.5c.3-.1.5.1.6.4v.2c0 .3-.2.5-.6.5h-4.5c-.3 0-.6-.2-.6-.5z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M8.7 36.6H20c.3 0 .6-.2.8-.5.2-.2.2-.6 0-.8l-2.1-5.2-1.8-.4c-1.3-.4-2.4-1.2-3.6-1l-1.2.5c-.6.4-1.3.6-2 .6l-2.2 5.5c-.1.3-.1.5 0 .8.2.3.5.5.8.5zm3.1-1.6c-.3 0-.6-.3-.6-.6s.3-.6.6-.6.6.3.6.6-.3.6-.6.6zm6.4-3.1c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4.2-.4.4-.4zM16.1 33c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-2.5-2.5c.3 0 .6.3.6.6.1.3-.1.5-.4.6h-.2c-.3 0-.6-.3-.6-.6s.3-.6.6-.6zm.6 3.1c0 .2-.2.4-.4.4s-.3-.2-.3-.4.1-.3.3-.3c.2 0 .4.1.4.3zm1.8 1.9c-.2 0-.4-.3-.4-.5s.2-.5.4-.5c.3 0 .5.2.5.5s-.2.5-.5.5zm-4.9-4.2c.2 0 .3.2.3.4s-.1.3-.3.3c-.2 0-.4-.1-.4-.3 0-.2.2-.4.4-.4z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M18.9 9.7h6.5c.3-.1.6-.3.6-.7 0-.3-.3-.6-.6-.6h-6.5c-.3 0-.6.3-.6.6 0 .4.3.6.6.7z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19.1 10.4v8.4c1-.3 2.1-.4 3.1-.4s2 .1 3 .4v-8.4h-6.1zM12.6 19.6v3.8l-2.4 6c.6-.1 1.2-.3 1.8-.6l1.2-.5c1.3-.3 2.6.6 3.8 1 .5.2 1.1.3 1.6.3l-2.5-6.1v-3.9h-3.5z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0451E",
    d: "M19.1 19.2v.3c1 .4 2 .6 3.1.5 1 0 2-.1 3-.5v-.3c-1-.4-2-.5-3-.5-1.1-.1-2.1.1-3.1.5z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M22.2 20.4c-1.1 0-2.1-.1-3.1-.5v9.3l2.4 5.8c.2.5.2 1-.1 1.5h.8c.9-.1 1.7-.4 2.3-1.1-2.8-2.8-2.8-7.3-.1-10 .2-.2.5-.5.8-.7v-4.8c-1 .4-2 .5-3 .5zm-1.9 2.1c0-.3.3-.6.6-.6s.5.2.5.6c0 .3-.2.5-.5.5s-.6-.2-.6-.5zm1.1 3.9c-.3 0-.5-.2-.5-.5s.2-.6.5-.6.6.3.6.6-.3.5-.6.5zm.6 2c0 .3-.3.6-.6.6s-.5-.3-.5-.6.2-.5.5-.5.6.2.6.5zm-.3 2.7c.3 0 .5.2.5.5s-.2.5-.5.5-.5-.2-.5-.5.2-.5.5-.5zm1.1 3c0 .2-.1.3-.3.3-.2 0-.3-.1-.3-.3 0-.2.1-.3.3-.3.2 0 .3.1.3.3zm.9-9.9c0 .4-.2.6-.5.6s-.6-.3-.6-.6.3-.5.6-.5.5.2.5.5z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M16.6 18.9c.4 0 .6-.2.6-.5.1-.3-.1-.5-.4-.6h-4.7c-.3 0-.6.3-.6.6s.3.5.6.5h4.5zM32.8 15.6c.3 0 .6-.3.6-.6 0-.4-.2-.7-.6-.7h-5.3c-.3.1-.6.3-.6.7 0 .3.3.6.6.6h5.3z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M27.7 24.1c-1.8.7-3.3 2-4.1 3.8 2.3-.1 4.5.4 6.5 1.6 2.3-.7 4.7-.8 7-.1-.4-2.4-2.1-4.4-4.4-5.3-.2 0-.3-.1-.3-.3v-7.5h-4.5v7.5c0 .2-.1.3-.2.3z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E98C0",
    d: "M29.7 29.6c-1.9-1.1-4-1.5-6.2-1.3-.3.8-.4 1.7-.3 2.6 2.9 1.3 5.1-.7 6.5-1.3z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M23.2 31.3c.3 2.4 1.9 4.4 4.1 5.3H33c2.8-1.1 4.5-3.9 4.2-6.9-8.5-2.1-9.1 3.5-14 1.6zm10.9-.5c.3 0 .6.3.6.6s-.3.5-.6.5-.5-.2-.5-.5.2-.6.5-.6zm-1 3.4c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4.2-.4.4-.4zm-2.4-2.6c.2 0 .4.1.4.3 0 .2-.2.4-.4.4s-.3-.2-.3-.4.1-.3.3-.3zm-.8 2.3c.4 0 .7.3.7.7 0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7zm-2-1.6c.3 0 .5.2.5.5s-.2.6-.5.6-.6-.3-.6-.6.3-.5.6-.5zm-1.6 2.2c0-.3.2-.5.5-.5s.5.2.5.5-.2.5-.5.5-.5-.2-.5-.5z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.1 32c.2 0 .3-.1.3-.3 0-.2-.1-.4-.3-.4-.2 0-.4.2-.4.4s.2.3.4.3zM21.4 22.5c0-.4-.2-.6-.5-.6s-.6.3-.6.6.3.5.6.5.5-.2.5-.5zM16.1 32c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.2-.5-.5-.5zM23.2 23.7c-.3 0-.6.2-.6.5s.3.6.6.6.5-.2.5-.6c0-.3-.2-.5-.5-.5zM27.3 34.5c0-.3-.2-.5-.5-.5s-.5.2-.5.5.2.5.5.5.5-.2.5-.5zM27.9 33.4c.3 0 .5-.3.5-.6s-.2-.5-.5-.5-.6.2-.6.5.3.6.6.6z"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 13.8,
    cy: 33.6,
    r: 0.4
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 21.4,
    cy: 25.9,
    r: 0.5
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.7 32.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5-.5.2-.5.5.2.5.5.5zM29.2 34.6c0 .4.3.7.7.7s.7-.3.7-.7-.3-.7-.7-.7-.7.3-.7.7zM13.6 31.7c.3.1.5-.1.6-.4v-.2c0-.3-.3-.6-.6-.6s-.6.3-.6.6.3.6.6.6zM12.4 34.4c0-.3-.3-.6-.6-.6s-.6.3-.6.6.3.6.6.6.6-.3.6-.6zM16 34.5c-.2 0-.4.3-.4.5s.2.5.4.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM18.2 32.7c.2 0 .4-.2.4-.4s-.2-.4-.4-.4-.4.2-.4.4.2.4.4.4zM21.4 27.9c-.3 0-.5.2-.5.5s.2.6.5.6.6-.3.6-.6-.3-.5-.6-.5zM22.2 34.1c0 .2.1.3.3.3s.3-.1.3-.3c0-.2-.1-.3-.3-.3-.2 0-.3.1-.3.3zM34.1 31.9c.3 0 .6-.2.6-.5s-.3-.6-.6-.6-.5.3-.5.6.2.5.5.5zM30.7 32.3c.2 0 .4-.2.4-.4s-.2-.3-.4-.3-.3.1-.3.3c0 .2.1.4.3.4zM32.6 34.6c0 .2.3.4.5.4s.4-.2.4-.4-.2-.4-.4-.4-.5.2-.5.4z"
  }))), _view22 || (_view22 = /*#__PURE__*/React.createElement("view", {
    id: "cleaning",
    viewBox: "45 180 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 45,
    y: 180,
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-406.1-169.8h612v1185h-612z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-406.1-169.8h612v1185h-612z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-406.1-169.8h612v1185h-612z"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M-406.1-169.8h612v1185h-612z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106107048690205286000000018352664977446084270_"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000106107048690205286000000018352664977446084270_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M20 39.8h9.5c.2 0 .5-.1.6-.3.2-.3.1-.7-.2-.8-2.3-2.1-1.8-4.5-1.3-6.8s.9-4.3-1.1-5.8c.2-.4.2-.9.2-1.4 0-1-.8-1.8-1.8-1.9V7.5c0-1.3-1-2.3-2.3-2.3h-1c-1.2.1-2.2 1.1-2.1 2.3v15.3c-1 .1-1.8.9-1.8 1.9 0 .4 0 .8.2 1.2-2.5 1.5-4 5.4-4 8.6s1.7 5.3 5.1 5.3zm1.7-32.3c0-.6.4-1 1-1.1h.9c.6 0 1.1.5 1.1 1.1v15.3h-3V7.5zm-2 19.4h6.8c1.7 1.1 1.4 2.5.9 4.7s-1 4.6.7 7h-.9c-.9-.8-1.5-1.8-1.8-3-.3-1.4-.2-2.9.3-4.2.3-.8-.8-1.3-1.1-.5-.7 1.6-.8 3.3-.4 5 .2 1 .6 1.9 1.3 2.7h-2.8c-.7-1.4-1-3-1-4.6 0-2 .8-4.1 1.3-4.7s.2-1.9-.9-.8c-1.1 1.1-1.7 3.3-1.6 5.5-.1 1.6.2 3.2.9 4.6h-1.8c-.7-.9-1.1-1.9-1.2-3 0-1.5.2-2.9.7-4.3.3-.7-.9-1.1-1.2-.3-.5 1.5-.7 3.1-.7 4.7.1.8.3 1.6.6 2.4-1.2-.8-1.8-2.2-1.7-3.6 0-2.3 1.4-6.9 3.6-7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M16.1 34.5c-.1 1.4.5 2.8 1.7 3.6-.3-.8-.5-1.6-.6-2.4 0-1.6.2-3.2.7-4.7.3-.8 1.5-.4 1.2.3-.5 1.4-.7 2.8-.7 4.3.1 1.1.5 2.1 1.2 3h1.8c-.7-1.4-1-3-.9-4.6-.1-2.2.5-4.4 1.6-5.5 1.1-1.1 1.4.2.9.8S21.7 32 21.7 34c0 1.6.3 3.2 1 4.6h2.8c-.7-.8-1.1-1.7-1.3-2.7-.4-1.7-.3-3.4.4-5 .3-.8 1.4-.3 1.1.5-.5 1.3-.6 2.8-.3 4.2.3 1.2.9 2.2 1.8 3h.9c-1.7-2.4-1.2-4.8-.7-7s.8-3.6-.9-4.7h-6.8c-2.2.7-3.6 5.3-3.6 7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M24.7 22.8V7.5c0-.6-.5-1.1-1.1-1.1h-.9c-.6.1-1 .5-1 1.1v15.3h3z"
  })))), _view23 || (_view23 = /*#__PURE__*/React.createElement("view", {
    id: "clipboard",
    viewBox: "90 180 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 90,
    y: 180,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M9.5 38.3c.1 1 .9 1.7 1.9 1.7h22.2c1 0 1.8-.7 1.9-1.7V9.6c-.1-1-.9-1.8-1.9-1.7h-1.9l-1-1.4h-.3c-1 .1-3.8.4-4.6.1l-.6-.7c-.3-.5-.6-.9-1.1-.9h-3.2c-.5 0-.8.4-1.1.9s-.4.5-.6.6-3.6 0-4.6-.1h-.3l-1 1.4h-1.9c-1-.1-1.8.7-1.9 1.7v28.8zM14.7 7c.8.1 3.7.4 4.8 0s.5-.5.8-.8l.6-.6h3.2l.6.6c.3.3.5.7.8.8s4 .1 4.8 0c.6.7 1.1 1.5 1.6 2.3H13.1c.5-.8 1-1.6 1.6-2.3zm-3.3 1.4h1.5c-.3.6-.5 1-.4 1.2.1.2.3.3.5.3h19c.2 0 .4-.1.5-.3.1-.2-.1-.6-.4-1.2h1.5c.7 0 1.2.5 1.3 1.2v28.7c-.1.7-.6 1.2-1.3 1.1H11.4c-.7.1-1.2-.4-1.3-1.1V9.6c.1-.7.6-1.2 1.3-1.2z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M31.9 9.3c-.5-.8-1-1.6-1.6-2.3-.8.1-3.7.4-4.8 0-1.1-.4-.5-.5-.8-.8l-.6-.6h-3.2l-.6.6c-.3.3-.5.7-.8.8-.3.1-4 .1-4.8 0-.6.7-1.1 1.5-1.6 2.3h18.8zm-9.4-3.2c.6 0 1.1.5 1.1 1.1 0 .6-.5 1.1-1.1 1.1-.6 0-1.1-.5-1.1-1.1 0-.6.5-1.1 1.1-1.1z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.1 38.3c.1.7.6 1.2 1.3 1.1h22.2c.7.1 1.2-.4 1.3-1.1V9.6c-.1-.7-.6-1.2-1.3-1.2h-1.5c.3.6.5 1 .4 1.2-.1.2-.3.3-.5.3H13c-.2 0-.4-.1-.5-.3-.1-.2.1-.6.4-1.2h-1.5c-.7 0-1.2.5-1.3 1.2v28.7z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.5 8.2c.6 0 1-.4 1.1-1 0-.6-.5-1.1-1.1-1.1-.6 0-1.1.5-1.1 1.1.1.6.5 1 1.1 1zm0-1.5c.3 0 .5.2.5.5s-.2.5-.5.5-.5-.2-.5-.5.2-.5.5-.5z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22.5 7.6c.2 0 .5-.2.5-.4 0-.3-.2-.5-.5-.5s-.5.2-.5.5c0 .2.3.4.5.4z"
  }))), _view24 || (_view24 = /*#__PURE__*/React.createElement("view", {
    id: "coffee",
    viewBox: "135 180 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 135,
    y: 180,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M33.5 7.9h-1v-.2c.1-1.2-.8-2.1-2-2.2H14.7c-1.2 0-2.1.9-2.1 2.1V8h-1c-.9-.1-1.6.6-1.7 1.5V10.3c0 .4.4.8.8.8h23.7c.4 0 .8-.4.8-.8v-.7c-.1-.9-.8-1.7-1.7-1.7zM32.5 11.8H12.6l-.6.3c-.1.1-.2.3-.1.5l2.4 26.2c0 .4.3.7.7.7h15.1c.4 0 .7-.3.7-.7l2.5-26.2c0-.2-.1-.4-.2-.5l-.6-.3zm-3.1 26.3H15.7l-.7-7.2h15.1l-.7 7.2zm.7-8.7H14.8l-.7-7.5h16.8l-.8 7.5zm.9-8.9H14l-.7-7.2h18.5l-.8 7.2z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.8 29.4h15.4l.7-7.5H14.1l.7 7.5zm7.7-6.2c1.7 0 3.1.7 3.5 1.8s-.1.2-.1.1l-1.6-.2c-.7 0-1.3.1-1.9.4-1 .4-2.2.5-3.2.1-.1 0-.2-.1-.1-.3 0-.2 1.7-1.9 3.4-1.9zm-3.3 3 1.5.2c.7 0 1.4-.1 2-.4 1-.4 2.1-.5 3.1-.1.1 0 .2.2.2.3s-1.8 2-3.5 2c-1.4.1-2.8-.6-3.4-1.9-.1-.1-.1-.2.1-.1zM15.7 38.1h13.7l.7-7.2H15zM14 20.5h17.1l.7-7.2H13.2z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M22.5 28.2c1.7 0 3.2-.9 3.5-2 .3-1.1-.1-.3-.2-.3-1-.4-2.1-.3-3.1.1-.6.3-1.3.4-2 .4l-1.5-.2c-.1-.1-.1 0-.1.1.6 1.3 1.9 2 3.4 1.9zM19.2 25.4c1 .4 2.2.3 3.2-.1.6-.3 1.2-.4 1.9-.4l1.6.2c0 .1.1 0 .1-.1s-1.8-1.8-3.5-1.8-3.1.8-3.4 1.9-.1.3.1.3z"
  }))), _view25 || (_view25 = /*#__PURE__*/React.createElement("view", {
    id: "coffee_machine",
    viewBox: "180 180 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 180,
    y: 180,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M33.5 7.9h-1v-.2c.1-1.2-.8-2.1-2-2.2H14.7c-1.2 0-2.1.9-2.1 2.1V8h-1c-.9-.1-1.6.6-1.7 1.5V10.3c0 .4.4.8.8.8h23.7c.4 0 .8-.4.8-.8v-.7c-.1-.9-.8-1.7-1.7-1.7zM32.5 11.8H12.6l-.6.3c-.1.1-.2.3-.1.5l2.4 26.2c0 .4.3.7.7.7h15.1c.4 0 .7-.3.7-.7l2.5-26.2c0-.2-.1-.4-.2-.5l-.6-.3zm-3.1 26.3H15.7l-.7-7.2h15.1l-.7 7.2zm.7-8.7H14.8l-.7-7.5h16.8l-.8 7.5zm.9-8.9H14l-.7-7.2h18.5l-.8 7.2z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.8 29.4h15.4l.7-7.5H14.1l.7 7.5zm7.7-6.2c1.7 0 3.1.7 3.5 1.8s-.1.2-.1.1l-1.6-.2c-.7 0-1.3.1-1.9.4-1 .4-2.2.5-3.2.1-.1 0-.2-.1-.1-.3 0-.2 1.7-1.9 3.4-1.9zm-3.3 3 1.5.2c.7 0 1.4-.1 2-.4 1-.4 2.1-.5 3.1-.1.1 0 .2.2.2.3s-1.8 2-3.5 2c-1.4.1-2.8-.6-3.4-1.9-.1-.1-.1-.2.1-.1zM15.7 38.1h13.7l.7-7.2H15zM14 20.5h17.1l.7-7.2H13.2z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M22.5 28.2c1.7 0 3.2-.9 3.5-2 .3-1.1-.1-.3-.2-.3-1-.4-2.1-.3-3.1.1-.6.3-1.3.4-2 .4l-1.5-.2c-.1-.1-.1 0-.1.1.6 1.3 1.9 2 3.4 1.9zM19.2 25.4c1 .4 2.2.3 3.2-.1.6-.3 1.2-.4 1.9-.4l1.6.2c0 .1.1 0 .1-.1s-1.8-1.8-3.5-1.8-3.1.8-3.4 1.9-.1.3.1.3z"
  }))), _view26 || (_view26 = /*#__PURE__*/React.createElement("view", {
    id: "cold",
    viewBox: "225 0 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 225,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24.2 11c0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3v13.4c0 .2-.1.5-.3.6-2.9 1.4-4.1 5-2.7 7.9s5 4.1 7.9 2.7c2.9-1.4 4.1-5 2.7-7.9-.6-1.2-1.5-2.1-2.7-2.7-.2-.1-.3-.4-.3-.6V11zm1.7 19.3c0 2.2-1.8 3.9-3.9 3.9s-3.9-1.8-3.9-3.9c0-1.9 1.4-3.5 3.3-3.8v-3.6c0-.3.3-.6.6-.6s.6.3.6.6v3.6c1.9.2 3.3 1.9 3.3 3.8z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M25.4 11c0-1.9-1.5-3.4-3.4-3.4s-3.4 1.5-3.5 3.4v13.1c-3.4 1.9-4.6 6.3-2.7 9.7 1.9 3.4 6.3 4.6 9.7 2.7 2.2-1.3 3.6-3.6 3.6-6.2s-1.4-5-3.7-6.2V11zm-.9 14c2.9 1.4 4.1 5 2.7 7.9s-5 4.1-7.9 2.7c-2.9-1.4-4.1-5-2.7-7.9.6-1.2 1.5-2.1 2.7-2.7.2-.1.3-.4.3-.6V11c0-1.3 1-2.3 2.3-2.3 1.3 0 2.3 1 2.3 2.3v13.4c0 .2.1.5.3.6z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M22.5 22.8c0-.3-.3-.6-.6-.6s-.6.3-.6.6v3.6c-2.1.3-3.6 2.3-3.3 4.5s2.3 3.6 4.5 3.3 3.6-2.3 3.3-4.5c-.3-1.7-1.6-3-3.3-3.3v-3.6z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M29.5 9.7H27c-.3 0-.6.3-.6.6s.3.6.6.6h2.6c.3 0 .6-.3.6-.6s-.3-.6-.7-.6zM28.4 12.6H27c-.3 0-.6.3-.6.6s.3.6.6.6h1.4c.3 0 .6-.3.6-.6s-.3-.6-.6-.6zM29.5 15.4H27c-.3 0-.6.3-.6.6s.3.6.6.6h2.6c.3 0 .6-.3.6-.6s-.3-.6-.7-.6c.1 0 .1 0 0 0zM27 19.5h1.4c.3 0 .6-.3.6-.6s-.3-.6-.6-.6H27c-.3 0-.6.3-.6.6s.2.6.6.6zM29.5 21.1H27c-.3 0-.6.3-.6.6s.3.6.6.6h2.6c.3 0 .6-.3.6-.6-.1-.3-.3-.6-.7-.6z"
  }))), _view27 || (_view27 = /*#__PURE__*/React.createElement("view", {
    id: "conf-rooms",
    viewBox: "225 45 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 225,
    y: 45,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 11,
    r: 2.7,
    fill: "#3c4652"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 11,
    r: 2.7,
    fill: "#3c4652"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 33,
    r: 2.7,
    fill: "#3c4652"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 33,
    r: 2.7,
    fill: "#3c4652"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 22,
    r: 2.7,
    fill: "#3c4652"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 22,
    r: 2.7,
    fill: "#3c4652"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.5,
    cy: 22,
    rx: 13.5,
    ry: 8,
    fill: "#c8925a"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.5,
    cy: 22,
    rx: 10.5,
    ry: 5.6,
    fill: "#d99a3f"
  }))), _view28 || (_view28 = /*#__PURE__*/React.createElement("view", {
    id: "conf_room",
    viewBox: "225 90 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 225,
    y: 90,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M3.9 18c.5 1.5 1.8 8.8 1.9 9.1s.4.9 2.8 1.3V31l-2.3-.9c-.2-.1-.4 0-.5.2-.1.2-.1.3 0 .5v.3c0 .3.3.5.6.5.2 0 .4-.2.4-.4l1.3.5-2 .8c-.2.1-.3.3-.2.5v.1c0 .1-.1.2-.1.3 0 .3.3.5.6.5s.5-.2.5-.5c0-.1 0-.1-.1-.2l2.5-1 2.5.9v.2c0 .3.2.5.5.5s.5-.2.5-.5V33c.1-.2.1-.4-.1-.6h-.1l-2-.8 1.1-.6c.1.1.2.2.4.2.3 0 .5-.2.5-.5.1-.1.1-.3 0-.4-.1-.2-.3-.3-.5-.2l-2.3.9v-2.6h.2l.5.2.4.2c1.2.5 2.4.8 3.6 1 .6.5 1.2 1 1.2 1.8v4s.6 1.4 6.9 1.4 7-1.4 7-1.4v-4c.1-.7.5-1.3 1.1-1.7 1.4-.2 2.7-.6 4-1.1h.2V31l-2.3-.9c-.2-.1-.5 0-.5.2-.1.2-.1.3 0 .5v.3c0 .3.2.5.5.5.2 0 .5-.2.5-.4l1.3.5-2 .8c-.2.1-.3.3-.2.5v.1c0 .1-.1.2-.1.3 0 .3.2.5.5.5s.5-.2.5-.5v-.2l2.5-1 2.4.8v.2c0 .3.2.5.5.5s.5-.2.5-.5V33c.1-.2.1-.4-.1-.6h-.1l-2.1-.8 1.4-.6c.1.2.2.2.4.2.3 0 .5-.2.5-.5 0-.1.1-.3 0-.4-.1-.2-.3-.3-.5-.2l-2.3.9v-2.7c2.7-.3 3.1-1.3 3.1-1.3s1.4-7.6 1.9-9.1c.4-1 .2-2-.5-2.8-.4-.4-2.6-.5-4.1-.5h-.9c-.9.1-1.6.7-1.8 1.6-.1.6-.5 2.2-.8 3.2v-.2l-.2-.2c.3-1 .7-2.3.8-2.8.1-1.1 1-1.9 2.1-2h.6c.2-.6.1-1.2-.3-1.7-.3-.3-1.6-.4-3.7-.4h-.5c-.7 0-1.3.6-1.3 1.3l-.6 2v-.2h-.2l.5-1.7c.1-.4.6-1.6 1.7-1.6h.5c.1-.5 0-1-.3-1.4-.4-.4-2.6-.6-3.4-.6s-1.1.8-1.2 1.2c-.1.4-.2.9-.3 1.3l-1.6-.6V9.4c0-.8-1.5-1.5-3.2-1.5s-3.2.7-3.2 1.5v2.4l-1.4.5c-.1-.4-.2-1-.3-1.3-.1-.3-.4-1.2-1.2-1.2-.8 0-3 .2-3.4.6-.3.4-.4.9-.3 1.4h.5c1.2 0 1.6 1.2 1.7 1.6l.5 1.6-.2.2v.2c-.2-.6-.4-1.3-.5-1.9-.1-.4-.5-1.3-1.4-1.3h-.5c-2.2 0-3.5.1-3.8.4-.4.5-.5 1.1-.3 1.7h.6c1.1.1 2 .9 2.1 2 .1.5.5 1.8.8 2.8H12v.2c-.3-1-.7-2.5-.8-3.1-.2-.9-1-1.5-1.9-1.5h-.9c-1.5 0-3.7.1-4.1.5-.7.7-.8 1.8-.4 2.8zM9 24.6h.1l2.6-3.5.8-1 2.4-3 .8-1.1 2-2.5c.4-.5 1.6-1.1 4.8-1.1s4.1.4 4.7 1.1l2.1 2.5.5.6 2.7 3.4.6.7 2.7 3.5h.1c.1.1.2.3.2.5-.6 1.4-7 3-13.6 3S9.6 26 9.1 24.7l-.1-.1z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22.5 28c6.6 0 13-1.6 13.6-3 0-.2-.1-.4-.2-.5h-.1L33.1 21l-.6-.7-2.7-3.4-.5-.6-2.1-2.7c-.6-.7-2.2-1.1-4.7-1.1s-4.4.6-4.8 1.1l-2 2.5-.8 1.1-2.4 3-.8 1-2.6 3.3c.5 1.6 6.5 3.5 13.4 3.5z"
  }))), _view29 || (_view29 = /*#__PURE__*/React.createElement("view", {
    id: "conf_room_equip",
    viewBox: "225 135 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 225,
    y: 135,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32.5 32.5c-.3-1.6-1.9-2.7-3.5-2.4-1.2.2-2.2 1.2-2.4 2.4-.4-.1-.7-.1-1.1 0-.3-1.6-1.9-2.7-3.5-2.4-1.2.2-2.2 1.2-2.4 2.4-.4-.1-.7-.1-1.1 0-.2-1.5-1.4-2.6-2.9-2.6s-2.8 1.1-3 2.6c-.8-.2-1.7.1-2.4.6-.7.6-1.1 1.4-1.1 2.3V37c0 .3.2.5.5.5h5c.3 0 .5-.2.5-.5v-1.5c0-.2 0-.3-.1-.5h1v2c0 .3.2.5.5.5h5c.3 0 .5-.2.5-.5v-1.5c0-.2-.1-.3-.1-.5H23v2c0 .3.2.5.5.5h4.9c.3 0 .5-.2.5-.5v-2H30c0 .2-.1.3-.1.5V37c0 .3.2.5.5.5h5c.3 0 .5-.2.5-.5v-1.5c0-.9-.4-1.7-1-2.3-.7-.6-1.6-.8-2.4-.7zm-3-1.5c1.1 0 1.9.8 2 1.9L30.3 34h-1.8c-.3-.4-.6-.8-1-1.1.1-1.1.9-1.9 2-1.9zm-7 0c1 .1 1.8.9 1.9 1.9-.4.3-.7.7-1 1.1h-1.8c-.3-.4-.7-.8-1.1-1.1.1-1.1 1-2 2-1.9zm-7 0c1 0 1.9.9 2 1.9-.5.3-.8.6-1.1 1.1h-1.8l-1.1-1.1c.1-1.1 1-2 2-1.9zM14 36.5h-4v-1c0-1.1.9-2 2-2s2 .9 2 2v1zm7 0h-4v-1c0-1.1.9-2 2-2s2 .9 2 2v1zm7-1v1h-4v-1c-.1-1 .7-1.9 1.8-2h.2c1 0 1.9.8 1.9 1.9.1 0 .1 0 .1.1zm7 0v1h-4v-1c0-1.1.9-2 2-2s2 .8 2 2z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M33 33.5c-1.1 0-2 .9-2 2v1h4v-1c0-1.2-.9-2-2-2zM12 33.5c-1.1 0-2 .9-2 2v1h4v-1c0-1.2-.8-2-2-2zM16.5 34c.3-.5.6-.8 1.1-1.1-.1-1-1-1.9-2-1.9-1.1 0-1.9.8-2 1.9l1.1 1.1h1.8zM19 33.5c-1.1 0-2 .9-2 2v1h4v-1c0-1.2-.8-2-2-2zM20.5 32.9c.4.3.8.7 1.1 1.1h1.8c.3-.4.6-.8 1-1.1-.1-1-.9-1.8-1.9-1.9-1-.1-1.9.8-2 1.9zM26 33.5h-.2c-1 .1-1.9 1-1.8 2v1h4v-1.1c0-1.1-.9-2-2-1.9zM27.5 32.9c.4.3.7.7 1 1.1h1.8l1.1-1.1c-.1-1.1-.9-1.9-2-1.9-1 0-1.8.8-1.9 1.9z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M37 7.5H8c-.2 0-.5.3-.5.5v2c0 .3.2.5.5.5h1V24c0 .3.2.5.5.5h9.2L19 26h-.4c-.2 0-.5.2-.5.4v2c0 .3.2.5.5.5h7.9c.3 0 .5-.2.5-.5v-2c0-.2-.3-.4-.5-.4H26l.3-1.5h9.1c.3 0 .5-.2.5-.5V10.5h1c.3 0 .5-.2.5-.5V8c.1-.2-.2-.5-.4-.5zM26 28h-7v-1h7v1zm-1-2h-5l-.8-5.5H26L25 26zm-7.9-7.5h10.7l-.2 1H17.4l-.3-1zm17.9 5h-8.5l.5-3h1c.2 0 .5-.2.5-.4l.5-2c.1-.2 0-.3-.1-.4-.1-.1-.2-.2-.4-.2h-1V16c0-.2 0-.3-.1-.4l-1-1c.1-.2.1-.4.1-.6 0-.8-.6-1.4-1.4-1.5-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5l.6-.2.8.9v1.3h-7.9v-1.3l.8-.9.7.2c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5-1.5.7-1.5 1.5c0 .2 0 .4.1.6l-1 1c-.1.1-.1.2-.1.4v1.5h-1c-.2 0-.3 0-.4.2-.2.3-.2.3-.2.5l.5 2c0 .2.3.4.5.4h1l.5 3H10v-13h25v12.9zM24.5 14c0-.3.2-.5.5-.5s.5.2.5.5-.2.5-.5.5-.5-.2-.5-.5zm-4.5-.5c.3 0 .5.2.5.5s-.2.5-.5.5-.5-.2-.5-.5c0-.2.3-.5.5-.5z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M26 20.5h-6.8L20 26h5l1-5.5zm-4 1h1v1h-1v-1zm-1 3v-1h3v1h-3z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22 21.5h1v1h-1zM21 23.5h3v1h-3z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M25.5 19.5h2.1l.2-1H17.1l.4 1h2zM19 27h7v1h-7z"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    fill: "#A1A1A1",
    cx: 25,
    cy: 14,
    r: 0.5
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    fill: "#A1A1A1",
    cx: 20,
    cy: 14,
    r: 0.5
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10 10.5v13h8.5l-.5-3h-1c-.2 0-.5-.2-.5-.4l-.5-2c0-.2 0-.2.1-.4s.2-.2.4-.2h1V16c0-.2 0-.3.1-.4l1-1c-.1-.2-.1-.4-.1-.6 0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5-.7 1.5-1.5 1.5l-.7-.2-.8.9v1.3h7.9v-1.3l-.8-.9-.6.2c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5c.8.1 1.4.7 1.4 1.5 0 .2 0 .4-.1.6l1 1c.1.1.1.2.1.4v1.5h1c.2 0 .3.1.4.2.2.2.2.3.2.5l-.5 2c0 .2-.3.4-.5.4h-1l-.5 3H35v-13H10z"
  }))), _view30 || (_view30 = /*#__PURE__*/React.createElement("view", {
    id: "cubicles",
    viewBox: "225 180 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 225,
    y: 180,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#505050"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8 7.7c-1.6 0-2.9 1.3-2.9 2.9s1.3 2.9 2.9 2.9 2.9-1.3 2.9-2.9-1.3-2.9-2.9-2.9zM13.5 8.5h1.8V20h-1.8zM24.7 14.3c-2.8.1-3.3 4-3.4 5.8h11.1c-.8-2-3-6-7.7-5.8zM4 37.3h37v-2.1h-4.6V21.4H8.8v13.8H4zM20.5 20.1c0-.9-.7-1.7-1.7-1.7h-.2c-.9-.1-1.8.6-1.9 1.5v.2h3.8z"
  })))), _view31 || (_view31 = /*#__PURE__*/React.createElement("view", {
    id: "default",
    viewBox: "0 225 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    y: 225,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.117,
    y1: 167.46,
    x2: 149.117,
    y2: 216.73,
    gradientTransform: "matrix(.5 0 0 .5 -52.06 -75.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e9e9e9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#e9e9e9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#e7e7e7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#e7e6e7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#e4e4e4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#e4e4e4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#e3e3e3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#e3e2e3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#e2e2e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#dfdfdf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#dfdedf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#dedede"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#ddd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#ddd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#dcdcdc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#dcdbdc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#dbdadb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#d8d8d8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#d8d7d8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#d7d7d7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#d7d6d7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#d6d6d6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#d5d5d5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#d5d5d5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#d4d3d4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#d3d3d3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#d3d2d3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#d2d2d2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#d0d0d0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#d0cfd0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#cfcecf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#cecece"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#cdcdcd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#cdcccd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#cccbcc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#cbcbcb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#cbcacb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#cacaca"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#c9c9c9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#c9c8c9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#c8c8c8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#c8c7c8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#c7c6c7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#c5c4c5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#c4c3c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#c3c3c3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#c3c2c3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#c2c2c2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#c2c1c2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#c1c0c1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "silver"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#c0bfc0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#bfbebf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#bebdbe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#bebdbe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#bdbcbd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#bcbcbc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#bcbbbc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#bbb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#bbbabb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#bab9ba"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#bab9ba"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#b9b8b9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#b8b8b8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#b8b7b8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#b7b7b7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#b7b6b7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#b6b5b6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#b6b5b6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#b5b4b5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#b4b4b4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#b4b3b4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#b3b2b3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#b2b1b2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#b2b1b2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#b1b0b1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#b0b0b0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#b0afb0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#afaeaf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#afaeaf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#aeadae"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#aeadae"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#adacad"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#acacac"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#acabac"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#abaaab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#abaaab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#aaa9aa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#aaa9aa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#a9a8a9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#a8a7a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#a7a6a7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#a7a6a7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#a6a5a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#a6a5a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#a5a4a5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#a4a4a4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#a4a3a4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#a3a2a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#a3a2a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#a2a1a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#a2a1a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#a1a0a1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a09fa0"
    }
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M12.4 25c-.7-1.6-1-3.4-.8-5.1.1-1.7.6-3.3 1.5-4.7.8-1.3 1.9-2.5 3.2-3.4 1.4-.9 2.9-1.5 4.5-1.8 1.7-.2 3.5-.1 5.2.5 1.5.5 2.9 1.3 4 2.4 1.2 1.1 2.1 2.5 2.7 4 1.3 3.1.9 6.6-.9 9.4-.8 1.3-1.8 2.5-3 3.5l-1.9 1.9-1 .9h.2l.5-.2.6-.2.5-.3.6-.2.5-.3c.2-.1.4-.2.5-.4l.5-.3.5-.4c.1-.1.3-.2.4-.4l.5-.4.4-.4.4-.5.4-.5.3-.5.3-.5.3-.5.3-.5c.1-.2.2-.4.2-.6l.3-.5c0-.2.1-.4.2-.6 0-.2.1-.4.1-.6.1-.2.1-.4.1-.6.1-.2.1-.4.2-.6V22c0-.2.1-.4.1-.6v-1.2c0-.2-.1-.4-.1-.6V19c-.1-.2-.1-.4-.2-.6 0-.2 0-.4-.1-.6 0-.2-.1-.4-.1-.6s-.2-.3-.2-.5l-.3-.6c0-.2-.1-.4-.2-.6l-.3-.5-.3-.4-.3-.5-.3-.5-.4-.5-.4-.5-.4-.4-.5-.4-.4-.4-.5-.4-.5-.3-.5-.3c-.2-.2-.3-.3-.5-.3l-.6-.3-.5-.3-.6-.2-.5-.2h-.6l-.6-.3h-4.8l-.6.2h-.6l-.5.3-.6.2-.6.3-.5.3c-.2 0-.4.1-.5.3l-.5.3-.5.3-.5.4-.5.4-.4.4-.4.4-.4.5-.4.5-.3.5-.4.5c-.1.2-.2.3-.2.5l-.3.5-.3.6c0 .2-.1.4-.2.6 0 .2-.1.3-.2.5s-.1.4-.1.6-.1.4-.2.6c0 .2 0 .4-.1.6v.6c-.1.2-.1.4-.1.6v1.2c0 .2 0 .4.1.6v.6c.1.2.1.4.1.6l.2.6c0 .2.1.4.1.6.1.2.2.4.2.6.1.1.2.3.2.5l.3.6.3.5c0 .2.1.4.2.5l.4.5.3.5.4.5.4.5.4.4.4.4.5.4.5.4.5.3c.1.2.3.3.5.4l.5.3.5.2.6.3.6.2h.3l-2.6-2.6c-1.5-1.4-2.7-3.1-3.7-4.9z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "m22.6 36.5 1.7-2.1 1-1.1.6-.6 1-.9 1.9-1.9c1.2-1 2.2-2.2 3-3.5 1.8-2.8 2.2-6.3.9-9.4-.6-1.5-1.5-2.9-2.7-4-1.1-1.1-2.5-1.9-4-2.4-1.7-.6-3.5-.7-5.2-.5-1.6.3-3.1.9-4.5 1.8-1.3.9-2.4 2.1-3.2 3.4-.9 1.4-1.4 3-1.5 4.7-.2 1.7.1 3.5.8 5.1 1 1.8 2.2 3.4 3.7 4.8l2.6 2.7 3.7 3.9h.2zm-4.3-7.8-.8-.5-.6-.5-.7-.7-.5-.6-.6-.7-.4-.7c-.1-.3-.2-.6-.4-.8-.1-.2-.2-.5-.2-.8-.1-.3-.2-.5-.2-.8-.1-.3-.1-.6-.2-.8 0-.2 0-.4-.1-.5 0-.3-.1-.6-.1-.9s-.1-.5-.1-.8.1-.6.1-.9.1-.6.1-.9.1-.5.2-.8l.3-.8c.1-.3.3-.5.4-.8l.5-.7c.1-.3.3-.5.5-.7l.6-.6c.2-.3.4-.5.7-.6.2-.2.4-.4.7-.5l.7-.5.8-.4.9-.2.8-.3h3.6l.8.3.9.2c.2.2.5.3.8.4l.7.5c.3.1.5.3.7.5.3.1.5.3.7.6l.6.6c.2.2.4.4.5.7l.5.7c.1.3.2.6.4.8l.3.8c0 .3.1.6.2.8 0 .3.1.6.1.9v1.7c0 .3-.1.6-.1.9-.1.3-.2.5-.2.8l-.3.9c-.1.2-.2.3-.2.4h-.1c0 .3-.1.6-.2.8-.1.3-.3.5-.4.8l-.4.7-.5.7-.6.6-.6.6-.7.5-.8.5-.7.3-.8.3-.9.2h-3.3l-.9-.2-.8-.3-.7-.2z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M13.7 21v-.8c.1-.3.1-.6.2-.9 0-.3.1-.5.2-.8 0-.3.1-.6.2-.8.2-.2.3-.5.4-.8l.4-.7.6-.7.5-.6.7-.6.6-.5.8-.4.7-.4.8-.3.9-.2H24l.9.2.8.3.7.4.8.4.7.5.6.6.6.6.5.7.4.7c.1.3.3.5.4.8.1.2.2.5.2.8l.3.8c0 .3 0 .6.1.9v1.7c-.1.3-.1.5-.1.8-.1.2-.2.5-.2.7 0-.1.1-.2.2-.4l.3-.8c0-.3.1-.5.2-.8 0-.3.1-.6.1-.9v-1.7c0-.3-.1-.6-.1-.9-.1-.2-.2-.5-.2-.8l-.3-.8c-.2-.2-.3-.5-.4-.8l-.5-.7c-.1-.3-.3-.5-.5-.7l-.6-.6c-.2-.3-.4-.5-.7-.6-.2-.2-.4-.4-.7-.5l-.7-.5c-.3-.1-.6-.2-.8-.4l-.9-.2-.8-.3h-3.6l-.8.3-.9.2-.8.4-.7.5c-.3.1-.5.3-.7.5-.3.1-.5.3-.7.6l-.6.6c-.2.2-.4.4-.5.7l-.5.7c-.1.3-.3.5-.4.8l-.3.7c-.1.3-.1.6-.2.8s-.1.6-.1.9-.1.6-.1.9.1.5.1.8c0 .3.1.6.1.9.1.1.1.3.1.5V21z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006707949651870303650000010659172495574511022_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.02,
    y1: 172.02,
    x2: 149.02,
    y2: 207.2,
    gradientTransform: "matrix(.5 0 0 .5 -52.06 -75.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#eaeaeb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e8e8e9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#e7e7e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#e5e5e6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#e3e3e4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#e2e2e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#e0e0e1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#dededf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#ddd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#dbdbdc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#d9d9da"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#d8d8d8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#d6d6d7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#d4d4d5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#d3d3d3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#d1d1d2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#cfcfd0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#cecece"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#cccccd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#cacacb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#c9c9c9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#c7c7c8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#c5c5c6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#c2c2c3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#c0c0c1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#bebebf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#bdbdbe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#bbbbbc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#b9b9ba"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#b8b8b9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#b6b6b7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#b4b4b5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#b3b3b4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#b1b1b2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#afafb0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#aeaeae"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#acacad"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#aaaaab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#a9a9a9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#a7a7a8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#a5a5a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#a4a4a4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#a2a2a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#a0a0a1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#9f9f9f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#9d9d9e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#9b9b9c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#9a9a9a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#989899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#969697"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#959595"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#939394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#919192"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#909090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#8e8e8f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#8c8c8d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#8b8b8b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#89898a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#878788"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#868686"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#848485"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#828283"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#818181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#7f7f80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#7d7d7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#787879"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#757575"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#737374"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#707070"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#6e6e6f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#6d6d6d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#6b6b6b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#69696a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#686868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#666"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#646465"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#636363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#5f5f60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#5e5e5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#5c5c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#5a5a5b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#595959"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#575757"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#555556"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#545454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#525252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#505051"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#4f4f4f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#4b4b4b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#4a4a4a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#484848"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#464646"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#454545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#434343"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#404040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#3e3e3e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#3c3c3c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#3b3b3b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#393939"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#373737"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#363636"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#343434"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#323232"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#313131"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#2f2f2f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#2d2d2d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#2c2c2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#2a2a2a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#282828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#272727"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#252525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#232323"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#212122"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#1e1e1e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#1c1c1d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#1b1b1b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#191919"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#171717"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#171717"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#171717"
    }
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000006707949651870303650000010659172495574511022_)",
    d: "M13.7 21v-.8c.1-.3.1-.6.2-.9 0-.3.1-.5.2-.8 0-.3.1-.6.2-.8.2-.2.3-.5.4-.8l.4-.7.6-.7.5-.6.7-.6.6-.5.8-.4.7-.4.8-.3.9-.2H24l.9.2.8.3.7.4.8.4.7.5.6.6.6.6.5.7.4.7c.1.3.3.5.4.8.1.2.2.5.2.8l.3.8c0 .3 0 .6.1.9v1.7c-.1.3-.1.5-.1.8-.1.2-.2.5-.2.7 0-.1.1-.2.2-.4l.3-.8c0-.3.1-.5.2-.8 0-.3.1-.6.1-.9v-1.7c0-.3-.1-.6-.1-.9-.1-.2-.2-.5-.2-.8l-.3-.8c-.2-.2-.3-.5-.4-.8l-.5-.7c-.1-.3-.3-.5-.5-.7l-.6-.6c-.2-.3-.4-.5-.7-.6-.2-.2-.4-.4-.7-.5l-.7-.5c-.3-.1-.6-.2-.8-.4l-.9-.2-.8-.3h-3.6l-.8.3-.9.2-.8.4-.7.5c-.3.1-.5.3-.7.5-.3.1-.5.3-.7.6l-.6.6c-.2.2-.4.4-.5.7l-.5.7c-.1.3-.3.5-.4.8l-.3.7c-.1.3-.1.6-.2.8s-.1.6-.1.9-.1.6-.1.9.1.5.1.8c0 .3.1.6.1.9.1.1.1.3.1.5V21z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m19.8 29.2.9.2H24l.9-.2.8-.3.7-.3.8-.5.7-.5.6-.6.6-.6.5-.7.4-.7c.1-.3.3-.5.4-.8.1-.2.2-.5.2-.8h.1c0-.2.1-.5.2-.7 0-.3 0-.5.1-.8v-1.8c-.1-.3-.1-.6-.1-.9l-.3-.8c0-.3-.1-.6-.2-.8-.1-.3-.3-.5-.4-.8l-.4-.7-.5-.7-.6-.6-.6-.6-.7-.5-.8-.4-.7-.4-.8-.3-.9-.2h-3.3l-.9.2-.8.3-.7.4-.8.4-.6.5-.7.6-.5.6-.6.7-.4.7c-.1.3-.2.6-.4.8-.1.2-.2.5-.2.8-.1.3-.2.5-.2.8-.1.3-.1.6-.2.9v1.7c.1.2.1.5.2.8 0 .3.1.5.2.8 0 .3.1.6.2.8.2.2.3.5.4.8l.4.7.6.7.5.6.7.6.6.5.8.5.7.4.8.2zm1.9-.4H21l-.8-.2-.8-.3-.7-.3-.7-.4-.6-.5-.6-.5-.5-.6c-.2-.2-.4-.4-.5-.7l-.4-.7-.3-.8c-.2-.2-.2-.4-.3-.7-.1-.3-.2-.5-.2-.8-.1-.3-.1-.5-.1-.8-.1-.3-.1-.5-.1-.8 0-.3 0-.5.1-.8 0-.2 0-.5.1-.7 0-.3.1-.6.2-.8.1-.3.2-.6.3-.8l.3-.7c.2-.2.3-.5.4-.7l.5-.6.5-.6.6-.5.6-.5.7-.4.7-.3.8-.3.8-.2h3.1l.8.2.7.3.7.3.7.4.7.5.6.5.5.6.5.6c.1.3.2.5.4.7l.3.7.3.8c.1.2.1.5.2.8.1.3.1.5.1.7v1.6c0 .3-.1.6-.1.8 0 .2-.1.5-.2.8l-.3.7-.3.8c-.2.2-.3.4-.4.6l-.5.7-.5.6-.6.5-.7.5-.7.4-.7.3-.7.3-.8.2-2.4.1z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m24.1 28.7.8-.2.7-.3.7-.3.7-.4.7-.5.6-.5.5-.6.5-.7c.1-.2.2-.4.4-.6l.3-.8.3-.7c.1-.3.1-.5.2-.8.1-.3.1-.5.1-.8v-1.6c0-.2-.1-.5-.1-.7 0-.2-.1-.6-.2-.8l-.3-.9-.3-.7c-.2-.2-.3-.4-.4-.7l-.5-.6-.5-.5-.6-.5-.7-.5-.7-.4-.7-.3-.7-.3-.8-.2H21l-.8.2-.8.3-.7.3-.7.4-.6.5-.6.5-.5.6-.5.6c-.1.2-.2.5-.4.7l-.3.7c-.1.2-.2.5-.3.8-.1.2-.2.5-.2.8-.1.2-.1.5-.1.7-.1.3-.1.5-.1.8 0 .3 0 .5.1.8 0 .3 0 .5.1.8 0 .3.1.5.2.8.1.3.1.5.3.7l.3.8.4.6c.1.3.3.5.5.7l.5.6.6.5.6.5.7.4.7.3.8.3.8.2h3.1zm6.1-7.2v.2c-.1 2.2-1.2 4.2-3 5.5 0-.1.2-4.2-.9-6.2.1 0 3.2-.5 3.9.5zm-.8-2.5v.3l-.2.3-.2.3-.3.1-.3.2h-1.5l-.3-.2-.3-.2-.2-.3-.2-.3c0-.1 0-.2-.1-.3v-.7c.1-.1.1-.3.1-.4l.2-.3c.1-.1.1-.2.2-.2l.3-.3h2l.3.3c.1 0 .2.1.2.2l.2.3.1 1.2zm-4.9-1.5c0 .1 0 .2-.1.3l-.2.4c0 .1-.1.2-.2.3l-.3.2-.3.3h-1.5l-.4-.2-.3-.2-.2-.4c-.1-.1-.1-.3-.2-.4-.1-.1-.1-.2-.1-.3v-.8c0-.1.1-.3.1-.4l.2-.3.2-.3.3-.2.4-.2h1.5l.3.2.3.2.2.3.2.3c.1.1.1.3.1.4.1.1.1.2.1.4s0 .3-.1.4zm-9 .7v-.4l.3-.3.2-.3.3-.2.3-.2H18l.3.2.3.2.2.3.2.3v1.4l-.2.3-.2.3-.3.2-.3.2h-1.4l-.3-.2-.3-.1-.2-.3-.2-.3v-1h-.1zm2.5 9.1c-1.9-1.3-3.2-3.4-3.4-5.7v-.2c.3-.2 1.2-.9 4.2-.5-.1.1-.8 1.2-.8 6.4zm2.4 1c-.2 0-.3-.2-.3-.4v-4.7l-.4 5-1.1-.6-.2-.2c0-.7 0-2.8.1-4.2.1-.9.4-1.7.9-2.5.8-1.4 4.1-1.1 4.6-1h.1c.8.1 1.5.5 1.9 1.2.9 1.4.9 6 .9 6v.3c-.1.1-.1.2-.2.2l-1.1.6-.4-4.5v4.3c0 .2-.1.3-.3.4-1.4.6-3 .7-4.5.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161604660273016167750000014731232408616634525_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.112,
    y1: 175.55,
    x2: 149.112,
    y2: 207.99,
    gradientTransform: "matrix(.5 0 0 .5 -52.06 -75.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d7eff7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d8f0f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#d8f0f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#d9f0f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#d9f0f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#daf0f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#daf1f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#dbf1f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#dbf1f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#dcf1f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#dcf1f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#ddf2f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ddf2f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#def2f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#def2f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#dff2f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#dff3f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#e0f3f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#e0f3f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#e1f3f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#e1f3f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#e2f4f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#e3f4fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#e3f4fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#e4f4fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#e4f4fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#e5f5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#e5f5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#e6f5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#e6f5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#e7f5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#e7f6fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#e8f6fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#e8f6fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#e9f6fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#e9f7fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#eaf7fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#eaf7fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#ebf7fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#ebf7fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#ecf8fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#ecf8fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#edf8fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#edf8fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#eef8fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#eff9fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#eff9fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#f0f9fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#f0f9fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#f1f9fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f1fafc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f2fafc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f2fafd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#f3fafd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#f3fafd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#f4fbfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#f4fbfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#f5fbfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#f5fbfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#f6fbfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#f6fcfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#f7fcfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#f7fcfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#f8fcfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#f8fcfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#f9fdfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#f9fdfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#fafdfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#fbfdfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#fbfdfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#fcfefe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#fcfefe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#fdfeff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#fdfeff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#fefeff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#feffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000161604660273016167750000014731232408616634525_)",
    d: "m24.1 28.7.8-.2.7-.3.7-.3.7-.4.7-.5.6-.5.5-.6.5-.7c.1-.2.2-.4.4-.6l.3-.8.3-.7c.1-.3.1-.5.2-.8.1-.3.1-.5.1-.8v-1.6c0-.2-.1-.5-.1-.7 0-.2-.1-.6-.2-.8l-.3-.9-.3-.7c-.2-.2-.3-.4-.4-.7l-.5-.6-.5-.5-.6-.5-.7-.5-.7-.4-.7-.3-.7-.3-.8-.2H21l-.8.2-.8.3-.7.3-.7.4-.6.5-.6.5-.5.6-.5.6c-.1.2-.2.5-.4.7l-.3.7c-.1.2-.2.5-.3.8-.1.2-.2.5-.2.8-.1.2-.1.5-.1.7-.1.3-.1.5-.1.8 0 .3 0 .5.1.8 0 .3 0 .5.1.8 0 .3.1.5.2.8.1.3.1.5.3.7l.3.8.4.6c.1.3.3.5.5.7l.5.6.6.5.6.5.7.4.7.3.8.3.8.2h3.1zm6.1-7.2v.2c-.1 2.2-1.2 4.2-3 5.5 0-.1.2-4.2-.9-6.2.1 0 3.2-.5 3.9.5zm-.8-2.5v.3l-.2.3-.2.3-.3.1-.3.2h-1.5l-.3-.2-.3-.2-.2-.3-.2-.3c0-.1 0-.2-.1-.3v-.7c.1-.1.1-.3.1-.4l.2-.3c.1-.1.1-.2.2-.2l.3-.3h2l.3.3c.1 0 .2.1.2.2l.2.3.1 1.2zm-4.9-1.5c0 .1 0 .2-.1.3l-.2.4c0 .1-.1.2-.2.3l-.3.2-.3.3h-1.5l-.4-.2-.3-.2-.2-.4c-.1-.1-.1-.3-.2-.4-.1-.1-.1-.2-.1-.3v-.8c0-.1.1-.3.1-.4l.2-.3.2-.3.3-.2.4-.2h1.5l.3.2.3.2.2.3.2.3c.1.1.1.3.1.4.1.1.1.2.1.4s0 .3-.1.4zm-9 .7v-.4l.3-.3.2-.3.3-.2.3-.2H18l.3.2.3.2.2.3.2.3v1.4l-.2.3-.2.3-.3.2-.3.2h-1.4l-.3-.2-.3-.1-.2-.3-.2-.3v-1h-.1zm2.5 9.1c-1.9-1.3-3.2-3.4-3.4-5.7v-.2c.3-.2 1.2-.9 4.2-.5-.1.1-.8 1.2-.8 6.4zm2.4 1c-.2 0-.3-.2-.3-.4v-4.7l-.4 5-1.1-.6-.2-.2c0-.7 0-2.8.1-4.2.1-.9.4-1.7.9-2.5.8-1.4 4.1-1.1 4.6-1h.1c.8.1 1.5.5 1.9 1.2.9 1.4.9 6 .9 6v.3c-.1.1-.1.2-.2.2l-1.1.6-.4-4.5v4.3c0 .2-.1.3-.3.4-1.4.6-3 .7-4.5.1z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m15.6 19.2.2.3.2.3.3.2.3.2H18l.3-.2.3-.2.2-.3.2-.3v-1.4l-.2-.3-.2-.3-.3-.2-.3-.1h-1.4l-.3.1-.3.2-.2.3-.2.3v1.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084488876130463756190000008027447289296616088_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.72,
    y1: 175.55,
    x2: 138.72,
    y2: 207.99,
    gradientTransform: "matrix(.5 0 0 .5 -52.06 -75.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d7eff7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d8f0f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#d8f0f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#d9f0f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#d9f0f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#daf0f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#daf1f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#dbf1f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#dbf1f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#dcf1f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#dcf1f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#ddf2f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ddf2f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#def2f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#def2f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#dff2f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#dff3f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#e0f3f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#e0f3f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#e1f3f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#e1f3f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#e2f4f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#e3f4fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#e3f4fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#e4f4fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#e4f4fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#e5f5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#e5f5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#e6f5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#e6f5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#e7f5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#e7f6fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#e8f6fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#e8f6fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#e9f6fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#e9f7fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#eaf7fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#eaf7fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#ebf7fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#ebf7fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#ecf8fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#ecf8fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#edf8fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#edf8fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#eef8fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#eff9fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#eff9fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#f0f9fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#f0f9fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#f1f9fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f1fafc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f2fafc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f2fafd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#f3fafd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#f3fafd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#f4fbfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#f4fbfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#f5fbfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#f5fbfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#f6fbfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#f6fcfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#f7fcfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#f7fcfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#f8fcfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#f8fcfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#f9fdfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#f9fdfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#fafdfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#fbfdfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#fbfdfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#fcfefe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#fcfefe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#fdfeff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#fdfeff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#fefeff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#feffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000084488876130463756190000008027447289296616088_)",
    d: "m15.6 19.2.2.3.2.3.3.2.3.2H18l.3-.2.3-.2.2-.3.2-.3v-1.4l-.2-.3-.2-.3-.3-.2-.3-.1h-1.4l-.3.1-.3.2-.2.3-.2.3v1.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168095276754322157890000004174495369974645433_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.72,
    y1: 183.89,
    x2: 138.72,
    y2: 191.17,
    gradientTransform: "matrix(.5 0 0 .5 -52.06 -75.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f9af8f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#f9ae8e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#f9ad8e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#f9ad8d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#f9ac8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#f9ab8b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#f8aa8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#f8a989"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#f8a988"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#f8a888"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#f8a787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#f8a686"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#f8a585"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#f8a484"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#f8a483"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#f8a382"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#f8a282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#f8a181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#f8a080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#f7a07f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#f79f7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#f79e7d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#f79d7c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#f79c7c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#f79b7b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f79b7a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f79a79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#f79978"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#f79877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#f79777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#f79776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#f79675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#f79574"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#f69473"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#f69372"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#f69271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#f69271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#f69170"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#f6906f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#f68f6e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#f68e6d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#f68e6c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#f68d6b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#f68c6b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#f68b6a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#f68a69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#f58968"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#f58967"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#f58866"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#f58765"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#f58665"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#f58564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#f58563"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#f58462"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#f58361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#f58260"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#f58160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#f5805f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#f5805e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#f57f5d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#f47e5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#f47d5b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#f47c5a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#f47c5a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f47b59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#f47a58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#f47957"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#f47856"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#f47755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#f47754"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#f47654"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#f47553"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#f47452"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#f47351"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#f37350"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#f3724f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#f3714e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#f3704e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#f36f4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#f36e4c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#f36e4b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#f36d4a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#f36c49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#f36b48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#f36a48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#f36a47"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#f36946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#f26845"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#f26744"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#f26643"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#f26543"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#f26542"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#f26441"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#f26340"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#f2623f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#f2613e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#f2613d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#f2603d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#f25f3c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#f25e3b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#f25d3a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#f15c39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#f15c38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#f15b37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#f15a37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#f15936"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#f15835"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#f15834"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#f15733"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#f15632"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#f15531"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#f15431"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#f15330"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#f1532f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#f0522e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#f0512d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#f0502c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#f04f2c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#f04f2b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#f04e2a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#f04d29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f04c28"
    }
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000168095276754322157890000004174495369974645433_)",
    d: "m15.6 19.2.2.3.2.3.3.2.3.2H18l.3-.2.3-.2.2-.3.2-.3v-1.4l-.2-.3-.2-.3-.3-.2-.3-.1h-1.4l-.3.1-.3.2-.2.3-.2.3v1.4z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m24.4 16.4-.2-.4-.2-.2-.3-.2-.3-.2h-1.5l-.4.2-.3.2-.2.2-.2.3c0 .1-.1.3-.1.4v.8c0 .1.1.2.1.3s.1.3.2.4l.2.3.3.2.4.2h1.5l.3-.2.3-.2c.1-.1.2-.2.2-.3l.2-.4c.1-.1.1-.2.1-.3.1-.1.1-.3.1-.4 0-.2 0-.3-.1-.4 0-.1 0-.2-.1-.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086656164780484276070000004341423511084660391_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.42,
    y1: 175.55,
    x2: 149.42,
    y2: 207.99,
    gradientTransform: "matrix(.5 0 0 .5 -52.06 -75.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d7eff7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d8f0f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#d8f0f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#d9f0f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#d9f0f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#daf0f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#daf1f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#dbf1f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#dbf1f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#dcf1f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#dcf1f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#ddf2f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ddf2f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#def2f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#def2f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#dff2f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#dff3f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#e0f3f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#e0f3f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#e1f3f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#e1f3f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#e2f4f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#e3f4fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#e3f4fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#e4f4fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#e4f4fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#e5f5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#e5f5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#e6f5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#e6f5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#e7f5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#e7f6fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#e8f6fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#e8f6fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#e9f6fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#e9f7fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#eaf7fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#eaf7fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#ebf7fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#ebf7fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#ecf8fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#ecf8fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#edf8fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#edf8fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#eef8fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#eff9fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#eff9fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#f0f9fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#f0f9fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#f1f9fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f1fafc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f2fafc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f2fafd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#f3fafd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#f3fafd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#f4fbfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#f4fbfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#f5fbfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#f5fbfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#f6fbfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#f6fcfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#f7fcfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#f7fcfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#f8fcfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#f8fcfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#f9fdfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#f9fdfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#fafdfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#fbfdfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#fbfdfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#fcfefe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#fcfefe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#fdfeff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#fdfeff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#fefeff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#feffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000086656164780484276070000004341423511084660391_)",
    d: "m24.4 16.4-.2-.4-.2-.2-.3-.2-.3-.2h-1.5l-.4.2-.3.2-.2.2-.2.3c0 .1-.1.3-.1.4v.8c0 .1.1.2.1.3s.1.3.2.4l.2.3.3.2.4.2h1.5l.3-.2.3-.2c.1-.1.2-.2.2-.3l.2-.4c.1-.1.1-.2.1-.3.1-.1.1-.3.1-.4 0-.2 0-.3-.1-.4 0-.1 0-.2-.1-.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071554514107484106770000003195061680932816286_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.42,
    y1: 180.73,
    x2: 149.42,
    y2: 188.53,
    gradientTransform: "matrix(.5 0 0 .5 -52.06 -75.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#afe1b5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#afe1b5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#aee0b4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#ade0b4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#ade0b3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#ace0b3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#ace0b2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#abdfb1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#aadfb1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#aadfb0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#a9dfb0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#a8deaf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#a8deaf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#a7deae"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#a7dead"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#a6ddad"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#a5ddac"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#a5ddac"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#a4ddab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#a4ddab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#a3dcaa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#a2dca9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#a2dca9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#a1dca8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#a0dba8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#a0dba7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#9fdba7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#9fdba6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#9edaa5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#9ddaa5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#9ddaa4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#9cdaa4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9cd9a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9bd9a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9ad9a2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#9ad9a1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#99d9a1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#98d8a0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#98d8a0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#97d89f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#97d89f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#96d79e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#95d79d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#95d79d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#94d79c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#93d69c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#93d69b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#92d69b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#92d69a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#91d699"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#90d599"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#90d598"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#8fd598"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#8fd597"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#8ed497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#8dd496"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#8dd495"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#8cd495"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#8bd394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#8bd394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#8ad393"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#8ad393"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#89d292"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#88d291"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#88d291"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#87d290"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#86d290"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#86d18f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#85d18f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#85d18e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#84d18d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#83d08d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#83d08c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#82d08c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#82d08b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#81cf8b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#80cf8a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#80cf89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#7fcf89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#7ecf88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#7ece88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#7dce87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#7dce87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#7cce86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#7bcd85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#7bcd85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#7acd84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#7acd84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#79cc83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#78cc83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#78cc82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#77cc81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#76cb81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#76cb80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#75cb80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#75cb7f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#74cb7f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#73ca7e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#73ca7d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#72ca7d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#71ca7c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#71c97c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#70c97b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#70c97b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#6fc97a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#6ec879"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#6ec879"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#6dc878"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#6dc878"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#6cc877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#6bc777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#6bc776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#6ac775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#69c775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#69c674"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#68c674"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#68c673"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#67c673"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#66c572"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#66c571"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#65c571"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#64c570"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#64c470"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#63c46f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#63c46f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#62c46e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#61c46d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#61c36d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#60c36c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#60c36c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#5fc36b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#5ec26b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#5ec26a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#5dc269"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#5cc269"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#5cc168"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#5bc168"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#5bc167"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#5ac167"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#59c166"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#59c066"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#58c065"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#58c064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#57c064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#56bf63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#56bf63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#55bf62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#54bf62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#54be61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#53be60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#53be60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#52be5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#51be5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#51bd5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#50bd5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#4fbd5d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#4fbd5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#4ebc5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#4ebc5b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#4dbc5b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#4cbc5a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#4cbb5a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#4bbb59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#4bbb58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#4abb58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#49ba57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#49ba57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#48ba56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#47ba56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#47ba55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#46b954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#46b954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#45b953"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#44b953"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#44b852"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#43b852"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#42b851"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#42b850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#41b750"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#41b74f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#40b74f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#3fb74e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#3fb74e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#3eb64d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#3eb64c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#3db64c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#3cb64b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#3cb54b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#3bb54a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#3bb54a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3bb54a"
    }
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000071554514107484106770000003195061680932816286_)",
    d: "m24.4 16.4-.2-.4-.2-.2-.3-.2-.3-.2h-1.5l-.4.2-.3.2-.2.2-.2.3c0 .1-.1.3-.1.4v.8c0 .1.1.2.1.3s.1.3.2.4l.2.3.3.2.4.2h1.5l.3-.2.3-.2c.1-.1.2-.2.2-.3l.2-.4c.1-.1.1-.2.1-.3.1-.1.1-.3.1-.4 0-.2 0-.3-.1-.4 0-.1 0-.2-.1-.3z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m29.3 17.9-.2-.3c0-.1-.1-.2-.2-.2l-.3-.4h-2l-.3.3c-.1 0-.1.1-.2.2l-.2.3c0 .1 0 .3-.1.4v.8c.1.1.1.2.1.3l.2.3.2.3.3.2.3.2h1.4l.3-.2.3-.2.2-.3.2-.3v-1.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114062346817081337580000002232414847465633977_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.22,
    y1: 175.55,
    x2: 159.22,
    y2: 207.99,
    gradientTransform: "matrix(.5 0 0 .5 -52.06 -75.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d7eff7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d8f0f7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#d8f0f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#d9f0f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#d9f0f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#daf0f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#daf1f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#dbf1f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#dbf1f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#dcf1f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#dcf1f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#ddf2f8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#ddf2f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#def2f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#def2f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#dff2f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#dff3f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#e0f3f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#e0f3f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#e1f3f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#e1f3f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#e2f4f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#e3f4fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#e3f4fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#e4f4fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#e4f4fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#e5f5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#e5f5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#e6f5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#e6f5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#e7f5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#e7f6fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#e8f6fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#e8f6fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#e9f6fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#e9f7fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#eaf7fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#eaf7fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#ebf7fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#ebf7fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#ecf8fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#ecf8fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#edf8fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#edf8fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#eef8fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#eff9fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#eff9fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#f0f9fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#f0f9fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#f1f9fc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f1fafc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f2fafc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#f2fafd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#f3fafd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#f3fafd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#f4fbfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#f4fbfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#f5fbfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#f5fbfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#f6fbfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#f6fcfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#f7fcfd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#f7fcfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#f8fcfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#f8fcfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#f9fdfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#f9fdfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#fafdfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#fbfdfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#fbfdfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#fcfefe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#fcfefe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#fdfeff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#fdfeff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#fefeff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#feffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000114062346817081337580000002232414847465633977_)",
    d: "m29.3 17.9-.2-.3c0-.1-.1-.2-.2-.2l-.3-.4h-2l-.3.3c-.1 0-.1.1-.2.2l-.2.3c0 .1 0 .3-.1.4v.8c.1.1.1.2.1.3l.2.3.2.3.3.2.3.2h1.4l.3-.2.3-.2.2-.3.2-.3v-1.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147934368797698228630000014976303967668748707_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.22,
    y1: 183.91,
    x2: 159.22,
    y2: 191.19,
    gradientTransform: "matrix(.5 0 0 .5 -52.06 -75.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cbeaf4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cbeaf4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#cae9f4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#c9e9f4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#c9e9f4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#c8e8f3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#c7e8f3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#c6e8f3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#c6e8f3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#c5e7f3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#c4e7f3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#c3e7f3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#c3e6f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#c2e6f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#c1e6f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#c1e5f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#c0e5f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#bfe5f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#bee5f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#bee4f1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#bde4f1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#bce4f1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#bbe3f1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#bbe3f1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#bae3f1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#b9e2f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#b8e2f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#b8e2f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#b7e2f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#b6e1f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#b6e1f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#b5e1f0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#b4e0ef"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#b3e0ef"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#b3e0ef"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#b2dfef"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#b1dfef"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#b0dfef"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#b0dfee"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#afdeee"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#aedeee"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#aedeee"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#adddee"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#acddee"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#abddee"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#abdced"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#aadced"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#a9dced"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#a8dced"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#a8dbed"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#a7dbed"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#a6dbec"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#a6daec"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#a5daec"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#a4daec"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#a3daec"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#a3d9ec"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#a2d9ec"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#a1d9eb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#a0d8eb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#a0d8eb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#9fd8eb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#9ed7eb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#9ed7eb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#9dd7eb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#9cd7ea"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#9bd6ea"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#9bd6ea"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#9ad6ea"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#99d5ea"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#98d5ea"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#98d5e9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#97d4e9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#96d4e9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#96d4e9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#95d4e9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#94d3e9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#93d3e9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#93d3e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#92d2e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#91d2e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#90d2e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#90d1e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#8fd1e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#8ed1e7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#8dd1e7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#8dd0e7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#8cd0e7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#8bd0e7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#8bcfe7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#8acfe7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#89cfe6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#88cee6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#88cee6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#87cee6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#86cee6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#85cde6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#85cde5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#84cde5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#83cce5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#83cce5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#82cce5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#81cbe5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#80cbe5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#80cbe4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#7fcbe4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#7ecae4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#7dcae4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#7dcae4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#7cc9e4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#7bc9e4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#7bc9e3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#7ac9e3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#79c8e3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#78c8e3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#78c8e3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#77c7e3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#76c7e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#75c7e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#75c6e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#74c6e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#73c6e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#73c6e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#72c5e2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#71c5e1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#70c5e1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#70c4e1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#6fc4e1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#6ec4e1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#6dc3e1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#6dc3e0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#6cc3e0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#6bc3e0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#6ac2e0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#6ac2e0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#69c2e0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#68c1e0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#68c1df"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#67c1df"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#66c0df"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#65c0df"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#65c0df"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#64c0df"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#63bfdf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#62bfde"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#62bfde"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#61bede"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#60bede"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#60bede"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#5fbdde"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#5ebddd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#5dbddd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#5dbddd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#5cbcdd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#5bbcdd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#5abcdd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#5abbdd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#59bbdc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#58bbdc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#58badc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#57badc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#56badc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#55badc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#55b9db"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#54b9db"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#53b9db"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#52b8db"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#52b8db"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#51b8db"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#50b8db"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#50b7da"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#4fb7da"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#4eb7da"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#4db6da"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#4db6da"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#4cb6da"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#4bb5d9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#4ab5d9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#4ab5d9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#49b5d9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#48b4d9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#48b4d9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#47b4d9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#46b3d8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#45b3d8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#45b3d8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#44b2d8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#43b2d8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#42b2d8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#42b2d8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#41b1d7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#40b1d7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#3fb1d7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#3fb0d7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#3eb0d7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#3db0d7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#3dafd6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#3cafd6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#3bafd6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#3aafd6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#3aaed6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#39aed6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#38aed6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#37add5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#37add5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#36add5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#35acd5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#35acd5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#34acd5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#33acd4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#32abd4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#32abd4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#31abd4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#30aad4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#2faad4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#2faad4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#2eaad3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#2da9d3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#2da9d3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#2ca9d3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#2ba8d3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#2aa8d3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#2aa8d2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#29a7d2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#28a7d2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#27a7d2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#27a7d2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#26a6d2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#25a6d2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#25a6d1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#24a5d1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#23a5d1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#23a5d1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23a5d1"
    }
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000147934368797698228630000014976303967668748707_)",
    d: "m29.3 17.9-.2-.3c0-.1-.1-.2-.2-.2l-.3-.4h-2l-.3.3c-.1 0-.1.1-.2.2l-.2.3c0 .1 0 .3-.1.4v.8c.1.1.1.2.1.3l.2.3.2.3.3.2.3.2h1.4l.3-.2.3-.2.2-.3.2-.3v-1.4z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF4024",
    d: "M18.9 21c-3-.4-3.9.3-4.2.5v.2c.2 2.3 1.5 4.4 3.4 5.7h.1c-.1-5.2.6-6.2.7-6.4z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#079A49",
    d: "M24.9 28.2c.2-.1.3-.2.3-.4v-4.3l.4 4.5 1.1-.6c.1 0 .1-.1.2-.2V27s0-4.6-.9-6c-.4-.7-1.1-1.1-1.9-1.2H24c-.5-.1-3.8-.4-4.6 1-.5.8-.8 1.6-.9 2.5-.1 1.4-.1 3.5-.1 4.2l.2.2 1.1.6.4-5V28c0 .2.1.4.3.4 1.5.5 3.1.4 4.5-.2z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B7AAA",
    d: "M26.3 21c1.1 2 .9 6.1.9 6.2 1.8-1.3 2.9-3.3 3-5.5v-.2c-.7-1-3.8-.5-3.9-.5z"
  }))), _view32 || (_view32 = /*#__PURE__*/React.createElement("view", {
    id: "desk-change-request",
    viewBox: "45 225 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 45,
    y: 225,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 9.5,
    width: 16,
    height: 10.8,
    rx: 1.4,
    fill: "#2e4057"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#cfe3ee",
    d: "M15.8 10.8h13.4V19H15.8z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e4057",
    d: "M21.4 20.3h2.2v2.8h-2.2z"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6,
    y: 22.6,
    width: 9.8,
    height: 1.6,
    rx: 0.8,
    fill: "#2e4057"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 21.6c-2.2-.4-3.3-1.9-3.3-3.9 2.2.4 3.3 1.9 3.3 3.9zM12.3 21.6c2.2-.4 3.3-1.9 3.3-3.9-2.2.4-3.3 1.9-3.3 3.9z",
    fill: "#6aa66b"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 21.4h4.2l-.7 2.8h-2.8z",
    fill: "#b3552f"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 24.2,
    width: 33,
    height: 3.2,
    rx: 1.5,
    fill: "#c8925a"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "#8a6238",
    d: "M8.6 27.4h2.7v13H8.6zM33.7 27.4h2.7v13h-2.7z"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 10.5,
    r: 7,
    fill: "#3d7dd8"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 32.6,
    y: 8,
    width: 5.2,
    height: 1.5,
    rx: 0.7,
    fill: "#fff"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "m37.6 6.8 3 1.95-3 1.95z",
    fill: "#fff"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 11.5,
    width: 5.2,
    height: 1.5,
    rx: 0.7,
    fill: "#fff"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "m35.4 10.3-3 1.95 3 1.95z",
    fill: "#fff"
  }))), _view33 || (_view33 = /*#__PURE__*/React.createElement("view", {
    id: "dolly",
    viewBox: "90 225 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 90,
    y: 225,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16.3 27.8c-2.3 0-4.2 1.9-4.2 4.2 0 2.3 1.9 4.2 4.2 4.2 2.3 0 4.2-1.9 4.2-4.2 0-2.3-1.9-4.2-4.2-4.2zm2.3 4.5c-.2 1.3-1.5 2.2-2.8 1.9s-2.2-1.5-1.9-2.8c.2-1.3 1.5-2.2 2.8-1.9s2.2 1.5 1.9 2.8z"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    fill: "#505050",
    cx: 16.3,
    cy: 31.9,
    r: 2.4
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M16.3 7.6h-4.8c-.3 0-.6.3-.6.6s.3.6.6.6h4.2v17.9c-2.7.3-4.8 2.6-4.8 5.3.2 2.5 2 4.5 4.4 4.9 2.9.5 5.7-1.4 6.3-4.3h11.9c.3 0 .6-.3.6-.6s-.3-.6-.6-.6h-2.4v-8.9c0-.3-.3-.6-.6-.6h-1.7V13c0-.3-.3-.6-.6-.6h-8.4c-.3 0-.6.3-.6.6v9.5c0 .3.3.6.6.6h1.8v8.3c-.3-2.5-2.2-4.4-4.7-4.7V8.2c0-.3-.3-.6-.6-.6zm7.1 6h1.2V16h-1.2v-2.4zm-3 8.3v-8.3h1.8v2.9c0 .3.3.6.6.6h2.4c.3 0 .6-.3.6-.6v-2.9h1.8v8.3h-7.2zm6.6 1.2v2.4h-1.2v-2.4H27zm-4.2 0h1.8v3c0 .3.3.5.6.5h2.4c.3 0 .6-.2.6-.5v-3h1.7v8.3h-7.1v-8.3zM20.5 32c0 2.3-1.9 4.2-4.2 4.2-2.3 0-4.2-1.9-4.2-4.2 0-2.3 1.9-4.2 4.2-4.2 2.3 0 4.2 1.9 4.2 4.2z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M23.4 13.6h1.2V16h-1.2zM25.8 23.1H27v2.4h-1.2z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8B85D",
    d: "M27.6 13.6h-1.8v2.9c0 .3-.3.6-.6.6h-2.4c-.3 0-.6-.3-.6-.6v-2.9h-1.8v8.3h7.2v-8.3zM22.8 31.4h7.1v-8.3h-1.7v3c0 .3-.3.5-.6.5h-2.4c-.3 0-.6-.2-.6-.5v-3h-1.8v8.3z"
  }))), _view34 || (_view34 = /*#__PURE__*/React.createElement("view", {
    id: "door",
    viewBox: "135 225 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 135,
    y: 225,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M37.5 5.1H7.8c-.2 0-.4.2-.4.4V39H5.7c-.2 0-.4.2-.4.4s.2.4.4.4h33.6c.2 0 .3-.2.3-.4s-.1-.4-.3-.4h-1.5V5.5c0-.2-.1-.4-.3-.4zm-25.1 34V10.6h9.8V39h-9.8zm20.2 0h-9.7V10.6h9.7v28.5zm4.5 0h-3.8V10.2c0-.2-.2-.4-.4-.4H12.1c-.2 0-.4.2-.4.4V39H8.1V5.9h29v33.2z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22.2 10.6h-9.8V39h9.8V10.6zm-4.1 14.3c-.1-.8.5-1.5 1.3-1.6.8.1 1.5.8 1.4 1.6 0 .8-.6 1.4-1.4 1.5-.8-.1-1.4-.8-1.3-1.5z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19.4 25.6c.4-.1.7-.4.7-.8s-.3-.7-.7-.7c-.4 0-.7.3-.7.7 0 .5.3.8.7.8zM25.6 24c-.4 0-.7.3-.7.7v.1c0 .4.3.7.7.7s.7-.3.7-.7c.1-.4-.2-.7-.6-.8 0 .1-.1 0-.1 0z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22.9 10.6V39h9.7V10.6h-9.7zm2.7 15.8c-.8-.1-1.4-.7-1.4-1.5s.6-1.4 1.4-1.4 1.4.6 1.4 1.4c0 .7-.6 1.4-1.4 1.5z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M8.1 5.9V39h3.6V10.2c0-.2.2-.4.4-.4h20.8c.2 0 .4.2.4.4V39h3.8V5.9h-29z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M19.4 26.4c.8-.1 1.4-.7 1.4-1.5.1-.8-.6-1.5-1.4-1.6-.8.1-1.4.8-1.3 1.6-.1.7.5 1.4 1.3 1.5 0-.1 0-.1 0 0zm-.7-1.5c0-.4.3-.7.7-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.8-.4-.1-.7-.4-.7-.8zM25.6 23.2c-.8.1-1.5.8-1.4 1.6 0 .8.6 1.4 1.4 1.4s1.4-.6 1.4-1.4c.1-.8-.6-1.5-1.4-1.6 0 .1 0 .1 0 0zm0 2.4c-.4-.1-.7-.4-.7-.8s.3-.7.7-.7.7.3.7.7c0 .5-.3.8-.7.8z"
  }))), _view35 || (_view35 = /*#__PURE__*/React.createElement("view", {
    id: "door-repairs",
    viewBox: "180 225 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 180,
    y: 225,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6h13c.8 0 1.5.7 1.5 1.5V38h-16V7.5C7.5 6.7 8.2 6 9 6z",
    fill: "#c7d3dc"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "#5a7d9a",
    d: "M9.8 8.5h11.4V38H9.8z"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8,
    y: 11,
    width: 7.4,
    height: 9,
    rx: 0.9,
    fill: "#6e91ad"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 24,
    r: 1.2,
    fill: "#3f4a54"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(38 31 22)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 7,
    width: 4.4,
    height: 9.5,
    rx: 2,
    fill: "#e0704f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8f9ba3",
    d: "M30.6 16.5H32V29h-1.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.3,
    y: 28.6,
    width: 2,
    height: 2.8,
    rx: 0.5,
    fill: "#8f9ba3"
  })))), _view36 || (_view36 = /*#__PURE__*/React.createElement("view", {
    id: "dry_ice",
    viewBox: "225 225 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 225,
    y: 225,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M38.1 9.9H7c-.3 0-.5.2-.5.5v23.1c0 .3.2.5.5.5h4.4v.8c0 .2.1.3.3.3h2.4c.2 0 .3-.1.3-.3V34h16.3v.8l.3.3h2.5c.1 0 .2-.2.2-.3V34h4.4c.3 0 .5-.2.5-.5V10.4c-.1-.3-.3-.5-.5-.5zm-.5 1v3.5H7.5v-3.5h30.1zM7.5 33V15.4h10.2v.3c0 .1.1.2.2.2h9.3c.2 0 .3-.1.3-.2v-.3h10.1V33H7.5z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M27.5 15.4v.3c0 .1-.1.2-.3.2h-9.3c-.1 0-.2-.1-.2-.2v-.3H7.5V33h30.1V15.4H27.5zM26.2 23l-.2.5-1-.6-1.8 1L25 25l1-.6.3.5-.7.4 1 .6-.3.5-1-.6v.8h-.6v-1.1l-1.8-1v2l1 .6-.3.5-.7-.4v1.2h-.6v-1.2l-.7.4-.3-.5 1-.6v-2l-1.8 1v1.1h-.6v-.8l-1.1.6-.3-.5 1.1-.6-.7-.4.3-.5 1 .6 1.8-1.1-1.8-1-1 .6-.3-.5.7-.4-1.1-.6.3-.6 1.1.6v-.8h.6v1.2l1.8 1v-2.1l-1-.5.3-.5.7.4v-1.3h.6v1.3l.7-.4.3.5-1 .5v2.1l1.8-1v-1.2h.6v.8l1-.6.3.6-1 .6.6.4zm9 8h-2.3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2.3c.3 0 .5.2.5.5s-.3.5-.5.5zm0-1.9h-2.3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2.3c.3 0 .5.2.5.5s-.3.5-.5.5zM17.9 14.4H37.6v-3.5H7.5v3.5z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M35.2 28.1h-2.3c-.3 0-.5.2-.5.5s.2.5.5.5h2.3c.3 0 .5-.2.5-.5s-.3-.5-.5-.5zM35.2 30h-2.3c-.3 0-.5.2-.5.5s.2.5.5.5h2.3c.3 0 .5-.2.5-.5s-.3-.5-.5-.5z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "m26.2 21.4-1 .6v-.8h-.5v1.2l-1.8 1v-2.1l1-.5-.3-.5-.7.4v-1.3h-.7v1.3l-.6-.4-.4.5 1 .5v2.1l-1.7-1v-1.2h-.6v.8l-1.1-.6-.3.6 1.1.6-.7.4.3.5 1-.6 1.8 1-1.8 1.1-1-.6-.3.5.7.4-1.1.6.3.5 1.1-.6v.8h.6v-1.1l1.7-1v2l-1 .6.4.5.6-.4v1.2h.7v-1.2l.7.4.3-.5-1-.6v-2l1.8 1v1.1h.5v-.8l1 .6.4-.5-1-.6.6-.4-.2-.5-1 .6-1.8-1.1 1.8-1 1 .6.2-.5-.6-.4 1-.6z"
  }))), _view37 || (_view37 = /*#__PURE__*/React.createElement("view", {
    id: "ehs_concern",
    viewBox: "270 0 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 270,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M39.8 38 23.4 5.6c-.2-.5-.8-.7-1.3-.5-.2.1-.4.3-.5.5L5.1 38c-.1.4-.1.8 0 1.2.2.4.6.7 1 .7h32.8c.7-.1 1.2-.6 1.1-1.3 0-.2-.1-.4-.2-.6zm-31.9-.5L22.5 8.7l14.6 28.7H7.9z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.9 37.5h29.2L22.5 8.7 7.9 37.5zm15.5-23.4 10 19.6c.1.2.1.5.1.7 0 .7-.4 1.2-1 1.2h-20c-.4 0-.7-.2-.9-.6-.2-.4-.2-.8 0-1.2l10-19.7c.2-.5.8-.7 1.3-.5.2.2.4.3.5.5z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.4 33.2h16.2l-8.1-16.1-8.1 16.1zm8.8-.7c-.2.2-.4.4-.7.4-.7-.1-1.2-.6-1.1-1.3 0-.3.1-.6.3-.8.2-.3.5-.4.8-.4.3 0 .6.2.7.4.2.2.4.5.4.8 0 .3-.2.6-.4.9zm.4-10.9v7c0 .6-.5 1.1-1.1 1.2-.6-.1-1.1-.6-1.1-1.2v-7c0-.6.5-1.1 1.1-1.2.6 0 1.1.5 1.1 1.2z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "m21.6 14.1-10 19.7c-.2.4-.2.8 0 1.2.2.4.5.6.9.6h20c.6 0 1-.5 1-1.2 0-.2 0-.5-.1-.7l-10-19.6c-.2-.5-.8-.7-1.3-.5-.2.2-.4.3-.5.5zm9 19.1H14.4l8.1-16.1 8.1 16.1z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M21.4 21.5v7c0 .6.5 1.1 1.1 1.2.6-.1 1.1-.6 1.1-1.2v-7c0-.6-.5-1.1-1.1-1.2-.6.1-1.1.6-1.1 1.2zM22.5 30.3c-.3 0-.6.1-.8.4-.2.2-.3.5-.3.8-.1.7.4 1.2 1.1 1.3.3 0 .5-.2.7-.4.2-.2.4-.6.4-.9 0-.3-.2-.6-.4-.8-.1-.2-.4-.4-.7-.4z"
  }))), _view38 || (_view38 = /*#__PURE__*/React.createElement("view", {
    id: "electrical",
    viewBox: "270 45 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 270,
    y: 45,
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-286.8-431.5h612v1185h-612z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-286.8-431.5h612v1185h-612z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-286.8-431.5h612v1185h-612z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-286.8-431.5h612v1185h-612z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-286.8-431.5h612v1185h-612z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-286.8-431.5h612v1185h-612z"
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M-286.8-431.5h612v1185h-612z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124854708263624986670000013137921749084916404_"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000124854708263624986670000013137921749084916404_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.3 39.5h.1c.5.1 1-.3 1.1-.9v-5.3h1c.5.1 1-.3 1.1-.9v-2c0-2.1 1-4 2.7-5.3 2.2-1.5 3.6-4 3.6-6.7V15c0-.6-.4-1-1-1h-2.7V6.9c-.1-.8-.8-1.5-1.6-1.4-.8 0-1.4.6-1.5 1.4V14h-5.3V6.9c-.1-.8-.8-1.5-1.6-1.4-.8-.1-1.5.6-1.6 1.4V14H14c-.6 0-1 .4-1 1v3.4c0 2.7 1.3 5.2 3.5 6.7 1.7 1.2 2.8 3.2 2.8 5.3v2c.1.5.5.9 1 .9h1.1v5.3c0 .5.4.9.9.9zm3.8-32.6c0-.3.3-.5.6-.5s.5.2.5.5V14h-1.1V6.9zm-8.3 0c-.1-.3.2-.5.5-.5s.5.2.5.5V14h-1V6.9zm.2 16.8c-1.7-1.2-2.8-3.2-2.8-5.3v-2.5h14.7v2.5c0 2.1-1.1 4.1-2.8 5.3-2.2 1.5-3.5 4-3.5 6.7v1.1h-2.1v-1.1c-.1-2.7-1.4-5.2-3.5-6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.5 31.5h2.1v-1.1c0-2.7 1.3-5.2 3.5-6.7 1.7-1.2 2.8-3.2 2.8-5.3v-2.5H15.1v2.5c0 2.1 1.1 4.1 2.8 5.3 2.2 1.5 3.5 4 3.5 6.7v1.1zM20.3 22h4.3c.3 0 .5.2.5.5s-.2.5-.5.5h-4.2c-.3 0-.6-.2-.6-.5s.3-.5.5-.5zm-.5-1.4c0-.3.2-.5.5-.5h4.3c.3 0 .5.2.5.5s-.2.5-.5.5h-4.2c-.2 0-.5-.2-.6-.5zm0-1.9c0-.2.3-.4.5-.4h4.3c.2 0 .5.2.5.4 0 .3-.2.5-.5.5h-4.2c-.2 0-.5-.2-.6-.5zM18.8 14V6.9c0-.3-.2-.5-.5-.5s-.6.2-.6.5h.1V14h1zM27.3 14V6.9c0-.3-.2-.5-.5-.5s-.6.2-.6.5V14h1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M20.5 19.2h4.2c.3 0 .5-.2.5-.5 0-.2-.3-.4-.5-.4h-4.3c-.2 0-.5.2-.5.4 0 .3.3.5.6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M20.5 21.1h4.2c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-4.3c-.3 0-.5.2-.5.5s.3.5.6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M20.5 23h4.2c.3 0 .5-.2.5-.5s-.3-.5-.6-.5h-4.3c-.3 0-.5.2-.5.5.1.3.4.5.7.5z"
  })))), _view39 || (_view39 = /*#__PURE__*/React.createElement("view", {
    id: "elevator",
    viewBox: "270 90 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 270,
    y: 90,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M19.7 5.1H8.5v4.5H5.1v30.3h34.8V9.6H25.3V5.1h-5.6zm-4.5 1.1h3.4v3.4h-3.4V6.2zm-5.6 0h4.5v3.4H9.6V6.2zM8.5 38.8V13h7.8v25.8H8.5zm16.8 0h-7.8V13h7.8v25.8zm1.1 0v-27H7.3v27H6.2V10.7h21.4v28.1h-1.2zm12.4 0H28.7V10.7h10.1v28.1zM24.2 9.6h-4.5V6.2h4.5v3.4z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19.7 6.2v3.4h4.5V6.2h-4.5zm3 2.9-.8-.8-.7.8-.8-.8 1.5-1.5 1.6 1.5-.8.8zM18.6 9.6V6.2h-3.4v3.4h3.4zm-2.3-1.1V7.3h1.2v1.2h-1.2zM14.1 9.6V6.2H9.6v3.4h4.5zm-3-2.7.7.8.8-.8.8.8-1.6 1.6-1.5-1.6.8-.8zM27.6 10.7H6.2v28.1h1.1v-27h19.1v27h1.2z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.5 13h7.9v25.8h-7.9zM8.5 13h7.9v25.8H8.5zM28.7 10.7v28.1h10.1V10.7H28.7zm5 25.1-2.8-3.7h5.7l-2.9 3.7zm2.9-4.9h-5.7V18.6h5.7v12.3zm0-13.4h-5.7l2.8-3.8 2.9 3.8z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M35.4 19.7h-3.3v4.5h1.1v1.1h-1.1v4.5h3.3v-4.5h-1.1v-1.1h1.1v-4.5zm-1.1 8.4h-1.1V27h1.1v1.1zm0-5.6h-1.1v-1.1h1.1v1.1zM33.2 16.3h1.1l-.6-.7zM33.7 33.9l.6-.7h-1.1z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M16.3 7.3h1.1v1.1h-1.1z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "m21.9 6.8-1.5 1.5.8.8.7-.8.8.8.8-.8z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "m11.8 9.3 1.6-1.6-.8-.8-.8.8-.7-.8-.8.8z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M30.9 18.6v12.3h5.7V18.6h-5.7zm4.5 5.6h-1.1v1.1h1.1v4.5h-3.3v-4.5h1.1v-1.1h-1.1v-4.5h3.3v4.5z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M33.2 21.4h1.1v1.1h-1.1zM33.2 27h1.1v1.1h-1.1z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M30.9 17.5h5.7l-2.9-3.8-2.8 3.8zm2.3-1.2.5-.7.6.7h-1.1z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "m30.9 32.1 2.8 3.7 2.9-3.7h-5.7zm2.8 1.8-.5-.7h1.1l-.6.7z"
  }))), _view40 || (_view40 = /*#__PURE__*/React.createElement("view", {
    id: "ev-charger",
    viewBox: "270 135 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 270,
    y: 135,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 38,
    width: 18,
    height: 3.2,
    rx: 1.2,
    fill: "#c3ccd2"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12c0-3.9 3.1-7 7-7s7 3.1 7 7v26.5H14z",
    fill: "#eef1f3"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 12.2c0-2 1.6-3.6 3.6-3.6s3.6 1.6 3.6 3.6v8.3h-7.2z",
    fill: "#333a40"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "m22.4 9.6-3.9 5.6h2.4L19.4 20l4-5.9H21z",
    fill: "#4cc38a"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 25,
    r: 1.5,
    fill: "#4cc38a"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6 24.5c4.6.4 6.4 3.2 6.4 7.2v4.5",
    fill: "none",
    stroke: "#333a40",
    strokeWidth: 1.9,
    strokeLinecap: "round"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6,
    y: 35.2,
    width: 4.8,
    height: 5.6,
    rx: 1.4,
    fill: "#333a40"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 32.9,
    y: 33.6,
    width: 2.2,
    height: 2.4,
    rx: 0.8,
    fill: "#5c6870"
  }))), _view41 || (_view41 = /*#__PURE__*/React.createElement("view", {
    id: "event_setup",
    viewBox: "270 180 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 270,
    y: 180,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M14.7 13.1h.5c.5 0 .9-.4.9-.9V8.5c0-.5-.4-.9-.9-.9h-.5c-.5 0-.9.4-.9.9v3.7c-.1.5.4.9.9.9zM27.4 13.1h.5c.5 0 .9-.4.9-.9V8.5c0-.5-.4-.9-.9-.9h-.5c-.5 0-.9.4-.9.9v3.7c0 .5.4.9.9.9zM18.2 17.4h-2.4c-.2 0-.4.2-.4.4v1.8c0 .2.2.4.4.4h2.4c.2 0 .4-.2.4-.4v-1.8c.1-.2-.1-.4-.4-.4zM22.5 17.4H20c-.2 0-.4.2-.4.4v1.8c0 .2.2.4.4.4h2.4c.2 0 .4-.2.4-.4v-1.8c.1-.2-.1-.4-.3-.4zM26.7 17.4h-2.4c-.2 0-.4.2-.4.4v1.8c0 .2.2.4.4.4h2.4c.2 0 .4-.2.4-.4v-1.8c-.1-.2-.2-.4-.4-.4zM30.9 17.4h-2.4c-.2 0-.4.2-.4.4v1.8c0 .2.2.4.4.4h2.4c.2 0 .4-.2.4-.4v-1.8c-.1-.2-.2-.4-.4-.4zM11.7 23.6H14c.2 0 .4-.2.4-.4v-1.8c0-.2-.2-.4-.4-.4h-2.4c-.2 0-.4.2-.4.4v1.8c0 .2.2.4.5.4z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M15.9 23.7h2.4c.2 0 .4-.2.4-.4v-1.8c0-.2-.2-.5-.4-.5h-2.4c-.2 0-.4.3-.4.5v1.8c0 .2.1.4.4.4z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M19.7 21.4v1.8c0 .2.2.4.4.4h2.4c.2 0 .4-.2.4-.4v-1.8c0-.2-.2-.4-.4-.4H20c-.2 0-.3.2-.3.4zM24.2 23.6h2.4c.2 0 .4-.2.4-.4v-1.8c0-.2-.2-.4-.4-.4h-2.4c-.2 0-.4.2-.4.4v1.8c.1.2.2.4.4.4zM30.9 23.6c.2 0 .4-.2.4-.4v-1.8c0-.2-.2-.4-.4-.4h-2.4c-.2 0-.4.2-.4.4v1.8c0 .2.2.4.4.4h2.4zM11.2 25.1v1.8c0 .2.2.4.4.4H14c.2 0 .4-.2.4-.4v-1.8c0-.2-.2-.4-.4-.4h-2.4c-.2 0-.4.2-.4.4zM18.2 24.7h-2.4c-.2 0-.4.2-.4.4v1.8c0 .2.2.4.4.4h2.4c.2 0 .4-.2.4-.4v-1.8c.1-.2-.1-.4-.4-.4zM22.5 24.7H20c-.2 0-.4.2-.4.4v1.8c0 .2.2.4.4.4h2.4c.2 0 .4-.2.4-.4v-1.8c.1-.2-.1-.4-.3-.4zM14 28.4h-2.4c-.2 0-.4.2-.4.4v1.8c0 .2.2.4.4.4H14c.2 0 .4-.2.4-.4v-1.8c.1-.2-.1-.4-.4-.4zM18.2 28.4h-2.4c-.2 0-.4.2-.4.4v1.8c0 .2.2.4.4.4h2.4c.2 0 .4-.2.4-.4v-1.8c.1-.2-.1-.4-.4-.4zM22.5 28.4H20c-.2 0-.4.2-.4.4v1.8c0 .2.2.4.4.4h2.4c.2 0 .4-.2.4-.4v-1.8c.1-.2-.1-.4-.3-.4z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M9 10.1c-.6 0-1.1.5-1.1 1.1v21.9c0 .6.5 1.1 1.1 1.1h15c-.2-.6-.4-1.1-.5-1.7H9.7V15.9h23.2V24l1.7.8V11.2c0-.6-.5-1.1-1.1-1.1h-4.1v2.1c0 .8-.7 1.5-1.5 1.6h-.5c-.8-.1-1.5-.8-1.5-1.6v-2.1h-9.2v2.1c0 .9-.7 1.6-1.6 1.6h-.4c-.9 0-1.6-.7-1.6-1.6v-2.1H9z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M37 31c0-3.5-2.9-6.4-6.4-6.4s-6.4 2.9-6.4 6.4c0 3.5 2.9 6.4 6.4 6.4S37 34.5 37 31zm-11.5 0c0-2.8 2.3-5.1 5.1-5.1s5.1 2.3 5.1 5.1-2.3 5.1-5.1 5.1-5.1-2.3-5.1-5.1z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M30.7 36.1c2.8 0 5.1-2.3 5.1-5.1s-2.3-5.1-5.1-5.1-5.1 2.3-5.1 5.1 2.2 5.1 5.1 5.1zm.2-8.7c.2.3.8 1.7.8 1.7 0 .1.1.2.2.2l1.9.2c.4 0 .4.3.2.5l-1.4 1.3c-.1 0-.1.1-.1.2l.4 1.9c0 .3-.2.5-.5.3l-1.6-1h-.3l-1.6 1c-.3.2-.5 0-.5-.3l.4-1.9v-.2c-.5-.4-1-.8-1.4-1.3-.3-.2-.2-.5.1-.5l1.9-.2c.1 0 .2-.1.2-.2 0 0 .6-1.4.8-1.7.1-.3.3-.3.5 0z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M29.5 29.1c0 .1-.1.2-.2.2l-1.9.2c-.3 0-.4.3-.1.5.4.5.9.9 1.4 1.3v.2l-.4 1.9c0 .3.2.5.5.3l1.6-1h.3l1.6 1c.3.2.5 0 .5-.3l-.4-1.9c0-.1 0-.2.1-.2L34 30c.2-.2.2-.5-.2-.5l-1.9-.2c-.1 0-.2-.1-.2-.2 0 0-.6-1.4-.8-1.7-.2-.3-.4-.3-.5 0-.2.3-.9 1.7-.9 1.7z"
  }))), _view42 || (_view42 = /*#__PURE__*/React.createElement("view", {
    id: "exclamation_mark",
    viewBox: "270 225 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 270,
    y: 225,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M39.3 30.6 27.9 9c-1.3-2.2-3-4-5.4-4s-4.1 1.8-5.4 4L5.6 30.7c-.8 2.1-.8 4.4.2 6.4.8 1.7 2.4 2.8 4.3 2.9h24.8c1.9-.1 3.5-1.2 4.3-2.9 1-2 1.1-4.4.1-6.5zm-2.2 5c-.4.9-1.2 1.4-2.2 1.5H10.1c-1-.1-1.8-.6-2.2-1.5-.5-1.1-.5-2.4-.1-3.5l11.3-21.5c.8-1.4 1.8-2.7 3.4-2.7s2.6 1.3 3.4 2.7l11.3 21.5c.4 1.1.4 2.4-.1 3.5z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M25.9 10.6c-.8-1.4-1.8-2.7-3.4-2.7s-2.6 1.3-3.4 2.7L7.8 32.1c-.4 1.1-.4 2.4.1 3.5.4.9 1.2 1.4 2.2 1.5h24.8c1-.1 1.8-.6 2.2-1.5.5-1.1.5-2.4.1-3.5L25.9 10.6zm-3.4 5.7c1.1.1 2 1.1 1.9 2.2l-.7 6.5c.1.7-.5 1.4-1.2 1.5-.7 0-1.2-.7-1.3-1.5l-.6-6.5c-.1-1.1.8-2.1 1.9-2.2zm.1 16.7h-.1c-1.1 0-2-1-1.9-2.1v-.1c-.1-1.1.8-2 1.9-2.1 1.1.1 2 1 1.9 2.1.1 1.1-.7 2.1-1.8 2.2z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M24.4 30.8c.1-1.1-.8-2-1.9-2.1-1.1.1-2 1-1.9 2.1v.1c0 1.1.8 2 1.9 2.1h.1c1.1-.1 1.9-1.1 1.8-2.2zM22.5 26.5c.7-.1 1.3-.8 1.2-1.5l.7-6.5c.1-1.1-.8-2.1-1.9-2.2-1.1.1-2 1.1-1.9 2.2l.6 6.5c.1.8.6 1.5 1.3 1.5z"
  }))), _view43 || (_view43 = /*#__PURE__*/React.createElement("view", {
    id: "eye",
    viewBox: "0 270 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    y: 270,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M2.8 17.1c-2.4 2.5-2.6 4.2.1 7.3 2.7 3.1 6.4 5.4 11.1 7.4 2.7 1.2 5.7 1.8 8.7 1.8h.4c6.8 0 13.3-3.2 19.2-9.5 2.2-2.3 2.2-4.4.1-6.7-5.4-6-12.7-9.8-19.9-9.7-7.2.2-14 3.5-19.7 9.4zm19.7-7.8c6.9.3 13.6 3.5 18.8 9.2 1.5 1.7 1.5 2.8-.1 4.6-5.6 5.9-11.7 9-18.1 9h-.4c-2.8 0-5.5-.6-8.1-1.8-4-1.5-7.6-3.9-10.5-6.9-1.8-2-1.8-3.2-.1-5.1 5.3-5.7 11.8-8.8 18.5-9z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.1 23.4c2.9 3.1 6.5 5.4 10.5 6.9 2.5 1.1 5.3 1.7 8.1 1.8h.4c6.4 0 12.5-3.1 18.1-9 1.6-1.8 1.6-2.9.1-4.6-5.2-5.7-11.9-9-18.8-9.2-6.8.2-13.2 3.2-18.5 9-1.8 1.9-1.8 3.1.1 5.1zm18.4-11.3c2.3-.1 4.5.9 6.1 2.5 1.7 1.6 2.6 3.8 2.5 6.1 0 4.8-3.9 8.7-8.7 8.7-4.8 0-8.7-3.9-8.7-8.7.2-4.7 4.1-8.5 8.8-8.6z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.5 29.4c4.8 0 8.7-3.9 8.7-8.7 0-2.3-.9-4.5-2.5-6.1-1.6-1.7-3.8-2.6-6.1-2.6v.1c-4.7 0-8.6 3.9-8.7 8.6-.1 4.8 3.8 8.7 8.6 8.7zm0-15.1c-1.2 2.4-.9 4.2.9 5.2s3.4.4 4.8-1.8c1.5 2.4 1.1 5.5-.9 7.6-2.5 2.7-6.6 2.8-9.3.4-1.8-1.7-2.5-4.3-1.8-6.7.8-2.9 3.4-4.7 6.3-4.7z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M18 25.6c2.7 2.5 6.8 2.3 9.3-.4 2-2 2.3-5.1.9-7.6-1.4 2.2-3.1 2.8-4.8 1.8-1.8-1-2.1-2.8-.9-5.2-2.9-.1-5.5 1.8-6.3 4.6-.7 2.5 0 5.1 1.8 6.8z"
  }))), _view44 || (_view44 = /*#__PURE__*/React.createElement("view", {
    id: "face-mask",
    viewBox: "45 270 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 45,
    y: 270,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17.5c-5.5.8-5.5 9.2 0 10M34.5 17.5c5.5.8 5.5 9.2 0 10",
    fill: "none",
    stroke: "#46626d",
    strokeWidth: 1.9,
    strokeLinecap: "round"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.5h22c1.4 0 2.5 1.1 2.5 2.5v10.4c0 1.4-1.1 2.5-2.5 2.5h-22c-1.4 0-2.5-1.1-2.5-2.5V17c0-1.4 1.1-2.5 2.5-2.5z",
    fill: "#4fb3c6"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 19.1,
    width: 23,
    height: 1.5,
    rx: 0.75,
    fill: "#d6ecf2"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 26,
    width: 23,
    height: 1.5,
    rx: 0.75,
    fill: "#d6ecf2"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 15.6,
    width: 8,
    height: 1.8,
    rx: 0.9,
    fill: "#46626d"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 21.2h2.2v1.7h1.7v2.2h-1.7v1.7h-2.2v-1.7h-1.7v-2.2h1.7z",
    fill: "#fff"
  }))), _view45 || (_view45 = /*#__PURE__*/React.createElement("view", {
    id: "faucet",
    viewBox: "90 270 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 90,
    y: 270,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M11.9 8.7c-.3 0-.6.2-.6.5v2.1c0 .3.3.6.6.6h5.8v.5c0 .3.3.5.6.5h.5v2.2h-3.2c-.3 0-.5.2-.5.5v1.1h-3.2v-.6c0-.3-.3-.5-.6-.5H8.1c-.3 0-.5.2-.5.5v7.5c0 .3.2.5.5.5h3.2c.3 0 .6-.2.6-.5V23h3.2v1.1c0 .3.2.5.5.5h10.6c.3 0 .6-.2.6-.5V23h1.6c.9 0 1.6.7 1.6 1.6v1.1h-.6c-.3 0-.5.2-.5.5v2.2c0 .3.2.5.5.5h7.5c.3 0 .5-.2.5-.5v-2.2c0-.3-.2-.5-.5-.5h-.5v-2.1c0-3.8-3.1-6.9-6.9-6.9h-2.7v-1.1c0-.3-.3-.5-.6-.5H23v-2.2h.6c.3 0 .5-.2.5-.5v-.5H30c.3 0 .5-.3.5-.6V9.2c0-.3-.2-.5-.5-.5h-5.9v-.6c0-.3-.2-.5-.5-.5h-5.3c-.3 0-.6.2-.6.5v.6h-5.8zm11.2 3.2h-4.3V8.7h4.3v3.2zM22 15h-2.1v-2.1H22V15zm-10.1 7v-4.3h3.2V22h-3.2zm4.2 1.6v-7.5h9.6v7.5h-9.6zm19.2-.2V25.7H31v-1.1c0-1.4-1.2-2.6-2.6-2.6h-1.6v-4.3h2.6c3.2-.1 5.8 2.5 5.9 5.7zM24.1 9.7h5.3v1.1h-5.3V9.7zm-6.4 0v1.1h-5.3V9.7h5.3z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M18.8 8.7h4.3v3.2h-4.3zM24.1 9.7h5.3v1.1h-5.3zM12.4 9.7h5.3v1.1h-5.3z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M19.9 12.9H22V15h-2.1zM11.9 17.7h3.2V22h-3.2zM16.1 16.1h9.6v7.5h-9.6zM26.8 17.7V22h1.6c1.4 0 2.6 1.2 2.6 2.6v1.1h4.3V23.4c-.1-3.2-2.7-5.8-5.9-5.7h-2.6z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "m33.6 30.2-.4-.2-.5.2c-.3.5-2.2 3.3-2.2 4.6.3 1.5 1.7 2.4 3.2 2.1 1.1-.2 1.9-1.1 2.1-2.1 0-1.3-1.8-4.1-2.2-4.6z"
  }))), _view46 || (_view46 = /*#__PURE__*/React.createElement("view", {
    id: "file_storage",
    viewBox: "135 270 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 135,
    y: 270,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M4.6 7.9v29.2c0 .2.2.4.4.4h34.9c.2 0 .4-.2.4-.4V11.3c0-.2-.2-.4-.4-.4H22.6l-1.8-3.2c-.1-.1-.2-.2-.4-.2H4.9c-.2 0-.3.2-.3.4zm35 3.8v1.7H24.1l-1-1.7h16.5zM5.4 8.3h14.8l3.2 5.7.3.2h15.8v22.5H5.4V8.3z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M39.6 14.2H23.7l-.3-.2-3.2-5.7H5.4v28.4h34.2z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M39.6 13.4v-1.7H23.1l1 1.7z"
  }))), _view47 || (_view47 = /*#__PURE__*/React.createElement("view", {
    id: "filter-socks",
    viewBox: "180 270 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 180,
    y: 270,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.8 0 0 .8 12 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2 10.5c.2 9.5 1.8 20 6.8 20s6.6-10.5 6.8-20z",
    fill: "#dfe6ec"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 10.3,
    rx: 7,
    ry: 2.2,
    fill: "#8f9ba3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 10.3,
    rx: 5.2,
    ry: 1.4,
    fill: "#5c6870"
  }))), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 10.5c.2 9.5 1.8 20 6.8 20s6.6-10.5 6.8-20z",
    fill: "#eef1f5"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "m12.6 14 8.8 8.6M12.4 19l6.6 7.6M23.4 14l-8.8 8.6M23.6 19 17 26.6",
    fill: "none",
    stroke: "#c3ccd2",
    strokeWidth: 0.8
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 10.3,
    rx: 7,
    ry: 2.2,
    fill: "#8f9ba3"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 10.3,
    rx: 5.2,
    ry: 1.4,
    fill: "#5c6870"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M18 32.5s1 1.7 1 2.5c0 .6-.45 1-1 1s-1-.4-1-1c0-.8 1-2.5 1-2.5zM14.8 36.2s.85 1.5.85 2.2c0 .55-.4.9-.85.9s-.85-.35-.85-.9c0-.7.85-2.2.85-2.2zM21.2 36.2s.85 1.5.85 2.2c0 .55-.4.9-.85.9s-.85-.35-.85-.9c0-.7.85-2.2.85-2.2z",
    fill: "#9fd8ef"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 8.5,
    r: 6,
    fill: "#23967f"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8 8.5a3.3 3.3 0 1 1-3.3-3.3",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "m37.3 3.5 3.2 1.7-3.2 1.7z",
    fill: "#fff"
  }))), _view48 || (_view48 = /*#__PURE__*/React.createElement("view", {
    id: "fire_extinguisher",
    viewBox: "225 270 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 225,
    y: 270,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M18.6 36.7c2 1.1 4.4 1.1 6.4 0 .6-.3.9-.9.9-1.5V17.4c0-1.4-.7-2.7-1.9-3.4l-.6-.3v-.5c.5-.1.9-.4 1.1-.8l4.1 2.1c.5.2 1.1 0 1.4-.5.2-.5 0-1.1-.5-1.4L25 10.4l3.4-.8c.5-.1.8-.5.8-1v-.2c0-.3-.2-.5-.4-.6-.2-.2-.5-.2-.8-.2L21.9 9h-.1c-.8-.1-1.5.5-1.6 1.3-2.9.5-5 3-5 5.9v10.6c-.2.2-.3.5-.3.8v3.3c0 .2.2.3.4.3h1.8c.1 0 .1-.1.1-.2v-3.4c0-.2-.1-.5-.2-.7V16.4c0-1.9 1.3-3.6 3.2-4v1.3l-.6.3c-1.2.7-1.9 2-1.9 3.4v17.8c0 .6.3 1.2.9 1.5zm.3-6.9h-.5v-.6h.3c2 .6 4.2.6 6.2 0h.3v.6h-.5c-1.9.6-3.9.6-5.8 0zm-.5-1.3V26h.3c2 .6 4.2.6 6.2 0h.3v2.4h-.5c-1.9.6-3.9.7-5.8.1h-.5zm2.7-16.9c0 .9.7 1.6 1.6 1.7v.9c-.5.4-1.3.4-1.8 0v-3.6c0-.5.4-.9.9-.9h.5c-.8.2-1.3 1-1.2 1.9zm8.1 1.6c.1 0 .2.2.1.4h-.4l-4.1-2V11l4.4 2.2zm-5.9-3.8 4.9-1.1c.2 0 .3.1.3.3 0 .2-.1.3-.2.3l-4.3 1-.6-.4-.1-.1zm-7.4 17.8h.2c.2 0 .4.3.4.5v2.9h-.9v-3c0-.1.1-.4.3-.4zm.4-10.8v10H16V16.2c0-2.5 1.7-4.7 4.2-5.1v.5c-2.3.4-3.9 2.4-3.9 4.8zm2.1 1c0-1.2.6-2.2 1.6-2.8h.2l.3.4c.8.5 1.7.5 2.5 0 .2-.1.3-.3.4-.4h.2c.5.3.9.7 1.2 1.2.2.5.4 1 .4 1.6V20h-.5c-1.9.6-3.9.6-5.8 0h-.5v-2.6zm.5 8.1h-.5v-4.7h.3c2 .6 4.2.6 6.2 0h.3v4.6h-.5c-1.9.6-3.9.6-5.8.1zm-.5 9.6v-4.7h.3c2 .6 4.2.7 6.2.1h.3v4.7c0 .4-.2.7-.5.9-1.8.9-4 .9-5.8 0-.3-.2-.5-.6-.5-1z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M20.2 11.1c-2.5.4-4.2 2.6-4.2 5.1v10.2h.3v-10c0-2.3 1.6-4.3 3.9-4.8v-.5z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M20.9 10.6v3.6c.5.4 1.3.4 1.8 0v-.9c-.9-.1-1.6-.8-1.6-1.7-.1-.8.4-1.6 1.2-1.9h-.5c-.5-.1-.9.4-.9.9zM15.6 30.5h.9v-2.9c0-.2-.2-.5-.4-.5h-.3c-.1 0-.2.2-.2.3v3.1z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M25.2 29.8v-.6h-.3c-2 .6-4.2.6-6.2 0h-.3v.6h.5c1.9.6 3.9.6 5.8 0h.5zM24.7 25.5h.5v-4.7h-.3c-2 .6-4.2.6-6.2 0h-.3v4.6h.5c1.9.6 3.9.6 5.8.1zM24.7 28.5h.5V26h-.3c-2 .6-4.2.6-6.2 0h-.3v2.4h.5c1.9.7 3.9.7 5.8.1z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M18.9 36c1.8.9 4 .9 5.8 0 .3-.2.5-.5.5-.9v-4.7h-.3c-2 .6-4.2.6-6.2 0h-.3v4.7c0 .4.2.8.5.9zM18.9 20.2c1.9.6 3.9.6 5.8 0h.5v-2.8c0-.6-.2-1.1-.4-1.6-.3-.5-.7-.9-1.2-1.2h-.2c-.1.1-.2.3-.4.4-.8.5-1.7.5-2.5 0l-.3-.4H20c-1 .6-1.6 1.6-1.6 2.8V20l.5.2z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "m24 9.9 4.3-1c.1 0 .2-.1.2-.3 0-.2-.1-.3-.3-.3l-4.9 1.1h.1l.6.5zM24.8 11.6l4.1 2.1h.4c.1-.2 0-.4-.1-.4L24.8 11v.6z"
  }))), _view49 || (_view49 = /*#__PURE__*/React.createElement("view", {
    id: "first_aid_box",
    viewBox: "270 270 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 270,
    y: 270,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M25.1 9.4h-5.3c-1.4.1-2.6 1.3-2.5 2.7v.8h10.4V12c0-1.5-1.2-2.7-2.6-2.6z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M25.1 7.6h-5.2c-2.4 0-4.4 2-4.4 4.4v.8h-5.2c-1.9 0-3.5 1.6-3.5 3.5v17.5c0 1.9 1.6 3.5 3.5 3.5h24.4c1.9 0 3.5-1.6 3.5-3.5V16.4c0-1.9-1.6-3.5-3.5-3.5h-5.2v-.8c0-2.5-2-4.5-4.4-4.5zm9.6 7.8c.5 0 .9.4.9.9v17.4c0 .5-.4.9-.9.9H10.3c-.5 0-.9-.4-.9-.9V16.4c0-.5.4-.9.9-.9h24.4zm-7-3.5v.9H17.3V12c-.1-1.4 1.1-2.6 2.5-2.7h5.3c1.4 0 2.6 1.2 2.6 2.6z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.4 16.4v17.4c0 .5.4.9.9.9h24.4c.5 0 .9-.4.9-.9V16.4c0-.5-.4-.9-.9-.9H10.3c-.5-.1-.9.4-.9.9zm17.5 7.4v2.7h-3.1v3h-2.6v-3h-3.1v-2.7h3.1v-3h2.6v3h3.1zm7 9.1H11.2v-1.7h22.7v1.7zM11.2 17.3h22.7V19H11.2v-1.7z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M21.2 20.8v3h-3.1v2.6h3.1v3h2.6v-3h3.1v-2.6h-3.1v-3z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M11.2 17.3h22.7V19H11.2zM11.2 31.1h22.7v1.7H11.2z"
  }))), _view50 || (_view50 = /*#__PURE__*/React.createElement("view", {
    id: "fitness-equipment",
    viewBox: "315 0 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 315,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14.7,
    width: 19,
    height: 2.6,
    rx: 1.3,
    fill: "#8f9ba3"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 3.8,
    height: 12,
    rx: 1.5,
    fill: "#3f4a54"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 11.5,
    width: 3,
    height: 9,
    rx: 1.3,
    fill: "#3f4a54"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8,
    y: 11.5,
    width: 3,
    height: 9,
    rx: 1.3,
    fill: "#3f4a54"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 10,
    width: 3.8,
    height: 12,
    rx: 1.5,
    fill: "#3f4a54"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8 29.5c0-5 9.4-5 9.4 0",
    fill: "none",
    stroke: "#d84338",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 33,
    r: 5.2,
    fill: "#d84338"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 38.2,
    width: 39,
    height: 1.5,
    rx: 0.75,
    fill: "#c3ccd2"
  }))), _view51 || (_view51 = /*#__PURE__*/React.createElement("view", {
    id: "floor-repairs",
    viewBox: "315 45 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 315,
    y: 45,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8d6e0",
    d: "M4 20h37v16H4z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "#aec1cf",
    d: "M4 20h5.3v5.3H4zM14.6 20h5.3v5.3h-5.3zM25.2 20h5.3v5.3h-5.3zM35.8 20H41v5.3h-5.2zM9.3 25.3h5.3v5.3H9.3zM30.5 25.3h5.3v5.3h-5.3zM4 30.6h5.3V36H4zM14.6 30.6h5.3V36h-5.3zM25.2 30.6h5.3V36h-5.3zM35.8 30.6H41V36h-5.2z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c6870",
    d: "M19.9 25.3h5.3v5.3h-5.3z"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 9,
    width: 6.5,
    height: 6.5,
    rx: 0.6,
    fill: "#aec1cf",
    transform: "rotate(-15 21.7 12.2)"
  }))), _view52 || (_view52 = /*#__PURE__*/React.createElement("view", {
    id: "flooring",
    viewBox: "315 90 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 315,
    y: 90,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfe6ec",
    d: "M2.5 8h40v8.5h-40z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4bfc6",
    d: "M2.5 15.2h40v1.3h-40z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8d6e0",
    d: "M2.5 16.5h40v21h-40z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "#aec1cf",
    d: "M2.5 16.5h5v5.25h-5zM12.5 16.5h5v5.25h-5zM22.5 16.5h5v5.25h-5zM32.5 16.5h5v5.25h-5zM7.5 21.75h5V27h-5zM17.5 21.75h5V27h-5zM27.5 21.75h5V27h-5zM37.5 21.75h5V27h-5zM2.5 27h5v5.25h-5zM12.5 27h5v5.25h-5zM22.5 27h5v5.25h-5zM32.5 27h5v5.25h-5zM7.5 32.25h5v5.25h-5zM17.5 32.25h5v5.25h-5zM27.5 32.25h5v5.25h-5zM37.5 32.25h5v5.25h-5z"
  }))), _view53 || (_view53 = /*#__PURE__*/React.createElement("view", {
    id: "flooring-no-photo",
    viewBox: "315 135 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 315,
    y: 135,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfe6ec",
    d: "M2.5 8h40v8.5h-40z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4bfc6",
    d: "M2.5 15.2h40v1.3h-40z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8d6e0",
    d: "M2.5 16.5h40v21h-40z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "#aec1cf",
    d: "M2.5 16.5h5v5.25h-5zM12.5 16.5h5v5.25h-5zM22.5 16.5h5v5.25h-5zM32.5 16.5h5v5.25h-5zM7.5 21.75h5V27h-5zM17.5 21.75h5V27h-5zM27.5 21.75h5V27h-5zM37.5 21.75h5V27h-5zM2.5 27h5v5.25h-5zM12.5 27h5v5.25h-5zM22.5 27h5v5.25h-5zM32.5 27h5v5.25h-5zM7.5 32.25h5v5.25h-5zM17.5 32.25h5v5.25h-5zM27.5 32.25h5v5.25h-5zM37.5 32.25h5v5.25h-5z"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 9,
    r: 7.2,
    fill: "#5c6870"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 32.3,
    y: 7,
    width: 7.4,
    height: 4.8,
    rx: 1,
    fill: "#fff"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 34.1,
    y: 6,
    width: 2.6,
    height: 1.4,
    rx: 0.6,
    fill: "#fff"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 9.4,
    r: 1.5,
    fill: "#5c6870"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 35.15,
    y: 3,
    width: 1.7,
    height: 12,
    rx: 0.85,
    fill: "#d84338",
    transform: "rotate(45 36 9)"
  }))), _view54 || (_view54 = /*#__PURE__*/React.createElement("view", {
    id: "floors-doors-shades",
    viewBox: "315 180 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 315,
    y: 180,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 33.5,
    width: 38,
    height: 6,
    rx: 1.2,
    fill: "#c8925a"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "#a9713d",
    d: "M3.5 36.1h38v.9h-38zM12 33.5h1v2.6h-1zM29 33.5h1v2.6h-1zM20.5 37h1v2.5h-1zM36 37h1v2.5h-1z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8H17c.6 0 1 .4 1 1v24.5H6.5V9c0-.6.4-1 1-1z",
    fill: "#c7d3dc"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "#5a7d9a",
    d: "M8 9.5h8.5v24H8z"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 11.5,
    width: 5.5,
    height: 8,
    rx: 0.8,
    fill: "#6e91ad"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.1,
    cy: 22.5,
    r: 0.95,
    fill: "#3f4a54"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 8,
    width: 17,
    height: 17,
    rx: 1.2,
    fill: "#7a6a55"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "#cfe6f2",
    d: "M25 9.5h14v14H25z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8ddc8",
    d: "M25 11.2h14v1.5H25zM25 13.3h14v1.5H25zM25 15.4h14v1.5H25zM25 17.5h14V19H25z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9c9a8",
    d: "M25 19.6h14v1.8H25z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3 21.4V23",
    fill: "none",
    stroke: "#7a6a55",
    strokeWidth: 0.8
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.3,
    cy: 23.5,
    r: 0.7,
    fill: "#7a6a55"
  }))), _view55 || (_view55 = /*#__PURE__*/React.createElement("view", {
    id: "food",
    viewBox: "315 225 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 315,
    y: 225,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M8.5 22.5c0 7.3 6 13.3 13.3 13.3S35 29.8 35 22.5c0-3.5-1.4-6.9-3.9-9.4-5.2-5.2-13.6-5.2-18.8 0-2.4 2.5-3.8 5.9-3.8 9.4zm4.5-8.8c2.3-2.3 5.5-3.6 8.8-3.6 3.3-.1 6.5 1.2 8.8 3.6 2.4 2.3 3.7 5.5 3.7 8.8 0 3.3-1.3 6.5-3.7 8.8l-.2.2c-4.9 4.7-12.6 4.7-17.4-.2-2.4-2.3-3.7-5.5-3.7-8.8-.1-3.3 1.3-6.5 3.7-8.8z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M9.2 22.5c0 3.3 1.3 6.5 3.7 8.8 4.7 4.9 12.5 5 17.4.2l.2-.2c2.4-2.3 3.7-5.5 3.7-8.8 0-3.3-1.3-6.5-3.7-8.8-2.3-2.4-5.5-3.7-8.8-3.6-3.3 0-6.5 1.3-8.8 3.6-2.3 2.3-3.7 5.5-3.7 8.8zm8-4.6c1.2-1.2 2.9-1.9 4.6-1.9 1.7 0 3.4.7 4.6 1.9 1.3 1.2 2 2.9 2 4.6 0 1.8-.7 3.5-2 4.7-1.2 1.2-2.9 1.9-4.6 1.9-1.7 0-3.4-.7-4.6-2-1.3-1.2-2-2.9-1.9-4.6-.1-1.7.6-3.4 1.9-4.6z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M40.2 8.1H39c-.2 0-.5.2-.5.4v4.3h-.4V8.5c0-.2-.2-.4-.4-.4h-1.3c-.2 0-.4.2-.4.4v8c0 .9.3 1.8 1 2.5.3.4.7.7 1.2.8v15.7c0 .8.6 1.4 1.4 1.5.8-.1 1.4-.7 1.4-1.5V19.8c.4-.2.8-.5 1.2-.8.6-.7 1-1.6 1-2.5v-8c0-.2-.2-.4-.4-.4h-1.3c-.2 0-.4.2-.4.4v4.3h-.4V8.5c0-.2-.2-.4-.5-.4zm1.4 5.5c.2 0 .4-.2.4-.4V8.9h.4V16.5c0 .7-.3 1.4-.8 1.9-.3.3-.7.6-1.1.7-.2.1-.3.2-.3.4v16c0 .3-.3.6-.6.6s-.6-.3-.6-.6v-16c0-.2-.1-.3-.3-.4-.4-.1-.8-.4-1.1-.7-.5-.5-.8-1.2-.8-1.9V8.9h.4v4.3c0 .2.3.4.5.4H39c.2 0 .4-.2.4-.4V8.9h.4v4.3c0 .2.2.4.4.4h1.4z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M39.8 13.2V8.9h-.4v4.3c0 .2-.2.4-.4.4h-1.3c-.2 0-.5-.2-.5-.4V8.9h-.4v7.6c0 .7.3 1.4.8 1.9.3.3.7.6 1.1.7.2.1.3.2.3.4v16c0 .3.3.6.6.6s.6-.3.6-.6v-16c0-.2.1-.3.3-.4.4-.1.8-.4 1.1-.7.5-.5.8-1.2.8-1.9V8.9H42v4.3c0 .2-.2.4-.4.4h-1.4c-.2 0-.4-.2-.4-.4z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M21.8 29.1c1.7 0 3.4-.7 4.6-1.9 1.3-1.2 2-2.9 2-4.7 0-1.7-.7-3.4-2-4.6-1.2-1.2-2.9-1.9-4.6-1.9-1.7 0-3.4.7-4.6 1.9-1.2 1.2-1.9 2.9-1.9 4.6-.1 1.7.6 3.4 1.9 4.6 1.1 1.3 2.8 2 4.6 2zm0-12.3c1.5 0 3 .6 4 1.7 1.1 1.1 1.7 2.5 1.7 4s-.6 3-1.7 4.1c-1.1 1-2.5 1.6-4 1.6s-2.9-.6-4-1.6c-1.1-1.1-1.7-2.6-1.7-4.1 0-3.1 2.5-5.6 5.7-5.7z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M21.8 28.2c1.5 0 2.9-.6 4-1.6 1.1-1.1 1.7-2.6 1.7-4.1 0-1.5-.6-2.9-1.7-4-1-1.1-2.5-1.7-4-1.7a5.9 5.9 0 0 0-5.7 5.7c0 1.5.6 3 1.7 4.1 1 1 2.5 1.6 4 1.6z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M1.8 12.3v13c0 .2.2.5.4.5h.2v10.1c0 .8.6 1.4 1.4 1.4s1.4-.6 1.4-1.4V25.8h.2c.2 0 .4-.3.4-.5V9.2c0-.5-.2-1-.5-1.3-.5-.3-1-.3-1.5 0l-.6.6c-.9 1.1-1.4 2.4-1.4 3.8zm2-3.3.5-.4h.5c.1.2.2.4.2.6v15.7h-.2c-.2 0-.4.2-.4.4v10.6c0 .3-.3.6-.6.6s-.6-.3-.6-.6V25.3c0-.2-.2-.4-.4-.4h-.3V12.3c.1-1.2.6-2.3 1.3-3.3z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M2.5 24.9h.2c.2 0 .4.2.4.4v10.6c0 .3.3.6.6.6s.6-.3.6-.6V25.3c0-.2.2-.4.4-.4H5V9.2c0-.2-.1-.4-.2-.6h-.6l-.4.4c-.7 1-1.1 2.1-1.2 3.3v12.6z"
  }))), _view56 || (_view56 = /*#__PURE__*/React.createElement("view", {
    id: "food-and-beverages-new",
    viewBox: "315 270 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 315,
    y: 270,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 22c0-4.8 4.3-8 9.7-8s9.7 3.2 9.7 8z",
    fill: "#e8b45a"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 17.7,
    rx: 0.9,
    ry: 0.55,
    fill: "#fff3da"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.2,
    cy: 16.6,
    rx: 0.9,
    ry: 0.55,
    fill: "#fff3da"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.3,
    cy: 17.9,
    rx: 0.9,
    ry: 0.55,
    fill: "#fff3da"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "#57b368",
    d: "M5.2 22h20v1.7h-20z"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 23.7,
    r: 1.3,
    fill: "#57b368"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8,
    cy: 23.7,
    r: 1.3,
    fill: "#57b368"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6,
    cy: 23.7,
    r: 1.3,
    fill: "#57b368"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3,
    cy: 23.7,
    r: 1.3,
    fill: "#57b368"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2c14e",
    d: "M6 24.8h18.5v1.6H6z"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 5.8,
    y: 26.4,
    width: 19,
    height: 2.6,
    rx: 1.3,
    fill: "#8a5a33"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 29,
    width: 19.7,
    height: 4.2,
    rx: 2,
    fill: "#d99a3f"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 5,
    width: 1.7,
    height: 8.5,
    rx: 0.85,
    fill: "#e0704f",
    transform: "rotate(14 34.3 13)"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 12.3,
    width: 8,
    height: 1.4,
    rx: 0.7,
    fill: "#3d8fa3"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8,
    y: 13.6,
    width: 12.4,
    height: 2,
    rx: 1,
    fill: "#3d8fa3"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 15.6h11l-1.3 15.9c-.1 1-.9 1.7-1.9 1.7h-4.6c-1 0-1.8-.7-1.9-1.7z",
    fill: "#4fb3c6"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "#dff2f7",
    d: "M29.3 20.5h9.4v2.6h-9.4z"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.8,
    cy: 28.8,
    r: 1.9,
    fill: "#57b368"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 27.7,
    r: 2,
    fill: "#3f8f4f"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.3,
    cy: 28.5,
    r: 1.9,
    fill: "#57b368"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 27.8,
    r: 2,
    fill: "#3f8f4f"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.4,
    cy: 28.8,
    r: 1.8,
    fill: "#57b368"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3,
    cy: 27,
    r: 0.95,
    fill: "#c8503f"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 26.7,
    r: 0.95,
    fill: "#c8503f"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 26,
    width: 2.2,
    height: 0.95,
    rx: 0.45,
    fill: "#e8923a",
    transform: "rotate(18 25.2 26.5)"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 29.6,
    y: 27.2,
    width: 2.2,
    height: 0.95,
    rx: 0.45,
    fill: "#e8923a",
    transform: "rotate(-14 30.7 27.7)"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 27,
    r: 0.7,
    fill: "#8e6bb5"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.6,
    cy: 28.7,
    r: 0.55,
    fill: "#f2c14e"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.4,
    cy: 28.9,
    r: 0.55,
    fill: "#f2c14e"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.7,
    cy: 29,
    r: 0.55,
    fill: "#f2c14e"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 29.5h15c0 4-3.3 6.5-7.5 6.5s-7.5-2.5-7.5-6.5z",
    fill: "#dfe6ec"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 29.5,
    width: 15,
    height: 1.3,
    rx: 0.65,
    fill: "#c3ccd2"
  }))), _view57 || (_view57 = /*#__PURE__*/React.createElement("view", {
    id: "food_and_beverage",
    viewBox: "0 315 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    y: 315,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m11.2 30.1 1.5.5c.4-.1.8-.2 1.1-.4.4-.4.9-.6 1.5-.6h-5l.9.5zM20.4 29.6c.6 0 1.1.2 1.5.6.3.2.7.4 1.1.4.4-.1.8-.2 1.1-.4.4-.4.9-.6 1.4-.6h-5.1zM16.7 30.3c.3.2.7.3 1.1.4.4 0 .8-.2 1.1-.4.4-.4.9-.6 1.5-.6h-5.1c.5 0 1 .2 1.4.6zM17.8 33.3c.4 0 .8-.2 1.1-.5.3-.2.7-.3 1-.4h-4.6c.5 0 1 .2 1.4.5.3.2.7.3 1.1.4zM20.9 32.3c.4.1.7.2 1 .4.3.3.7.5 1.1.5.4-.1.8-.2 1.1-.5.3-.2.6-.3.9-.4h-4.1zM26 32.3c.4.1.7.2 1 .4.3.3.7.4 1.1.5.5-.1 1-.3 1.5-.5l.7-.4H26zM13.8 32.8c.5-.3 1-.5 1.5-.5h-5l.9.5c.5.2 1 .4 1.5.5.4 0 .8-.2 1.1-.5z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M14.2 30.9c.3-.2.7-.4 1.1-.4.4.1.8.2 1.1.4.4.4.9.6 1.4.6.6 0 1.1-.2 1.5-.6.3-.2.7-.3 1.1-.4.4.1.8.2 1.1.4.4.4.9.6 1.5.6.5 0 1.1-.3 1.5-.6.3-.2.6-.3 1-.4.4 0 .8.2 1.1.4.4.4.9.6 1.5.6s1.3-.3 1.8-.6c.4-.1.7-.3 1-.5.2-.1.2-.3.1-.5s-.3-.2-.5-.1l-.9.5-1.5.4c-.4-.1-.8-.2-1.1-.4-.4-.4-.9-.6-1.5-.6-.5 0-1 .2-1.4.6-.3.2-.7.3-1.1.4-.4 0-.8-.2-1.1-.4-.4-.4-.9-.6-1.5-.6s-1.1.2-1.5.6c-.3.2-.7.4-1.1.4-.4-.1-.8-.2-1.1-.4-.4-.4-.9-.6-1.4-.6-.6 0-1.1.2-1.5.6-.3.2-.7.3-1.1.4l-1.5-.5-.9-.5h20.4c.2 0 .4-.2.4-.4 0-.4-.1-.8-.2-1.2H33l-.2 4c0 .4-.1.7-.3 1-.2.2-.4.3-.7.4v.7c.5 0 .9-.2 1.2-.6.3-.4.5-.9.6-1.4l.8-14.8c.5-.3.9-.8.9-1.4-.1-.8-.7-1.4-1.5-1.4h-.1c-.1-1.6-.8-3-1.9-4.1l1-1.4 2-.7h.1c.1-.1.2-.2.2-.4-.1-.2-.2-.3-.4-.3h-.2l-2.1.7-.2.2-1 1.4c-.9-.6-2.1-1-3.2-1-3.1 0-5.6 2.5-5.7 5.6h-.2c-.8 0-1.4.6-1.5 1.4 0 .6.4 1.1.9 1.3l.2 2.8h-1.3c-2.8.1-5.5 1.2-7.5 3.2-2 1.8-3.2 4.1-3.1 6 0 .2.1.4.3.4-.2 0-.3.1-.3.3-.1.2 0 .3.1.4l1 .5c.5.3 1.2.5 1.8.6.6-.1 1.1-.3 1.5-.6zm18.9-3.5h-2.4c-.6-1.5-1.6-2.9-2.8-4-.4-.5-.9-.9-1.4-1.2h6.9l-.3 5.2zM28 9.8v-.2c1 0 2 .4 2.8 1l-1.3 1.8c-.1.3.1.7.4.6h.3l1.2-1.9c1 .9 1.5 2.2 1.5 3.5H23c.1-2.6 2.3-4.8 5-4.8zm-6.6 6.1c0-.4.3-.7.7-.7h11.7c.4 0 .7.3.7.7s-.3.7-.7.7H22.1c-.4 0-.7-.3-.7-.7zm.8 1.5h11.5l-.3 4h-8c-.9-.5-1.9-.9-2.9-1.1l-.3-2.9zm-8.8 6.5c1.9-1.8 4.4-2.9 7-3 2.6.1 5.1 1.2 7 3 1.5 1.3 2.5 3.1 2.8 5H10.6c.3-2 1.3-3.8 2.8-5zM10.1 35.1h20.6c.1 0 .3-.1.3-.2.1-.1.1-.3 0-.4 0-.1-.2-.2-.3-.2H10.1c-.2 0-.4.2-.4.4.1.1.2.4.4.4zM30.6 35.1H10.1c-.2 0-.3.2-.3.4 0 .6.2 1.1.6 1.5.4.2.8.3 1.3.3h17.4c.4 0 .8-.1 1.2-.3.5-.3.7-.9.7-1.5 0-.2-.2-.4-.4-.4zm-.7 1.3H11.8c-.3 0-.7-.1-1-.2-.1 0-.2-.1-.2-.3v-.1.1h19.6l-.3.5z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M14.2 33.4c.3-.2.7-.4 1.1-.4.4.1.8.2 1.1.4.4.4.9.6 1.4.6.6 0 1.1-.2 1.5-.6.3-.2.7-.3 1.1-.4.4.1.8.2 1.1.4.4.4.9.6 1.5.6.5 0 1.1-.3 1.5-.6.3-.2.6-.3 1-.4.4 0 .8.2 1.1.4.4.4.9.6 1.5.6.6-.1 1.2-.2 1.8-.5l1-.6c.1 0 .2-.2.2-.3 0-.1-.2-.3-.3-.3l.3-.3c0-.1 0-.3-.1-.4H10v-.1c-.2 0-.3.2-.3.4s.1.3.3.3l-.3.4c0 .1.1.3.2.3l1 .6c.6.3 1.2.4 1.8.5.6 0 1.1-.2 1.5-.6zm9.9-.6c-.3.3-.7.4-1.1.5-.4 0-.8-.2-1.1-.5-.3-.2-.7-.3-1-.4H25c-.3 0-.6.2-.9.4zm5.5 0c-.5.2-1 .4-1.5.5-.4-.1-.8-.2-1.1-.5-.3-.2-.7-.3-1-.4h4.3l-.7.4zm-19.3-.5h9.6c-.4.1-.7.2-1 .4-.3.3-.7.5-1.1.5-.4 0-.8-.2-1.1-.4-.4-.3-.9-.5-1.4-.5-.5 0-1 .2-1.5.5-.3.3-.7.4-1.1.5-.5-.1-1-.3-1.5-.5l-.9-.5z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M22.1 16.6h11.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7H22.1c-.4 0-.7.3-.7.7s.3.7.7.7z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M25.4 21.4h8l.3-4H22.2l.3 2.9c1 .3 2 .6 2.9 1.1zM26.5 22.1c.5.3 1 .7 1.4 1.2 1.2 1.1 2.2 2.5 2.8 4h2.4l.3-5.2h-6.9z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M32.9 14.6c0-1.3-.5-2.6-1.5-3.5L30.2 13h-.3c-.3.1-.5-.3-.4-.6l1.3-1.8c-.8-.6-1.8-.9-2.8-1v.1c-2.7.1-4.9 2.2-5 4.9h9.9z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "#CD9444",
    d: "M10.8 36.3c.3.1.7.2 1 .2h18.1l.3-.5H10.6c0 .1.1.3.2.3zM10.6 35.9zM30.2 28.9c-.3-1.9-1.3-3.7-2.8-5-1.9-1.8-4.4-2.9-7-3-2.6.1-5.1 1.2-7 3-1.5 1.3-2.5 3-2.8 5h19.6z"
  }))), _view58 || (_view58 = /*#__PURE__*/React.createElement("view", {
    id: "furniture",
    viewBox: "45 315 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 45,
    y: 315,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45.001 22.75 16.3)",
    fill: "none",
    d: "M21.3 16.2h3v.1h-3z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M32.2 9.9h.2c.1-.2.4-.2.6-.1l.7.3.8-.7c.2-.2.5-.3.7-.1l1.3 1V8.7h-4.3v1.2zM23.7 22h2.1v1h-2.1z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M37.5 20h-2v-1.8c.6-.3 1-.8 1.1-1.5v-1.1c0-.3-.3-.5-.6-.5h-2.1c-.3 0-.5.2-.5.5v1.1c0 .6.4 1.2 1 1.5v1.7h-2c-.1.2-.1.3-.1.5l.5 2.5H27v-1h2.6c.9 0 1.6-.7 1.6-1.6v-5.2c0-.9-.7-1.6-1.6-1.6H20c-.9 0-1.6.7-1.6 1.6v5.3c0 .9.7 1.6 1.6 1.6h2.6v1h-4.2v-.5c0-.6-.5-1.1-1.1-1.1h-1.6c-.6 0-1.1.5-1.1 1.1v.5H14c-.2-1.1-1.1-1.9-2.2-2l-1.7-3.5c.5-.3.8-.8.8-1.4 0-.4-.1-.7-.4-1l1-.5c-.1.1-.1.3-.1.5 0 .3.3.5.6.5h4.2c.3 0 .6-.2.6-.5 0-.9-.4-1.7-1.1-2.2v-.5c0-.9-.7-1.6-1.6-1.6-.9 0-1.6.7-1.6 1.6v.5l-3.4 1.6c-.9-.1-1.6.6-1.7 1.5-.1.9.6 1.6 1.5 1.7l1.7 3.4c-.9.2-1.6 1-1.8 1.9h-.6c-.3 0-.5.3-.5.6v2.1c0 .3.2.5.5.5h1.1v10.7c0 .3.2.5.5.5h2.7c.3 0 .5-.2.5-.5V26.2h19.2v10.7c0 .3.2.5.5.5h2.7c.3 0 .5-.2.5-.5V26.2H37c.3 0 .5-.2.5-.5v-2.1c0-.3-.2-.5-.5-.5l.5-2.6c.1-.2 0-.3 0-.5zm-23.3-8.1c.3 0 .5.2.5.5h-1c0-.3.2-.5.5-.5zm0 1.6c.7 0 1.3.4 1.5 1h-3c.2-.6.8-1 1.5-1zm-4.8 3.1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.3.5-.5.5zm25-.5h1.1v.6c0 .3-.2.5-.5.5s-.6-.2-.6-.5v-.6zm2.1 4.8L36 23h-2.1l-.4-2.1h3zm-17-5.8c0-.3.3-.6.6-.6h9.5c.3 0 .6.3.6.6v3.7H19.5v-3.7zm.5 5.8c-.3 0-.6-.2-.6-.5v-.5h10.7v.5c0 .3-.3.5-.6.5H20zm5.9 1.1v1h-2.1v-1h2.1zm-10.2.5h1.6v.5h-1.6v-.5zm-4.3-.5c.7 0 1.3.4 1.5 1h-3c.3-.6.9-1 1.5-1zm.6 14.3h-1.6V26.2H12v10.1zm23 0h-1.6V26.2H35v10.1zm1.5-11.1H8.9v-1.1h27.7v1.1z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "m36 23 .5-2.1h-3l.4 2.1z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B949",
    d: "M35 17.2c.3 0 .5-.2.5-.5v-.6h-1.1v.6c0 .3.3.5.6.5zM15.7 22.5h1.6v.5h-1.6z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M14.2 11.9c-.3 0-.5.2-.5.5h1c0-.3-.3-.5-.5-.5z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M14.2 13.5c-.7 0-1.3.4-1.5 1h3c-.3-.6-.9-1-1.5-1zM11.4 22c-.7 0-1.3.4-1.5 1h3c-.2-.6-.8-1-1.5-1z"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F9F9F9",
    cx: 9.4,
    cy: 16.1,
    r: 0.5
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M33.4 26.2H35v10.1h-1.6zM8.9 24.1v1.1h27.6v-1.1h-3.1zM10.4 26.2H12v10.1h-1.6z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M30.2 20.4v-.5H19.5v.5c0 .3.3.5.6.5h9.5c.2 0 .5-.2.6-.5zM30.2 15.1c0-.3-.3-.6-.6-.6H20c-.3 0-.6.3-.6.6v3.7h10.7v-3.7zm-7.7 3.1-.8-.8-.1-.1 2.1-2.1.1.1.8.7-2.1 2.2zm3.2-.1-.7-.8 2.1-2.1.8.8-2.2 2.1z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M26.4 28.9c0-.9-.7-1.6-1.6-1.6h-4.2c-.9 0-1.6.7-1.6 1.6s.7 1.6 1.6 1.6h.3L19 36.7v.7h1V37l1.9-6.5h.2v6.9h1v-6.9h.2l2 6.5v.4h1v-.7l-1.9-6.2h.3c.9 0 1.7-.7 1.7-1.6zm-5.9.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4.2c.3 0 .5.2.5.5s-.2.5-.5.5h-4.2z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M25.2 28.9c0-.3-.2-.5-.5-.5h-4.2c-.3 0-.5.2-.5.5s.2.5.5.5h4.2c.3 0 .5-.2.5-.5z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "#00BAE0",
    d: "M37 7.6h-5.3c-.3 0-.6.2-.6.5v4.3c0 .3.3.5.6.5H37c.3 0 .5-.2.5-.5V8.1c0-.3-.2-.5-.5-.5zm-.5 2.7-1.3-1c-.2-.2-.5-.1-.7.1l-.8.7-.7-.3c-.2-.1-.5-.1-.6.1h-.2V8.7h4.3v1.6z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF693C",
    d: "m21.7 17.4.8.7v.1l2.2-2.2-.8-.7z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45.001 26.4 16.65)",
    fill: "#FF693C",
    d: "M24.9 16.1h3v1.1h-3z"
  }))), _view59 || (_view59 = /*#__PURE__*/React.createElement("view", {
    id: "furniture_2",
    viewBox: "90 315 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 90,
    y: 315,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.5 19.5h7.9v7.4h-7.9z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M37 16.5h-3v-1l3.5-7.3c0-.1 0-.3-.1-.4-.1-.2-.2-.3-.4-.3-1.5.1-2.8 1-3.4 2.3L31 14.5h-4c-1.1.1-2.1.9-2.4 2H24c-.3 0-.5.2-.5.5v5.5c0-.8-.7-1.5-1.5-1.5h-9.7c.2-.7.2-1.4.2-2.1L12 9.5c-.1-1.9-1.3-2-2.5-2s-2 .5-2 2.5l.5 9.5c0 1 .1 1.9.5 2.8v.7c0 .8.7 1.5 1.5 1.5h2.1c0 .2-.1.4-.1.5v.5c.1.8.7 1.4 1.5 1.4h1v6H11c-.3 0-.5.2-.5.5-.9.3-1.5 1.2-1.5 2.1.1 1 .8 1.7 1.8 1.8 1 .1 1.9-.5 2.1-1.5H19c.1 1.1 1 1.9 2.2 1.8 1.1-.1 1.9-1 1.8-2.2 0-.9-.6-1.7-1.5-2 0-.3-.2-.5-.5-.5h-3.5v-6h1c.8 0 1.5-.7 1.5-1.5V25c0-.2-.1-.3-.1-.5H22c.8 0 1.5-.7 1.5-1.5v14c0 .3.2.5.5.5h2c.3 0 .5-.2.5-.5v-7h7.9v7c0 .3.2.5.5.5h2c.3 0 .5-.2.5-.5V17c.1-.2-.2-.5-.4-.5zM19.8 34c-.3.3-.6.6-.7 1H13c-.1-.4-.3-.7-.6-1h7.4zm-.8-8.5c0 .3-.2.5-.5.5h-5c-.3 0-.5-.2-.5-.5V25c0-.3.2-.5.5-.5h5c.3 0 .5.2.5.5v.5zM34.5 29h-8v-1h8v1zm-8-2v-7.4h7.9V27h-7.9zm10 9.5h-1V19c0-.3-.2-.5-.5-.5h-9c-.3 0-.5.2-.5.5v17.4h-1V17.5h11.9v19z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M13 35h6c.1-.4.4-.7.7-1h-7.4c.3.2.5.6.7 1zM18.5 24.5h-5c-.3 0-.5.2-.5.5v.5c0 .3.2.5.5.5h5c.3 0 .5-.2.5-.5V25c0-.2-.2-.5-.5-.5zM26.5 28h8v1h-8z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M24.5 36.5h1V19c0-.3.2-.5.5-.5h9c.3 0 .5.2.5.5v17.4h1V17.5h-12v19z"
  }))), _view60 || (_view60 = /*#__PURE__*/React.createElement("view", {
    id: "gas_cylinders",
    viewBox: "135 315 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 135,
    y: 315,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M9.3 37.3h5.9c.9 0 1.6-.7 1.7-1.6V16.4c0-2.4-1.9-4.4-4.3-4.5v-1.2h1.6c.6 0 1.1-.5 1.1-1.1v-.8c0-.6-.5-1.1-1.1-1.1h-3.9c-.6.1-1 .5-1 1.1v.8c0 .6.4 1 1 1.1h1.6v1.2c-2.4.1-4.2 2.1-4.2 4.5v19.4c0 .8.7 1.5 1.6 1.5zm1-27.4c-.2 0-.3-.1-.3-.3v-1c0-.2.1-.3.3-.3h3.9c.2 0 .3.1.3.3v.9c0 .2-.1.3-.3.3h-3.9zm-1.9 6.5c0-2.1 1.7-3.8 3.8-3.8h.2c2.1.1 3.7 1.7 3.7 3.8v3.2H8.4v-3.2zm0 4h7.7v9.9H8.4v-9.9zm0 10.5h7.7v4.8c0 .4-.4.8-.8.8h-6c-.4.1-.8-.3-.9-.7V30.9z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.1 30.3v-9.9H8.4v9.9h7.7zm-3.8-7.5c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5zM8.4 35.9c.1.4.5.7.9.7h6c.4 0 .8-.4.8-.8V31H8.4V35.9zM16.1 19.6v-3.2c0-2.1-1.6-3.7-3.7-3.8h-.2c-2.1 0-3.8 1.7-3.8 3.8v3.2h7.7z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBCBCB",
    d: "M14.2 9.9c.2 0 .3-.1.3-.3v-1c0-.2-.1-.3-.3-.3h-3.9c-.2 0-.3.1-.3.3v.9c0 .2.1.3.3.3h3.9z"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    fill: "#28B557",
    cx: 12.3,
    cy: 25.3,
    r: 2.5
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M19.5 37.3h6c.9 0 1.6-.7 1.6-1.6V16.4c0-2.4-1.8-4.3-4.2-4.5v-1.2h1.6c.6-.1 1-.5 1-1.1v-.8c0-.6-.4-1-1-1.1h-3.9c-.6 0-1.1.5-1.1 1.1v.8c0 .6.5 1.1 1.1 1.1h1.5v1.2c-2.4.2-4.2 2.1-4.2 4.5v19.4c0 .8.7 1.5 1.6 1.5zm1.1-27.4c-.2 0-.3-.1-.3-.3v-1c0-.2.1-.3.3-.3h3.9c.2 0 .3.1.3.3v.9c0 .2-.1.3-.3.3h-3.9zm-1.9 6.5c0-2.1 1.6-3.7 3.7-3.8h.2c2 0 3.7 1.7 3.7 3.7V19.6h-7.6v-3.2zm0 4h7.6v9.9h-7.6v-9.9zm0 10.5h7.7v4.8c-.1.5-.4.8-.9.8h-6c-.4 0-.8-.4-.8-.8v-4.8z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M24.5 9.9c.2 0 .3-.1.3-.3v-1c0-.2-.1-.3-.3-.3h-3.9c-.2 0-.3.1-.3.3v.9c0 .2.1.3.3.3h3.9z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M26.3 30.3v-9.9h-7.6v9.9h7.6zm-3.8-7.5c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5zM19.5 36.6h6c.5 0 .8-.3.9-.8V31h-7.7v4.8c0 .4.4.8.8.8zM26.3 19.6V16.3c0-2-1.7-3.7-3.7-3.7h-.2c-2.1.1-3.7 1.7-3.7 3.8v3.2h7.6z"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    fill: "#4AB8DC",
    cx: 22.5,
    cy: 25.3,
    r: 2.5
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M33.1 11.9v-1.2h1.6c.6 0 1.1-.5 1.1-1.1v-.8c0-.6-.5-1.1-1.1-1.1h-3.9c-.6 0-1 .4-1 1v.9c-.1.5.3 1 .9 1.1H32.4v1.2c-2.4.1-4.3 2.1-4.2 4.5v19.4c0 .9.7 1.6 1.6 1.6h5.9c.9 0 1.6-.7 1.6-1.6V16.4c.1-2.4-1.8-4.4-4.2-4.5zm-2.3-2c-.2 0-.3-.1-.3-.3v-1c0-.2.1-.3.3-.3h3.9c.2 0 .3.1.3.3v.9c0 .2-.1.3-.3.3h-3.9zm5.8 25.9c0 .4-.4.8-.8.8h-6c-.4.1-.8-.3-.9-.7V31h7.7v4.8zm0-5.5h-7.7v-9.9h7.7v9.9zm0-13.9v3.2h-7.7v-3.2c0-2.1 1.7-3.8 3.8-3.8h.1c2.1 0 3.8 1.7 3.8 3.8z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M28.9 20.4v9.9h7.7v-9.9h-7.7zm3.9 7.4c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5c0 1.3-1.1 2.5-2.5 2.5zM28.9 30.9V35.8c.1.4.5.7.9.7h6c.4 0 .8-.4.8-.8v-4.8h-7.7zM32.8 12.6c-2.2 0-3.9 1.7-3.9 3.8v3.2h7.7v-3.2c0-2.1-1.7-3.8-3.8-3.8z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M35 9.6v-1c0-.2-.1-.3-.3-.3h-3.9c-.2 0-.3.1-.3.3v.9c0 .2.1.3.3.3h3.9c.2.1.3-.1.3-.2z"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F2724A",
    cx: 32.8,
    cy: 25.3,
    r: 2.5
  }))), _view61 || (_view61 = /*#__PURE__*/React.createElement("view", {
    id: "gauge",
    viewBox: "180 315 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 180,
    y: 315,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M29.9 9.4c-2.3-1.2-4.8-1.8-7.4-1.8C13.4 7.6 6 15 6 24.2c0 2.6.6 5.2 1.8 7.5.2.2.4.4.7.4H11l2.1 4.8c.1.3.4.5.7.5h17.3c.3 0 .6-.2.6-.5l2.2-4.8h2.6c.3 0 .6-.2.7-.4 4.2-8.2.9-18.2-7.3-22.3zm6.3 21.3H8.9c-.8-1.8-1.3-3.8-1.4-5.8h3.1c.4.1.7-.2.8-.6v-.1c0-.4-.3-.7-.7-.8H7.5c.2-3.5 1.6-6.8 3.9-9.3l2.2 2.2.6.2.5-.2c.3-.3.3-.8 0-1.1L12.5 13c2.5-2.3 5.8-3.7 9.3-3.9v3.2c.1.4.4.7.8.7s.7-.3.7-.7V9.1c3.5.2 6.8 1.6 9.4 3.9l-2.2 2.2c-.3.3-.3.8 0 1.1l.5.2.5-.2 2.2-2.2c2.4 2.5 3.8 5.8 3.9 9.3h-3.1c-.4 0-.8.4-.8.8s.3.7.7.7h3.2c-.1 2-.6 4-1.4 5.8z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M37.5 24.9h-3.2c-.4 0-.7-.3-.7-.7 0-.4.4-.8.8-.8h3.1c-.1-3.5-1.5-6.8-3.9-9.3l-2.2 2.2-.4.2-.5-.2c-.3-.3-.3-.8 0-1.1l2.2-2.2c-2.6-2.3-5.9-3.7-9.4-3.9v3.2c0 .4-.3.7-.7.7-.4 0-.7-.3-.8-.7V9.1c-3.5.2-6.8 1.6-9.3 3.9l2.2 2.2c.3.3.3.8 0 1.1l-.5.2-.6-.2-2.2-2.2c-2.3 2.5-3.7 5.8-3.9 9.3h3.2c.4.1.7.4.7.8v.1c-.1.4-.4.6-.8.6H7.5c.1 2 .6 4 1.4 5.8h27.3c.8-1.8 1.3-3.8 1.3-5.8zm-12.6-.7c0 1.3-1 2.3-2.3 2.3s-2.3-1-2.3-2.3c0-1.3 1-2.3 2.3-2.3l1 .2 3.5-3.5c.3-.3.8-.3 1.1 0 .2.3.2.7 0 1l-3.6 3.6c.2.3.3.6.3 1z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M28.2 18.6c-.3-.3-.8-.3-1.1 0l-3.5 3.5-1-.2c-1.3 0-2.3 1-2.3 2.3 0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3c0-.4-.1-.7-.3-1l3.6-3.6c.2-.3.2-.7 0-1z"
  }))), _view62 || (_view62 = /*#__PURE__*/React.createElement("view", {
    id: "gears",
    viewBox: "225 315 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 225,
    y: 315,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M9.5 15.5c-.1.3.1.6.4.7l1.6.7c0 .6.1 1.3.3 1.9L10.5 20c-.2.2-.2.5-.1.8l.5.7.4.7c.2.3.5.4.8.3l1.6-.7c.4.5.9.9 1.5 1.2v1.6c0 .3.2.6.5.7l.8.2.8.2c.3.1.7-.1.8-.4l.5-1.5 2-.4 1.1 1.3c.2.2.5.3.8.1l.7-.4.7-.4c.3-.2.4-.5.3-.8l-.7-1.6c.5-.5.9-1 1.2-1.6h1.7c.3 0 .6-.2.6-.5l.2-.8.2-.8c0-.3-.1-.5-.4-.6l-1.5-.7c-.1-.6-.2-1.3-.4-1.9l1.3-1.2c.2-.2.3-.5.1-.8L26 12l-.4-.7c0-.3-.3-.4-.6-.3-.1 0-.1.1-.2.1l-1.6.6c-.5-.5-1-.9-1.6-1.2V8.8c0-.3-.2-.6-.5-.7l-.6-.1-.9-.2c-.3-.1-.6.1-.7.4l-.7 1.6c-.6 0-1.3.1-1.9.3l-1.1-1.3c-.2-.2-.5-.3-.8-.1l-.7.3-.7.5c-.3.1-.4.5-.3.8l.7 1.5c-.5.5-.9 1-1.2 1.6h-1.6c-.3 0-.6.2-.7.5l-.2.8-.2.8zm5.4.3c.5-2 2.5-3.1 4.5-2.7 1.9.5 3.1 2.4 2.7 4.4-.4 2-2.4 3.2-4.4 2.8-2-.4-3.3-2.4-2.8-4.5zM24.9 24.7c-.2.1-.4.2-.4.4v1c0 .2.2.4.4.4l1 .2c.1.4.3.8.5 1.1l-.6.9c-.2.1-.1.3 0 .5l.4.3.3.4c.1.1.4.1.5 0l.9-.6 1.1.5v1c0 .2.2.2.4.2h1.1c.2 0 .3-.1.3-.3l.2-1 1.1-.5.9.6c.1.1.4.1.5 0l.3-.4.4-.4c.1-.1.2-.3.1-.4l-.1-.1-.6-.8c.2-.3.4-.7.5-1.1l1-.2c.2 0 .4-.2.4-.4v-1c0-.1-.1-.3-.3-.3l-1-.2c-.1-.4-.3-.8-.5-1.1l.6-.8c.1-.1.2-.3.1-.4l-.1-.1-.4-.4-.3-.4H33l-.8.7-1.2-.5-.2-1c0-.2-.2-.3-.4-.3h-1c-.2 0-.4.1-.4.3l-.2 1.1-1.1.4-.7-.7c-.2-.1-.4-.1-.5.1l-.5.4-.3.4c-.2.1-.2.3-.1.5l.6.8c-.2.4-.3.8-.4 1.2h-.9zm5.1-1.4c1.3 0 2.3 1 2.3 2.3 0 1.3-1 2.3-2.3 2.3-1.3 0-2.3-1-2.3-2.3 0-1.2 1.1-2.3 2.3-2.3zM16.7 27.8l-.3.4-.4.3c-.1.1-.1.4 0 .5l.6.8c-.2.3-.3.7-.4 1.1l-1 .2c-.2 0-.3.2-.3.4v1c0 .2.2.3.4.4h1c.1.4.2.8.4 1.1l-.5.8c-.1.1-.1.4 0 .5l.3.4.3.4c.1.1.4.1.5 0l.8-.6 1.1.4.2 1c0 .2.2.3.4.3h1c.2 0 .2-.2.2-.4l.2-1 1-.4.9.5c.1.1.4.1.5 0l.3-.4.3-.3c.2-.2.2-.4.1-.5l-.6-.7c.2-.3.3-.7.4-1.1l1-.2c.2 0 .3-.2.3-.4v-1c0-.3-.2-.3-.4-.3l-1-.2c-.1-.4-.2-.7-.4-1l.5-.9c.1-.1.1-.4 0-.5l-.4-.4-.3-.4H23l-.8.6-1.2-.4-.2-1c-.1-.2-.2-.3-.4-.3h-1c-.2 0-.4.2-.4.4v1l-1 .4-.8-.5c-.2-.1-.4-.1-.5 0zm3.2 2h.1c1.2-.3 2.4.4 2.7 1.6s-.4 2.4-1.6 2.7c-.3.1-.6.1-.9 0-1.2.1-2.1-.8-2.2-2V32c-.1-1.2.8-2.2 1.9-2.2z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.7 20.3c2 .4 4-.8 4.4-2.8.4-2-.8-3.9-2.7-4.4-2-.4-4 .7-4.5 2.7-.5 2.1.8 4.1 2.8 4.5zM30 28c1.3 0 2.3-1 2.3-2.3 0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.2 1.1 2.3 2.3 2.3zM20.2 34c.3.1.6.1.9 0 1.2-.3 1.9-1.5 1.6-2.7s-1.5-1.9-2.7-1.6h-.1c-1.2.1-2.1 1-2 2.2v.1c.1 1.2 1.1 2.1 2.3 2z"
  }))), _view63 || (_view63 = /*#__PURE__*/React.createElement("view", {
    id: "gift-card-raffle",
    viewBox: "270 315 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 270,
    y: 315,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    width: 21,
    height: 13.5,
    rx: 2,
    fill: "#23967f"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2c14e",
    d: "M14.8 14H18v13.5h-3.2z"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.6,
    cy: 13,
    rx: 2.3,
    ry: 1.15,
    fill: "#f2c14e",
    transform: "rotate(-24 13.6 13)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2,
    cy: 13,
    rx: 2.3,
    ry: 1.15,
    fill: "#f2c14e",
    transform: "rotate(24 19.2 13)"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4,
    cy: 13.4,
    r: 1,
    fill: "#d99a3f"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 24.5,
    width: 15,
    height: 7,
    rx: 1.2,
    fill: "#d99a3f",
    transform: "rotate(7 30.5 28)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-8 31 30.7)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 27.2,
    width: 15,
    height: 7,
    rx: 1.2,
    fill: "#e0704f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3 28v5.4",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.9,
    strokeDasharray: "1.3 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.3 28.4.75 1.45 1.45.75-1.45.75-.75 1.45-.75-1.45-1.45-.75 1.45-.75z",
    fill: "#fff"
  })))), _view64 || (_view64 = /*#__PURE__*/React.createElement("view", {
    id: "glassware",
    viewBox: "315 315 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 315,
    y: 315,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M7.3 35c-.3.5-.3 1 0 1.5s.8.8 1.4.8H20c.3 0 .6-.1.9-.3.4.2.8.3 1.3.3 1.1 0 2.1-.5 2.8-1.3.6.5 1.3 1 2.1 1.3h6.1c3.8-1.4 5.7-5.6 4.3-9.4-.8-2-2.3-3.6-4.4-4.3v-7.4c.6-.1 1-.6 1-1.2.1-.7-.5-1.3-1.2-1.4H27.5c-.7 0-1.3.6-1.3 1.3v.1c0 .6.4 1.1 1 1.2v7.4l-1.3.7v-14c.5-.2.8-.7.8-1.3 0-.7-.6-1.3-1.3-1.3h-6.5c-.7 0-1.3.6-1.3 1.3 0 .6.3 1.1.8 1.3v17.1l-1.6-4.1v-3.7c.6-.1 1.1-.6 1.1-1.2 0-.7-.6-1.3-1.3-1.3h-4.5c-.7 0-1.3.6-1.3 1.3 0 .7.5 1.2 1.2 1.2v3.7L7.3 35zm.6.3 2.2-5.5c.7 0 1.4-.2 2-.6l1.2-.5c1.2-.2 2.3.6 3.6 1l1.8.4 2.1 5.2c.2.2.2.6 0 .8-.2.3-.5.5-.8.5H8.7c-.3 0-.6-.2-.8-.5-.1-.3-.1-.5 0-.8zM33 36.6h-5.7c-2.2-.9-3.8-2.9-4.1-5.3 4.9 1.9 5.5-3.7 14-1.6.3 3-1.4 5.8-4.2 6.9zm-9.5-8.3c2.2-.2 4.3.2 6.2 1.3-1.4.6-3.6 2.6-6.5 1.3-.1-.9 0-1.8.3-2.6zM26.9 15c0-.4.3-.6.6-.7h5.3c.4 0 .6.3.6.7 0 .3-.3.6-.6.6h-5.3c-.3 0-.6-.3-.6-.6zm1 1.3h4.5v7.5c0 .2.1.3.3.3 2.3.9 4 2.9 4.4 5.3-2.3-.7-4.7-.6-7 .1-2-1.2-4.2-1.7-6.5-1.6.8-1.8 2.3-3.1 4.1-3.8.1 0 .2-.1.2-.3v-7.5zm-2.7 8.5c-3.1 2.4-3.7 6.8-1.4 9.9.2.3.4.5.7.8-.6.7-1.4 1-2.3 1.1h-.8c.3-.5.3-1 .1-1.5l-2.4-5.9v-9.3c1 .4 2 .5 3.1.5 1 0 2-.1 3-.5v4.9zm-3-6.1c1 0 2 .1 3 .5v.3c-1 .4-2 .5-3 .5-1.1.1-2.1-.1-3.1-.5v-.3c1-.4 2-.6 3.1-.5zm3 .1c-1-.3-2-.4-3-.4s-2.1.1-3.1.4v-8.4h6.1v8.4zM18.3 9c0-.3.3-.6.6-.6h6.5c.3 0 .6.3.6.6 0 .4-.3.6-.6.7h-6.5c-.3-.1-.6-.3-.6-.7zm-2.2 14.4 2.5 6.3c-.5 0-1.1-.1-1.6-.3-1.2-.4-2.5-1.3-3.8-1l-1.2.5c-.6.3-1.2.5-1.8.6l2.4-6v-3.9h3.5v3.8zm-4.6-5c0-.3.3-.6.6-.6h4.5c.3-.1.5.1.6.4v.2c0 .3-.2.5-.6.5h-4.5c-.3 0-.6-.2-.6-.5z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M8.7 36.6H20c.3 0 .6-.2.8-.5.2-.2.2-.6 0-.8l-2.1-5.2-1.8-.4c-1.3-.4-2.4-1.2-3.6-1l-1.2.5c-.6.4-1.3.6-2 .6l-2.2 5.5c-.1.3-.1.5 0 .8.2.3.5.5.8.5zm3.1-1.6c-.3 0-.6-.3-.6-.6s.3-.6.6-.6.6.3.6.6-.3.6-.6.6zm6.4-3.1c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4.2-.4.4-.4zM16.1 33c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-2.5-2.5c.3 0 .6.3.6.6.1.3-.1.5-.4.6h-.2c-.3 0-.6-.3-.6-.6s.3-.6.6-.6zm.6 3.1c0 .2-.2.4-.4.4s-.3-.2-.3-.4.1-.3.3-.3c.2 0 .4.1.4.3zm1.8 1.9c-.2 0-.4-.3-.4-.5s.2-.5.4-.5c.3 0 .5.2.5.5s-.2.5-.5.5zm-4.9-4.2c.2 0 .3.2.3.4s-.1.3-.3.3c-.2 0-.4-.1-.4-.3 0-.2.2-.4.4-.4z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M18.9 9.7h6.5c.3-.1.6-.3.6-.7 0-.3-.3-.6-.6-.6h-6.5c-.3 0-.6.3-.6.6 0 .4.3.6.6.7z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19.1 10.4v8.4c1-.3 2.1-.4 3.1-.4s2 .1 3 .4v-8.4h-6.1zM12.6 19.6v3.8l-2.4 6c.6-.1 1.2-.3 1.8-.6l1.2-.5c1.3-.3 2.6.6 3.8 1 .5.2 1.1.3 1.6.3l-2.5-6.1v-3.9h-3.5z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0451E",
    d: "M19.1 19.2v.3c1 .4 2 .6 3.1.5 1 0 2-.1 3-.5v-.3c-1-.4-2-.5-3-.5-1.1-.1-2.1.1-3.1.5z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M22.2 20.4c-1.1 0-2.1-.1-3.1-.5v9.3l2.4 5.8c.2.5.2 1-.1 1.5h.8c.9-.1 1.7-.4 2.3-1.1-2.8-2.8-2.8-7.3-.1-10 .2-.2.5-.5.8-.7v-4.8c-1 .4-2 .5-3 .5zm-1.9 2.1c0-.3.3-.6.6-.6s.5.2.5.6c0 .3-.2.5-.5.5s-.6-.2-.6-.5zm1.1 3.9c-.3 0-.5-.2-.5-.5s.2-.6.5-.6.6.3.6.6-.3.5-.6.5zm.6 2c0 .3-.3.6-.6.6s-.5-.3-.5-.6.2-.5.5-.5.6.2.6.5zm-.3 2.7c.3 0 .5.2.5.5s-.2.5-.5.5-.5-.2-.5-.5.2-.5.5-.5zm1.1 3c0 .2-.1.3-.3.3-.2 0-.3-.1-.3-.3 0-.2.1-.3.3-.3.2 0 .3.1.3.3zm.9-9.9c0 .4-.2.6-.5.6s-.6-.3-.6-.6.3-.5.6-.5.5.2.5.5z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M16.6 18.9c.4 0 .6-.2.6-.5.1-.3-.1-.5-.4-.6h-4.7c-.3 0-.6.3-.6.6s.3.5.6.5h4.5zM32.8 15.6c.3 0 .6-.3.6-.6 0-.4-.2-.7-.6-.7h-5.3c-.3.1-.6.3-.6.7 0 .3.3.6.6.6h5.3z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M27.7 24.1c-1.8.7-3.3 2-4.1 3.8 2.3-.1 4.5.4 6.5 1.6 2.3-.7 4.7-.8 7-.1-.4-2.4-2.1-4.4-4.4-5.3-.2 0-.3-.1-.3-.3v-7.5h-4.5v7.5c0 .2-.1.3-.2.3z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E98C0",
    d: "M29.7 29.6c-1.9-1.1-4-1.5-6.2-1.3-.3.8-.4 1.7-.3 2.6 2.9 1.3 5.1-.7 6.5-1.3z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M23.2 31.3c.3 2.4 1.9 4.4 4.1 5.3H33c2.8-1.1 4.5-3.9 4.2-6.9-8.5-2.1-9.1 3.5-14 1.6zm10.9-.5c.3 0 .6.3.6.6s-.3.5-.6.5-.5-.2-.5-.5.2-.6.5-.6zm-1 3.4c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4.2-.4.4-.4zm-2.4-2.6c.2 0 .4.1.4.3 0 .2-.2.4-.4.4s-.3-.2-.3-.4.1-.3.3-.3zm-.8 2.3c.4 0 .7.3.7.7 0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7zm-2-1.6c.3 0 .5.2.5.5s-.2.6-.5.6-.6-.3-.6-.6.3-.5.6-.5zm-1.6 2.2c0-.3.2-.5.5-.5s.5.2.5.5-.2.5-.5.5-.5-.2-.5-.5z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.1 32c.2 0 .3-.1.3-.3 0-.2-.1-.4-.3-.4-.2 0-.4.2-.4.4s.2.3.4.3zM21.4 22.5c0-.4-.2-.6-.5-.6s-.6.3-.6.6.3.5.6.5.5-.2.5-.5zM16.1 32c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.2-.5-.5-.5zM23.2 23.7c-.3 0-.6.2-.6.5s.3.6.6.6.5-.2.5-.6c0-.3-.2-.5-.5-.5zM27.3 34.5c0-.3-.2-.5-.5-.5s-.5.2-.5.5.2.5.5.5.5-.2.5-.5zM27.9 33.4c.3 0 .5-.3.5-.6s-.2-.5-.5-.5-.6.2-.6.5.3.6.6.6z"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 13.8,
    cy: 33.6,
    r: 0.4
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 21.4,
    cy: 25.9,
    r: 0.5
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.7 32.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5-.5.2-.5.5.2.5.5.5zM29.2 34.6c0 .4.3.7.7.7s.7-.3.7-.7-.3-.7-.7-.7-.7.3-.7.7zM13.6 31.7c.3.1.5-.1.6-.4v-.2c0-.3-.3-.6-.6-.6s-.6.3-.6.6.3.6.6.6zM12.4 34.4c0-.3-.3-.6-.6-.6s-.6.3-.6.6.3.6.6.6.6-.3.6-.6zM16 34.5c-.2 0-.4.3-.4.5s.2.5.4.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM18.2 32.7c.2 0 .4-.2.4-.4s-.2-.4-.4-.4-.4.2-.4.4.2.4.4.4zM21.4 27.9c-.3 0-.5.2-.5.5s.2.6.5.6.6-.3.6-.6-.3-.5-.6-.5zM22.2 34.1c0 .2.1.3.3.3s.3-.1.3-.3c0-.2-.1-.3-.3-.3-.2 0-.3.1-.3.3zM34.1 31.9c.3 0 .6-.2.6-.5s-.3-.6-.6-.6-.5.3-.5.6.2.5.5.5zM30.7 32.3c.2 0 .4-.2.4-.4s-.2-.3-.4-.3-.3.1-.3.3c0 .2.1.4.3.4zM32.6 34.6c0 .2.3.4.5.4s.4-.2.4-.4-.2-.4-.4-.4-.5.2-.5.4z"
  }))), _view65 || (_view65 = /*#__PURE__*/React.createElement("view", {
    id: "gloves",
    viewBox: "360 0 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 360,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M9.6 11.9c-.9 0-1.7.8-1.7 1.7v6.5c0 1.7.6 3.4 1.8 4.7v12.6h10.5V24.8c1.2-1.3 1.8-3 1.8-4.7v-3.8c0-1-.7-1.7-1.7-1.8-.4 0-.7.1-1 .3v-3.3c0-.9-.8-1.7-1.7-1.7-.3 0-.6.1-.9.3v-.7c0-1-.8-1.8-1.8-1.8-1 .1-1.7.8-1.7 1.8v.4c-.3-.2-.6-.3-.9-.3-.9 0-1.7.8-1.7 1.7V12l-1-.1zm1.8 6.5v-7c0-.5.4-.9.9-.9s.9.4.9.9v7h.8v-9c-.1-.5.3-.9.8-1h.1c.6 0 1 .4 1 1v8.9h.8v-6.9c0-.5.4-.9.9-.9s.9.4.9.9v8.4h.8v-3.6c.1-.5.5-.9 1-.9s.9.4.9.9V20c0 1.6-.6 3.1-1.7 4.3h-.1v9.5h-6.2v.9h6.2v1.6h-8.9v-1.5h2v-.9h-2v-9.5h-.1c-1.1-1.2-1.7-2.8-1.7-4.4v-6.5c0-.5.4-.9.9-.9s.9.4 1 .9v4.8h.8z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M10.6 13.6c-.1-.5-.5-.9-1-.9s-.9.4-.9.9v6.5c0 1.6.6 3.2 1.7 4.4h.1V34h2v.9h-2v1.5h8.9v-1.6h-6.2v-.9h6.2v-9.5h.1c1.1-1.2 1.7-2.7 1.7-4.3v-3.8c0-.5-.4-.9-.9-.9s-.9.4-1 .9v3.6h-.8v-8.4c0-.5-.4-.9-.9-.9s-.9.4-.9.9v6.9h-.8v-9c0-.6-.4-1-1-1h-.1c-.5.1-.8.5-.8 1v8.9h-.8v-7c0-.5-.4-.9-.9-.9s-.9.4-.9.9v7h-.8v-4.7zm1 19.2h-.8V31h.8v1.8zm1.3 0h-.8V31h.8v1.8zm1.2 0h-.8V31h.8v1.8zm1.2 0h-.8V31h.8v1.8zm1.1 0h-.8V31h.8v1.8zm1.4 0H17V31h.8v1.8zm1.1 0h-.8V31h.8v1.8z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.4 31.1h.8v1.8h-.8zM15.6 31.1h.8v1.8h-.8zM16.9 31.1h.8v1.8h-.8zM18.1 31.1h.8v1.8h-.8zM13.3 31.1h.8v1.8h-.8zM12.1 31.1h.8v1.8h-.8zM10.9 31.1h.8v1.8h-.8z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M30.2 7.7c-.9 0-1.7.8-1.7 1.7v.6c-.3-.2-.6-.3-1-.3-.9 0-1.7.8-1.7 1.7v3.3c-.3-.2-.6-.3-.9-.3-1 0-1.8.8-1.8 1.8V20c0 1.7.7 3.4 1.8 4.7v12.6h10.6V24.8c1.1-1.3 1.7-3 1.7-4.7v-6.5c0-.9-.8-1.7-1.7-1.7l-.9.2v-.7c0-1-.8-1.8-1.8-1.8l-.9.3v-.5c0-.9-.8-1.7-1.7-1.7zm2.6 2.7c.5 0 .9.4 1 .9v7h.8v-4.8c0-.5.4-.9.9-.9s.9.4.9.9V20c0 1.6-.6 3.1-1.7 4.3h-.1v9.5h-1.9v.9h1.9v1.6h-8.8v-1.5H32v-.9h-6.2v-9.5h-.2c-1-1.2-1.6-2.7-1.6-4.3v-3.9c0-.5.4-.9.9-.9s.9.4.9.9v3.6h.8v-8.4c0-.5.4-.9.9-.9s.9.4 1 .9v6.9h.8V9.4c0-.5.4-.9.9-.9s.8.5.9.9v8.9h.8v-7c0-.4.4-.9.9-.9z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M31.9 18.4h-.8v-9c0-.5-.4-.9-.9-.9s-1 .5-.9.9v8.9h-.8v-6.9c-.1-.5-.5-.9-1-.9s-.9.4-.9.9v8.4h-.8v-3.6c0-.5-.4-.9-.9-.9s-.9.4-.9.9v3.9c0 1.6.6 3.1 1.6 4.3h.2v9.5H32v.9h-6.2v1.5h8.8v-1.6h-1.9v-.9h1.9v-9.5h.1c1.1-1.2 1.7-2.7 1.7-4.3v-6.5c0-.5-.4-.9-.9-.9s-.9.4-.9.9v4.8h-.8v-7c-.1-.5-.5-.9-1-.9s-.9.4-.9.9v7.1zm-5 14.4h-.8V31h.8v1.8zm1.2 0h-.8V31h.8v1.8zm1.3 0h-.8V31h.8v1.8zm1.2 0h-.8V31h.8v1.8zm1.2 0H31V31h.8v1.8zm1.1 0h-.8V31h.8v1.8zm1.2 0h-.8V31h.8v1.8z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M29.8 31.1h.8v1.8h-.8zM28.6 31.1h.8v1.8h-.8zM27.4 31.1h.8v1.8h-.8zM26.1 31.1h.8v1.8h-.8zM30.9 31.1h.8v1.8h-.8zM32.1 31.1h.8v1.8h-.8zM33.3 31.1h.8v1.8h-.8z"
  }))), _view66 || (_view66 = /*#__PURE__*/React.createElement("view", {
    id: "gmp-cleaning-staff",
    viewBox: "360 45 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 360,
    y: 45,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 37.8,
    width: 34,
    height: 1.6,
    rx: 0.8,
    fill: "#c3ccd2"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 11.5,
    r: 6,
    fill: "#dfe6ec"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.8,
    cy: 12,
    r: 3.6,
    fill: "#e8b48e"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2,
    y: 9.8,
    width: 5.4,
    height: 1.9,
    rx: 0.95,
    fill: "#46626d"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 12.2,
    width: 5.8,
    height: 3.4,
    rx: 1.5,
    fill: "#4fb3c6"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 17,
    width: 10,
    height: 13,
    rx: 4,
    fill: "#dfe6ec"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6,
    y: 18,
    width: 0.9,
    height: 7,
    rx: 0.45,
    fill: "#b9c6cf"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 29.5,
    width: 3.4,
    height: 8.6,
    rx: 1.4,
    fill: "#dfe6ec"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 18.6,
    y: 29.5,
    width: 3.4,
    height: 8.6,
    rx: 1.4,
    fill: "#dfe6ec"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M14 36.2h4.2c1 0 1.4.4 1.4.9 0 .4-.3.7-.7.7H14z",
    fill: "#8fb6c9"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 36.2h4.2c1 0 1.4.4 1.4.9 0 .4-.3.7-.7.7h-4.9z",
    fill: "#8fb6c9"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "m31.5 15.5-7 19",
    fill: "none",
    stroke: "#9aa7b0",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 18.4,
    width: 8.6,
    height: 2.7,
    rx: 1.35,
    fill: "#dfe6ec",
    transform: "rotate(33.5 21.5 19.7)"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 22.4,
    width: 8,
    height: 2.7,
    rx: 1.35,
    fill: "#dfe6ec",
    transform: "rotate(38.3 20.5 23.7)"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.3,
    cy: 24,
    r: 1.7,
    fill: "#5a8fd8"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.7,
    cy: 28.4,
    r: 1.7,
    fill: "#5a8fd8"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3,
    y: 34.9,
    width: 9.2,
    height: 3,
    rx: 1.5,
    fill: "#c9d3da"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "m35.5 22.6.95 1.85 1.85.95-1.85.95-.95 1.85-.95-1.85-1.85-.95 1.85-.95zM39 30.4l.7 1.35 1.35.7-1.35.7-.7 1.35-.7-1.35-1.35-.7 1.35-.7zM8.5 19.2l.7 1.35 1.35.7-1.35.7-.7 1.35-.7-1.35-1.35-.7 1.35-.7z",
    fill: "#7fd1c0"
  }))), _view67 || (_view67 = /*#__PURE__*/React.createElement("view", {
    id: "hand_sanitizer",
    viewBox: "360 90 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 360,
    y: 90,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M30.2 16.6h-3.5v-1.5c0-.3-.2-.5-.5-.5h-1v-2h1c.3 0 .5-.2.5-.5v-4c0-.3-.2-.5-.5-.5h-4.9c-.3 0-.5.2-.5.5v.5h-4.5c-1.6-.1-2.9 1.2-3 2.8v1.7c0 .3.2.5.5.5h2c.3 0 .5-.2.5-.5v-1.5h4.5v.5c0 .3.2.5.5.5h1v2h-1c-.3 0-.5.2-.5.5v1.5h-3.5c-.8 0-1.4.6-1.5 1.4v18c.1.8.7 1.4 1.5 1.4h12.9c.8 0 1.4-.6 1.5-1.4V18c-.1-.8-.7-1.4-1.5-1.4zm.5 1.4v3.5h-6.5v-2h.5c.3 0 .5-.2.5-.5v-1.5h5c.3 0 .5.2.5.5zM16.8 33.5h13.9V36c0 .3-.2.5-.5.5H17.3c-.3 0-.5-.2-.5-.5v-2.5zm13.9-1H16.8v-10h13.9v10zm-13.4-15h5V19c0 .3.2.5.5.5h.4v2h-6.4V18c0-.3.2-.5.5-.5zm6.9 1h-1v-1h1v1zm-9.9-5.9v-1c0-1.1.9-2 2-2h4.5v1h-4.5c-.5-.1-.9.3-1 .8v1.2h-1zm8.9 0h1v2h-1v-2zm-1.4 3h3.9v1h-3.9v-1z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M24.7 16.6h1v-1h-3.9v1h1z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M30.2 17.5h-5V19c0 .3-.2.5-.5.5h-.5v2h6.5V18c0-.3-.2-.5-.5-.5zM16.8 21.5h6.4v-2h-.4c-.3 0-.5-.2-.5-.5v-1.5h-5c-.3 0-.5.2-.5.5v3.5zM17.3 36.5h12.9c.3 0 .5-.2.5-.5v-2.5H16.8V36c0 .3.2.5.5.5z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M23.2 17.5h1v1h-1zM23.2 12.6h1v2h-1z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M15.3 11.6c-.1-.5.3-.9.8-1h4.7v-1h-4.5c-1.1 0-2 .9-2 2v1h1v-1z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M16.8 22.5v10h13.9v-10H16.8zm6.9 9c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M26.7 27.5c0-1.7-1.3-3-3-3s-3 1.3-3 3 1.3 3 3 3 3-1.3 3-3zm-1.5.5h-1v1c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-1h-.9c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h.9v-1c0-.3.2-.5.5-.5s.5.2.5.5v1h1c.3 0 .5.2.5.5s-.2.5-.5.5z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M27.7 27.5c0-2.2-1.8-4-4-4s-4 1.8-4 4 1.8 4 4 4 4-1.8 4-4zm-4 3c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M25.7 27.5c0-.3-.2-.5-.5-.5h-1v-1c0-.3-.2-.5-.5-.5s-.5.2-.5.5v1h-.9c-.3 0-.5.2-.5.5s.2.5.5.5h.9v1c0 .3.2.5.5.5s.5-.2.5-.5v-1h1c.3 0 .5-.2.5-.5z"
  }))), _view68 || (_view68 = /*#__PURE__*/React.createElement("view", {
    id: "happy_face",
    viewBox: "360 135 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 360,
    y: 135,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.5 37.3c8.2 0 14.8-6.6 14.8-14.8S30.7 7.8 22.5 7.8 7.8 14.4 7.8 22.5s6.6 14.8 14.7 14.8zm0-27.5c7.1 0 12.8 5.7 12.8 12.8 0 7.1-5.7 12.8-12.8 12.8-7.1 0-12.8-5.7-12.8-12.8.1-7.1 5.8-12.8 12.8-12.8z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.8 22.5c0 7.1 5.7 12.8 12.8 12.8 7.1 0 12.8-5.7 12.8-12.8 0-7.1-5.7-12.8-12.8-12.8-7.1.1-12.8 5.8-12.8 12.8zm4.4 2.7 1.5-.5c1.9 4.9 11.8 4.9 13.7 0l1.5.5c-2.9 7-13.9 7-16.7 0zm2-5.9c0-.9.8-1.7 1.7-1.7.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-1 0-1.7-.7-1.7-1.7zm9.3 0c0-.9.8-1.7 1.7-1.7.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-1 0-1.7-.7-1.7-1.7z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M17.8 21c.9 0 1.7-.8 1.7-1.7 0-.9-.8-1.7-1.7-1.7-.9 0-1.7.8-1.7 1.7.1 1 .8 1.7 1.7 1.7zM27.2 21c.9 0 1.7-.8 1.7-1.7 0-.9-.8-1.7-1.7-1.7-.9 0-1.7.8-1.7 1.7 0 1 .7 1.7 1.7 1.7zM30.8 25.2l-1.5-.5c-1.9 4.9-11.8 4.9-13.7 0l-1.5.5c2.9 7 13.9 7 16.7 0z"
  }))), _view69 || (_view69 = /*#__PURE__*/React.createElement("view", {
    id: "hazardous_waste",
    viewBox: "360 180 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 360,
    y: 180,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#505050"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.6 37.1 4.9-8.4c-1.8-1-2.9-2.9-3-4.9H6.9c0 5.5 3 10.5 7.7 13.3zM38.1 23.8h-9.7c-.1 2.1-1.3 4-3.1 5l4.9 8.3c4.9-2.7 7.9-7.8 7.9-13.3zM22.6 17.6c1.1 0 2.3.4 3.2 1l4.7-8.6c-2.4-1.3-5.1-2.1-7.9-2.1-2.8 0-5.5.7-7.9 2.1l4.6 8.6c.9-.6 2.1-1 3.3-1zM25.6 23.6c0-1.7-1.4-3.1-3.1-3.1s-3.1 1.4-3.1 3.1 1.4 3.1 3.1 3.1 3.1-1.4 3.1-3.1z"
  })))), _view70 || (_view70 = /*#__PURE__*/React.createElement("view", {
    id: "heart_with_cross",
    viewBox: "360 225 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 360,
    y: 225,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M36.9 10.4c-3.8-3.7-9.8-3.7-13.6 0l-.8.8-.8-.8c-3.8-3.7-9.8-3.7-13.6 0-3.7 3.7-3.8 9.7-.1 13.4l.1.1 13.1 13c.7.7 1.9.7 2.6 0l4-4h-2.6c-.7 0-1.4-.2-2-.6-1.4-.9-2-2.6-1.5-4.1.5-1.5 1.9-2.6 3.5-2.6h2.7v-2.7c0-1.6 1.1-3.1 2.7-3.5 1.5-.4 3.2.2 4 1.6.4.6.6 1.2.6 1.9v2.7l1.7-1.7c3.7-3.7 3.8-9.7 0-13.5z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M31.5 37.3h.1c1 0 1.7-.7 1.8-1.7v-4.5h4.5c.9 0 1.7-.8 1.7-1.7v-.1c0-1-.7-1.7-1.7-1.8h-4.5v-4.6c0-.2 0-.4-.1-.5-.2-.9-1.1-1.4-2-1.3-.9.1-1.6.9-1.5 1.8v4.6h-4.6c-.9 0-1.7.6-1.8 1.5-.1.9.4 1.7 1.2 2h5.2v4.6c0 .9.8 1.7 1.7 1.7z"
  }))), _view71 || (_view71 = /*#__PURE__*/React.createElement("view", {
    id: "hot",
    viewBox: "360 270 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 360,
    y: 270,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24.2 11c0-1.2-1-2.2-2.2-2.2h-.1c-1.2 0-2.2 1-2.3 2.2v13.4c0 .2-.1.5-.3.6-2.1.9-3.4 3-3.4 5.3 0 3.3 2.7 6 6 6s6-2.7 6-6c0-2.3-1.3-4.3-3.3-5.3-.2-.1-.4-.3-.4-.6V11zM26 30.3c-.1 2.2-1.8 3.9-4 3.8-2.1.1-3.8-1.6-3.9-3.7v-.1c0-1.9 1.4-3.6 3.3-3.9V9.8c0-.3.3-.6.6-.6s.6.3.6.6v16.6c1.9.3 3.3 1.9 3.4 3.9z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M25.5 11c0-1.9-1.5-3.4-3.4-3.4H22c-1.9 0-3.4 1.5-3.5 3.4v13.1c-2.3 1.2-3.7 3.6-3.7 6.2 0 3.9 3.2 7.1 7.1 7.1h.1c4 .1 7.2-3.1 7.3-7.1 0-2.6-1.5-5-3.8-6.2V11zm-.9 14c2 1 3.3 3 3.3 5.3 0 3.3-2.7 6-6 6s-6-2.7-6-6c0-2.3 1.3-4.4 3.4-5.3.2-.1.3-.4.3-.6V11c.1-1.2 1.1-2.2 2.3-2.2 1.2-.1 2.2.9 2.3 2.1v13.5c.1.3.2.5.4.6z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3B30",
    d: "M22.5 9.8c0-.3-.3-.6-.6-.6s-.6.3-.6.6v16.6c-1.9.3-3.3 2-3.3 3.9 0 2.1 1.7 3.8 3.8 3.8h.1c2.2.1 3.9-1.6 4-3.8 0-2-1.5-3.6-3.4-3.9V9.8z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M27 10.9h2.6c.3 0 .6-.3.6-.6s-.3-.6-.6-.6H27c-.3 0-.6.3-.6.6.1.3.3.6.6.6zM27 13.8h1.4c.3 0 .6-.3.6-.6.1-.3-.1-.5-.4-.6H27c-.3 0-.6.3-.6.6.1.3.3.6.6.6zM27 16.6h2.6c.3 0 .6-.3.6-.6s-.3-.6-.6-.6H27c-.3 0-.6.3-.6.6.1.3.3.6.6.6zM27 19.5h1.4c.3 0 .6-.3.6-.6.1-.3-.1-.5-.4-.6H27c-.3 0-.6.3-.6.6.1.3.3.6.6.6zM29.6 21.1H27c-.3 0-.6.3-.6.6s.3.6.6.6h2.6c.3 0 .6-.3.6-.6s-.2-.6-.6-.6z"
  }))), _view72 || (_view72 = /*#__PURE__*/React.createElement("view", {
    id: "housekeeping_supplies",
    viewBox: "360 315 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 360,
    y: 315,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M17 37.3c0 .1.1.1.2.1h20c.2 0 .4-.1.5-.3l1.4-1.5c.2-.2.2-.6 0-.8L38 33.5l1.1-1.2c.2-.2.2-.6 0-.8l-1.2-1.3 1.2-1.2c.2-.2.2-.6 0-.8L38 27l1.1-1.3c.2-.2.2-.6 0-.8L38 23.7l1.1-1.3c.2-.2.2-.5 0-.7L37.6 20c-.1-.1-.2-.2-.4-.2h-6.4v-5.6c0-3.7-5.5-6.6-12.4-6.6S5.9 10.5 5.9 14.2v16.6c0 3.4 4.8 6.2 11.1 6.5zm8.3-17.5c1.7-.5 3.2-1.5 4.4-2.8v2.8h-4.4zM18.4 8.7c6.1 0 11.3 2.5 11.3 5.5s-5.2 5.6-11.3 5.6S7 17.2 7 14.2s5.2-5.5 11.4-5.5zM7 30.8V17c1.9 2.3 6.2 3.8 11.2 3.9v1.5c0 .3.3.6.6.6s.5-.3.5-.6v-1.5h17.6l1 1.1-1.1 1.3c-.2.2-.2.5 0 .7l1.1 1.3-1.1 1.3c-.2.2-.2.5 0 .7l1.1 1.3-1.1 1.3c-.2.2-.2.5 0 .7l1.1 1.3-1.1 1.3c-.2.2-.2.5 0 .7l1.1 1.3-.9 1.1H18.9c.3 0 .5-.3.4-.6v-1.8c0-.3-.2-.6-.5-.6s-.6.3-.6.6v1.8c0 .3.2.5.4.6h-.2c-6.3 0-11.5-2.6-11.4-5.5z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M7 14.2c0 3 5.2 5.6 11.4 5.6s11.3-2.6 11.3-5.6-5.2-5.5-11.3-5.5S7 11.2 7 14.2zm11.4 2.2c-2.2 0-3.9-.9-3.9-2.2s1.7-2.2 3.9-2.2 3.8 1 3.8 2.2-1.7 2.2-3.8 2.2z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M29.6 19.8V17c-1.2 1.3-2.7 2.3-4.4 2.8h4.4z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M18.4 36.3h.2c-.2-.1-.4-.3-.4-.6v-1.8c0-.3.3-.6.6-.6s.5.3.5.6v1.8c.1.3-.1.5-.4.6H37l.9-1.1-1.1-1.3c-.2-.2-.2-.5 0-.7l1.1-1.3-1.1-1.3c-.2-.2-.2-.5 0-.7l1.1-1.3-1.1-1.3c-.2-.2-.2-.5 0-.7l1.1-1.3-1.1-1.3c-.2-.2-.2-.5 0-.7l1.1-1.3-1-1.1H19.2v1.5c0 .3-.2.6-.5.6s-.6-.3-.6-.6v-1.5c-5-.1-9.3-1.6-11.2-3.9v13.8c.1 2.9 5.3 5.5 11.5 5.5zm.4-11.9c.3 0 .5.3.5.6v1.9c0 .3-.2.5-.5.5s-.6-.2-.6-.5V25c-.1-.3.2-.6.6-.6zm-.7 5c0-.3.3-.5.6-.5s.5.2.5.5v1.9c0 .3-.2.6-.5.6s-.6-.3-.6-.6v-1.9z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M18.2 26.9c0 .3.3.5.6.5s.5-.2.5-.5V25c0-.3-.2-.6-.5-.6s-.6.3-.6.6v1.9zM18.8 31.9c.3 0 .5-.3.5-.6v-1.9c0-.3-.2-.5-.5-.5s-.6.2-.6.5v1.9c-.1.3.2.6.6.6zM18.4 12c-2.2 0-3.9 1-3.9 2.2s1.7 2.2 3.9 2.2 3.8-.9 3.8-2.2-1.7-2.2-3.8-2.2zm0 3.3c-1.7 0-2.7-.6-2.7-1.1s1-1.1 2.7-1.1 2.7.7 2.7 1.1c-.1.4-1.1 1.1-2.7 1.1z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M18.4 13.1c-1.7 0-2.7.7-2.7 1.1 0 .4 1 1.1 2.7 1.1s2.7-.6 2.7-1.1-1.1-1.1-2.7-1.1z"
  }))), _view73 || (_view73 = /*#__PURE__*/React.createElement("view", {
    id: "huddles",
    viewBox: "0 360 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    y: 360,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 14,
    r: 2.6,
    fill: "#3c4652"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 29.5,
    r: 2.6,
    fill: "#3c4652"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 29.5,
    r: 2.6,
    fill: "#3c4652"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 24.5,
    r: 8,
    fill: "#5f7d95"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 24.5,
    r: 5.8,
    fill: "#6e91ad"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 6,
    width: 9.5,
    height: 6.5,
    rx: 2.2,
    fill: "#5a8fd8"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "m33 12.3-1.4 2.5 3.2-1.7z",
    fill: "#5a8fd8"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 11.5,
    width: 7.5,
    height: 5.5,
    rx: 2,
    fill: "#23967f"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "m41 16.8 1.2 2.2-3-1.4z",
    fill: "#23967f"
  }))), _view74 || (_view74 = /*#__PURE__*/React.createElement("view", {
    id: "humidity",
    viewBox: "45 360 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 45,
    y: 360,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m27 19.2-1.7-2.5L23 14l-.5-.5-.5.5-2.3 2.7-1.7 2.5c-.8 1.4-1.3 2.9-1.7 4.4-.2.6-.2 1.2-.2 1.8 0 .6.1 1.1.2 1.7.3 1 .9 1.8 1.6 2.5 2.7 2.3 6.5 2.3 9.2 0 .7-.7 1.3-1.5 1.6-2.5.1-.6.2-1.1.2-1.7 0-.6 0-1.2-.2-1.8-.4-1.5-.9-3-1.7-4.4zm1.1 7.7c-.2.9-.7 1.7-1.3 2.3-2.5 2-6.1 2-8.6 0-.6-.6-1.1-1.4-1.3-2.3-.2-.5-.3-1-.3-1.5 0-.6.1-1.1.2-1.7.3-1.5.9-2.9 1.7-4.2.5-.8 1.1-1.6 1.7-2.4.7-1 1.4-1.9 2.2-2.7h.2c.8.9 1.6 1.8 2.3 2.7l1.6 2.4c.8 1.3 1.4 2.7 1.7 4.2.1.6.2 1.1.2 1.7 0 .5-.1 1-.3 1.5z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22.5 9C15 9 9 15 9 22.5S15 36 22.5 36 36 30 36 22.5C35.9 15.1 29.9 9.1 22.5 9zm6.7 18.2c-.3 1.1-.9 2-1.7 2.8-2.9 2.4-7.1 2.4-10 0-.8-.8-1.4-1.7-1.7-2.8-.1-.6-.2-1.1-.2-1.7-.1-.7 0-1.3.1-2 .4-1.6 1.1-3.1 1.9-4.5.5-.9 1.1-1.8 1.7-2.6l2.3-2.8.9-.9.9.9 2.3 2.8c.6.8 1.2 1.7 1.7 2.6.8 1.4 1.5 2.9 1.9 4.5.1.7.2 1.3.1 2 0 .6-.1 1.1-.2 1.7z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.5 7.5c-8.3 0-15 6.7-15 15 .1 8.3 6.7 14.9 15 15 8.3-.1 14.9-6.7 15-15-.1-8.3-6.7-14.9-15-15zm0 28.5C15 36 9 30 9 22.5S15 9 22.5 9 36 15 36 22.5c-.1 7.4-6.1 13.4-13.5 13.5z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M27.4 19c-.5-.9-1.1-1.8-1.7-2.6l-2.3-2.8-.9-.9-.9.9-2.3 2.8c-.6.8-1.2 1.7-1.7 2.6-.8 1.4-1.5 2.9-1.9 4.5-.1.7-.2 1.3-.1 2 0 .6.1 1.1.2 1.7.3 1.1.9 2 1.7 2.8 2.9 2.4 7.1 2.4 10 0 .8-.8 1.4-1.7 1.7-2.8.1-.6.2-1.1.2-1.7.1-.7 0-1.3-.1-2-.4-1.6-1.1-3.1-1.9-4.5zm1.3 8.1c-.3 1-.9 1.8-1.6 2.5-2.7 2.3-6.5 2.3-9.2 0-.7-.7-1.3-1.5-1.6-2.5-.1-.6-.2-1.1-.2-1.7 0-.6 0-1.2.2-1.8.4-1.5.9-3 1.7-4.4l1.7-2.5L22 14l.5-.5.5.5 2.3 2.7 1.7 2.5c.8 1.4 1.3 2.9 1.7 4.4.2.6.2 1.2.2 1.8 0 .6-.1 1.1-.2 1.7z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "m26.5 19.5-1.6-2.4c-.7-.9-1.5-1.8-2.3-2.7h-.2c-.8.8-1.5 1.7-2.2 2.7-.6.8-1.2 1.6-1.7 2.4-.8 1.3-1.4 2.7-1.7 4.2-.1.6-.2 1.1-.2 1.7 0 .5.1 1 .3 1.5.2.9.7 1.7 1.3 2.3 2.5 2 6.1 2 8.6 0 .6-.6 1.1-1.4 1.3-2.3.2-.5.3-1 .3-1.5 0-.6-.1-1.1-.2-1.7-.3-1.5-.9-2.9-1.7-4.2z"
  }))), _view75 || (_view75 = /*#__PURE__*/React.createElement("view", {
    id: "ice-machine",
    viewBox: "90 360 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 90,
    y: 360,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 6,
    width: 23,
    height: 31,
    rx: 2.5,
    fill: "#a7b2ba"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 6.6,
    width: 12,
    height: 1.4,
    rx: 0.7,
    fill: "#8a6238"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "m14.5 13.5 2-5.7h12l2 5.7z",
    fill: "#b07845"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 13.5,
    width: 16,
    height: 10.5,
    rx: 1.5,
    fill: "#3f4a54"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9,
    y: 11.7,
    width: 3.8,
    height: 3.8,
    rx: 0.9,
    fill: "#bfe3f2"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4,
    y: 15.6,
    width: 4,
    height: 4,
    rx: 0.9,
    fill: "#bfe3f2"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9,
    y: 15.6,
    width: 4,
    height: 4,
    rx: 0.9,
    fill: "#bfe3f2"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2,
    y: 19.8,
    width: 4,
    height: 4,
    rx: 0.9,
    fill: "#bfe3f2"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7,
    y: 19.8,
    width: 4,
    height: 4,
    rx: 0.9,
    fill: "#bfe3f2"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2,
    y: 19.8,
    width: 4,
    height: 4,
    rx: 0.9,
    fill: "#bfe3f2"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 26.5,
    width: 18,
    height: 8,
    rx: 1.2,
    fill: "#98a5ad"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 28,
    width: 8,
    height: 1.4,
    rx: 0.7,
    fill: "#5c6870"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.7,
    cy: 30.7,
    r: 1,
    fill: "#58c47a"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 37,
    width: 3,
    height: 2.2,
    rx: 0.6,
    fill: "#7d8a93"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 37,
    width: 3,
    height: 2.2,
    rx: 0.6,
    fill: "#7d8a93"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 35.6,
    y: 34.6,
    width: 4.4,
    height: 4.4,
    rx: 1,
    fill: "#bfe3f2"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 38.6,
    y: 30,
    width: 3.6,
    height: 3.6,
    rx: 0.9,
    fill: "#bfe3f2"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "m39.6 22.4.7 1.4 1.4.7-1.4.7-.7 1.4-.7-1.4-1.4-.7 1.4-.7z",
    fill: "#9fd8ef"
  }))), _view76 || (_view76 = /*#__PURE__*/React.createElement("view", {
    id: "in-meeting-food-request",
    viewBox: "135 360 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 135,
    y: 360,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e5334",
    d: "M8 18.7h1.8v5.5H8zM35.2 18.7H37v5.5h-1.8z"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 16.5,
    width: 34,
    height: 2.2,
    rx: 1,
    fill: "#8a6238"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5,
    cy: 15,
    rx: 5,
    ry: 2.5,
    fill: "#e8b45a"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5,
    cy: 15,
    rx: 3.9,
    ry: 1.85,
    fill: "#f2c14e"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.9,
    cy: 14.7,
    r: 0.6,
    fill: "#c8503f"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4,
    cy: 15.6,
    r: 0.6,
    fill: "#c8503f"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 14.3,
    r: 0.6,
    fill: "#c8503f"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.3,
    cy: 13.3,
    r: 1.25,
    fill: "#57b368"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 12.6,
    r: 1.45,
    fill: "#57b368"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.7,
    cy: 13.3,
    r: 1.25,
    fill: "#57b368"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 13.6,
    r: 0.55,
    fill: "#c8503f"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 13.8h6.4c0 1.9-1.4 2.9-3.2 2.9s-3.2-1-3.2-2.9z",
    fill: "#dfe6ec"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "m25.9 16.5 3-5 3 5z",
    fill: "#d9c9a8"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "m27.2 16.5 3-5 3 5z",
    fill: "#e8ddc8"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2 15.2h4.1l.5.8h-5.1z",
    fill: "#c8503f"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 34.4,
    y: 11.8,
    width: 2.2,
    height: 4.7,
    rx: 1,
    fill: "#9fd8ef"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 34.95,
    y: 10.9,
    width: 1.1,
    height: 1.1,
    rx: 0.3,
    fill: "#4a7fa5"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "#eef1f5",
    d: "M34.4 13.7h2.2v1.2h-2.2z"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 37.2,
    y: 11.8,
    width: 2.2,
    height: 4.7,
    rx: 1,
    fill: "#9fd8ef"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 37.75,
    y: 10.9,
    width: 1.1,
    height: 1.1,
    rx: 0.3,
    fill: "#4a7fa5"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "#eef1f5",
    d: "M37.2 13.7h2.2v1.2h-2.2z"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 26.3,
    width: 6,
    height: 6.5,
    rx: 2,
    fill: "#3c4652"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 32.5,
    width: 7.2,
    height: 1.9,
    rx: 0.9,
    fill: "#3c4652"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c6870",
    d: "M13.35 34.4h1.3v2.2h-1.3z"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3,
    y: 36.6,
    width: 5.9,
    height: 1.1,
    rx: 0.55,
    fill: "#5c6870"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 26.3,
    width: 6,
    height: 6.5,
    rx: 2,
    fill: "#3c4652"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 26.9,
    y: 32.5,
    width: 7.2,
    height: 1.9,
    rx: 0.9,
    fill: "#3c4652"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c6870",
    d: "M29.85 34.4h1.3v2.2h-1.3z"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8,
    y: 36.6,
    width: 5.9,
    height: 1.1,
    rx: 0.55,
    fill: "#5c6870"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 30,
    width: 39,
    height: 3.4,
    rx: 1.6,
    fill: "#5f7d95"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "#46626d",
    d: "M8 33.4h3V40H8zM34 33.4h3V40h-3z"
  }))), _view77 || (_view77 = /*#__PURE__*/React.createElement("view", {
    id: "in-meeting-request",
    viewBox: "180 360 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 180,
    y: 360,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 38.5,
    width: 39,
    height: 1.5,
    rx: 0.75,
    fill: "#c3ccd2"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 21.3,
    width: 6,
    height: 6.5,
    rx: 2,
    fill: "#3c4652"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9,
    y: 27.7,
    width: 7.2,
    height: 1.9,
    rx: 0.9,
    fill: "#3c4652"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c6870",
    d: "M21.85 29.6h1.3V32h-1.3z"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8,
    y: 32,
    width: 5.9,
    height: 1.1,
    rx: 0.55,
    fill: "#5c6870"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 21.3,
    width: 6,
    height: 6.5,
    rx: 2,
    fill: "#3c4652"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4,
    y: 27.7,
    width: 7.2,
    height: 1.9,
    rx: 0.9,
    fill: "#3c4652"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c6870",
    d: "M31.35 29.6h1.3V32h-1.3z"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 29.3,
    y: 32,
    width: 5.9,
    height: 1.1,
    rx: 0.55,
    fill: "#5c6870"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 27.5,
    width: 27,
    height: 3,
    rx: 1.4,
    fill: "#5f7d95"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "#46626d",
    d: "M17.5 30.5h2.6v8h-2.6zM35.5 30.5h2.6v8h-2.6z"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 15.5,
    r: 3.2,
    fill: "#5a8fd8"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 18.7,
    width: 6.6,
    height: 10.5,
    rx: 2.8,
    fill: "#5a8fd8"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 11,
    width: 2.2,
    height: 9,
    rx: 1.1,
    fill: "#5a8fd8",
    transform: "rotate(28 10.6 19.5)"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.7,
    cy: 11.7,
    r: 1.15,
    fill: "#5a8fd8"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 29.2,
    width: 2.4,
    height: 9.3,
    rx: 1,
    fill: "#4a77b8"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 8.8,
    y: 29.2,
    width: 2.4,
    height: 9.3,
    rx: 1,
    fill: "#4a77b8"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 36.9h2.8c.9 0 1.3.4 1.3.85 0 .4-.3.75-.7.75H8.8z",
    fill: "#31281f"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 36.9h2.8c.9 0 1.3.4 1.3.85 0 .4-.3.75-.7.75H5.6z",
    fill: "#31281f"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 4H28c1.4 0 2.6 1.2 2.6 2.6v2.8c0 1.4-1.2 2.6-2.6 2.6h-5.5l-3.6 3.2.5-3.3c-1.2-.3-2.4-1.2-2.4-2.5V6.6C17 5.2 18.2 4 19.6 4z",
    fill: "#e0704f"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 22.9,
    y: 5.7,
    width: 1.7,
    height: 4.6,
    rx: 0.85,
    fill: "#fff"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 21.45,
    y: 7.15,
    width: 4.6,
    height: 1.7,
    rx: 0.85,
    fill: "#fff"
  }))), _view78 || (_view78 = /*#__PURE__*/React.createElement("view", {
    id: "janitorial",
    viewBox: "225 360 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 225,
    y: 360,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M39.1 11.2c0-1.1-.9-2-2-2H37c-1.1 0-2 .9-2 2 0 1 .8 1.9 1.9 1.9h.1c1.1.1 2-.7 2.1-1.9-.1.1-.1.1 0 0z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22.5 35.3c-.1-.3-.2-.3-.5-.3h-4.4c-.2 0-.2-.1-.3-.3-.1-.7-.7-1.2-1.4-1.1h-1.7c-.8-.1-1.5.4-1.6 1.2 0 .2-.1.2-.3.2H7.9c-.3 0-.4.1-.4.3h15zM14.5 32.8h1V6.1c0-.1-.1-.2-.1-.3h-.8c-.2 0-.2.3-.2.4.1 8.8.1 17.6.1 26.3v.3zM26.2 30.8h4.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-4.4c-.3 0-.6.2-.7.5-.1.3.3.9.7.9zM22.6 36.2H7.5c-.1 0-.2.1-.2.2-.3.7-.5 1.4-.8 2l-.3 1h1l.6-2.4.8.2-.6 2h1.3c.2-.7.3-1.4.5-2.2h.5c.2 0 .2.1.2.2s-.1.5-.2.7c0 .4-.1.9-.2 1.3h1.3l.3-2.1h.7c0 .7-.1 1.4-.2 2.1h1.3c.1-.7.1-1.4.1-2.1h.8c0 .7-.1 1.4-.1 2.1h1.4c-.1-.7-.1-1.4-.1-2.1h.7c.1.7.1 1.4.1 2.1h1.4l-.3-2.1h.8c.1.7.1 1.4.2 2.1h1.4c-.2-.7-.3-1.3-.4-2l.7-.2c.2.7.3 1.5.4 2.2H22l-.6-2 .7-.2c.2.8.4 1.5.7 2.2h1l-1.2-3z"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M19.1 18.5c-.5.2-1 .6-1.2 1.1h19.5c0-.8-.6-1.4-1.3-1.6h-.5c.3-.4.5-.9.5-1.4.1-1-.8-1.9-1.8-2-1-.1-1.9.8-2 1.8 0 .2 0 .5-.1.6h-.7c-.2-1.1.4-2.2 1.4-2.7-.4-.7-1.2-1.2-2-1.1-1.2 0-2.2 1-2.3 2.2h-1.4c-.8.1-1.5.8-1.6 1.6 0 .1 0 .2-.1.2h-.6c-.1-.4 0-.8.2-1.2 0-.1 0-.2-.1-.3-.7-.8-1.8-1-2.8-.6-1 .3-1.6 1.3-1.6 2.3 0 .1 0 .2.2.3.6.1 1.1.4 1.4.9l-.4.4c-.4-.3-.8-.5-1.2-.7-.5 0-1 0-1.5.2z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M38.2 19.6H17v1.6c-.1.9.6 1.6 1.5 1.7h.1c.7 3.7 1.3 7.5 2 11.3h-2.2c-.2.1-.4 0-.5-.1 0 0 0-.1-.1-.2 0-.1-.1-.1-.1-.2-.4-.4-.8-.8-1.4-.9V6.1c0-.6-.4-1-1-1.1h-.6c-.6.1-1.1.6-1 1.2v26.4c0 .2-.1.3-.3.3-.6.2-1 .6-1.3 1.1-.1.2-.2.2-.4.2H7.9c-.7 0-1.2.5-1.2 1.2 0 .1 0 .2-.1.3-.3 1-.7 2-1 2.9-.3.9-.3.9-.5 1.3h19.8l-.3-.7h7.7c1.7 0 3.3-1.2 3.6-2.9.1-.7.2-1.3.4-2 .2-1.4.5-2.9.7-4.4.2-1.5.9-4.5 1.3-6.7 0-.2 0-.2.2-.3.6 0 1.2-.5 1.3-1.1v-2.2h-1.6zM25.5 29.8c.1-.3.4-.5.7-.5h4.4c.4 0 .7.3.7.7 0 .4-.3.7-.7.7h-4.4c-.4.1-.8-.5-.7-.9zM14.4 6.2c0-.1 0-.4.2-.4h.8c0 .1.1.2.1.3v26.7h-1v-.3c0-8.7 0-17.5-.1-26.3zM7.9 35h4.4c.2 0 .3 0 .3-.2.1-.8.8-1.3 1.6-1.2h1.7c.7-.1 1.3.4 1.4 1.1.1.2.1.3.3.3H22c.3 0 .4 0 .5.3h-15c0-.1.1-.3.4-.3zm14.9 4.2c-.3-.7-.5-1.4-.7-2.2l-.7.2.6 2h-1.4c-.1-.7-.2-1.5-.4-2.2l-.7.2c.1.7.2 1.3.4 2h-1.4c-.1-.7-.1-1.4-.2-2.1h-.8l.3 2.1h-1.4c0-.7 0-1.4-.1-2.1h-.7c0 .7 0 1.4.1 2.1h-1.4c0-.7.1-1.4.1-2.1h-.8c0 .7 0 1.4-.1 2.1h-1.3c.1-.7.2-1.4.2-2.1h-.7l-.3 2.1h-1.3c.1-.4.2-.8.2-1.2.1-.2.1-.5.2-.7s0-.2-.2-.2h-.5c-.2.8-.3 1.5-.5 2.2H8l.6-2-.8-.3-.6 2.2h-1l.3-1c.3-.6.5-1.3.8-2 0-.1.1-.2.2-.2h15.1l1.2 3.1-1 .1zm13.5-9.3-.9 4.8-.3 1.6c-.3 1.3-1.5 2.2-2.8 2.2h-7.7c-.2 0-.3-.1-.4-.3l-.9-2.6v-.3c-.1-.6-.6-1-1.2-1h-.7c-.4-2.4-.9-4.7-1.3-7.1h.2c1.1 1.3 2.6 2.3 4.2 2.9l.3.3c.1.6.7 1.1 1.3 1.1h4.5c.7 0 1.3-.4 1.4-1.1 0-.2.1-.2.2-.3 1.6-.5 3-1.4 4.1-2.6l.5-.6c-.1.9-.3 1.9-.5 3zm1-6.4c0 .3-.1.7-.2 1-.6 1.7-1.7 3.1-3.2 4l-2 .9c-.3-.6-.9-1-1.6-.9-1.3.1-2.5 0-3.8 0-.7-.1-1.3.2-1.7.8-3.4-1.1-5.3-3.6-5.4-6.4h18c0 .2-.1.4-.1.6zm1.7-2c0 .3-.3.6-.6.6H18.8c-.6 0-.9-.2-.9-.9v-.8h21.2c0 .4 0 .8-.1 1.1z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M26.4 13c.7.1 1.3-.5 1.4-1.2v-.1c-.1-.7-.7-1.3-1.4-1.2-.7-.1-1.2.4-1.3 1.1v.1c0 .8.5 1.3 1.3 1.3z"
  }))), _view79 || (_view79 = /*#__PURE__*/React.createElement("view", {
    id: "just_right",
    viewBox: "270 360 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 270,
    y: 360,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24.2 11c0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3v13.4c0 .2-.1.5-.3.6-2.9 1.4-4.1 5-2.7 7.9s5 4.1 7.9 2.7c2.9-1.4 4.1-5 2.7-7.9-.6-1.2-1.5-2.1-2.7-2.7-.2-.1-.3-.4-.3-.6V11zm1.7 19.3c0 2.2-1.8 3.9-3.9 3.9s-3.9-1.8-3.9-3.9c0-1.9 1.4-3.5 3.3-3.8v-9.6c0-.3.3-.6.6-.6s.6.3.6.6v9.6c1.9.2 3.3 1.9 3.3 3.8z"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M25.4 11c0-1.9-1.5-3.4-3.4-3.4s-3.4 1.5-3.5 3.4v13.1c-3.4 1.9-4.6 6.3-2.7 9.7 1.9 3.4 6.3 4.6 9.7 2.7 2.2-1.3 3.6-3.6 3.6-6.2s-1.4-5-3.7-6.2V11zm-.9 14c2.9 1.4 4.1 5 2.7 7.9s-5 4.1-7.9 2.7c-2.9-1.4-4.1-5-2.7-7.9.6-1.2 1.5-2.1 2.7-2.7.2-.1.3-.4.3-.6V11c0-1.3 1-2.3 2.3-2.3 1.3 0 2.3 1 2.3 2.3v13.4c0 .2.1.5.3.6z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M22.5 16.8c0-.3-.3-.6-.6-.6s-.6.3-.6.6v9.6c-2.1.3-3.6 2.3-3.3 4.5s2.3 3.6 4.5 3.3 3.6-2.3 3.3-4.5c-.3-1.7-1.6-3-3.3-3.3v-9.6z"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M29.5 9.7H27c-.3 0-.6.3-.6.6s.3.6.6.6h2.6c.3 0 .6-.3.6-.6s-.3-.6-.7-.6zM27 13.8h1.4c.3 0 .6-.3.6-.6s-.3-.6-.6-.6H27c-.3 0-.6.3-.6.6s.2.6.6.6zM27 16.6h2.6c.3 0 .6-.3.6-.6s-.3-.6-.6-.6H27c-.3 0-.6.3-.6.6s.2.6.6.6zM27 19.5h1.4c.3 0 .6-.3.6-.6s-.3-.6-.6-.6H27c-.3 0-.6.3-.6.6s.2.6.6.6zM29.5 21.1H27c-.3 0-.6.3-.6.6s.3.6.6.6h2.6c.3 0 .6-.3.6-.6-.1-.3-.3-.6-.7-.6z"
  }))), _view80 || (_view80 = /*#__PURE__*/React.createElement("view", {
    id: "keg",
    viewBox: "315 360 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 315,
    y: 360,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-166.2-953.5h612v1330h-612z"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-166.2-953.5h612v1330h-612z"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-166.2-953.5h612v1330h-612z"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-166.2-953.5h612v1330h-612z"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-166.2-953.5h612v1330h-612z"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M11.1 37.5h22.7c.7 0 1.3-.6 1.3-1.3v-1c0-.6-.4-1.1-1-1.2v-9.7c.6-.2 1-.7 1-1.3v-1c0-.6-.4-1.1-1-1.3V11c.6-.1 1-.6 1-1.2v-1c0-.7-.6-1.3-1.3-1.3H11.1c-.7 0-1.3.6-1.3 1.3v1c0 .6.4 1.1 1 1.2v9.7c-.6.2-1 .7-1 1.3v1c0 .6.4 1.1 1 1.3V34c-.6.1-1 .6-1 1.2v1c.1.7.6 1.3 1.3 1.3zm-.5-27.6V8.8c0-.3.2-.5.5-.5h22.8c.3 0 .5.2.5.5v1.1c0 .3-.2.5-.5.5H11.1c-.2 0-.5-.3-.5-.5zm1 1.2h21.7v9.7H11.6v-9.7zm-1 12V22c0-.3.2-.5.5-.5h22.8c.3 0 .5.2.5.5v1.1c0 .3-.2.5-.5.5H11.1c-.2 0-.5-.3-.5-.5zm1 1.2h21.7V34H11.6v-9.7zm-1 10.9c0-.3.2-.5.5-.5h22.8c.3 0 .5.2.5.5v1.1c0 .3-.2.5-.5.5H11.1c-.3 0-.5-.2-.5-.5v-1.1z"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M33.3 20.8v-9.7H11.6v9.7h21.7zm-14.4-7.6h7.2c.7 0 1.3.6 1.3 1.3v1c0 .7-.6 1.3-1.3 1.3h-7.2c-.7 0-1.3-.6-1.3-1.3v-1c0-.7.6-1.3 1.3-1.3zM11.6 24.3h21.7V34H11.6z"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M33.9 10.4c.3 0 .5-.2.5-.5V8.8c0-.3-.2-.5-.5-.5H11.1c-.3 0-.5.2-.5.5v1.1c0 .3.2.5.5.5h22.8zM11.1 36.8h22.8c.3 0 .5-.2.5-.5v-1.1c0-.3-.2-.5-.5-.5H11.1c-.3 0-.5.2-.5.5v1.1c0 .2.3.5.5.5zM33.9 23.6c.3 0 .5-.2.5-.5V22c0-.3-.2-.5-.5-.5H11.1c-.3 0-.5.2-.5.5v1.1c0 .3.2.5.5.5h22.8z"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M17.6 15.5c0 .7.6 1.3 1.3 1.3h7.2c.7 0 1.3-.6 1.3-1.3v-1c0-.7-.6-1.3-1.3-1.3h-7.2c-.7 0-1.3.6-1.3 1.3v1z"
  }))), _view81 || (_view81 = /*#__PURE__*/React.createElement("view", {
    id: "key",
    viewBox: "360 360 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 360,
    y: 360,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    stroke: "#505050",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M34.6 33.7v.7l-2.1.3-.9-1-.4-1.6c0-.1-.1-.2-.2-.2l-1.6-.4-.3-1.5c0-.1 0-.1-.1-.1l-1.6-.4-.4-1.6c0-.1-.1-.2-.2-.2l-1.6-.4-2.1-2.1 1.3-1.1.3-.3-.2-.2c-.1 0-.1-.2 0-.3l-.4.5c-.5.4-1 .8-1.6 1.1 0 .1-.1.1-.1.2s.1.1.1.2l2.4 2.4h.1l1.6.4.4 1.6c0 .1 0 .2.1.2l1.6.4.4 1.7h.2l1.6.4.3 1.7h.1l1.1 1.1h.2l2.4-.4.1-.2v-1.1c0 .1 0 .2-.1.3h-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m23.1 25.2 2.1 2.1 1.6.4c.1 0 .2.1.2.2l.4 1.6 1.6.4c.1 0 .1 0 .1.1l.4 1.6 1.6.4c.1 0 .2.1.2.2l.4 1.6.9 1 2.1-.3v-.7l-10-10-.3.2-1.3 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "m24.4 23.5.2.2 10 10h.3c.1-.1.1-.2.1-.3l-.4-2.2-9.1-9c0-.1 0-.1-.1-.1s-.1 0-.1.1h-.2c-.2.4-.4.7-.7 1v.3zm1-.8 8.8 8.8.2 1.5-9.5-9.5c.2-.3.3-.6.5-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m24.9 23.5 9.5 9.5-.2-1.5-8.8-8.8c-.2.2-.3.5-.5.8z"
  }))), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#505050",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    cx: 19.4,
    cy: 18.6,
    r: 7.1
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    stroke: "#505050",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M16.9 14.2c-1.3 0-2.4 1.1-2.4 2.4 0 1.3 1.1 2.4 2.4 2.4 1.3 0 2.4-1.1 2.4-2.4.1-1.3-1-2.4-2.4-2.4zm0 4.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.8 2-2 2z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ECECEC",
    cx: 16.9,
    cy: 16.7,
    r: 2
  })))), _view82 || (_view82 = /*#__PURE__*/React.createElement("view", {
    id: "lab_equipment",
    viewBox: "405 0 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 405,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M19.3 9.8h-.5l-1.4 1.4-2.9-2.8.4-.4c.1-.1.1-.4 0-.5l-.6-.6c-.6-.5-1.4-.5-2 0l-1.7 1.7c-.3.2-.4.6-.4.9 0 .4.1.7.4 1l.6.6h.6l.4-.4 2.8 2.8-1.4 1.4c-.1.2-.1.3 0 .5l2.7 2.7c-.5.5-.7 1.2-.7 1.9-.1.6.1 1.2.5 1.6-.5 1.1-.7 2.3-.7 3.5 0 2.9 1.3 5.7 3.7 7.5l-1.5 3.6c-.3 0-.7.1-.9.4-.3.3-.5.7-.5 1.1v.4c0 .2.2.4.4.4h12.1c.2 0 .4-.2.4-.4v-.4c0-.4-.2-.8-.5-1.1-.2-.3-.6-.4-.9-.4l-.7-1.7c2.3-.5 4.4-1.8 5.9-3.7h.3c.8 0 1.5-.7 1.6-1.5V29c0-.2-.2-.4-.4-.4h-6.7c-.2 0-.3.2-.3.4v.3c0 .8.6 1.4 1.4 1.5-.9.6-1.9.9-2.9 1l-.5-1.2c-.1-.2-.2-.3-.4-.3h-4.3c-1.6-1.2-2.5-3.2-2.5-5.2 0-.7.2-1.4.4-2.1.7 0 1.4-.3 2-.7l2.6 2.6h.6l1.4-1.4 2.4 2.4c.2.2.5.3.8.3 0 .2 0 .3.1.4h.5l1.6-1.7c.2-.1.2-.3 0-.5h-.3c0-.3-.1-.5-.3-.7l-2.5-2.4 1.4-1.4.2-.2-.2-.3-9.6-9.6zm-6.6.4L14 8.9l2.8 2.8-1.3 1.3-2.8-2.8zM28 37.1c.2.2.3.4.3.6H17c0-.2.1-.4.2-.6.2-.2.4-.3.7-.3h9.5c.2 0 .5.1.6.3zm2-6.3h1.9c-1.3 1.6-3.2 2.6-5.2 3l-.5-1.3c1.4-.2 2.7-.8 3.8-1.7zm-5.2.3 2.1 5h-8.5l2.1-5h4.3zm-4.9-.5-.5 1.3c-2.1-1.6-3.3-4.1-3.3-6.8 0-1 .2-2 .5-2.9.4.3.8.6 1.3.7-.3.7-.4 1.4-.4 2.2 0 2.1.9 4.1 2.4 5.5zm-1.3-8.4c-1.2.3-2.5-.5-2.7-1.8-.3-1.2.5-2.5 1.8-2.7.3-.1.6-.1 1 0 1.2-.3 2.5.5 2.7 1.8s-.5 2.5-1.8 2.7c-.4.1-.7.1-1 0zm10.8 1.9c.1.1.2.2.2.4s0 .3-.2.4l-.4.5c-.2.2-.6.2-.8 0L25.7 23l1.3-1.3 2.4 2.4zm-1.2-4.5-4.7 4.5-2.4-2.4c.3-.5.6-1.1.6-1.7 0-1.7-1.3-3-3-3h-.1c-.7 0-1.3.2-1.8.6l-2.4-2.4 1.4-1.4 1.8-1.8 1.4-1.4 9.2 9z"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.6 17.7c-1.2-.3-2.5.5-2.7 1.8-.3 1.2.5 2.5 1.8 2.7.3.1.6.1 1 0 1.2.3 2.5-.5 2.7-1.8s-.5-2.5-1.8-2.7c-.4-.1-.7-.1-1 0zm1 3.2c-.3.3-.6.4-1 .4s-.7-.1-1-.4c-.5-.5-.5-1.4 0-1.9.6-.5 1.4-.5 2 0 .5.5.5 1.4 0 1.9z"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M17.6 19c-.5.5-.5 1.4 0 1.9.3.3.6.4 1 .4s.7-.1 1-.4c.5-.5.5-1.4 0-1.9-.6-.5-1.4-.5-2 0z"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m25.7 23 2.5 2.4c.2.2.6.2.8 0l.4-.5c.2-.1.2-.2.2-.4s-.1-.3-.2-.4L27 21.7 25.7 23zM16.8 11.7 14 8.9l-1.3 1.3 2.8 2.8z"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M19 10.6 17.6 12l-1.8 1.8-1.4 1.4 2.4 2.4c.5-.4 1.1-.6 1.8-.6 1.7-.1 3 1.2 3.1 2.9v.1c0 .6-.3 1.2-.6 1.7l2.4 2.4 4.7-4.5-9.2-9z"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.4 36.1h8.5l-2.1-5h-4.3l-2.1 5zm5.2-4.1c.5.5.5 1.4 0 1.9-.3.3-.6.4-1 .4-.3 0-.7-.1-.9-.4-.5-.4-.6-1.2-.2-1.7.1-.1.1-.2.2-.2.5-.5 1.4-.5 1.9 0z"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M21.7 32c-.5.4-.6 1.2-.2 1.7.1.1.1.2.2.2.2.3.6.4.9.4.4 0 .7-.1 1-.4.5-.5.5-1.4 0-1.9s-1.4-.5-1.9 0z"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.9 36.8c-.3 0-.5.1-.7.3-.1.2-.2.4-.2.6h11.3c0-.2-.1-.4-.3-.6-.1-.2-.4-.3-.6-.3h-9.5z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M17.9 22.9c-.5-.1-.9-.4-1.3-.7-.3.9-.5 1.9-.5 2.9 0 2.7 1.2 5.2 3.3 6.8l.5-1.3c-1.5-1.4-2.4-3.4-2.4-5.5 0-.8.1-1.5.4-2.2zM26.2 32.5l.5 1.3c2-.4 3.9-1.4 5.2-3H30c-1.1.9-2.4 1.5-3.8 1.7z"
  }))), _view83 || (_view83 = /*#__PURE__*/React.createElement("view", {
    id: "lab_services",
    viewBox: "405 45 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 405,
    y: 45,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M7.3 35c-.3.5-.3 1 0 1.5s.8.8 1.4.8H20c.3 0 .6-.1.9-.3.4.2.8.3 1.3.3 1.1 0 2.1-.5 2.8-1.3.6.5 1.3 1 2.1 1.3h6.1c3.8-1.4 5.7-5.6 4.3-9.4-.8-2-2.3-3.6-4.4-4.3v-7.4c.6-.1 1-.6 1-1.2.1-.7-.5-1.3-1.2-1.4H27.5c-.7 0-1.3.6-1.3 1.3v.1c0 .6.4 1.1 1 1.2v7.4l-1.3.7v-14c.5-.2.8-.7.8-1.3 0-.7-.6-1.3-1.3-1.3h-6.5c-.7 0-1.3.6-1.3 1.3 0 .6.3 1.1.8 1.3v17.1l-1.6-4.1v-3.7c.6-.1 1.1-.6 1.1-1.2 0-.7-.6-1.3-1.3-1.3h-4.5c-.7 0-1.3.6-1.3 1.3 0 .7.5 1.2 1.2 1.2v3.7L7.3 35zm.6.3 2.2-5.5c.7 0 1.4-.2 2-.6l1.2-.5c1.2-.2 2.3.6 3.6 1l1.8.4 2.1 5.2c.2.2.2.6 0 .8-.2.3-.5.5-.8.5H8.7c-.3 0-.6-.2-.8-.5-.1-.3-.1-.5 0-.8zM33 36.6h-5.7c-2.2-.9-3.8-2.9-4.1-5.3 4.9 1.9 5.5-3.7 14-1.6.3 3-1.4 5.8-4.2 6.9zm-9.5-8.3c2.2-.2 4.3.2 6.2 1.3-1.4.6-3.6 2.6-6.5 1.3-.1-.9 0-1.8.3-2.6zM26.9 15c0-.4.3-.6.6-.7h5.3c.4 0 .6.3.6.7 0 .3-.3.6-.6.6h-5.3c-.3 0-.6-.3-.6-.6zm1 1.3h4.5v7.5c0 .2.1.3.3.3 2.3.9 4 2.9 4.4 5.3-2.3-.7-4.7-.6-7 .1-2-1.2-4.2-1.7-6.5-1.6.8-1.8 2.3-3.1 4.1-3.8.1 0 .2-.1.2-.3v-7.5zm-2.7 8.5c-3.1 2.4-3.7 6.8-1.4 9.9.2.3.4.5.7.8-.6.7-1.4 1-2.3 1.1h-.8c.3-.5.3-1 .1-1.5l-2.4-5.9v-9.3c1 .4 2 .5 3.1.5 1 0 2-.1 3-.5v4.9zm-3-6.1c1 0 2 .1 3 .5v.3c-1 .4-2 .5-3 .5-1.1.1-2.1-.1-3.1-.5v-.3c1-.4 2-.6 3.1-.5zm3 .1c-1-.3-2-.4-3-.4s-2.1.1-3.1.4v-8.4h6.1v8.4zM18.3 9c0-.3.3-.6.6-.6h6.5c.3 0 .6.3.6.6 0 .4-.3.6-.6.7h-6.5c-.3-.1-.6-.3-.6-.7zm-2.2 14.4 2.5 6.3c-.5 0-1.1-.1-1.6-.3-1.2-.4-2.5-1.3-3.8-1l-1.2.5c-.6.3-1.2.5-1.8.6l2.4-6v-3.9h3.5v3.8zm-4.6-5c0-.3.3-.6.6-.6h4.5c.3-.1.5.1.6.4v.2c0 .3-.2.5-.6.5h-4.5c-.3 0-.6-.2-.6-.5z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M8.7 36.6H20c.3 0 .6-.2.8-.5.2-.2.2-.6 0-.8l-2.1-5.2-1.8-.4c-1.3-.4-2.4-1.2-3.6-1l-1.2.5c-.6.4-1.3.6-2 .6l-2.2 5.5c-.1.3-.1.5 0 .8.2.3.5.5.8.5zm3.1-1.6c-.3 0-.6-.3-.6-.6s.3-.6.6-.6.6.3.6.6-.3.6-.6.6zm6.4-3.1c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4.2-.4.4-.4zM16.1 33c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-2.5-2.5c.3 0 .6.3.6.6.1.3-.1.5-.4.6h-.2c-.3 0-.6-.3-.6-.6s.3-.6.6-.6zm.6 3.1c0 .2-.2.4-.4.4s-.3-.2-.3-.4.1-.3.3-.3c.2 0 .4.1.4.3zm1.8 1.9c-.2 0-.4-.3-.4-.5s.2-.5.4-.5c.3 0 .5.2.5.5s-.2.5-.5.5zm-4.9-4.2c.2 0 .3.2.3.4s-.1.3-.3.3c-.2 0-.4-.1-.4-.3 0-.2.2-.4.4-.4z"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M18.9 9.7h6.5c.3-.1.6-.3.6-.7 0-.3-.3-.6-.6-.6h-6.5c-.3 0-.6.3-.6.6 0 .4.3.6.6.7z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19.1 10.4v8.4c1-.3 2.1-.4 3.1-.4s2 .1 3 .4v-8.4h-6.1zM12.6 19.6v3.8l-2.4 6c.6-.1 1.2-.3 1.8-.6l1.2-.5c1.3-.3 2.6.6 3.8 1 .5.2 1.1.3 1.6.3l-2.5-6.1v-3.9h-3.5z"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0451E",
    d: "M19.1 19.2v.3c1 .4 2 .6 3.1.5 1 0 2-.1 3-.5v-.3c-1-.4-2-.5-3-.5-1.1-.1-2.1.1-3.1.5z"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M22.2 20.4c-1.1 0-2.1-.1-3.1-.5v9.3l2.4 5.8c.2.5.2 1-.1 1.5h.8c.9-.1 1.7-.4 2.3-1.1-2.8-2.8-2.8-7.3-.1-10 .2-.2.5-.5.8-.7v-4.8c-1 .4-2 .5-3 .5zm-1.9 2.1c0-.3.3-.6.6-.6s.5.2.5.6c0 .3-.2.5-.5.5s-.6-.2-.6-.5zm1.1 3.9c-.3 0-.5-.2-.5-.5s.2-.6.5-.6.6.3.6.6-.3.5-.6.5zm.6 2c0 .3-.3.6-.6.6s-.5-.3-.5-.6.2-.5.5-.5.6.2.6.5zm-.3 2.7c.3 0 .5.2.5.5s-.2.5-.5.5-.5-.2-.5-.5.2-.5.5-.5zm1.1 3c0 .2-.1.3-.3.3-.2 0-.3-.1-.3-.3 0-.2.1-.3.3-.3.2 0 .3.1.3.3zm.9-9.9c0 .4-.2.6-.5.6s-.6-.3-.6-.6.3-.5.6-.5.5.2.5.5z"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M16.6 18.9c.4 0 .6-.2.6-.5.1-.3-.1-.5-.4-.6h-4.7c-.3 0-.6.3-.6.6s.3.5.6.5h4.5zM32.8 15.6c.3 0 .6-.3.6-.6 0-.4-.2-.7-.6-.7h-5.3c-.3.1-.6.3-.6.7 0 .3.3.6.6.6h5.3z"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M27.7 24.1c-1.8.7-3.3 2-4.1 3.8 2.3-.1 4.5.4 6.5 1.6 2.3-.7 4.7-.8 7-.1-.4-2.4-2.1-4.4-4.4-5.3-.2 0-.3-.1-.3-.3v-7.5h-4.5v7.5c0 .2-.1.3-.2.3z"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E98C0",
    d: "M29.7 29.6c-1.9-1.1-4-1.5-6.2-1.3-.3.8-.4 1.7-.3 2.6 2.9 1.3 5.1-.7 6.5-1.3z"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M23.2 31.3c.3 2.4 1.9 4.4 4.1 5.3H33c2.8-1.1 4.5-3.9 4.2-6.9-8.5-2.1-9.1 3.5-14 1.6zm10.9-.5c.3 0 .6.3.6.6s-.3.5-.6.5-.5-.2-.5-.5.2-.6.5-.6zm-1 3.4c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4.2-.4.4-.4zm-2.4-2.6c.2 0 .4.1.4.3 0 .2-.2.4-.4.4s-.3-.2-.3-.4.1-.3.3-.3zm-.8 2.3c.4 0 .7.3.7.7 0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7zm-2-1.6c.3 0 .5.2.5.5s-.2.6-.5.6-.6-.3-.6-.6.3-.5.6-.5zm-1.6 2.2c0-.3.2-.5.5-.5s.5.2.5.5-.2.5-.5.5-.5-.2-.5-.5z"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.1 32c.2 0 .3-.1.3-.3 0-.2-.1-.4-.3-.4-.2 0-.4.2-.4.4s.2.3.4.3zM21.4 22.5c0-.4-.2-.6-.5-.6s-.6.3-.6.6.3.5.6.5.5-.2.5-.5zM16.1 32c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.2-.5-.5-.5zM23.2 23.7c-.3 0-.6.2-.6.5s.3.6.6.6.5-.2.5-.6c0-.3-.2-.5-.5-.5zM27.3 34.5c0-.3-.2-.5-.5-.5s-.5.2-.5.5.2.5.5.5.5-.2.5-.5zM27.9 33.4c.3 0 .5-.3.5-.6s-.2-.5-.5-.5-.6.2-.6.5.3.6.6.6z"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 13.8,
    cy: 33.6,
    r: 0.4
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 21.4,
    cy: 25.9,
    r: 0.5
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.7 32.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5-.5.2-.5.5.2.5.5.5zM29.2 34.6c0 .4.3.7.7.7s.7-.3.7-.7-.3-.7-.7-.7-.7.3-.7.7zM13.6 31.7c.3.1.5-.1.6-.4v-.2c0-.3-.3-.6-.6-.6s-.6.3-.6.6.3.6.6.6zM12.4 34.4c0-.3-.3-.6-.6-.6s-.6.3-.6.6.3.6.6.6.6-.3.6-.6zM16 34.5c-.2 0-.4.3-.4.5s.2.5.4.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM18.2 32.7c.2 0 .4-.2.4-.4s-.2-.4-.4-.4-.4.2-.4.4.2.4.4.4zM21.4 27.9c-.3 0-.5.2-.5.5s.2.6.5.6.6-.3.6-.6-.3-.5-.6-.5zM22.2 34.1c0 .2.1.3.3.3s.3-.1.3-.3c0-.2-.1-.3-.3-.3-.2 0-.3.1-.3.3zM34.1 31.9c.3 0 .6-.2.6-.5s-.3-.6-.6-.6-.5.3-.5.6.2.5.5.5zM30.7 32.3c.2 0 .4-.2.4-.4s-.2-.3-.4-.3-.3.1-.3.3c0 .2.1.4.3.4zM32.6 34.6c0 .2.3.4.5.4s.4-.2.4-.4-.2-.4-.4-.4-.5.2-.5.4z"
  }))), _view84 || (_view84 = /*#__PURE__*/React.createElement("view", {
    id: "landscaping",
    viewBox: "405 90 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 405,
    y: 90,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M16.5 25.1H18v5.4h7.4L22.7 25c-.1-.3-.1-.6.1-.8.1-.2.4-.3.6-.3H25l-4.1-6.2c-.1-.3-.2-.6 0-.8.1-.2.3-.4.6-.4h1l-5.3-7-5.2 7h1c.3 0 .5.1.6.4.2.2.1.5 0 .8l-4.1 6.2h1.6c.2 0 .5.1.6.3.2.2.2.5.1.8l-2.7 5.5h7.4v-5.4z"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FC0",
    cx: 32.6,
    cy: 12,
    r: 4.5
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M34.6 33c-.3-.3-.8-.3-1.2-.1l-1.8 1.2-2-2c-.4-.3-.9-.3-1.3 0L23.6 36H18v-4h8.6c.3 0 .5-.2.7-.4.1-.2.1-.5 0-.7l-2.7-5.5h1.8c.3 0 .5-.2.6-.4.2-.2.2-.6 0-.8L22.9 18h1c.3 0 .6-.2.7-.4.1-.3.1-.6-.1-.8l-6.7-9c-.1-.2-.4-.3-.6-.3l-.6.3-6.7 9c-.1.3-.1.5 0 .8.1.2.4.4.7.4h1l-4.1 6.2c-.1.3-.2.6 0 .8.1.2.3.4.6.4h1.8l-2.7 5.5c-.1.2-.1.5 0 .7.2.2.4.4.7.4h8.6v4H6v1.5h33V36h-.6l-3.8-3zM9.1 30.5l2.7-5.5c.1-.3.1-.6-.1-.8-.1-.2-.4-.3-.6-.3H9.5l4.1-6.2c.1-.3.2-.6 0-.8-.1-.3-.3-.4-.6-.4h-1l5.2-7 5.3 7h-1c-.3 0-.5.2-.6.4-.2.2-.1.5 0 .8l4.1 6.2h-1.6c-.2 0-.5.1-.6.3-.2.2-.2.5-.1.8l2.7 5.5H18v-5.4h-1.5v5.4H9.1z"
  }))), _view85 || (_view85 = /*#__PURE__*/React.createElement("view", {
    id: "leak",
    viewBox: "405 135 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 405,
    y: 135,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32.5 18.6h1v-3h-1v-.5c0-.3.2-.5.5-.5h1.5v1h3v-8h-3v1H30c-2.4.1-4.4 2.1-4.4 4.5v2.5h-1v3h.9c-.3 2.3-2.1 4-4.4 4h-1c-2.3 0-4.2-1.7-4.5-4h1v-3h-1v-5h1v-3h-9v3h1v5h-1v3h1c.2 4.4 2.9 8.3 7 10 .8.7 1.5 1.6 2 2.6.2.5-.1 1.2-.3 1.9-.2.7-.8 2.2-.1 3.2.3.7 1 1.1 1.8 1.1s1.6-.4 2-1.1c.3-.8.4-1.7.1-2.5-.3-1.5-.6-3.1 1.1-4.3h.8c.7.3 1 .6 1 1.1-.1.6.1 1.2.6 1.5l.8.2.7-.2c.6-.3.9-.9.8-1.5V30c-.1-.8.1-1.6.4-2.3 3.2-2 5.1-5.4 5.2-9.1zm-6-5.5c.1-1.9 1.6-3.4 3.5-3.5h4.5v4H33c-.8 0-1.5.7-1.5 1.5v.5h-5v-2.5zM9.6 10.6h5v5h-5v-5zM20 34c.1.7.3 1.4.1 1.7-.3.4-.7.7-1.2.7-.4 0-.8-.3-1-.7-.4-.6-.1-1.4.2-2.3.4-.8.5-1.7.3-2.5-.2-.6-.5-1.2-1-1.6l2.6.2h.6c-1.1 1.5-.7 3.2-.6 4.5zm6-4.1c0 .2.1.4.1.6 0 .2-.1.5-.3.6-.2.1-.4.1-.6 0-.2-.1-.2-.3-.2-.5 0-.6-.2-1.2-.7-1.6.6-.1 1.2-.3 1.7-.6 0 .5-.1 1 0 1.5zm-5-1.4h-1.7l-.7-1.7 2.6-1.3-.5-.9-2.6 1.4-1.8-.9-.4.9 1.8.9.6 1.5c-4.9-.8-8.5-4.9-8.7-9.8h5c.3 2.8 2.6 5 5.5 5h1c2.8 0 5.2-2.2 5.4-5h5c-.3 5.6-4.9 10-10.5 9.9z"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M20.7 29.5H20l-2.6-.2c.5.4.8 1 1 1.6.2.8.1 1.7-.3 2.5-.3.9-.6 1.7-.2 2.3.2.4.6.7 1 .7.5 0 .9-.3 1.2-.7.2-.3 0-1-.1-1.7s-.5-3 .7-4.5zM24.3 29c.5.4.7 1 .7 1.6-.1.2 0 .4.1.5.2.1.4.1.6 0 .2-.1.3-.4.3-.6 0-.2-.1-.4-.1-.6 0-.5 0-1 .1-1.5-.5.3-1.1.5-1.7.6z"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M14.6 15.6v-5h-5v5h5zm-2-4h1v3h-1v-3zM31.5 18.6h-5c-.2 2.8-2.6 5-5.4 5h-1c-2.9 0-5.2-2.2-5.5-5h-5c.2 4.9 3.8 9 8.7 9.8l-.6-1.5-1.9-.9.4-.9 1.8.9 2.7-1.4.5.9-2.6 1.3.7 1.7H21c5.6.1 10.2-4.3 10.5-9.9zm-18.9 1h1v1h-1v-1zM31.5 15.6v-.5c0-.8.7-1.5 1.5-1.5h1.5v-4H30c-1.9.1-3.4 1.6-3.5 3.5v2.5h5zm1.5-5v1h-1v-1h1zm-3 0h1v1h-1c-.8 0-1.5.7-1.5 1.5v1h-1v-1c0-1.4 1.1-2.5 2.5-2.5z"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M27.5 13.1v1h1v-1c0-.8.7-1.5 1.5-1.5h1v-1h-1c-1.4 0-2.5 1.1-2.5 2.5zM12.6 11.6h1v3h-1zM12.6 19.6h1v1h-1zM32 10.6h1v1h-1z"
  }))), _view86 || (_view86 = /*#__PURE__*/React.createElement("view", {
    id: "letter",
    viewBox: "405 180 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 405,
    y: 180,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M6.4 33.3h32.2c.7.1 1.3-.5 1.4-1.2V12.9c0-.4-.2-.7-.5-.9h-34c-.3.2-.5.5-.5 1v19.3c.1.6.7 1.1 1.4 1 0 .1 0 .1 0 0zm33.1-20.4v19.3c0 .1-.1.2-.2.3L27 21.4l12.3-8.9.2.4zm-.9-.8h.3L22.5 23.9 6.1 12.1h32.5zm-33.1.8.2-.4 12.2 8.8-12.3 11c-.1-.1-.1-.1-.1-.2V12.9zM6 32.8l12.4-11.2 3.9 2.9h.4l3.9-2.8 12.3 11.2H6.4c-.3 0-.8-.1-.8-.4l.4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M39.3 32.4c.1-.1.2-.2.2-.3V12.9l-.2-.4L27 21.4l12.3 11zM38.9 12.1H6.1l16.4 11.8zM17.9 21.3 5.7 12.4l-.2.4v19.3c0 .1 0 .1.1.2l12.3-11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M38.9 32.8 26.6 21.6l-3.9 2.8h-.4l-3.9-2.9L6 32.8l-.4-.3c.1.3.5.4.8.4h32.5z"
  })))), _view87 || (_view87 = /*#__PURE__*/React.createElement("view", {
    id: "light_levels",
    viewBox: "405 225 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 405,
    y: 225,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "#686868",
    d: "M30.2 8C27.3 5.9 23.6 5 20 5.6c-4.8.9-8.6 4.7-9.5 9.5-.6 3.8.9 7.7 3.9 10.2 1.3 1.2 2.1 2.9 2.2 4.7h.1v5.8c0 .3.3.6.6.6h.7c.1 1.6 1.5 2.9 3.1 3h2.8c1.7-.1 3-1.4 3.2-3h.6c.3 0 .6-.3.6-.6V30c0-1.9.9-3.7 2.4-4.8 2.5-2.1 3.9-5.2 3.9-8.4-.1-3.4-1.7-6.7-4.4-8.8zm-6.3 30.3H21c-1-.1-1.8-.8-1.9-1.8h6.6c0 1-.9 1.8-1.8 1.8zm3.1-3h-9v-4.8h9v4.8zm-5.5-15h1.9v9h-1.9v-9zm-1.1-1.2h-1c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4 1 .9v.9zM27 29.3h-2.4v-9h1c1.2 0 2.1-.9 2.1-2.1s-.9-2.1-2.1-2.1c-1.2 0-2.1.9-2.2 2.1v.9h-1.9v-.9c0-1.2-1-2.2-2.2-2.2s-2.2 1-2.2 2.2c.1 1.2 1 2.1 2.2 2.1h1v9h-2.5c-.3-1.9-1.2-3.6-2.6-4.9-2.7-2.2-4-5.7-3.4-9.1.7-4.3 4.2-7.8 8.5-8.5 3.2-.6 6.4.1 9 2.1 4.4 3.4 5.2 9.7 1.8 14-.4.5-.9 1-1.4 1.5-1.5 1.3-2.4 3-2.7 4.9zm-2.3-10.2v-.9c0-.5.4-.9.9-.9h.1c.5 0 .9.4.9.9s-.4.9-.9.9h-1z"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M19.4 17.3c-.5 0-.9.4-.9.9s.4.9.9.9h1v-.9c-.1-.5-.5-.9-1-.9zM26.5 18.3c0-.5-.4-.9-.9-.9h-.1c-.5 0-.9.4-.9.9v.9h1c.5-.1.9-.5.9-.9z"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M21 38.3h2.8c1 0 1.8-.8 1.9-1.8h-6.6c.2 1 1 1.8 1.9 1.8z"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M21.5 20.3h1.9v9h-1.9z"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M24.2 30.5H18v4.8h9v-4.8z"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M29.7 24.5c.5-.4 1-.9 1.4-1.5 3.4-4.4 2.6-10.7-1.8-14-2.6-2-5.8-2.7-9-2.1-4.3.7-7.8 4.2-8.5 8.5-.6 3.4.7 6.9 3.4 9.1 1.4 1.3 2.3 3 2.6 4.9h2.5v-9h-1c-1.2 0-2.1-.9-2.2-2.1 0-1.2 1-2.2 2.2-2.2s2.2 1 2.2 2.2v.9h1.9v-.9c.1-1.2 1-2.1 2.2-2.1 1.2 0 2.1.9 2.1 2.1s-.9 2.1-2.1 2.1h-1v9H27c.3-2 1.2-3.7 2.7-4.9z"
  }))), _view88 || (_view88 = /*#__PURE__*/React.createElement("view", {
    id: "lighting",
    viewBox: "405 270 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 405,
    y: 270,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "#686868",
    d: "M30.2 8.1C27.3 5.9 23.6 5 20 5.7c-4.8.9-8.6 4.7-9.5 9.5-.6 3.8.9 7.7 3.9 10.2 1.3 1.2 2.1 2.9 2.2 4.7h.1v5.8c0 .3.3.6.6.6h.6c.1 1.6 1.5 2.9 3.1 3h2.8c1.7-.1 3-1.4 3.2-3h.6c.3 0 .6-.3.6-.6v-5.8c0-1.9.9-3.7 2.4-4.8 2.5-2.1 3.9-5.2 3.9-8.4 0-3.5-1.6-6.8-4.3-8.8zm-6.4 30.3H21c-1-.1-1.8-.8-1.9-1.8h6.6c0 .9-.9 1.7-1.9 1.8zm3.2-3h-9v-4.8h9v4.8zm-5.5-15h1.9v9h-1.9v-9zm-1.2-1.2h-1c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4 1 .9v.9zm4.3-1c0-.5.4-.9.9-.9h.1c.5 0 .9.4.9.9s-.4.9-.9.9h-1v-.9zM27 29.4h-2.4v-9h1c1.2 0 2.1-.9 2.1-2.1 0-1.2-.9-2.1-2.1-2.1-1.2 0-2.1.9-2.2 2.1v.9h-1.9v-.9c0-1.2-1-2.2-2.2-2.2-1.2 0-2.2 1-2.2 2.2.1 1.2 1 2.1 2.2 2.1h1v9h-2.5c-.3-1.9-1.2-3.6-2.6-4.9-2.7-2.2-4-5.7-3.4-9.1.7-4.3 4.2-7.8 8.5-8.5 3.2-.6 6.4.1 9 2.1 4.4 3.4 5.2 9.7 1.8 14-.4.5-.9 1-1.4 1.5-1.5 1.2-2.4 2.9-2.7 4.9z"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBE900",
    d: "M19.3 17.4c-.5 0-.9.4-.9.9s.4.9.9.9h1v-.9c0-.6-.4-1-1-.9zM25.6 19.2c.5 0 .9-.4.9-.9s-.4-.9-.9-.9c-.5-.1-.9.3-1 .8v1h1z"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M21 38.4h2.8c1 0 1.8-.8 1.9-1.8h-6.6c.2.9 1 1.7 1.9 1.8z"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBE900",
    d: "M23.5 20.4h-2v9h2z"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M24.2 30.6H18v4.7h9v-4.7z"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBE900",
    d: "M29.8 24.5c4.2-3.6 4.7-9.9 1.1-14.1-.4-.5-.9-1-1.5-1.4-2.6-2-5.8-2.7-9-2.1-4.3.7-7.8 4.2-8.5 8.5-.6 3.4.7 6.9 3.4 9.1 1.4 1.3 2.3 3 2.6 4.9h2.5v-9h-1c-1.2 0-2.1-.9-2.2-2.1 0-1.2 1-2.2 2.2-2.2 1.2 0 2.2 1 2.2 2.2v.9h1.9v-.9c.1-1.2 1-2.1 2.2-2.1 1.2 0 2.1.9 2.1 2.1s-.9 2.1-2.1 2.1h-1v9H27c.3-2 1.2-3.7 2.8-4.9z"
  }))), _view89 || (_view89 = /*#__PURE__*/React.createElement("view", {
    id: "lockers",
    viewBox: "405 315 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 405,
    y: 315,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 31,
    height: 31,
    rx: 1.5,
    fill: "#4a77b8"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 8.6,
    height: 28,
    rx: 0.8,
    fill: "#5a8fd8"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2,
    y: 8.5,
    width: 8.6,
    height: 28,
    rx: 0.8,
    fill: "#5a8fd8"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9,
    y: 8.5,
    width: 8.6,
    height: 28,
    rx: 0.8,
    fill: "#5a8fd8"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 10.3,
    y: 10.5,
    width: 5,
    height: 2.6,
    rx: 0.6,
    fill: "#dfe6ec"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10.5,
    width: 5,
    height: 2.6,
    rx: 0.6,
    fill: "#dfe6ec"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 29.7,
    y: 10.5,
    width: 5,
    height: 2.6,
    rx: 0.6,
    fill: "#dfe6ec"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 15.5h5m-5 2.3h5M20 15.5h5m-5 2.3h5M29.7 15.5h5m-5 2.3h5",
    stroke: "#2e4057",
    strokeLinecap: "round"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3,
    y: 22,
    width: 1.4,
    height: 3.6,
    rx: 0.7,
    fill: "#2e4057"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 22,
    width: 1.4,
    height: 3.6,
    rx: 0.7,
    fill: "#2e4057"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7,
    y: 22,
    width: 1.4,
    height: 3.6,
    rx: 0.7,
    fill: "#2e4057"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 38.2,
    width: 39,
    height: 1.5,
    rx: 0.75,
    fill: "#c3ccd2"
  }))), _view90 || (_view90 = /*#__PURE__*/React.createElement("view", {
    id: "machinery",
    viewBox: "405 360 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 405,
    y: 360,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.2 29.9h18.6v3.9H13.2z"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M31.9 34.8v.9c0 .6.3 1.1.8 1.4s1.1.3 1.6 0 .8-.8.8-1.4V30h1.8c.3 0 .5-.2.5-.5s-.2-.5-.6-.5H8.1c-.3 0-.5.2-.5.5s.2.5.5.5H10v5.8c0 .6.3 1.1.8 1.4.5.3 1.1.3 1.6 0s.8-.8.8-1.4v-.9h18.7zm2.3-4.9v5.8c0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7v-5.8h1.4zm-22.6 6.5c-.4 0-.7-.3-.7-.7v-5.8h1.4v5.8c0 .5-.3.7-.7.7zm1.6-2.6V30h18.6v3.9H13.2z"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M32.8 35.8c0 .4.3.7.7.7.4 0 .7-.3.7-.7V30h-1.4v5.8zM12.3 29.9h-1.4v5.8c0 .4.3.7.7.7s.7-.3.7-.7v-5.8z"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M11.3 28h22.3c2 0 3.7-1.7 3.7-3.7-.1-2-1.7-3.6-3.7-3.7H11.4c-2 .1-3.6 1.7-3.7 3.7-.1 2.1 1.6 3.7 3.6 3.7zm-2.8-3.6c0-1.5 1.3-2.8 2.8-2.8h22.3c1.5 0 2.8 1.3 2.8 2.8s-1.3 2.8-2.8 2.8H11.3c-1.5-.1-2.8-1.3-2.8-2.8z"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.3 27.1h22.3c1.5 0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8H11.3c-1.5 0-2.8 1.3-2.8 2.8s1.3 2.8 2.8 2.8zm21.2-4.7c.8-.3 1.7-.2 2.3.4.4.4.6 1 .6 1.5 0 1.2-1 2.1-2.1 2.1-1.1-.1-2-1-2.1-2.1 0-.8.6-1.5 1.3-1.9zm-4.9.7c.7-.6 1.7-.5 2.3.1.4.4.6 1.1.3 1.7-.2.6-.8 1-1.5 1-.9 0-1.6-.7-1.6-1.6 0-.4.3-.9.5-1.2zm-4.2 0c.7-.6 1.7-.5 2.3.1.4.4.6 1.1.3 1.7-.2.6-.8 1-1.5 1-.4 0-.8-.1-1.1-.4-.3-.3-.5-.8-.5-1.2 0-.4.2-.9.5-1.2zm-3.6-.2c.6-.2 1.3-.1 1.8.4.5.4.6 1.1.4 1.7-.3.6-.9 1-1.5 1-.9 0-1.6-.7-1.7-1.6 0-.6.3-1.3 1-1.5zm-4.2 0c.6-.2 1.3-.1 1.7.4.5.4.6 1.1.4 1.7-.3.6-.9 1-1.5 1-.9 0-1.6-.7-1.6-1.6 0-.6.4-1.3 1-1.5zm-6.1 1.5c0-.8.5-1.6 1.2-1.9.8-.3 1.7-.2 2.3.4s.8 1.5.5 2.3-1.1 1.3-2 1.3h-.1c-1.1-.1-2-1.1-1.9-2.1z"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M11.4 26.4h.1c.9 0 1.7-.5 2-1.3s.1-1.7-.5-2.3c-.6-.6-1.5-.7-2.3-.4-.7.3-1.2 1.1-1.2 1.9-.1 1.1.8 2.1 1.9 2.1zM31.2 24.4c.1 1.1 1 2 2.1 2.1 1.2 0 2.1-.9 2.1-2.1 0-.6-.2-1.1-.6-1.5-.6-.6-1.5-.7-2.3-.4-.7.3-1.3 1-1.3 1.9zM27.1 24.4c0 .9.7 1.6 1.6 1.6.7 0 1.3-.4 1.5-1 .3-.6.1-1.3-.3-1.7-.6-.7-1.6-.7-2.3-.1-.2.2-.5.7-.5 1.2zm1.7-.8c.3 0 .5.2.6.4.2.3.1.6-.1.8-.3.2-.5.3-.8.2-.2-.2-.4-.4-.4-.7-.1-.4.3-.7.7-.7z"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M28 24.4c0 .3.2.5.4.7.3.1.6 0 .8-.2.2-.2.3-.5.1-.8-.1-.2-.3-.4-.6-.4-.3-.1-.7.2-.7.7z"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.9 24.4c0 .4.2.9.5 1.2.3.3.7.4 1.1.4.7 0 1.3-.4 1.5-1 .3-.6.1-1.3-.3-1.7-.6-.7-1.6-.7-2.3-.1-.3.2-.5.7-.5 1.2zm1.6-.8c.3 0 .6.2.7.4.1.3 0 .6-.2.8-.2.2-.4.3-.7.2-.3-.2-.5-.4-.5-.7.1-.4.3-.7.7-.7z"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M23.9 24.4c0 .3.2.5.5.7.3.1.5 0 .7-.2s.3-.5.2-.8c-.1-.2-.4-.4-.7-.4-.5-.1-.7.2-.7.7z"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M18.8 24.4c.1.9.8 1.6 1.7 1.6.6 0 1.2-.4 1.5-1 .2-.6.1-1.3-.4-1.7-.5-.5-1.2-.6-1.8-.4-.7.2-1 .9-1 1.5zm1.6-.8c.3 0 .5.2.6.4.1.3 0 .6-.2.8-.2.2-.4.3-.7.2-.2-.1-.4-.4-.4-.7.1-.4.3-.7.7-.7z"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M19.8 24.4c0 .3.2.6.4.7.3.1.5 0 .7-.2s.3-.5.2-.8c-.1-.2-.3-.4-.6-.4-.5-.1-.7.2-.7.7z"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M14.6 24.4c0 .9.7 1.6 1.6 1.6.6 0 1.2-.4 1.5-1 .2-.6.1-1.3-.4-1.7-.4-.5-1.1-.6-1.7-.4-.6.2-1 .9-1 1.5zm1.6-.8c.3 0 .5.2.6.4.1.3.1.6-.1.8-.2.2-.5.3-.8.2-.2-.2-.4-.4-.4-.7 0-.4.3-.7.7-.7z"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M15.5 24.4c0 .3.2.5.4.7.3.1.6 0 .8-.2.2-.2.2-.5.1-.8-.1-.2-.3-.4-.6-.4-.4-.1-.7.2-.7.7z"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M13.1 9h-1.2c-2.4 0-4.3 1.9-4.3 4.3v6.1c0 .3.2.5.5.5h12.5v-3c0-.1 0-.3.1-.3l.3-.2h2.8l.4.2c0 .1.1.2.1.3v3h12.5c.3 0 .5-.2.5-.5v-6.1c0-2.4-1.9-4.3-4.3-4.3h-1.2l-1.3-1.2-.6-.2h-.2c-.2 0-.5.1-.6.3l-3.2 3.5c0 .1-.1.1-.1.2l-1 .4c-.2.1-.3.3-.3.5l.3 1.2c0 .2.1.3.3.3h.4c.1-.2.2-.3.2-.5l-.2-.8h.5l1.4 1.1v.4h-.8c-.2.1-.4.3-.3.5 0 .2.2.4.4.4h.1l1.2-.2c.2 0 .3-.2.4-.4v-.4l.5-.3 1-1.2.7.5v3.1l-2 2.8h-3.3v-2.1c0-.8-.6-1.4-1.4-1.4h-2.8c-.7 0-1.3.6-1.3 1.3V19h-3.5l-1.9-2.7v-3.1l.8-.7 1.2 1.3.3.2v.6c0 .2.1.4.3.4l1.2.2h.1c.2 0 .4-.2.4-.4.1-.2-.1-.4-.3-.5h-.7v-.4l1.5-1.1c0-.1 0-.1.1-.2h.2l-.2.8c0 .2.1.3.2.5h.5c.1 0 .2-.1.3-.3l.2-1.2c0-.2-.1-.4-.3-.5l-.7-.3-.2-.3L16 7.9c-.1-.2-.4-.3-.6-.3h-.2l-.5.2L13.1 9zm19.9.9c1.9 0 3.4 1.5 3.4 3.4V19h-2.9l.4-.6c.2-.4.4-.8.4-1.2v-5.4c0-.1-.1-.3-.1-.4-.1-.4-.4-.7-.7-1l-.6-.5h.1zm-3.1 1.4-1.7 1.9-1.6-1.2 3.1-3.5h.3l3 2.6c.5.3.6 1 .3 1.5-.3.2-.5.4-.8.4-.3.1-.6 0-.8-.2l-1.8-1.5zm1.6 4.1v-1.6c.6.3 1.3.2 1.8-.1v1.9c-.5-.4-1.1-.4-1.8-.2zm-.1 1.2c.4-.4.9-.5 1.4-.3.3.2.5.4.5.7.1.3 0 .6-.2.8l-.7 1.2h-2.7l1.7-2.4zM8.5 19v-5.7c0-1.9 1.5-3.4 3.4-3.4h.1l-.6.5c-.4.3-.7.8-.8 1.3v5.7c0 .4.2.7.4 1l.3.6H8.5zm4.9-2.4 1.7 2.4h-2.7l-.6-1.1c-.2-.2-.3-.5-.2-.8 0-.3.2-.6.4-.7.5-.3 1-.2 1.4.2zm-1.9-2.8c.6.3 1.3.4 1.9.1v1.6h-.8c-.4 0-.8 0-1.1.2v-1.9zm3.8-5.3 3.2 3.5-1.6 1.2-1.7-1.9-2 1.5c-.4.3-.9.3-1.3 0 0-.1-.1-.1-.1-.2-.4-.4-.3-1 .1-1.4l.1-.1 3.1-2.6h.2z"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M11 18.5c-.2-.3-.4-.6-.4-1v-5.7c.1-.5.4-1 .8-1.3l.6-.6h-.1c-1.9 0-3.4 1.5-3.4 3.4V19h2.8l-.3-.5zM34.2 11.4c0 .1.1.3.1.4v5.4c0 .4-.2.8-.4 1.2l-.3.6h2.9v-5.7c0-1.9-1.5-3.4-3.4-3.4H33l.6.5c.2.4.6.6.6 1z"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "m12 11.1-.1.1c-.4.4-.5 1-.1 1.4 0 .1.1.1.1.2.3.4.9.4 1.3 0l2-1.5 1.7 1.9 1.6-1.2-3.2-3.5h-.2L12 11.1zM12 16.5c-.2.1-.4.4-.4.7-.1.3 0 .6.2.8l.6 1.1h2.7l-1.7-2.4c-.4-.5-.9-.6-1.4-.2zM32.5 13c.3 0 .5-.2.7-.4.3-.5.2-1.2-.3-1.5l-3-2.6h-.2L26.6 12l1.5 1.2 1.7-1.9 1.9 1.5c.2.2.5.3.8.2zM32.4 19l.7-1.2c.2-.2.3-.5.2-.8 0-.3-.2-.5-.5-.7-.5-.2-1-.1-1.4.3L29.8 19h2.6z"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.4 15.4v-1.6c-.6.3-1.3.2-1.9-.1v1.9c.3-.2.7-.2 1.1-.2h.8zM31.5 13.8v1.6c.6-.2 1.3-.2 1.8.2v-1.9c-.5.3-1.1.4-1.8.1z"
  }))), _view91 || (_view91 = /*#__PURE__*/React.createElement("view", {
    id: "mail-request",
    viewBox: "0 405 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    y: 405,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 14.5,
    width: 25.5,
    height: 17,
    rx: 2,
    fill: "#dfe6ec"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "m7.2 15.6 12 8.8 12-8.8",
    fill: "none",
    stroke: "#8f9ba3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6 30.4 16 24M30.8 30.4 22.4 24",
    fill: "none",
    stroke: "#8f9ba3",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 10,
    r: 6,
    fill: "#e0704f"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 35.15,
    y: 6.8,
    width: 1.7,
    height: 6.4,
    rx: 0.85,
    fill: "#fff"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 9.15,
    width: 6.4,
    height: 1.7,
    rx: 0.85,
    fill: "#fff"
  }))), _view92 || (_view92 = /*#__PURE__*/React.createElement("view", {
    id: "mail-services",
    viewBox: "45 405 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 45,
    y: 405,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6.5,
    width: 31,
    height: 23,
    rx: 1.5,
    fill: "#8a6238"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "#efe6d4",
    d: "M8.8 8.3h8.4v8.8H8.8zM18.3 8.3h8.4v8.8h-8.4zM27.8 8.3h8.4v8.8h-8.4zM8.8 18.6h8.4v8.8H8.8zM18.3 18.6h8.4v8.8h-8.4zM27.8 18.6h8.4v8.8h-8.4z"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfe6ec",
    d: "M9.8 11.5h6.4v4.4H9.8z"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "m9.8 11.7 3.2 2.2 3.2-2.2",
    fill: "none",
    stroke: "#8f9ba3",
    strokeWidth: 0.8
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfe6ec",
    d: "M28.8 21.8h6.4v4.4h-6.4z"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "m28.8 22 3.2 2.2 3.2-2.2",
    fill: "none",
    stroke: "#8f9ba3",
    strokeWidth: 0.8
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-6 27 34.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 30.5,
    width: 14,
    height: 8.5,
    rx: 1,
    fill: "#dfe6ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.4 31 6.6 4.6 6.6-4.6",
    fill: "none",
    stroke: "#8f9ba3",
    strokeWidth: 1.1
  })))), _view93 || (_view93 = /*#__PURE__*/React.createElement("view", {
    id: "maintenance",
    viewBox: "90 405 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 90,
    y: 405,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "m12.3 17.6-4.1-4.2c-.1 0-.2-.1-.3 0l-.2.2c-.6 2.8.4 5.7 2.7 7.5 1.3 1.1 3 1.7 4.7 1.7 1 0 2-.2 2.9-.6l14.4 14.4c1.3 1 3.2.7 4.2-.6.8-1.1.8-2.5 0-3.6L22.2 18c.3-.8.5-1.6.5-2.4.2-2.2-.6-4.4-2.2-5.9-1.8-1.8-4.4-2.6-6.9-2-.1 0-.2.1-.2.2-.1.1 0 .2 0 .3l4.2 4.1c.3.4.3.9 0 1.3l-4 4c-.4.3-.9.3-1.3 0zm23.9 15.2c.8 1 .8 2.4 0 3.4-1 .9-2.4.9-3.4 0L18.6 21.9l1.3-.8c.8-.7 1.5-1.5 2-2.5l14.3 14.2zM14.1 18l3.9-3.9c.6-.6.6-1.6 0-2.2l-3.6-3.7c2.1-.2 4.2.5 5.7 2 1.4 1.4 2.1 3.3 2 5.3s-1.1 3.8-2.6 5.1c-2.6 2-6.1 2-8.7 0-1.9-1.5-2.9-3.8-2.6-6.2l3.7 3.6c.6.6 1.6.6 2.2 0z"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M8.2 14.4c-.3 2.4.7 4.7 2.6 6.2 2.6 2 6.1 2 8.7 0 1.5-1.3 2.5-3.1 2.6-5.1s-.6-3.9-2-5.3c-1.5-1.5-3.6-2.2-5.7-2l3.6 3.7c.6.6.6 1.6 0 2.2L14.1 18c-.6.6-1.6.6-2.2 0l-3.7-3.6zM19.9 21.1l-1.3.8 14.2 14.3c1 .9 2.4.9 3.4 0 .8-1 .8-2.4 0-3.4L21.9 18.6c-.5 1-1.2 1.8-2 2.5zm12.3 11.1c.5-.5 1.2-.5 1.7 0l1.4 1.3c.4.5.4 1.2 0 1.7-.2.2-.5.3-.8.3s-.6-.1-.9-.3l-1.4-1.4c-.4-.5-.4-1.1 0-1.6zm-8.8-10.8 8.2 8.2c.3.3.4.7.4 1.1s-.1.7-.4 1-.6.4-1 .4-.7-.1-1-.4l-8.3-8.2c-.2-.3-.4-.7-.4-1.1s.2-.7.4-1c.3-.3.7-.4 1.1-.4s.7.1 1 .4z"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "m32.2 33.8 1.4 1.4c.3.2.6.3.9.3.3 0 .6-.1.8-.3.4-.5.4-1.2 0-1.7l-1.4-1.3c-.5-.5-1.2-.5-1.7 0-.4.5-.4 1.1 0 1.6zM20.9 22.4c0 .4.2.8.4 1.1l8.3 8.2c.3.3.6.4 1 .4s.7-.1 1-.4c.3-.3.4-.6.4-1s-.1-.8-.4-1.1l-8.2-8.2c-.3-.3-.6-.4-1-.4s-.8.1-1.1.4c-.2.3-.4.6-.4 1z"
  }))), _view94 || (_view94 = /*#__PURE__*/React.createElement("view", {
    id: "medical",
    viewBox: "135 405 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 135,
    y: 405,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.8 13.9h17.5V9.6h-3.1v.8c0 .3-.2.5-.5.5H17.2c-.3 0-.5-.2-.5-.5v-.8h-3v4.3z"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M12.8 13.9H8.3c-1.4 0-2.6 1.2-2.6 2.6v18.2c0 1.4 1.2 2.6 2.6 2.6h28.3c1.4 0 2.6-1.2 2.6-2.6V16.6c0-1.4-1.2-2.6-2.6-2.6h-4.4V9.1c0-.3-.2-.5-.5-.5h-3.6v-.5c0-.3-.2-.5-.5-.5H17.2c-.3 0-.5.2-.5.5v.4h-3.5c-.3 0-.5.2-.5.5v4.9zm23.9 1c.9 0 1.6.7 1.6 1.6v18.2c0 .9-.7 1.6-1.6 1.6H8.3c-.9 0-1.6-.7-1.6-1.6V16.6c0-.9.7-1.6 1.6-1.6h28.4zM16.8 9.6v.8c0 .3.2.5.5.5h10.4c.3 0 .5-.2.5-.5v-.8h3.1V14H13.8V9.6h3z"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M8.3 14.9c-.9 0-1.6.7-1.6 1.6v18.2c0 .9.7 1.6 1.6 1.6h28.3c.9 0 1.6-.7 1.6-1.6V16.6c0-.9-.7-1.6-1.6-1.6H8.3zM31 25.6c0 4.7-3.8 8.5-8.5 8.5S14 30.3 14 25.6s3.8-8.5 8.5-8.5 8.5 3.8 8.5 8.5z"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M14 25.6c0 4.7 3.8 8.5 8.5 8.5s8.5-3.8 8.5-8.5-3.8-8.5-8.5-8.5-8.5 3.8-8.5 8.5zm16 0c0 4.2-3.4 7.6-7.6 7.6-4.2 0-7.6-3.4-7.6-7.6 0-4.2 3.4-7.6 7.6-7.6 4.2.1 7.6 3.5 7.6 7.6z"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M14.8 25.6c0 4.2 3.4 7.6 7.6 7.6 4.2 0 7.6-3.4 7.6-7.6 0-4.2-3.4-7.6-7.6-7.6-4.1.1-7.6 3.5-7.6 7.6zm9.5-4.7v2.9h2.8c.3 0 .5.2.5.5V27c0 .3-.2.5-.5.5h-2.8v2.8c0 .3-.2.5-.5.5h-2.7c-.3 0-.5-.2-.5-.5v-2.8h-2.9c-.3 0-.5-.2-.5-.5v-2.7c0-.3.2-.5.5-.5h2.9v-2.9c0-.3.2-.5.5-.5h2.7c.3 0 .5.3.5.5z"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M20.7 20.9v2.9h-2.9c-.3 0-.5.2-.5.5V27c0 .3.2.5.5.5h2.9v2.8c0 .3.2.5.5.5h2.7c.3 0 .5-.2.5-.5v-2.8h2.8c.3 0 .5-.2.5-.5v-2.7c0-.3-.2-.5-.5-.5h-2.8v-2.9c0-.3-.2-.5-.5-.5h-2.7c-.3 0-.5.3-.5.5z"
  }))), _view95 || (_view95 = /*#__PURE__*/React.createElement("view", {
    id: "meeting-room-setup",
    viewBox: "180 405 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 180,
    y: 405,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 38.5,
    width: 39,
    height: 1.5,
    rx: 0.75,
    fill: "#c3ccd2"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 26.8,
    width: 6,
    height: 6.5,
    rx: 2,
    fill: "#3c4652"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 15.4,
    y: 33,
    width: 7.2,
    height: 1.9,
    rx: 0.9,
    fill: "#3c4652"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c6870",
    d: "M18.35 34.9h1.3v2.4h-1.3z"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3,
    y: 37.3,
    width: 5.9,
    height: 1.1,
    rx: 0.55,
    fill: "#5c6870"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 26.8,
    width: 6,
    height: 6.5,
    rx: 2,
    fill: "#3c4652"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4,
    y: 33,
    width: 7.2,
    height: 1.9,
    rx: 0.9,
    fill: "#3c4652"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c6870",
    d: "M25.35 34.9h1.3v2.4h-1.3z"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3,
    y: 37.3,
    width: 5.9,
    height: 1.1,
    rx: 0.55,
    fill: "#5c6870"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "#8a6238",
    d: "M13 28.7h1.7v7H13zM30.5 28.7h1.7v7h-1.7z"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 26.3,
    width: 24.1,
    height: 2.4,
    rx: 1.1,
    fill: "#c8925a"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.78 0 0 .78 0 8.47)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 15.6,
    r: 3.4,
    fill: "#5a8fd8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 19,
    width: 7,
    height: 11,
    rx: 3,
    fill: "#5a8fd8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 19.8,
    width: 6.5,
    height: 2.2,
    rx: 1.1,
    fill: "#5a8fd8",
    transform: "rotate(33 10 20.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.8,
    cy: 24.2,
    r: 1.2,
    fill: "#5a8fd8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.3,
    y: 30,
    width: 2.6,
    height: 8.5,
    rx: 1,
    fill: "#4a77b8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 30,
    width: 2.6,
    height: 8.5,
    rx: 1,
    fill: "#4a77b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7 36.9h3c.9 0 1.3.4 1.3.85 0 .4-.3.75-.7.75H8.7z",
    fill: "#31281f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3 36.9h3c.9 0 1.3.4 1.3.85 0 .4-.3.75-.7.75H5.3z",
    fill: "#31281f"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.78 0 0 .78 11 8.47)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 15.6,
    r: 3.4,
    fill: "#23967f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 19,
    width: 7,
    height: 11,
    rx: 3,
    fill: "#23967f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 19.8,
    width: 6.5,
    height: 2.2,
    rx: 1.1,
    fill: "#23967f",
    transform: "rotate(-33 35.5 20.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.2,
    cy: 24.2,
    r: 1.2,
    fill: "#23967f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 30,
    width: 2.6,
    height: 8.5,
    rx: 1,
    fill: "#1a6e5c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.1,
    y: 30,
    width: 2.6,
    height: 8.5,
    rx: 1,
    fill: "#1a6e5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3 36.9h-3c-.9 0-1.3.4-1.3.85 0 .4.3.75.7.75h3.6z",
    fill: "#31281f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7 36.9h-3c-.9 0-1.3.4-1.3.85 0 .4.3.75.7.75h3.6z",
    fill: "#31281f"
  })))), _view96 || (_view96 = /*#__PURE__*/React.createElement("view", {
    id: "microscope",
    viewBox: "225 405 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 225,
    y: 405,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M19.3 9.8h-.5l-1.4 1.4-2.9-2.8.4-.4c.1-.1.1-.4 0-.5l-.6-.6c-.6-.5-1.4-.5-2 0l-1.7 1.7c-.3.2-.4.6-.4.9 0 .4.1.7.4 1l.6.6h.6l.4-.4 2.8 2.8-1.4 1.4c-.1.2-.1.3 0 .5l2.7 2.7c-.5.5-.7 1.2-.7 1.9-.1.6.1 1.2.5 1.6-.5 1.1-.7 2.3-.7 3.5 0 2.9 1.3 5.7 3.7 7.5l-1.5 3.6c-.3 0-.7.1-.9.4-.3.3-.5.7-.5 1.1v.4c0 .2.2.4.4.4h12.1c.2 0 .4-.2.4-.4v-.4c0-.4-.2-.8-.5-1.1-.2-.3-.6-.4-.9-.4l-.7-1.7c2.3-.5 4.4-1.8 5.9-3.7h.3c.8 0 1.5-.7 1.6-1.5V29c0-.2-.2-.4-.4-.4h-6.7c-.2 0-.3.2-.3.4v.3c0 .8.6 1.4 1.4 1.5-.9.6-1.9.9-2.9 1l-.5-1.2c-.1-.2-.2-.3-.4-.3h-4.3c-1.6-1.2-2.5-3.2-2.5-5.2 0-.7.2-1.4.4-2.1.7 0 1.4-.3 2-.7l2.6 2.6h.6l1.4-1.4 2.4 2.4c.2.2.5.3.8.3 0 .2 0 .3.1.4h.5l1.6-1.7c.2-.1.2-.3 0-.5h-.3c0-.3-.1-.5-.3-.7l-2.5-2.4 1.4-1.4.2-.2-.2-.3-9.6-9.6zm-6.6.4L14 8.9l2.8 2.8-1.3 1.3-2.8-2.8zM28 37.1c.2.2.3.4.3.6H17c0-.2.1-.4.2-.6.2-.2.4-.3.7-.3h9.5c.2 0 .5.1.6.3zm2-6.3h1.9c-1.3 1.6-3.2 2.6-5.2 3l-.5-1.3c1.4-.2 2.7-.8 3.8-1.7zm-5.2.3 2.1 5h-8.5l2.1-5h4.3zm-4.9-.5-.5 1.3c-2.1-1.6-3.3-4.1-3.3-6.8 0-1 .2-2 .5-2.9.4.3.8.6 1.3.7-.3.7-.4 1.4-.4 2.2 0 2.1.9 4.1 2.4 5.5zm-1.3-8.4c-1.2.3-2.5-.5-2.7-1.8-.3-1.2.5-2.5 1.8-2.7.3-.1.6-.1 1 0 1.2-.3 2.5.5 2.7 1.8s-.5 2.5-1.8 2.7c-.4.1-.7.1-1 0zm10.8 1.9c.1.1.2.2.2.4s0 .3-.2.4l-.4.5c-.2.2-.6.2-.8 0L25.7 23l1.3-1.3 2.4 2.4zm-1.2-4.5-4.7 4.5-2.4-2.4c.3-.5.6-1.1.6-1.7 0-1.7-1.3-3-3-3h-.1c-.7 0-1.3.2-1.8.6l-2.4-2.4 1.4-1.4 1.8-1.8 1.4-1.4 9.2 9z"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.6 17.7c-1.2-.3-2.5.5-2.7 1.8-.3 1.2.5 2.5 1.8 2.7.3.1.6.1 1 0 1.2.3 2.5-.5 2.7-1.8s-.5-2.5-1.8-2.7c-.4-.1-.7-.1-1 0zm1 3.2c-.3.3-.6.4-1 .4s-.7-.1-1-.4c-.5-.5-.5-1.4 0-1.9.6-.5 1.4-.5 2 0 .5.5.5 1.4 0 1.9z"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M17.6 19c-.5.5-.5 1.4 0 1.9.3.3.6.4 1 .4s.7-.1 1-.4c.5-.5.5-1.4 0-1.9-.6-.5-1.4-.5-2 0z"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m25.7 23 2.5 2.4c.2.2.6.2.8 0l.4-.5c.2-.1.2-.2.2-.4s-.1-.3-.2-.4L27 21.7 25.7 23zM16.8 11.7 14 8.9l-1.3 1.3 2.8 2.8z"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M19 10.6 17.6 12l-1.8 1.8-1.4 1.4 2.4 2.4c.5-.4 1.1-.6 1.8-.6 1.7-.1 3 1.2 3.1 2.9v.1c0 .6-.3 1.2-.6 1.7l2.4 2.4 4.7-4.5-9.2-9z"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.4 36.1h8.5l-2.1-5h-4.3l-2.1 5zm5.2-4.1c.5.5.5 1.4 0 1.9-.3.3-.6.4-1 .4-.3 0-.7-.1-.9-.4-.5-.4-.6-1.2-.2-1.7.1-.1.1-.2.2-.2.5-.5 1.4-.5 1.9 0z"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M21.7 32c-.5.4-.6 1.2-.2 1.7.1.1.1.2.2.2.2.3.6.4.9.4.4 0 .7-.1 1-.4.5-.5.5-1.4 0-1.9s-1.4-.5-1.9 0z"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.9 36.8c-.3 0-.5.1-.7.3-.1.2-.2.4-.2.6h11.3c0-.2-.1-.4-.3-.6-.1-.2-.4-.3-.6-.3h-9.5z"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M17.9 22.9c-.5-.1-.9-.4-1.3-.7-.3.9-.5 1.9-.5 2.9 0 2.7 1.2 5.2 3.3 6.8l.5-1.3c-1.5-1.4-2.4-3.4-2.4-5.5 0-.8.1-1.5.4-2.2zM26.2 32.5l.5 1.3c2-.4 3.9-1.4 5.2-3H30c-1.1.9-2.4 1.5-3.8 1.7z"
  }))), _view97 || (_view97 = /*#__PURE__*/React.createElement("view", {
    id: "mobile_phone",
    viewBox: "270 405 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 270,
    y: 405,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M30.3 33.4c.2-.1.4-.3.5-.5l1.4 1.9c.1.2.4 0 .3-.2l-1.5-2c-.1-.1-.1-.2-.3-.2h-.3c-.9-1.5-1.6-3.2-2-4.9-.9-2.8-1.6-5.1-4.7-6.1V8.5c0-.6-.4-1-1-1h-7.9c-.6 0-1 .4-1.1 1v13.1c-1.6 0-1.6 1.8 0 2v.4c-1.6.1-1.6 1.9 0 2v.8c0 .4.3.8.7 1-1.3.7-.7 2.2 1.3 1.8h.7l2.1.2 1.2.2c.3 0 .6.3.9.6.5.6.9 1.2 1.2 1.8.4.9 1.1 1.7 2 2.3.5.2.9.5 1.3.9l.3.3c-.1.1-.1.1-.2.1-.1.2 0 .3.1.5l.6.9c.2.2.4 0 .3-.2l-.6-.8.8-.3c1.4-.8 2.7-1.7 3.9-2.7zm-16.6-7.7c-1.2-.1-1.2-1.3 0-1.3v1.3zm0-2.3c-1.2-.1-1.2-1.3 0-1.3v1.3zm.3 3.5V8.5c.1-.4.4-.7.8-.7h7.9c.4 0 .7.3.7.7V26c-.1-.1-.2-.2-.2-.3V9c0-.2-.2-.4-.4-.4h-8.1c-.2 0-.4.2-.4.4v17.2c0 .2.2.3.4.3h4.6c.6.1 1.2.5 1.6 1h-6.1c-.4.1-.7-.2-.8-.6zm3.6-1.2c.3.3.7.5 1.1.6h-4c-.2 0-.3-.1-.3-.2V9c0-.2.1-.3.3-.3h8.1c.1 0 .2.2.2.3v16.6c-.4-.5-.8-.9-1.3-1.2-.6-.4-1.4-.6-2.1-.5l-1.2-.2c-1.3 0-1.8 1.3-.8 2zM26 36l-.6-.6-.2-.2h.4c.2 0 .1-.3-.1-.3-.5.1-1-.1-1.4-.5-.8-.5-1.5-1.2-1.9-2.1-.3-.6-.6-1.1-1-1.6-.1-.1-.2-.2-.2-.4V30c.1-.2-.2-.4-.3-.2 0 .1 0 .2-.1.3l-.6-.4.2-.3c.1-.2-.2-.3-.3-.1 0 .1-.1.2-.2.2h-1.6c.1 0 .1 0 .1-.1.1-.1-.1-.2-.1-.1h-1.8c0-.1 0-.2.1-.3h-.2c-.1.3-.4.3-.6.4-1.9.4-2.1-1.2-.4-1.5H21c.6 2.1 1.9 4.7 4.2 5.2.2.1.2-.2 0-.3-2.1-.5-3.4-3.1-4-5.1-.1-.4-.4-.7-.7-.9l-.5-.3c.1-.2-.1-.3-.2-.2-.1.1-.3 0-.4-.1-.6-.1-1.1-.4-1.6-.7-.8-.6-.4-1.5.5-1.5l1.3.2c.7-.1 1.3.1 1.9.4.6.4 1.1.9 1.5 1.5.6.7 1.3 1.2 2.1 1.6.1.1.2-.2 0-.3-.4-.2-.8-.5-1.1-.8.3 0 .6 0 .9-.2.1-.1-.1-.3-.2-.2h-1v-.4c.4-.2.6-.5.8-.9v-.2c-.1 0-.1 0-.2.1-.2.3-.3.5-.6.6v-3.8c2.9 1 3.6 3.2 4.4 5.9.5 1.9 1.3 3.7 2.4 5.3l-.3.2c-1.2 1-2.5 1.9-3.9 2.7l-.3.3z"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.9 27.5c-.4-.5-1-.9-1.6-1h-4.6c-.2 0-.4-.1-.4-.3V9c0-.2.2-.4.4-.4h8.1c.2 0 .4.2.4.4v16.7c0 .1.1.2.2.3V8.5c0-.4-.3-.7-.7-.7h-7.9c-.4 0-.7.3-.8.7v18.3c.1.4.4.7.8.7h6.1zM19.6 8.2h.1c.1 0 .1.1 0 .1h-.1c-.1.1-.1-.1 0-.1zm-1.4 0v.1c-.1.1-.1-.1 0-.1z"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "m18.4 23.7 1.2.2c.7-.1 1.5.1 2.1.5.5.3.9.7 1.3 1.2V9c0-.2-.1-.3-.2-.3h-8.1c-.2 0-.3.1-.3.3v17.1c0 .1.1.2.3.2h4c-.4-.1-.8-.3-1.1-.6-1-.7-.5-2 .8-2zm-2.8 2-.4-.4h.1l.4.3s0 .1-.1.1zm.5-.2-.8-.7c-.1-.1 0-.2.1-.1l.8.7c.1.1 0 .3-.1.1z"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M15.4 24.7c-.1-.1-.2 0-.1.1l.8.7c.1.1.2 0 .1-.1l-.8-.7zM15.3 25.2l.3.4c.1 0 .1 0 .1-.1l-.4-.3z"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECD5D5",
    d: "M13.7 23.4V22c-1.2 0-1.2 1.2 0 1.4zM13.7 25.7v-1.3c-1.2.1-1.2 1.3 0 1.3zM30.5 32.9c-1.1-1.6-1.9-3.4-2.4-5.3-.8-2.7-1.5-4.9-4.4-5.9v3.8c.3-.1.4-.3.6-.6 0-.1.1-.1.2-.1s.1.1 0 .2c-.2.4-.4.7-.8.9v.4h1c.1-.1.3.1.2.2-.3.2-.6.2-.9.2.3.3.7.6 1.1.8.2.1.1.4 0 .3-.8-.4-1.5-.9-2.1-1.6-.4-.6-.9-1.1-1.5-1.5-.6-.3-1.2-.5-1.9-.4l-1.3-.3c-.9 0-1.3.8-.5 1.5.5.3 1 .6 1.6.7.1.1.3.2.4.1.1-.1.3 0 .2.2l.5.2c.3.2.6.5.7.9.6 2 1.9 4.6 4 5.1.2.1.2.4 0 .3-2.3-.5-3.6-3.1-4.2-5.2h-5.8c-1.7.3-1.5 1.9.4 1.5.2-.1.5-.1.6-.4h.2c-.1.1-.1.2-.1.3h1.8c0-.1.2 0 .1.1 0 .1 0 .1-.1.1h1.6c.1 0 .2-.1.2-.2.1-.2.4-.1.3.1l-.2.4.6.5c.1-.1.1-.2.1-.3.1-.2.4 0 .3.2v.2c0 .2.1.3.2.4.4.5.7 1 1 1.6.4.9 1.1 1.6 1.9 2.1.4.4.9.6 1.4.5.2 0 .3.3.1.3h-.4l.2.2.6.6.3-.2c1.4-.8 2.7-1.7 3.9-2.7l.3-.2zm-11.1-8.2c-.1.1-.2.2-.3.4-.1.2-.8.3-1.1.1-.2 0-.1-.2 0-.1s.8.2 1-.1l.2-.5c.2-.1.3 0 .2.2zm.8.5s-.1 0 0 0c.1-.2.1-.4.2-.5h.1c0 .3-.1.5-.3.5zm.4 0c0 .2-.1 0 0 0-.1-.2 0-.2.1-.3.1 0 .1 0 .1.1l-.2.2z"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M20.7 25c-.1.1-.2.1-.2.2s.1.2.1.1l.1-.3c.1 0 .1 0 0 0zM20.4 24.7c-.1.1-.1.3-.2.4-.1.1 0 .1 0 .1.2 0 .3-.2.2-.5zM19.2 24.5l-.2.5c-.2.3-.9.2-1 .1-.1-.1-.2.1 0 .1.3.2 1 .1 1.1-.1.1-.2.2-.3.3-.4.1-.2 0-.3-.2-.2zM19.7 8.4c.1 0 .1-.1 0-.1h-.1c-.1 0-.1.1 0 .1h.1zM18.2 8.2c-.1 0-.1.1 0 .1v-.1z"
  }))), _view98 || (_view98 = /*#__PURE__*/React.createElement("view", {
    id: "monitor",
    viewBox: "315 405 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 315,
    y: 405,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M37.2 34.5c1.2-.1 2.2-1.2 2.1-2.4V9.3c.1-1.2-.9-2.3-2.1-2.4H7.8C6.6 7 5.6 8.1 5.7 9.3v22.8c-.1 1.2.9 2.3 2.1 2.4h12.6v2.4h-4.2v1.2h12.6v-1.2h-4.2v-2.4h12.6zm-13.6 2.4h-2.1v-2.4h2.1v2.4zM6.7 9.3c-.1-.6.4-1.1 1-1.2h29.5c.6 0 1.1.5 1.1 1.1V32.1c0 .6-.5 1.1-1.1 1.2H7.8c-.6-.1-1.1-.6-1.1-1.2V9.3z"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.5 34.5h2.1v2.4h-2.1zM7.8 33.3h29.4c.6-.1 1.1-.6 1.1-1.2V9.2c0-.6-.5-1.1-1.1-1.1H7.7c-.6.1-1.1.6-1 1.2v22.8c0 .6.5 1.1 1.1 1.2zm14.7-1.2c-.6 0-1-.5-1-1.2s.4-1.2 1-1.2 1 .5 1 1.2-.4 1.2-1 1.2zM7.8 9.3h29.4v19.2H7.8V9.3z"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.8 10.5h27.3v16.8H8.8z"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M37.2 28.5V9.3H7.8v19.2h29.4zm-28.4-18h27.3v16.8H8.8V10.5z"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#28B557",
    cx: 22.5,
    cy: 30.9,
    rx: 1,
    ry: 1.2
  }))), _view99 || (_view99 = /*#__PURE__*/React.createElement("view", {
    id: "neutral_face",
    viewBox: "360 405 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 360,
    y: 405,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.5 37.5c8.3 0 15-6.7 15-15s-6.7-15-15-15-15 6.7-15 15 6.7 15 15 15zm0-28.7c7.6 0 13.7 6.1 13.7 13.7s-6.1 13.7-13.7 13.7S8.8 30.1 8.8 22.5 14.9 8.8 22.5 8.8z"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22.5 36.2c7.6 0 13.7-6.1 13.7-13.7S30.1 8.8 22.5 8.8 8.8 14.9 8.8 22.5s6.1 13.7 13.7 13.7zm-7.7-18c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm11.4 0c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm2.3 9c-.1.3-.3.6-.7.6H17.2c-.4 0-.6-.3-.7-.6 0-.4.3-.7.7-.7h10.6c.4 0 .7.3.7.7z"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    fill: "#505050",
    cx: 16.8,
    cy: 18.2,
    r: 2
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    fill: "#505050",
    cx: 28.2,
    cy: 18.2,
    r: 2
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M17.2 26.5c-.4 0-.7.3-.7.7.1.3.3.6.7.6h10.6c.4 0 .6-.3.7-.6 0-.4-.3-.7-.7-.7H17.2z"
  }))), _view100 || (_view100 = /*#__PURE__*/React.createElement("view", {
    id: "noise_and_odors",
    viewBox: "405 405 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 405,
    y: 405,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "#505050"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6 32.3h.7c1.3 0 2.2-.5 3.3-1.1.4-.2.9-.5 1.5-.7.9.5 1.9.9 2.8.9.3 0 .7-.1 1-.2 2.6-1.1 2.9-3.4 2.9-5 0-2.3-2.4-5.1-4.4-7.7-.7-.8-1.3-1.6-1.8-2.2-1.9-2.7-4.6-6.4-6.8-8.2-.4-.3-1-.3-1.4.1-.3.4-.3 1 .1 1.4 2.2 1.8 5.4 6.3 6.5 7.8.5.7 1.1 1.5 1.8 2.3 1.7 2 4 4.8 4 6.4 0 1.8-.5 2.7-1.7 3.3-.5.2-1.4-.3-2.3-.7-.1-.1-.2-.1-.4-.2-1.2-.6-2.6-1.2-4.1-.9-.5.1-.9.6-.8 1.1.1.5.6.9 1.1.8.3-.1.7 0 1 0-1.1.6-1.8 1-2.7.8-.8-.1-1.3-.7-1.5-1-.3-.5-.5-1-.4-1.4.2-.9 1.2-1.3 1.2-1.3.5-.2.7-.8.5-1.3-.2-.5-.8-.7-1.3-.5-.1 0-2 .8-2.4 2.8-.2.9.1 2 .8 2.9.6 1.1 1.6 1.7 2.8 1.8zM22.7 32.8c2.6 0 4.7-2.2 4.7-5 0-.5-.4-1-1-1-.5 0-1 .4-1 1 0 1.7-1.2 3-2.7 3-1.5 0-2.3-1-3.3-2.7-.8-1.4-1.4-2.2-2.1-3.1-.4-.5-.9-1.2-1.5-2-1.5-2.1-1.9-4.8-1.2-8 .7-3 3.2-5.1 6.1-5.1 3 0 5.2 2.1 5.4 5.3 0 .5.5.9 1 .9s.9-.5.9-1c-.2-4.2-3.3-7.1-7.3-7.1-3.8 0-7.1 2.7-8 6.6-.8 3.7-.3 7 1.5 9.5.6.9 1.1 1.5 1.5 2.1.7.9 1.2 1.6 2 2.9.7 1.3 2.1 3.7 5 3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1 18.9h.9l.1-.7c.1-1.8 0-4-1.4-5.5-.8-.9-1.9-1.3-3.2-1.3-1.4 0-2.6.6-3.5 1.7-1.4 1.8-1.7 4.5-1.3 6.3.1.5.6.8 1.2.7.5-.1.8-.6.7-1.2-.3-1.4-.1-3.4.9-4.7.5-.6 1.2-1 2-1s1.4.2 1.8.7c.6.7 1 1.9.9 3.5-1.2.4-1.9 1.6-1.9 2.8 0 1.4 1 2.8 2.8 2.8.5 0 1-.5 1-1s-.4-1-1-1c-.9 0-.9-.9-.9-1 0 .1 0-1.1.9-1.1zM3.6 28c.2.2.4.2.6.2.3 0 .6-.2.8-.5.1-.3 0-.7-.3-.9-3.7-3.7-3.7-9.6 0-13.3.3-.3.3-.8 0-1.2-.3-.3-.8-.3-1.2 0-4.2 4.4-4.2 11.4.1 15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9 14.7c-3 3-3 8 0 11 .2.2.4.2.6.2.3 0 .6-.2.8-.5.1-.3.1-.7-.2-.9-2.4-2.4-2.4-6.3 0-8.7.3-.3.3-.8 0-1.2-.4-.3-.9-.3-1.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17.8c.3-.3.3-.8 0-1.2-.3-.3-.8-.3-1.2 0-1.9 1.9-1.9 5 0 6.9.2.2.4.2.6.2.2 0 .4-.1.6-.2.2-.2.2-.4.2-.6 0-.2-.1-.4-.2-.6-1.3-1.1-1.3-3.2 0-4.5z"
  })))), _view101 || (_view101 = /*#__PURE__*/React.createElement("view", {
    id: "nose",
    viewBox: "450 0 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 450,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M13.7 30.4c1 .7 2.2.9 3.3.5 1-.2 1.7.3 2.6.9.8.7 1.8 1.1 2.9 1.2 1-.1 2-.5 2.8-1.2.7-.7 1.7-1 2.7-.9 1.1.4 2.3.2 3.3-.5.9-.8 1.3-2 1.2-3.2 0-2.1-1.2-4-3.1-4.9-.3-1.4-1.1-6.1-1.9-9.4-.8-3.3-2.5-5.2-5-5.2s-4.2 1.7-5 5.2c-.8 3.5-1.7 8-1.9 9.4-1.9.9-3.2 2.8-3.2 4.9-.1 1.2.4 2.4 1.3 3.2zm2.8-6.9c.2-.1.4-.3.4-.5 0-.1 1-5.9 2-9.7s2.5-4.2 3.6-4.2 2.6.5 3.6 4.2S28 22.9 28 23c0 .1.2.4.5.5 1.5.6 2.5 2.1 2.6 3.7.1.8-.2 1.5-.7 2.1l-.7.3c-.5-.7-1.3-1-2.2-1-1.5 0-2.3 2.6-5 2.6s-3.5-2.6-5.1-2.6c-.8 0-1.7.3-2.2 1l-.7-.3c-.5-.6-.8-1.3-.7-2.1.1-2.7 2.7-3.6 2.7-3.7z"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECD5D5",
    d: "m14.5 29.3.7.3c.5-.7 1.4-1 2.2-1 1.6 0 2.4 2.6 5.1 2.6 2.7 0 3.5-2.6 5-2.6.9 0 1.7.3 2.2 1l.7-.3c.5-.6.8-1.3.7-2.1-.1-1.6-1.1-3.1-2.6-3.7-.3-.1-.5-.4-.5-.5 0-.1-.9-6-1.9-9.7s-2.5-4.2-3.6-4.2-2.6.4-3.6 4.2-2 9.6-2 9.7c0 .2-.2.4-.4.5-.1.1-2.7 1-2.7 3.7 0 .8.2 1.5.7 2.1zm3.7-4.2c.5-2 .9-4 1.1-6 .1-.4.5-.7.9-.6.3.1.6.4.5.8-.2 2.1-.6 4.2-1.1 6.2-.1.3-.4.5-.7.5H18.6c-.4-.1-.6-.5-.4-.9z"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M18.6 26h.3c.3 0 .6-.2.7-.5.5-2 .9-4.1 1.1-6.2.1-.4-.2-.7-.5-.8-.4-.1-.8.2-.9.6-.2 2-.6 4-1.1 6-.2.4 0 .8.4.9z"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M18.2 37.3c.3.1.6-.1.7-.5l.7-2.3c.1-.3-.1-.7-.4-.8h-.1c-.3-.1-.6.1-.7.5l-.7 2.3v.1c0 .4.2.7.5.7zM15.2 36.5c.8-.8 1.4-1.7 1.9-2.7 0-.1.1-.1.1-.2.1-.3-.1-.5-.4-.6h-.2c-.2-.1-.5.1-.6.3-.4.8-.9 1.5-1.5 2.2-.3.2-.4.5-.2.8.4.3.6.4.9.2zM26.5 33.7c-.4.1-.6.5-.5.8l.6 2.3c.1.3.4.6.8.5.3-.1.5-.4.4-.7v-.1l-.6-2.3c-.2-.4-.5-.6-.7-.5zM31.2 36.3c.2-.2.2-.5 0-.7l-.1-.1c-.6-.7-1.1-1.4-1.5-2.2-.2-.2-.4-.3-.6-.3h-.3c-.3.1-.4.5-.3.8.5 1 1.2 1.9 2 2.7.2.2.6.1.8-.2z"
  }))), _view102 || (_view102 = /*#__PURE__*/React.createElement("view", {
    id: "office-kitchen",
    viewBox: "450 45 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 450,
    y: 45,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 38.5,
    width: 39,
    height: 1.5,
    rx: 0.75,
    fill: "#c3ccd2"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9,
    width: 10,
    height: 29.5,
    rx: 1.5,
    fill: "#a7b2ba"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fill: "#8f9ba3",
    d: "M6 18.5h10v1H6z"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8,
    y: 12,
    width: 1.1,
    height: 4.5,
    rx: 0.55,
    fill: "#5c6870"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8,
    y: 21.5,
    width: 1.1,
    height: 6,
    rx: 0.55,
    fill: "#5c6870"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 6,
    width: 12,
    height: 7.5,
    rx: 1,
    fill: "#c8925a"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fill: "#8a6238",
    d: "M33.55 6h.9v7.5h-.9z"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.3,
    cy: 10.2,
    r: 0.6,
    fill: "#5c6870"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.7,
    cy: 10.2,
    r: 0.6,
    fill: "#5c6870"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f4a54",
    d: "M20.5 17h2.8v9h-2.8z"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 17,
    width: 6.2,
    height: 2.6,
    rx: 1,
    fill: "#3f4a54"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 24.3,
    width: 6.2,
    height: 1.7,
    rx: 0.8,
    fill: "#3f4a54"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 23.6,
    y: 21,
    width: 2.9,
    height: 3.3,
    rx: 0.6,
    fill: "#4fb3c6"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 21.7c1.3 0 1.3 2 0 2",
    fill: "none",
    stroke: "#4fb3c6",
    strokeWidth: 0.9
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8925a",
    d: "M19.5 28H40v10.5H19.5z"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fill: "#8a6238",
    d: "M29.4 28h.9v10.5h-.9z"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 33,
    r: 0.7,
    fill: "#5c6870"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fill: "#a7b2ba",
    d: "M19.5 28h9.9v10.5h-9.9z"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3,
    y: 28.7,
    width: 8.3,
    height: 1.2,
    rx: 0.6,
    fill: "#5c6870"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3,
    y: 31,
    width: 8.3,
    height: 1,
    rx: 0.5,
    fill: "#8f9ba3"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.6,
    cy: 29.3,
    r: 0.35,
    fill: "#9fd8ef"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 26,
    width: 22.5,
    height: 2,
    rx: 1,
    fill: "#dfe6ec"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 26.4,
    width: 7.4,
    height: 2.6,
    rx: 0.9,
    fill: "#8f9ba3"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 29.8,
    y: 26.9,
    width: 5.8,
    height: 1.6,
    rx: 0.5,
    fill: "#5c6870"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c6870",
    d: "M31.8 24.2h1.4v2.2h-1.4z"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 24.2V22c0-1.5 1.2-2.7 2.7-2.7h.8v2",
    fill: "none",
    stroke: "#5c6870",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.7,
    cy: 24.9,
    r: 1.2,
    fill: "#c8503f"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7 23.7c.2-.7.7-1.1 1.4-1.1-.1.7-.6 1.1-1.4 1.1z",
    fill: "#57b368"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M36 22.6s.7 1.2.7 1.8c0 .4-.3.7-.7.7s-.7-.3-.7-.7c0-.6.7-1.8.7-1.8z",
    fill: "#9fd8ef"
  }))), _view103 || (_view103 = /*#__PURE__*/React.createElement("view", {
    id: "offices",
    viewBox: "450 90 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 450,
    y: 90,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 38,
    width: 39,
    height: 1.5,
    rx: 0.75,
    fill: "#c3ccd2"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10.5,
    width: 13,
    height: 9,
    rx: 1.1,
    fill: "#2e4057"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fill: "#cfe3ee",
    d: "M21.2 11.7h10.6v6.6H21.2z"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e4057",
    d: "M25.6 19.5h1.8v2.6h-1.8z"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 22.1,
    width: 7.4,
    height: 1.4,
    rx: 0.7,
    fill: "#2e4057"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 23.5,
    width: 24,
    height: 2.6,
    rx: 1.2,
    fill: "#c8925a"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fill: "#8a6238",
    d: "M18 26.1h2.2V38H18zM35.5 26.1h2.2V38h-2.2z"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 15.5,
    width: 6,
    height: 6.5,
    rx: 2,
    fill: "#3c4652"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 5.4,
    y: 21.7,
    width: 7.2,
    height: 1.9,
    rx: 0.9,
    fill: "#3c4652"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c6870",
    d: "M8.35 23.6h1.3V26h-1.3z"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 6.3,
    y: 26,
    width: 5.9,
    height: 1.1,
    rx: 0.55,
    fill: "#5c6870"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c6870",
    d: "M8.35 27.1h1.3v11h-1.3z"
  }))), _view104 || (_view104 = /*#__PURE__*/React.createElement("view", {
    id: "other",
    viewBox: "450 135 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 450,
    y: 135,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    fill: "#505050"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 22.5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 22.5,
    r: 5
  })))), _view105 || (_view105 = /*#__PURE__*/React.createElement("view", {
    id: "outdoor-courtyard",
    viewBox: "450 180 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 450,
    y: 180,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 7.5,
    r: 3.6,
    fill: "#f2c14e"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M38 1.2v1.6m4.5.9-1.1 1.1m3 5.2h-1.6M32 3.7l1.1 1.1M30.2 10h1.6",
    stroke: "#f2c14e",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8,
    cy: 15.5,
    r: 6,
    fill: "#57b368"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.8,
    cy: 19.5,
    r: 4.2,
    fill: "#3f8f4f"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.8,
    cy: 19.5,
    r: 4.2,
    fill: "#3f8f4f"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fill: "#8a6238",
    d: "M11.5 22.5h2.6V36h-2.6z"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 20.5,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#c8925a"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 26.5,
    width: 16,
    height: 2.4,
    rx: 1.1,
    fill: "#c8925a"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c6870",
    d: "M25.5 22.5h1.6v4h-1.6zM36.9 22.5h1.6v4h-1.6zM25.5 28.9h1.6V36h-1.6zM36.9 28.9h1.6V36h-1.6z"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 36,
    width: 39,
    height: 1.5,
    rx: 0.75,
    fill: "#c3ccd2"
  }))), _view106 || (_view106 = /*#__PURE__*/React.createElement("view", {
    id: "paint-brush-can",
    viewBox: "450 225 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 450,
    y: 225,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(18 -12.255 26)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5.5,
    width: 4.6,
    height: 13,
    rx: 2,
    fill: "#8a5a33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 18,
    width: 6.2,
    height: 4.2,
    rx: 1,
    fill: "#9aa7b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6 22.2H16v6.2c0 1.5-1.2 2.7-2.7 2.7s-2.7-1.2-2.7-2.7z",
    fill: "#efe6d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6 27H16v1.4c0 1.5-1.2 2.7-2.7 2.7s-2.7-1.2-2.7-2.7z",
    fill: "#7fae62"
  }))), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 21.5H39v16c0 1.1-.9 2-2 2H26.5c-1.1 0-2-.9-2-2z",
    fill: "#9aa7b0"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 21c2-4.5 10.5-4.5 12.5 0",
    fill: "none",
    stroke: "#5f6d77",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 23.2,
    y: 19.4,
    width: 17.1,
    height: 3.4,
    rx: 1.7,
    fill: "#5f6d77"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2 22.8h15.1c-.3 1.3-1.6 1.6-2.6 2.9-.6.8.1 2.9-1.3 3.4-1.3.5-1.9-1.5-3.4-1.5s-2.3 1.2-3.7.9c-1.3-.3-.8-2-1.7-2.8-1-.9-2.4-1.4-2.4-2.9z",
    fill: "#7fae62"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2 26.4s1.1 2.6 1.1 3.7c0 .7-.5 1.2-1.1 1.2s-1.1-.5-1.1-1.2c0-1.1 1.1-3.7 1.1-3.7z",
    fill: "#7fae62"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 31.5,
    width: 10.5,
    height: 3.6,
    rx: 1,
    fill: "#efe6d4"
  }))), _view107 || (_view107 = /*#__PURE__*/React.createElement("view", {
    id: "paper_clip",
    viewBox: "450 270 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 450,
    y: 270,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M23.9 8.2c-2.4.3-4.3 2.2-4.6 4.6v14.4c.3 1.9 2.1 3.1 3.9 2.8 1.4-.2 2.5-1.4 2.8-2.8V16.4c0-.3-.2-.5-.5-.5s-.5.2-.5.5v10.8c0 1.3-1 2.3-2.3 2.3h-.1c-1.3.1-2.3-.9-2.4-2.2V12.8c0-2.4 2-4.4 4.4-4.4s4.4 2 4.4 4.4V30c0 3.6-2.9 6.5-6.5 6.5S16 33.6 16 30V17.6c0-.2-.3-.4-.5-.4s-.5.2-.5.4V30c.1 4.1 3.4 7.4 7.5 7.5 4.1-.1 7.4-3.4 7.5-7.5V12.8c-.4-3-3.1-5-6.1-4.6z"
  }))), _view108 || (_view108 = /*#__PURE__*/React.createElement("view", {
    id: "pencil_and_paper",
    viewBox: "450 315 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 450,
    y: 315,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M9.4 7.5c-1-.1-1.8.6-1.9 1.6v22.5l2.5 5.5c.2.2.5.3.8.3.3 0 .7-.1.9-.3l2.4-5.5c.1-.1.1-.1.1-.2V9.1c-.1-1-1-1.7-2-1.6H9.4zm2.8.8c.7 0 1.2.4 1.2.8v3H8.3v-3c0-.4.5-.8 1.1-.8h2.8zm-3.9 4.6h2.2v18H8.3v-18zM12 34.5H9.7l-1.3-2.9h4.9L12 34.5zm1.4-3.6h-2.2v-18h2.2v18z"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m8.4 31.6 1.3 2.9H12l1.3-2.9z"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDEAF",
    d: "M11.2 12.9h2.2v18h-2.2zM8.3 12.9h2.2v18H8.3z"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fill: "#FA908A",
    d: "M8.3 9.1v3h5.1v-3c0-.4-.5-.8-1.2-.8H9.4c-.6 0-1.1.4-1.1.8z"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M37.1 7.5H16.6c-.2 0-.4.2-.4.4v29.2c0 .2.2.4.4.4h20.5c.2 0 .4-.2.4-.4V7.9c0-.2-.2-.4-.4-.4zm-.4 29.2H16.9V8.3h19.8v28.4z"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.9 8.3v28.4h19.8V8.3H16.9zm3.9 22.4c0-.2.1-.4.3-.4h11.4c.2 0 .4.2.4.4s-.2.4-.4.4H21.1c-.2 0-.3-.2-.3-.4zm0-4.1c0-.2.1-.4.3-.4h11.4c.2 0 .4.2.4.4s-.2.4-.4.4H21.1c-.2 0-.3-.2-.3-.4zm0-4.1c0-.2.1-.4.3-.4h11.4c.2 0 .4.2.4.4s-.2.4-.4.4H21.1c-.2 0-.3-.2-.3-.4zm0-4.1c0-.2.1-.4.3-.4h11.4c.2 0 .4.2.4.4s-.2.4-.4.4H21.1c-.2 0-.3-.2-.3-.4zm0-4.1c0-.2.1-.4.3-.4h11.4c.2 0 .4.2.4.4s-.2.4-.4.4H21.1c-.2 0-.3-.2-.3-.4z"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32.5 31.1c.2 0 .4-.2.4-.4s-.2-.4-.4-.4H21.1c-.2 0-.3.2-.3.4s.1.4.3.4h11.4zM32.5 27c.2 0 .4-.2.4-.4s-.2-.4-.4-.4H21.1c-.2 0-.3.2-.3.4s.1.4.3.4h11.4zM32.5 22.9c.2 0 .4-.2.4-.4s-.2-.4-.4-.4H21.1c-.2 0-.3.2-.3.4s.1.4.3.4h11.4zM32.5 18.8c.2 0 .4-.2.4-.4s-.2-.4-.4-.4H21.1c-.2 0-.3.2-.3.4s.1.4.3.4h11.4zM32.5 14.7c.2 0 .4-.2.4-.4s-.2-.4-.4-.4H21.1c-.2 0-.3.2-.3.4s.1.4.3.4h11.4z"
  }))), _view109 || (_view109 = /*#__PURE__*/React.createElement("view", {
    id: "personal_storage",
    viewBox: "450 360 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 450,
    y: 360,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M10 35.7h1.9v.9H10zM33.1 35.7H35v.9h-1.9z"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32.7 37.3h2.7c.2 0 .4-.1.4-.3v-1.3H37c.2 0 .3-.2.3-.4V8.1c0-.2-.1-.4-.3-.4H8.1c-.2 0-.4.2-.4.4v27.2c0 .2.2.4.4.4h1.1V37c0 .2.2.3.4.3h2.7c.2 0 .4-.1.4-.3v-1.3h19.7V37c0 .2.1.3.3.3zm2.3-.7h-1.9v-.9H35v.9zm-23.1 0H10v-.9h1.9v.9zm-3.5-1.7V8.4H17v26.5H8.4zm9.3 0V8.4h9.6v26.5h-9.6zm10.3 0V8.4h8.6v26.5H28z"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M27.3 8.4h-9.6v26.5h9.6V8.4zm-3.2 16.5V24c0-.2.2-.4.4-.4s.4.2.4.4v.9c0 .2-.2.4-.4.4s-.4-.2-.4-.4zm.4-11.9h-4.1c-.2 0-.4-.1-.4-.3 0-.2.2-.4.4-.4h4.1c.2 0 .4.2.4.4s-.2.3-.4.3zm.4 1.1c0 .2-.2.4-.4.4h-4.1c-.2 0-.4-.2-.4-.4s.2-.4.4-.4h4.1c.2 0 .4.2.4.4zm-4.5 1.1h4.1c.2 0 .4.2.4.4s-.2.3-.4.3h-4.1c-.2 0-.4-.1-.4-.3 0-.2.2-.4.4-.4zM17 8.4H8.4v26.5H17V8.4zM14.3 24c0-.2.1-.4.3-.4.2 0 .4.2.4.4v.9c0 .2-.2.4-.4.4s-.3-.2-.3-.4V24zm.7-11.3c0 .2-.2.3-.4.3h-4c-.3 0-.4-.1-.4-.3 0-.2.2-.4.4-.4h4c.2 0 .4.2.4.4zm-4.4 1h4c.2 0 .4.2.4.4s-.2.4-.4.4h-4c-.2 0-.4-.2-.4-.4s.2-.4.4-.4zm0 1.5h4c.2 0 .4.2.4.4s-.2.3-.4.3h-4c-.3 0-.4-.1-.4-.3 0-.2.2-.4.4-.4zM36.6 8.4H28v26.5h8.6V8.4zM34 24.9V24c0-.2.2-.4.4-.4s.3.2.3.4v.9c0 .2-.1.4-.3.4-.2 0-.4-.2-.4-.4zm.5-11.9h-4c-.2 0-.4-.2-.4-.4s.2-.3.4-.3h4c.2 0 .4.1.4.3 0 .2-.2.4-.4.4zm.4 1.1c0 .2-.2.4-.4.4h-4c-.2 0-.4-.2-.4-.4s.2-.4.4-.4h4c.2 0 .4.2.4.4zm-4.4 1.1h4c.2 0 .4.2.4.4s-.2.3-.4.3h-4c-.2 0-.4-.1-.4-.3 0-.2.2-.4.4-.4z"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M24.5 12.3h-4.1c-.2 0-.4.2-.4.4s.2.3.4.3h4.1c.2 0 .4-.1.4-.3 0-.2-.2-.4-.4-.4zM24.5 13.7h-4.1c-.2 0-.4.2-.4.4s.2.4.4.4h4.1c.2 0 .4-.2.4-.4s-.2-.4-.4-.4zM20.4 15.9h4.1c.2 0 .4-.1.4-.3 0-.2-.2-.4-.4-.4h-4.1c-.2 0-.4.2-.4.4s.2.3.4.3zM34.5 12.3h-4c-.2 0-.4.1-.4.3 0 .2.2.4.4.4h4c.2 0 .4-.2.4-.4s-.2-.3-.4-.3zM34.5 13.7h-4c-.2 0-.4.2-.4.4s.2.4.4.4h4c.2 0 .4-.2.4-.4s-.2-.4-.4-.4zM30.5 15.9h4c.2 0 .4-.1.4-.3 0-.2-.2-.4-.4-.4h-4c-.2 0-.4.2-.4.4s.2.3.4.3zM10.6 12.3c-.2 0-.4.2-.4.4s.1.3.4.3h4c.2 0 .4-.1.4-.3 0-.2-.2-.4-.4-.4h-4zM10.6 14.5h4c.2 0 .4-.2.4-.4s-.2-.4-.4-.4h-4c-.2 0-.4.2-.4.4s.2.4.4.4zM10.6 15.9h4c.2 0 .4-.1.4-.3 0-.2-.2-.4-.4-.4h-4c-.2 0-.4.2-.4.4s.1.3.4.3zM14.6 25.3c.2 0 .4-.2.4-.4V24c0-.2-.2-.4-.4-.4s-.3.2-.3.4v.9c0 .2.1.4.3.4zM24.9 24.9V24c0-.2-.2-.4-.4-.4s-.4.2-.4.4v.9c0 .2.2.4.4.4s.4-.2.4-.4zM34.7 24.9V24c0-.2-.1-.4-.3-.4-.2 0-.4.2-.4.4v.9c0 .2.2.4.4.4s.3-.2.3-.4z"
  }))), _view110 || (_view110 = /*#__PURE__*/React.createElement("view", {
    id: "phone",
    viewBox: "450 405 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 450,
    y: 405,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "m21.3 33.8 4.3 2.6c.8.6 1.8.9 2.8.9 1.4 0 2.7-.6 3.7-1.6l1.2-1.2.5.5h.8l2.5-2.6c.1-.1.2-.2.2-.3 0-.2-.1-.3-.2-.4l-6-6c-.2-.1-.5-.1-.7 0l-2.5 2.6c-.2.2-.2.5 0 .7l.5.5-1.4 1.4c-.3.2-.7.2-1 0l-11.9-12c-.3-.3-.3-.7 0-1l1.3-1.3.5.5h.8l2.5-2.6.2-.3c0-.2-.1-.3-.2-.4l-6-6h-.7L10 10.4c-.2.2-.2.5 0 .7l.5.5-1.2 1.2c-1.8 1.7-2.1 4.5-.8 6.6l2.7 4.3c2.6 4.1 6 7.5 10.1 10.1zm9.5-7 5.2 5.3-1.8 1.8-.5-.5-2.1-2.1-2.7-2.6 1.9-1.9zM12.9 8.9l5.2 5.3-1.8 1.8-.5-.5-2.1-2.1-2.7-2.6 1.9-1.9zm-3.5 10c-1.1-1.7-.8-4 .6-5.4l1.2-1.2 1.7 1.8 1.8 1.8-1.3 1.3c-.7.7-.7 1.8 0 2.5l11.9 11.9c.7.6 1.7.6 2.4 0l1.4-1.4 1.7 1.8 1.8 1.8-1.2 1.2c-1.4 1.4-3.6 1.6-5.3.6l-4.3-2.7c-4-2.5-7.3-5.8-9.8-9.8l-2.6-4.2z"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "m15.8 15.5.5.5 1.8-1.8-5.2-5.3-1.9 1.9 2.7 2.6zM31.6 31.3l2.1 2.1.5.5 1.8-1.8-5.2-5.3-1.9 1.9z"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "m21.8 32.9 4.3 2.7c1.7 1 3.9.8 5.3-.6l1.2-1.2-1.8-1.8-1.7-1.8-1.4 1.4c-.7.6-1.7.6-2.4 0L13.4 19.7c-.7-.7-.7-1.8 0-2.5l1.3-1.3-1.8-1.8-1.7-1.8-1.2 1.2c-1.4 1.4-1.7 3.7-.6 5.4l2.6 4.2c2.5 4 5.8 7.3 9.8 9.8z"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.5 7.7c-.3 0-.5.2-.5.5s.2.5.5.5c7.6 0 13.7 6.1 13.7 13.7v.1c0 .3.2.5.5.5s.6-.2.6-.5c0-8.2-6.6-14.8-14.8-14.8z"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32.2 22.5c.3 0 .5-.2.5-.5 0-5.4-4.3-9.7-9.7-9.7-.3 0-.5.2-.5.5s.2.5.5.5c4.8 0 8.7 3.9 8.7 8.7 0 .3.2.5.5.5zM28.1 21.5c0-2.5-2.1-4.6-4.6-4.6-.3 0-.5.2-.5.5s.2.5.5.5c2 0 3.6 1.6 3.6 3.6 0 .3.2.5.5.5s.5-.2.5-.5z"
  }))), _view111 || (_view111 = /*#__PURE__*/React.createElement("view", {
    id: "pipettes",
    viewBox: "0 450 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    y: 450,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M7.6 35.5c0 .2.1.3.1.4l1.5 1.5h.8l2.5-2.6c1.4.5 2.9.2 3.9-.9l11-11.1 2.2 2.1.4.1c.2 0 .3-.1.4-.2l2-2c.1-.1.1-.2.1-.3 0-.2 0-.3-.1-.4L30.1 20l6.2-6.2c1.1-1 1.4-2.6.8-4-.5-1.4-1.8-2.3-3.3-2.3-1 0-1.9.4-2.6 1.1L25 14.9l-2.2-2.2h-.7l-2 2c-.1 0-.1.2-.1.3 0 .1 0 .2.1.3l2.2 2.2-11.2 11.2c-1 1-1.4 2.5-.9 3.8l-2.6 2.6v.4zM21.3 15l1.3-1.3 8.7 8.8-1.3 1.4-2.1-2.2-4.5-4.5-2.1-2.2zm-10 18c.1-.2.1-.4.1-.6-.5-1-.3-2.2.5-3l.2-.3 1.6 1.7.7-.7-1.6-1.7.8-.7 1.1 1.1.7-.7-1.1-1.1.8-.7 1.6 1.6.7-.7-1.6-1.6.8-.8 1.1 1.1.7-.7-1.1-1.2.8-.8 1.6 1.6.7-.7-1.6-1.6.8-.8 1.1 1.1.7-.7-1.1-1.1.8-.8 1.6 1.6.7-.7-1.6-1.6 1.3-1.3 3.7 3.8-11.2 11.2c-.8.8-2.1 1-3.1.5H12l-2.5 2.6-.8-.8 2.6-2.5z"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12 33.7h.5c1 .5 2.3.3 3.1-.5L26.8 22 23 18.2l-1.3 1.3 1.6 1.6-.7.7-1.6-1.6-.7.8 1.1 1.1-.7.7-1.1-1.1-.8.8 1.6 1.6-.7.7-1.7-1.6-.7.8 1.1 1.1-.7.7-1.1-1.1-.8.8 1.6 1.6-.7.7-1.7-1.6-.7.8 1.1 1.2-.7.7-1.1-1.1-.8.7 1.6 1.7-.7.7-1.7-1.7-.2.3c-.8.8-1 2-.5 3 0 .2 0 .4-.1.6l-2.5 2.4.8.8 2.5-2.6z"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "m27.8 21.7 2.2 2.2 1.3-1.4-8.8-8.8-1.2 1.3 2 2.2z"
  }))), _view112 || (_view112 = /*#__PURE__*/React.createElement("view", {
    id: "plant",
    viewBox: "45 450 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 45,
    y: 450,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M8 12c0 .1 0 .3.1.4h.3c1.7-.1 3.2 1.2 3.3 2.9.2 1.5 1 2.9 2.2 3.9 1 .8 2.4 1.3 3.7 1.3h.7c1.7-.2 3.2-1.1 4.2-2.5.5 1.2.8 2.4.8 3.7v4.1h-7c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.9h.7l1.7 7.6c.1.2.2.3.4.3h10.5c.2 0 .3-.1.4-.3l1.7-7.6h.7c1-.1 1.8-.9 1.8-1.9 0-1-.8-1.8-1.8-1.8h-7v-4.1c0-.4 0-.9-.1-1.3.2-.9.5-1.7 1-2.4.5.7 1.3 1.2 2.1 1.4l1.5.3c.7 0 1.4-.2 2-.5 1.6-.8 2.6-2.4 2.6-4.2 0-1.3 1-2.3 2.2-2.4.2 0 .3-.1.3-.2.1-.1.1-.2 0-.3-1.9-2.9-5.8-3.7-8.7-1.8-2 1.3-3 3.6-2.8 6-.3.5-.6 1-.8 1.5-.3-1-.8-1.9-1.4-2.7-.1-1.7-.7-3.3-1.7-4.6-1.4-1.6-3.3-2.7-5.4-3C12.8 7.2 9.5 9 8 12zm21.4 24.7H19.2l-1.6-7.3H31l-1.6 7.3zM28.7 11c2.3-1.6 5.5-1.2 7.3 1-1.4.4-2.3 1.6-2.3 3 .1 1.5-.8 3-2.2 3.6-.9.5-2 .5-3 .2s-1.8-1-2.3-2c-.5-2.2.5-4.6 2.5-5.8zm-5.5 5.5v-.2c.4.8.8 1.6 1 2.5.1.2.2.3.3.3.2 0 .3-.1.4-.3.2-.6.5-1.1.8-1.6-.5 1-.9 2-1.2 3.1.1.4.1.9.1 1.3v4.1H24v-4c0-1.6-.4-3.1-1-4.5l.2-.7zM16 8.2c2 .2 3.7 1.2 4.9 2.8 1.2 1.5 1.8 3.4 1.6 5.3-.7 1.9-2.4 3.3-4.4 3.5-1.4.2-2.8-.2-3.8-1.1-1.1-.9-1.8-2.1-2-3.5-.2-1.8-1.7-3.2-3.5-3.4C10.3 9.4 13.2 8 16 8.2z"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "m17.7 29.5 1.5 7.2h10.2l1.6-7.2z"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9705",
    d: "M24 21.7v4h.7v-4.1c0-.4 0-.9-.1-1.3.3-1.1.7-2.1 1.2-3.1-.3.5-.6 1-.8 1.6-.1.2-.2.3-.4.3-.1 0-.2-.1-.3-.3-.2-.9-.6-1.7-1-2.5v.2l-.3.7c.6 1.5.9 3 1 4.5z"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M12.4 15.2c.2 1.4.9 2.6 2 3.5 1 .9 2.4 1.3 3.8 1.1 2-.2 3.7-1.6 4.4-3.5.2-1.9-.4-3.8-1.6-5.3-1.2-1.5-3-2.6-5-2.8-2.9-.3-5.7 1.1-7.2 3.6 1.9.2 3.3 1.6 3.6 3.4zm2.5-4.2c2.5.2 4.8 1.3 6.6 3.1.1.1.1.4 0 .5H21c-1.6-1.7-3.8-2.7-6.1-3-.2 0-.3-.1-.3-.3s.1-.4.3-.3zM28.5 18.9c1 .3 2.1.3 3-.2 1.4-.6 2.3-2.1 2.2-3.6 0-1.4.9-2.6 2.3-3-1.8-2.2-5-2.7-7.4-1.1-2 1.3-2.9 3.6-2.4 5.9.5.9 1.3 1.6 2.3 2zm-1.8-3.4c1.5-1.8 3.6-3 5.9-3.4.3-.1.4-.1.4.1s-.1.4-.3.4c-2.1.5-4 1.6-5.5 3.2l-.2.2h-.2c-.3-.3-.3-.5-.1-.5z"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M14.9 11.5c2.3.3 4.5 1.3 6.1 3h.5c.1-.1.1-.4 0-.5-1.8-1.8-4.1-2.9-6.6-3.1-.2-.1-.3.1-.3.3s.1.3.3.3zM27 16l.3-.2c1.5-1.6 3.4-2.7 5.5-3.2.2 0 .3-.2.3-.4s-.2-.2-.4-.2c-2.3.4-4.4 1.6-5.9 3.4-.2.1-.2.3 0 .5h.2z"
  }))), _view113 || (_view113 = /*#__PURE__*/React.createElement("view", {
    id: "plotter-issue",
    viewBox: "90 450 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 90,
    y: 450,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 12,
    width: 18,
    height: 2.6,
    rx: 1.3,
    fill: "#dfe6ec"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    width: 30,
    height: 8,
    rx: 2,
    fill: "#3c4652"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 15.8,
    width: 4.6,
    height: 2.2,
    rx: 0.7,
    fill: "#8fb6c9"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22h16v8.5l-2.7-1.6-2.6 1.6-2.7-1.6-2.6 1.6-2.7-1.6-2.7 1.6z",
    fill: "#eef1f5"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "m14.5 27 3-2.6 2.9 1.6 3.1-3",
    fill: "none",
    stroke: "#5a8fd8",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fill: "#46626d",
    d: "M8.5 22H11v13.5H8.5zM31 22h2.5v13.5H31z"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.8,
    cy: 8,
    r: 5.6,
    fill: "#d84338"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 37.95,
    y: 4.6,
    width: 1.7,
    height: 4.4,
    rx: 0.85,
    fill: "#fff"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.8,
    cy: 10.9,
    r: 0.95,
    fill: "#fff"
  }))), _view114 || (_view114 = /*#__PURE__*/React.createElement("view", {
    id: "plumbing",
    viewBox: "135 450 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 135,
    y: 450,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M18 20.4h-.9c-.2 0-.4.3-.4.5V24c0 .2.2.4.4.4h.9c-.2 2.9-2.6 5.1-5.5 5.1h-.2v-1.1c0-.2-.2-.4-.4-.4H8.6c-.2 0-.4.2-.4.4v1.1H5.7c-.2 0-.4.2-.4.4v7.6c0 .2.2.5.4.5h2.6v1c0 .2.2.4.4.4h3.2c.2 0 .4-.2.4-.4v-1h.8c7.6 0 13.7-6 13.9-13.6h.9c.2 0 .4-.2.4-.4v-3.1c0-.2-.2-.5-.4-.5h-.8c.3-2.8 2.6-5 5.5-5h.2v1c0 .2.2.5.4.5h3.2c.2 0 .4-.3.4-.5v-1h2.6c.2 0 .4-.2.4-.4V7.3c0-.2-.2-.4-.4-.4h-2.6v-1c0-.2-.2-.4-.4-.4h-3.2c-.2 0-.4.2-.4.4v1H32c-7.6 0-13.7 6-14 13.5zm-.5 3.2v-2.3h1.9v2.3h-1.9zm-8.4 5.3h2.3v1.8H9.1v-1.8zm0 5.3h2.3V36H9.1v-1.8zm0-.9v-1.8h2.3v1.8H9.1zm2.3 5.2H9.1v-1.7h2.3v1.7zm1.6-1.3h-.8v-6.7h.2c3.4 0 6.1-2.6 6.4-6h7.3c-.2 7-6 12.7-13.1 12.7zm7.2-13.6v-2.3H22v2.3h-1.8zm2.8 0v-2.3h1.7v2.3H23zm4.4-2.3v2.3h-1.8v-2.3h1.8zm8.4-5.3h-2.3v-1.8h2.3V16zm0-5.3h-2.3V8.9h2.3v1.8zm0 .9v1.7h-2.3v-1.7h2.3zm-2.3-5.3h2.3v1.8h-2.3V6.3zM32 7.8h.8v6.7h-.2c-3.3 0-6.1 2.6-6.4 5.9h-7.3c.2-7 6-12.6 13.1-12.6z"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    d: "M23 21.3h1.8v2.3H23zM20.2 21.3H22v2.3h-1.8zM25.5 21.3h1.8v2.3h-1.8zM33.5 14.2h2.3V16h-2.3zM33.5 8.9h2.3v1.8h-2.3zM33.5 11.6h2.3v1.8h-2.3zM33.5 6.3h2.3v1.8h-2.3z"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M18.9 20.4h7.3c.3-3.3 3.1-5.9 6.4-5.9h.2V7.8H32c-7.1 0-12.9 5.6-13.1 12.6z"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    d: "M17.5 21.3h1.8v2.3h-1.8z"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M18.9 24.4c-.3 3.4-3 6-6.4 6h-.2v6.7h.8c7.1 0 12.9-5.6 13.1-12.7h-7.3z"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    d: "M9.1 34.2h2.3V36H9.1zM9.1 31.5h2.3v1.8H9.1zM9.1 28.9h2.3v1.8H9.1zM9.1 36.8h2.3v1.8H9.1z"
  }))), _view115 || (_view115 = /*#__PURE__*/React.createElement("view", {
    id: "printer",
    viewBox: "180 450 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 180,
    y: 450,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "m35.2 7.6-24.7 5c-1.6 0-2.9 1.3-2.9 2.9v21.8h29.7V15.5c0-1.6-1.3-2.9-2.9-2.9H15.6l19.8-4c.3-.1.5-.3.4-.6 0-.3-.3-.4-.6-.4zM14.8 26.9H19v1c0 .6.4 1 1 1h4.4c.6 0 1-.4 1-1v-1h4.7c.4 0 .8.4.8.8v3.7H14v-3.7c.1-.4.4-.7.8-.8zm-.8 5.5h5v.9c-.1.5.3.9.8 1H24.4c.5.1.9-.3 1-.8v-1.1h5.5v3.9H14v-3.9zm22.3 3.9h-4.4v-8.6c0-1-.8-1.8-1.8-1.8H14.8c-1 0-1.8.8-1.8 1.8v8.6H8.6V21.5h27.7v14.8zm-1.9-22.8c1.1.1 1.9.9 1.9 2v5H8.6v-5c0-1.1.8-1.9 1.9-2h23.9z"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M30.9 36.3v-3.9h-5.5v.9c.1.5-.3.9-.8 1H20c-.5.1-.9-.3-1-.8v-1.1h-5v3.9h16.9zM14 31.4h16.9v-3.7c0-.4-.4-.8-.8-.8h-4.7v1c0 .6-.4 1-1 1H20c-.6 0-1-.4-1-1v-1h-4.2c-.4 0-.8.4-.8.8v3.7z"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M8.6 21.5v14.8H13v-8.6c0-1 .8-1.8 1.8-1.8h15.3c1 0 1.8.8 1.8 1.8v8.6h4.4V21.5H8.6zm9.9 2.4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h7.4c.3 0 .5.2.5.5s-.2.5-.5.5h-7.4z"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.6 15.5v5h27.7v-5c0-1.1-.8-1.9-1.9-2H10.5c-1 .1-1.9 1-1.9 2zm14.9 3H23c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h.5c.3 0 .5.2.5.5s-.3.5-.5.5zm2.4 0h-.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h.5c.3 0 .5.2.5.5s-.2.5-.5.5zm6.9-3.5c1.1-.1 2 .8 2.1 1.9S34.2 19 33 19s-2-.8-2.1-1.9V17c0-1 .9-1.9 1.9-2zm-7.4.5h.5c.3 0 .5.2.5.5s-.2.5-.5.5h-.5c-.3 0-.5-.2-.5-.5s.3-.5.5-.5zm-2.5 0h.5c.3 0 .5.2.5.5s-.2.5-.5.5h-.5c-.2 0-.4-.3-.4-.5s.2-.4.4-.5zm-1.9-1v5H10.1v-5H21z"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M10.1 19.5H21v-5H10.1v5zm9.9-4v3h-8.9v-3H20z"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.1 15.5H20v3h-8.9z"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M30.9 17c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2h-.1c-1 .1-1.9 1-1.9 2zm1.9-1c.6 0 1 .4 1 1 .1.5-.3.9-.8 1h-.2c-.5 0-.9-.4-.9-.9V17c0-.5.4-.9.9-1z"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M31.9 17c-.1.5.3.9.8 1h.1c.5.1.9-.3 1-.8V17c0-.6-.4-1-1-1-.5.1-.9.5-.9 1z"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M26.4 23.5c0-.3-.2-.5-.5-.5h-7.4c-.3 0-.5.2-.5.5s.2.5.5.5h7.4c.3-.1.5-.3.5-.5z"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M23 16.5h.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H23c-.2 0-.4.3-.4.5-.1.3.1.5.4.5z"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M23.5 17.5H23c-.3 0-.5.2-.5.5s.2.5.5.5h.5c.3 0 .5-.2.5-.5s-.3-.5-.5-.5z"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M25.4 16.5h.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-.5c-.3 0-.5.2-.5.5s.3.5.5.5z"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M25.9 17.5h-.5c-.3 0-.5.2-.5.5s.2.5.5.5h.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  }))), _view116 || (_view116 = /*#__PURE__*/React.createElement("view", {
    id: "projector",
    viewBox: "405 540 41.2 30.6"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 405,
    y: 540,
    width: 41.2,
    height: 30.6,
    xmlSpace: "preserve",
    viewBox: "0 0 41.2 30.6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M32.7 23.2c0 .3.2.5.5.5h.3c.3 0 .5-.2.5-.5v-1h-1.3v1zM8.5 23.2c0 .3.2.5.5.5h.2c.3 0 .5-.2.5-.5v-1H8.5v1zM24.9 11c1.8-2.3 5.1-2.8 7.4-1 2 1.6 2.5 4.4 1.3 6.7h2V8.6c0-.8-.7-1.5-1.5-1.5h-26c-.8.1-1.4.8-1.4 1.6v8h17.8c-1-1.8-.8-4 .4-5.7zM9.5 14c0 .3-.3.5-.6.5s-.5-.2-.5-.5V9.8c0-.3.2-.5.5-.5s.6.2.6.5V14zm3 0c0 .3-.3.5-.6.5s-.5-.2-.5-.5v-2.8c0-.3.2-.6.5-.6s.6.3.6.6V14zm2.9 0c0 .3-.2.5-.5.5s-.6-.2-.6-.5v-1.4c0-.3.3-.6.6-.6s.5.3.5.6V14zm0-2.8c0 .3-.2.6-.5.6s-.6-.3-.6-.6V9.8c0-.3.3-.5.6-.5s.5.2.5.5v1.4zm3 2.8c0 .3-.2.5-.5.5s-.6-.2-.6-.5V9.8c0-.3.3-.5.6-.5s.5.2.5.5V14z"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M35.1 22c1-.4 1.7-1.3 1.7-2.4V8.7c0-1.4-1.2-2.6-2.6-2.6H15.5v-.3c0-.4-.1-.7-.4-1-.3-.3-.7-.5-1.1-.5h-1.4c-.8 0-1.5.7-1.5 1.5V6H8.2c-.7 0-1.4.3-1.8.8-.5.5-.8 1.2-.8 1.9v10.9c0 1.1.7 2.1 1.8 2.4v1.2c0 .2 0 .4.1.6H6.3c-.3 0-.5.2-.5.5s.2.6.5.6h5.2c.3 0 .5-.3.5-.6s-.2-.5-.5-.5h-.8c.1-.2.1-.4.1-.6v-1h20.8v1c0 .2.1.4.1.6h-.8c-.3 0-.6.2-.6.5s.3.6.6.6h4.9c.3 0 .6-.3.6-.6s-.3-.5-.6-.5H35c0-.2.1-.4.1-.6V22zM12.2 5.8c0-.2.2-.4.4-.4H14c.2 0 .5.2.5.4V6h-2.3v-.2zM6.7 8.7c0-.8.7-1.5 1.5-1.6h26c.8 0 1.5.7 1.5 1.5v8.1h-2c1.2-2.3.7-5.1-1.3-6.7-2.3-1.8-5.7-1.3-7.4 1-1.3 1.6-1.4 3.9-.5 5.7H6.7v-8zm25.5 8.2c-.8.9-1.9 1.4-3.1 1.4h-.9c-.9-.2-1.7-.7-2.3-1.3-1.5-1.7-1.3-4.3.3-5.8s4.2-1.5 5.8 0c1.5 1.6 1.6 4.1.2 5.7zM9.7 23.2c0 .3-.2.5-.5.5H9c-.3 0-.5-.2-.5-.5v-1h1.2v1zm24.3 0c0 .3-.2.5-.5.5h-.3c-.3 0-.5-.2-.5-.5v-1H34v1zm.2-2h-26c-.8 0-1.5-.7-1.5-1.5v-1.8h18.6l.1.1.2.2.2.2c.1 0 .1.1.2.1l.3.2c.1 0 .1.1.2.1l.2.1c-.1.1.1.2.2.1l.3.1.2.1c.1 0 .3 0 .4.1.1 0 0-.1.1 0 .1 0 .3 0 .5.1h1.5l.4-.1.1-.1c.1 0 .3 0 .4-.1.1 0 .1-.1.2-.1l.3-.1.2-.1.3-.1c.1 0 .1-.1.2-.1l.2-.2c.1 0 .1-.1.2-.2l.2-.2.2-.2.1-.1h2.8v1.8c0 1.1-.7 1.7-1.5 1.7z"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M14.5 5.8c0-.2-.3-.4-.5-.4h-1.4c-.2 0-.4.2-.4.4V6h2.3v-.2z"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M8.9 9.3c-.3 0-.5.2-.5.5V14c0 .3.2.5.5.5s.6-.2.6-.5V9.8c-.1-.2-.3-.5-.6-.5zM11.9 10.6c-.3 0-.5.3-.5.6V14c0 .3.2.5.5.5s.6-.2.6-.5v-2.8c0-.3-.3-.6-.6-.6zM14.9 12c-.3 0-.6.3-.6.6V14c0 .3.3.5.6.5s.5-.2.5-.5v-1.4c0-.3-.2-.5-.5-.6zM14.9 9.3c-.3 0-.6.2-.6.5v1.4c0 .3.3.6.6.6s.5-.3.5-.6V9.8c0-.2-.3-.5-.5-.5zM17.9 9.3c-.3 0-.6.2-.6.5V14c0 .3.3.5.6.5s.5-.2.5-.5V9.8c0-.2-.3-.5-.5-.5z"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M26.2 11.2c-1.6 1.5-1.8 4.1-.3 5.8.6.6 1.4 1.1 2.3 1.3h.9c1.2 0 2.3-.5 3.1-1.4 1.4-1.7 1.3-4.1-.2-5.7-1.7-1.5-4.2-1.5-5.8 0zm4.5 4.5c-.4.4-1 .7-1.6.7-1.2 0-2.2-1.1-2.2-2.3s1-2.2 2.2-2.2 2.2 1 2.2 2.2c0 .6-.2 1.2-.6 1.6z"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fill: "#737373",
    d: "M29.1 11.9c-1.2 0-2.2 1-2.2 2.2s1 2.3 2.2 2.3c.6 0 1.2-.3 1.6-.7.4-.4.6-1 .6-1.6 0-1.2-1-2.2-2.2-2.2z"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M35.7 19.7v-1.9h-2.8l-.2.2-.2.2-.2.2-.2.2-.2.1c-.1 0-.2.1-.3.1l-.3.2h-.1l-.2.1c-.1 0-.2.1-.3.2-.1 0-.2.1-.3.1l-.3.1-.4.1h-1.4c-.1 0-.2-.1-.4-.1-.1 0-.2-.1-.2-.1-.2-.1-.3 0-.4-.1l-.2-.1-.1-.1c-.1 0-.1-.1-.2-.1l-.3-.2c-.1 0-.1-.1-.2-.1l-.3-.2c-.1 0-.1-.1-.2-.1l-.2-.2-.2-.2-.1-.1H6.7v1.8c0 .8.7 1.5 1.5 1.5h26c.8 0 1.5-.6 1.5-1.5z"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "m11.5 10.1.1.1c.1.1.2.2.4.2.3 0 .5-.2.5-.5 0-.1-.1-.3-.2-.4-.2-.2-.7-.2-.8 0-.1.1-.1.1-.1.3v.2l.1.1"
  }))), _view117 || (_view117 = /*#__PURE__*/React.createElement("view", {
    id: "pure_pack",
    viewBox: "225 450 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 225,
    y: 450,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M10.6 35.6c-.1 1 .7 1.8 1.7 1.9h20.2c1 0 1.9-.9 1.9-1.9-.1-1-.9-1.8-1.9-1.9v-2.4h1.2V30h-1.2V15h1.2v-1.3h-1.2v-2.4c1-.1 1.8-.9 1.9-1.9 0-1-.9-1.9-1.9-1.9h-20c-1-.1-1.8.7-1.9 1.7v.2c0 1 .9 1.9 1.9 1.9v2.4h-1.3V15h1.3v15h-1.3v1.3h1.3v2.4c-1 0-1.9.9-1.9 1.9zM15 35v-1.3h-1.3v-2.4H15V30h-1.3V15H15v-1.3h-1.3v-2.4H15V10h-2.5c-.4 0-.6-.3-.7-.6 0-.4.3-.7.7-.7h20c.3.1.6.3.6.7 0 .3-.3.6-.6.6H16.2v1.3h15v2.4h-15V15h15v15h-15v1.3h15v2.4h-15V35h16.3c.3 0 .6.3.6.6 0 .4-.3.6-.6.7h-20c-.4 0-.7-.3-.7-.7.1-.3.3-.6.7-.6H15z"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M11.8 35.6c0 .4.3.7.7.7h20c.3-.1.6-.3.6-.7 0-.3-.3-.6-.6-.6H16.2v-1.3h15v-2.4h-15V30h15V15h-15v-1.3h15v-2.4h-15V10h16.3c.3 0 .6-.3.6-.6 0-.4-.3-.6-.6-.7h-20c-.4 0-.7.3-.7.7.1.3.3.6.7.6H15v1.3h-1.3v2.4H15V15h-1.3v15H15v1.3h-1.3v2.4H15V35h-2.5c-.4 0-.6.3-.7.6zM19.3 25l2.4-4.8c.3-.5.8-.7 1.3-.5.2.1.4.3.5.6l2.4 4.8c.2.5 0 1-.5 1.3h-5.2c-.6 0-1-.4-1-1 0-.2.1-.3.1-.4z"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M20.2 26.4h5.2c.5-.3.7-.8.5-1.3l-2.4-4.8c-.1-.3-.3-.5-.5-.6-.5-.2-1 0-1.3.5L19.3 25c0 .1-.1.2-.1.4 0 .6.4 1 1 1z"
  }))), _view118 || (_view118 = /*#__PURE__*/React.createElement("view", {
    id: "rake",
    viewBox: "270 450 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 270,
    y: 450,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m19.5 26.5-.1-.2-1.5 1.5 1.1 1.1zM15.3 25.2l2.4-.5-.5-.5-.2-.2h-2.9zM18.5 25.5l-2.4.5 1.1 1.1 1.5-1.5zM20.8 27.8l-.5-.5-.4 2.5 1.1 1.1V28z"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "m19 24.6 1.4 1.4c.1 0 .1.1.1.1l.6.6.7-.7c.1-.1.2-.2.2-.3 0-.2-.1-.3-.2-.4l-2.1-2.1c-.2-.2-.5-.2-.7 0l-.7.7.7.7c-.1-.1 0 0 0 0z"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M7.5 26.4c0 .2.1.3.3.4h.5l4.4-2.8 1.5 1.5-4 2.9c-.2.1-.2.3-.2.5s.1.3.3.4h.5l4.1-3.1 1.6 1.6-3.5 3.5c-.1.1-.2.3-.2.5.1.2.2.3.4.4.2 0 .4-.1.5-.2l3.5-3.5 1.6 1.6-3.1 4.1c-.1.2-.1.6.2.7.2.2.5.1.7-.1l2.9-4 1.5 1.5-2.8 4.4c-.1.1-.1.4 0 .5.1.2.2.3.4.3l.5-.2 2.8-4.6c0-.1.1-.2.1-.3v-4.6c0-.1-.1-.3-.2-.4l.7-.7c.3-.2.5-.6.5-1s-.2-.8-.5-1.1l14.6-14.5c.5-.6.5-1.6 0-2.2-.3-.2-.7-.4-1.1-.4-.4 0-.8.2-1.1.4L20.4 22.5c-.3-.3-.7-.5-1.1-.5-.4 0-.8.2-1 .5l-.7.7-.4-.2h-4.6l-.3.1-4.6 2.8c-.1.1-.2.3-.2.5zm8.6-.4 2.4-.5.2.2-1.5 1.5-1.1-1.2zm1.8 1.8 1.5-1.5.2.2-.6 2.4-1.1-1.1zm3.1 3.1-1.1-1.1.5-2.4.5.5.1.1v2.9zM35.6 8.6c.3-.1.5-.1.8 0 .1.3.1.5 0 .8L21.8 23.9l-.7-.7L35.6 8.6zM19 23.2c.2-.2.5-.2.7 0l2.1 2.1c.1.1.2.2.2.4 0 .1-.1.2-.2.3l-.7.7-.6-.6c0-.1-.1-.1-.1-.1L19 24.6l-.6-.6.6-.8zm-2 .8.2.2.5.5-2.4.5-1.2-1.2H17z"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "m21.1 23.2.7.7L36.4 9.4c.1-.3.1-.5 0-.8-.3-.1-.5-.1-.8 0L21.1 23.2z"
  }))), _view119 || (_view119 = /*#__PURE__*/React.createElement("view", {
    id: "recycling",
    viewBox: "315 450 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 315,
    y: 450,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    fill: "#4AB8DC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.5 9.8-3.2 5.6c-.1.2-.1.5-.1.7.1.2.3.4.5.5l3.9 2.2c.4.2.9.1 1.2-.3l1.8-3.2L18 9.2l-.5.6zM20.6 34.1c.1-.2.2-.4.2-.6V29c0-.5-.4-.9-.9-.9h-3.7l-3.5 6.2h7.2v.1c.3 0 .5-.1.7-.3zM26.9 25.8c-.2-.1-.4 0-.5.1l-3.6 4.4c-.5.6-.5 1.5 0 2.1l3.6 4.3c.2.1.4.2.6.1.2-.1.3-.3.3-.5v-1.9h4.5c1.1 0 2.1-.6 2.7-1.6l2.3-4.1.3-.5h-9.8v-2c0-.2-.2-.3-.4-.4zM31.6 12.7l-1.6.9-2.3-3.8c-.5-1-1.6-1.6-2.7-1.6h-5.3l4.9 8.5-1.7 1c-.2.1-.3.3-.2.5 0 .3.2.4.4.5l5.5.9c.8.1 1.6-.3 1.8-1.1l2-5.2c0-.2 0-.4-.2-.6h-.6zM8.3 28.7l2.4 4.1c.1.2.2.4.4.5l4.9-8.5 1.6 1c.2.1.4.1.6-.1.2-.1.2-.3.1-.5l-1.9-5.3c-.3-.7-1.1-1.1-1.9-1l-5.5.9-.4.4c0 .2.1.4.3.6l1.6.9-2.2 3.9c-.5 1-.5 2.1 0 3.1zM36.8 25.6l-3.2-5.7c-.3-.4-.8-.5-1.3-.3L28.5 22s-.1 0-.1.1c-.4.3-.4.8-.2 1.1l1.8 3.1h7.1c0-.3-.1-.5-.3-.7z"
  })))), _view120 || (_view120 = /*#__PURE__*/React.createElement("view", {
    id: "recycling_waste",
    viewBox: "360 450 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 360,
    y: 450,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    fill: "#4AB8DC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.5 9.8-3.2 5.6c-.1.2-.1.5-.1.7.1.2.3.4.5.5l3.9 2.2c.4.2.9.1 1.2-.3l1.8-3.2L18 9.2l-.5.6zM20.6 34.1c.1-.2.2-.4.2-.6V29c0-.5-.4-.9-.9-.9h-3.7l-3.5 6.2h7.2v.1c.3 0 .5-.1.7-.3zM26.9 25.8c-.2-.1-.4 0-.5.1l-3.6 4.4c-.5.6-.5 1.5 0 2.1l3.6 4.3c.2.1.4.2.6.1.2-.1.3-.3.3-.5v-1.9h4.5c1.1 0 2.1-.6 2.7-1.6l2.3-4.1.3-.5h-9.8v-2c0-.2-.2-.3-.4-.4zM31.6 12.7l-1.6.9-2.3-3.8c-.5-1-1.6-1.6-2.7-1.6h-5.3l4.9 8.5-1.7 1c-.2.1-.3.3-.2.5 0 .3.2.4.4.5l5.5.9c.8.1 1.6-.3 1.8-1.1l2-5.2c0-.2 0-.4-.2-.6h-.6zM8.3 28.7l2.4 4.1c.1.2.2.4.4.5l4.9-8.5 1.6 1c.2.1.4.1.6-.1.2-.1.2-.3.1-.5l-1.9-5.3c-.3-.7-1.1-1.1-1.9-1l-5.5.9-.4.4c0 .2.1.4.3.6l1.6.9-2.2 3.9c-.5 1-.5 2.1 0 3.1zM36.8 25.6l-3.2-5.7c-.3-.4-.8-.5-1.3-.3L28.5 22s-.1 0-.1.1c-.4.3-.4.8-.2 1.1l1.8 3.1h7.1c0-.3-.1-.5-.3-.7z"
  })))), _view121 || (_view121 = /*#__PURE__*/React.createElement("view", {
    id: "red_exclamation",
    viewBox: "405 450 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 405,
    y: 450,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M7.8 22.5c0 8.1 6.6 14.7 14.7 14.7s14.7-6.6 14.7-14.7S30.6 7.8 22.5 7.8 7.8 14.4 7.8 22.5zM22.5 8.6c7.7 0 13.9 6.2 13.9 13.9-.1 7.7-6.2 13.8-13.9 13.9-7.7 0-13.9-6.2-13.9-13.9S14.8 8.6 22.5 8.6z"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22.5 36.4c7.7-.1 13.8-6.2 13.9-13.9 0-7.7-6.2-13.9-13.9-13.9S8.6 14.8 8.6 22.5s6.2 13.9 13.9 13.9zm-4.1-21.9c0-1.1 2-1.7 4.1-1.7 2.1 0 4.1.6 4.1 1.7-.5 3.8-1.9 12.8-4.1 12.8s-3.6-9-4.1-12.8zm6.3 14.4v2.3c0 .6-.4 1-1 1h-2.4c-.6 0-1-.4-1-1v-2.3c0-.6.4-1 1-1h2.4c.6 0 1 .4 1 1z"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M22.5 27.3c2.2 0 3.6-9 4.1-12.8 0-1.1-2-1.7-4.1-1.7-2.1 0-4.1.6-4.1 1.7.5 3.8 1.9 12.8 4.1 12.8zM23.7 27.9h-2.4c-.6 0-1 .4-1 1v2.3c0 .6.4 1 1 1h2.4c.6 0 1-.4 1-1v-2.3c0-.6-.4-1-1-1z"
  }))), _view122 || (_view122 = /*#__PURE__*/React.createElement("view", {
    id: "refill-oil-pig-pads",
    viewBox: "450 450 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 450,
    y: 450,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 30,
    width: 24,
    height: 4.4,
    rx: 1.5,
    fill: "#d5dde2"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 9.2,
    y: 25.8,
    width: 21.6,
    height: 4.4,
    rx: 1.5,
    fill: "#eef1f5"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 21.6,
    width: 19.2,
    height: 4.4,
    rx: 1.5,
    fill: "#d5dde2"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8s3.4 5 3.4 7.4c0 2.1-1.5 3.6-3.4 3.6s-3.4-1.5-3.4-3.6C16.6 13 20 8 20 8z",
    fill: "#4a3b2a"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 8.5,
    r: 6,
    fill: "#23967f"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8 8.5a3.3 3.3 0 1 1-3.3-3.3",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "m37.3 3.5 3.2 1.7-3.2 1.7z",
    fill: "#fff"
  }))), _view123 || (_view123 = /*#__PURE__*/React.createElement("view", {
    id: "refill-pig-pads",
    viewBox: "495 0 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 495,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 30,
    width: 24,
    height: 4.4,
    rx: 1.5,
    fill: "#d5dde2"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 9.2,
    y: 25.8,
    width: 21.6,
    height: 4.4,
    rx: 1.5,
    fill: "#eef1f5"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 21.6,
    width: 19.2,
    height: 4.4,
    rx: 1.5,
    fill: "#d5dde2"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-9 19 16)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 14,
    width: 19,
    height: 4.4,
    rx: 1.5,
    fill: "#eef1f5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9aa7b0",
    d: "M9.5 15.7h19v1h-19z"
  }))), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 8.5,
    r: 6,
    fill: "#23967f"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8 8.5a3.3 3.3 0 1 1-3.3-3.3",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "m37.3 3.5 3.2 1.7-3.2 1.7z",
    fill: "#fff"
  }))), _view124 || (_view124 = /*#__PURE__*/React.createElement("view", {
    id: "refill-ppe",
    viewBox: "495 45 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 495,
    y: 45,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 24.2a4.6 4.6 0 0 1 9.2 0z",
    fill: "#f2c14e"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 9.8,
    y: 23.7,
    width: 11.2,
    height: 1.6,
    rx: 0.8,
    fill: "#e0a52f"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 21,
    width: 4.2,
    height: 2.8,
    rx: 1.2,
    fill: "#46626d"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 26.9,
    y: 21,
    width: 4.2,
    height: 2.8,
    rx: 1.2,
    fill: "#46626d"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2 22.2h.7",
    fill: "none",
    stroke: "#46626d"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "m8 25.5-4.2-4.8H10l3 4.8zM33 25.5l4.2-4.8H31l-3 4.8z",
    fill: "#d99a3f"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 25.5,
    width: 25,
    height: 11.5,
    rx: 1.2,
    fill: "#c8925a"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 8.5,
    r: 6,
    fill: "#23967f"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8 8.5a3.3 3.3 0 1 1-3.3-3.3",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "m37.3 3.5 3.2 1.7-3.2 1.7z",
    fill: "#fff"
  }))), _view125 || (_view125 = /*#__PURE__*/React.createElement("view", {
    id: "refill-spill-socks",
    viewBox: "495 90 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 495,
    y: 90,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 33,
    rx: 8.5,
    ry: 2.5,
    fill: "#9fd8ef"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 31.5c3-9.5 26-9.5 29 0",
    fill: "none",
    stroke: "#d9c9a8",
    strokeWidth: 5.5,
    strokeLinecap: "round"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "m12.6 26.2 2 2.6M18.6 23.9l.6 3.2M25.4 23.9l-.6 3.2M31.4 26.2l-2 2.6",
    fill: "none",
    stroke: "#b8a37a",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 8.5,
    r: 6,
    fill: "#23967f"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8 8.5a3.3 3.3 0 1 1-3.3-3.3",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "m37.3 3.5 3.2 1.7-3.2 1.7z",
    fill: "#fff"
  }))), _view126 || (_view126 = /*#__PURE__*/React.createElement("view", {
    id: "register",
    viewBox: "495 135 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 495,
    y: 135,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.3 13.3h3.4v1.6h-3.4z"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M6.5 37.2h31.9v-6.8H37L34.1 15h-3.6v-1.6h1.1c.7.1 1.3-.5 1.4-1.2V9c0-.7-.6-1.3-1.3-1.3h-7.3c-.7 0-1.3.6-1.3 1.3v3c0 .7.6 1.3 1.3 1.3h1.2V15h-5.8v-2c0-.7-.6-1.3-1.3-1.3h-4.3c-.7-.1-1.3.5-1.4 1.2V15h-2L8 30.5H6.5v6.7zM21 33.8c0-.9.7-1.6 1.6-1.6s1.6.7 1.6 1.6c0 .9-.7 1.6-1.6 1.6s-1.6-.7-1.6-1.6zM23.8 9c0-.3.3-.6.6-.6h7.2c.3 0 .6.3.6.6v3c0 .3-.3.6-.6.6h-7.2c-.3.1-.6-.2-.6-.6V9zm2.5 4.3h3.4V15h-3.4v-1.7zM13.5 13c0-.3.3-.6.6-.6h4.3c.3 0 .6.3.6.6v9.7h-5.5V13zm-2 2.8h1.4v7h-1.4v.7h9.8v-.7h-1.4v-7h13.7l2.8 14.7H8.6l2.9-14.7z"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.6 30.5h27.7l-2.8-14.7H19.8v7h1.4v.7h-9.8v-.7h1.4v-7h-1.4L8.6 30.5zm23.9-8.4h-8.7v-4.4h8.7v4.4zm-.2 4.9h-1.8v-.7h1.8v.7zm0 2.1h-1.8v-.7h1.8v.7zM29.1 27h-2v-.7h2v.7zm-3.3-2.1h-2v-.7h2v.7zm3.3 0h-2v-.7h2v.7zm-5.3 1.3h2v.8h-2v-.8zm0 2.1h2v.7h-2v-.7zm3.3 0h2v.7h-2v-.7zm5.2-3.4h-1.8v-.7h1.8v.7z"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M24.5 12.5h7.2c.3 0 .6-.3.6-.6V9c0-.3-.3-.6-.6-.6h-7.2c-.3 0-.6.3-.6.6v3c-.1.3.2.7.6.5z"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.5 22.8H19V13c0-.3-.3-.6-.6-.6h-4.3c-.3 0-.6.3-.6.6v9.8zm4.6-4.5v.7h-3.6v-.7h3.6zM14.5 17v-.7h3.6v.7h-3.6zm3 3.3v.7H15v-.7h2.5zm.6-6.1v.8h-3.6v-.7h3.6z"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M23.8 17.8v4.4h8.7v-4.4h-8.7zm7.8.7v2.9h-7.2v-2.9h7.2z"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M24.5 18.5h7.2v2.9h-7.2z"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M23.8 24.2h2v.7h-2zM30.5 24.2h1.8v.7h-1.8zM27.1 24.2h2v.7h-2zM27.1 26.2h2v.7h-2zM30.5 26.2h1.8v.7h-1.8zM23.8 26.2h2v.7h-2zM23.8 28.3h2v.7h-2zM27.1 28.3h2v.7h-2zM30.5 28.3h1.8v.7h-1.8z"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22.5 35.5c.9 0 1.6-.7 1.6-1.6 0-.9-.7-1.6-1.6-1.6S21 33 21 33.8c0 .9.7 1.7 1.5 1.7z"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M14.5 14.2h3.6v.7h-3.6zM14.5 16.2h3.6v.7h-3.6zM14.5 18.3h3.6v.7h-3.6zM15 20.3h2.5v.7H15z"
  }))), _view127 || (_view127 = /*#__PURE__*/React.createElement("view", {
    id: "remote-working-support",
    viewBox: "495 180 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 495,
    y: 180,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 25,
    height: 17.5,
    rx: 2,
    fill: "#4a5568"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fill: "#eef1fb",
    d: "M12 12h21v13.5H12z"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3 25.5c0-3.1 2.3-4.8 5.2-4.8s5.2 1.7 5.2 4.8z",
    fill: "#7c6ff0"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 17.2,
    r: 2.7,
    fill: "#7c6ff0"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 17.2c0-1.7 1.3-3 3-3s3 1.3 3 3",
    fill: "none",
    stroke: "#333a45",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9,
    y: 16.6,
    width: 1.3,
    height: 2.2,
    rx: 0.6,
    fill: "#333a45"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8,
    y: 16.6,
    width: 1.3,
    height: 2.2,
    rx: 0.6,
    fill: "#333a45"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4 18.8c0 1.2-1 1.9-2 1.9",
    fill: "none",
    stroke: "#333a45",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 27.5h25.2l2.7 3.7c.5.7 0 1.7-.9 1.7H8.1c-.9 0-1.4-1-.9-1.7z",
    fill: "#5c6b80"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 19.4,
    y: 28.9,
    width: 6.2,
    height: 1.3,
    rx: 0.65,
    fill: "#8b99ad"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8 3.5h6.8c1.7 0 3 1.3 3 3v3.2c0 1.7-1.3 3-3 3h-4.3l-2.9 2.6.4-2.7c-1.5-.2-3-1.3-3-2.9V6.5c0-1.7 1.3-3 3-3z",
    fill: "#7c6ff0"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "m33.9 8.1 1.7 1.7 3.2-3.2",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _view128 || (_view128 = /*#__PURE__*/React.createElement("view", {
    id: "repairs",
    viewBox: "495 225 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 495,
    y: 225,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "m29.3 11.7 1.4.4h.3c.2-.4-.1-.7-.7-1.3-1.4-1.3-3.1-2.2-5-2.5h-7v.3c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-.3c0-.4-.4-.8-.8-.8h-1.8c-.4 0-.8.4-.8.8v3.8c0 .4.4.8.8.8h1.8c.4 0 .8-.4.8-.8 0-.3.2-.5.5-.5s.5.2.5.5v.3h2.1v6.4c-.4.1-.8.4-.8.8v17c0 .5.4.9.9.9h2.7c.5-.1.8-.4.8-.9V19.5c0-.4-.4-.7-.8-.8v-6.4h2.1v-1.5c1.4.1 2.7.4 4 .9zm-12.5.4c0 .2-.1.3-.3.3h-1.8c-.2 0-.3-.1-.3-.3V8.3c0-.2.1-.3.3-.3h1.8c.2 0 .3.1.3.3v3.8zm1.5-1-.5-.1h-.5V9.4l.5.2.5-.2v1.7zm5.1 8.4v17.1c0 .2-.1.3-.3.3h-2.7c-.2 0-.3-.1-.3-.3V19.5c0-.2.1-.3.3-.3h2.7c.2 0 .3.1.3.3zm1.4-7.7h-6v-3h6v3z"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.3 9.4V11h.5l.5.1V9.4l-.5.2z"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fill: "#CD9444",
    d: "M23.1 19.2h-2.7c-.2 0-.3.1-.3.3v17.1c0 .2.1.3.3.3h2.7c.2 0 .3-.1.3-.3V19.5c0-.2-.1-.3-.3-.3z"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M18.8 8.8v3h6v-3z"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M16.5 8h-1.8c-.2 0-.3.1-.3.3v3.8c0 .2.1.3.3.3h1.8c.2 0 .3-.1.3-.3V8.3c0-.2-.1-.3-.3-.3z"
  }))), _view129 || (_view129 = /*#__PURE__*/React.createElement("view", {
    id: "restock_supplies",
    viewBox: "495 270 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 495,
    y: 270,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M9.4 7.5c-1-.1-1.8.6-1.9 1.6v22.5l2.5 5.5c.2.2.5.3.8.3.3 0 .7-.1.9-.3l2.4-5.5c.1-.1.1-.1.1-.2V9.1c-.1-1-1-1.7-2-1.6H9.4zm2.8.8c.7 0 1.2.4 1.2.8v3H8.3v-3c0-.4.5-.8 1.1-.8h2.8zm-3.9 4.6h2.2v18H8.3v-18zM12 34.5H9.7l-1.3-2.9h4.9L12 34.5zm1.4-3.6h-2.2v-18h2.2v18z"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m8.4 31.6 1.3 2.9H12l1.3-2.9z"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDEAF",
    d: "M11.2 12.9h2.2v18h-2.2zM8.3 12.9h2.2v18H8.3z"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    fill: "#FA908A",
    d: "M8.3 9.1v3h5.1v-3c0-.4-.5-.8-1.2-.8H9.4c-.6 0-1.1.4-1.1.8z"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M37.1 7.5H16.6c-.2 0-.4.2-.4.4v29.2c0 .2.2.4.4.4h20.5c.2 0 .4-.2.4-.4V7.9c0-.2-.2-.4-.4-.4zm-.4 29.2H16.9V8.3h19.8v28.4z"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.9 8.3v28.4h19.8V8.3H16.9zm3.9 22.4c0-.2.1-.4.3-.4h11.4c.2 0 .4.2.4.4s-.2.4-.4.4H21.1c-.2 0-.3-.2-.3-.4zm0-4.1c0-.2.1-.4.3-.4h11.4c.2 0 .4.2.4.4s-.2.4-.4.4H21.1c-.2 0-.3-.2-.3-.4zm0-4.1c0-.2.1-.4.3-.4h11.4c.2 0 .4.2.4.4s-.2.4-.4.4H21.1c-.2 0-.3-.2-.3-.4zm0-4.1c0-.2.1-.4.3-.4h11.4c.2 0 .4.2.4.4s-.2.4-.4.4H21.1c-.2 0-.3-.2-.3-.4zm0-4.1c0-.2.1-.4.3-.4h11.4c.2 0 .4.2.4.4s-.2.4-.4.4H21.1c-.2 0-.3-.2-.3-.4z"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32.5 31.1c.2 0 .4-.2.4-.4s-.2-.4-.4-.4H21.1c-.2 0-.3.2-.3.4s.1.4.3.4h11.4zM32.5 27c.2 0 .4-.2.4-.4s-.2-.4-.4-.4H21.1c-.2 0-.3.2-.3.4s.1.4.3.4h11.4zM32.5 22.9c.2 0 .4-.2.4-.4s-.2-.4-.4-.4H21.1c-.2 0-.3.2-.3.4s.1.4.3.4h11.4zM32.5 18.8c.2 0 .4-.2.4-.4s-.2-.4-.4-.4H21.1c-.2 0-.3.2-.3.4s.1.4.3.4h11.4zM32.5 14.7c.2 0 .4-.2.4-.4s-.2-.4-.4-.4H21.1c-.2 0-.3.2-.3.4s.1.4.3.4h11.4z"
  }))), _view130 || (_view130 = /*#__PURE__*/React.createElement("view", {
    id: "restrooms",
    viewBox: "495 315 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 495,
    y: 315,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.9 18.8v6.1c0 .4.3.6.7.6s.8-.2.8-.6v-6.1c0-.2.2-.4.4-.4s.5.2.5.4v16.8c0 .6.4 1 1 1 .5-.1.9-.5 1-1V25.1c0-.2.2-.4.4-.4s.5.2.5.4v10.5c0 .6.4 1 1 1 .5 0 1-.5 1-1V18.8c0-.2.3-.4.5-.4s.5.2.5.4v6.1c0 .4.3.6.7.6.4 0 .7-.2.7-.6v-6.1c0-2.7-2.5-3.9-4.8-3.9S9 16.1 8.9 18.8zM11.7 10.5c.1 1.1 1 2 2.1 2.1 1.2 0 2.1-.9 2.1-2.1s-.9-2.1-2.1-2.1-2.1.9-2.1 2.1zM31.9 14.9h-3.7c-.6 0-1.2.3-1.6.8-1 2.3-1.7 4.7-2.3 7.1l-.2.6c0 .2 0 .3.1.5 0 .1.2.2.4.3h.2c.2.1.5 0 .7-.1l1.3-5.3c.1-.1.2-.2.4-.2.3 0 .5.2.5.5L25 29.5h2.5c.2 0 .4.2.4.4v5.9c.1.5.4.8.9.8.4 0 .8-.4.8-.8v-5.9c0-.2.2-.4.4-.4s.5.2.5.4v5.9c0 .4.4.8.8.8s.8-.4.8-.8v-5.9c0-.2.3-.4.5-.4h2.5l-2.7-10.4c-.1-.2.1-.5.3-.6.2 0 .5.1.6.3l1.3 5.3c.2.1.5.2.7.1h.2l.4-.3c.1-.2.1-.3.1-.5l-.2-.6c-.6-2.4-1.3-4.8-2.3-7.1-.4-.5-1-.8-1.6-.8zM27.9 10.5c0 1.2.9 2.1 2.1 2.1 1.2 0 2.1-.9 2.1-2.1s-.9-2.1-2.1-2.1c-1.2 0-2.1.9-2.1 2.1z"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M14 7.5h-.2c-1.7 0-3 1.3-3 3 .1 1.6 1.4 2.9 3 3 1.7 0 3-1.3 3-3 .1-1.6-1.2-2.9-2.8-3zm1.9 3c0 1.2-.9 2.1-2.1 2.1-1.1-.1-2-1-2.1-2.1 0-1.2.9-2.1 2.1-2.1s2.1.9 2.1 2.1zM8.1 18.8v6.1c.1.8.8 1.4 1.6 1.4h.8v9.3c0 1 .9 1.9 1.9 1.9.5 0 1.1-.3 1.4-.7.4.4.9.7 1.5.7 1-.1 1.8-.9 1.9-1.9v-9.3h.7c.8 0 1.5-.5 1.6-1.3v-6.2c0-3.2-2.9-4.8-5.7-4.8s-5.7 1.5-5.7 4.8zm5.7-3.9c2.3 0 4.8 1.2 4.8 3.9v6.1c0 .4-.3.6-.7.6-.4 0-.7-.2-.7-.6v-6.1c0-.2-.3-.4-.5-.4s-.5.2-.5.4v16.8c0 .5-.5 1-1 1-.6 0-1-.4-1-1V25.1c0-.2-.3-.4-.5-.4s-.4.2-.4.4v10.5c-.1.5-.5.9-1 1-.6 0-1-.4-1-1V18.8c0-.2-.3-.4-.5-.4s-.4.2-.4.4v6.1c0 .4-.4.6-.8.6s-.7-.2-.7-.6v-6.1c.1-2.7 2.6-3.9 4.9-3.9zM30.2 7.5H30c-1.7 0-3 1.3-3 3s1.3 3 3 3c1.6.1 2.9-1.2 3-2.8v-.2c.1-1.6-1.2-2.9-2.8-3zm1.9 3c0 1.2-.9 2.1-2.1 2.1-1.2 0-2.1-.9-2.1-2.1s.9-2.1 2.1-2.1c1.2 0 2.1.9 2.1 2.1zM32 14h-3.8c-1 0-1.9.5-2.4 1.3-1 2.3-1.8 4.7-2.4 7.2l-.2.7c-.1.4 0 .8.2 1.1.2.4.6.7 1 .8h.8L24 29.8c-.1.1 0 .3.1.4.1.1.2.2.3.2H27V36c0 .1.1.2.1.3.2.7.9 1.2 1.7 1.2.5 0 .9-.2 1.2-.6.3.4.8.6 1.3.6.8 0 1.4-.5 1.7-1.2 0-.1.1-.2.1-.3v-5.6h2.6l.3-.2c.1-.1.1-.3.1-.4l-1.2-4.7h.8c.4-.1.8-.4 1-.8.2-.3.3-.7.1-1.1v-.7c-.6-2.4-1.5-4.9-2.4-7.2-.5-.8-1.4-1.3-2.4-1.3zm3.8 8.8.2.6c0 .2 0 .3-.1.5l-.4.3h-.2c-.2.1-.5 0-.7-.1l-1.3-5.3c-.1-.2-.4-.3-.6-.3-.2.1-.4.4-.3.6l2.7 10.4h-2.5c-.2 0-.5.2-.5.4v5.9c0 .4-.4.8-.8.8s-.8-.4-.8-.8v-5.9c0-.2-.3-.4-.5-.4s-.4.2-.4.4v5.9c0 .4-.4.8-.8.8-.5 0-.8-.3-.9-.8v-5.9c0-.2-.2-.4-.4-.4H25l2.7-10.4c0-.3-.2-.5-.5-.5-.2 0-.3.1-.4.2l-1.3 5.3c-.2.1-.5.2-.7.1h-.2c-.2-.1-.4-.2-.4-.3-.1-.2-.1-.3-.1-.5l.2-.6c.6-2.4 1.3-4.8 2.3-7.1.4-.5 1-.8 1.6-.8h3.7c.6 0 1.2.3 1.6.8 1 2.3 1.7 4.7 2.3 7.1z"
  }))), _view131 || (_view131 = /*#__PURE__*/React.createElement("view", {
    id: "safety-concern",
    viewBox: "495 360 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 495,
    y: 360,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22 7.6v1h-2.5c-.3 0-.6.2-.6.5v2.1c-5 1.4-8.8 5.6-9.6 10.8H7.6c-.3 0-.5.2-.5.5v3.1c0 .3.2.5.5.5h29.9c.3 0 .5-.2.5-.5v-3.1c0-.3-.2-.5-.5-.5h-1.7c-.8-5.2-4.6-9.4-9.6-10.8V9.1c0-.3-.3-.5-.6-.5H23v-1h-1zm3 2v6.7h1.1v-4.1c4.6 1.5 8 5.5 8.6 10.3.1.3.3.5.5.5H37v2H8.1v-2h1.7c.3 0 .5-.2.5-.5.6-4.8 4-8.8 8.6-10.3v4.1H20V9.6h2v4.6h1V9.6h2zM38 29.7c0-.3-.2-.5-.5-.5h-2.6v-1c0-.3-.2-.5-.5-.5H10.6c-.3 0-.5.2-.5.5v1H7.6c-.3 0-.5.2-.5.5v3.1c0 .3.2.6.5.6h2.6v.5c0 .1 0 .2.1.3l2 3c.1.2.3.3.5.3h6.1c.2 0 .4-.1.4-.2l2.1-2.6h.1l.9-2.3h.3l.9 2.3h.1l2.1 2.6c.1.1.2.2.4.2h6.1c.2 0 .4-.1.5-.3l2-3c.1-.1.1-.2.1-.3v-.5h2.6c.3 0 .5-.3.5-.6v-3.1zm-4.2 4L32 36.3h-5.7L24.5 34l-1-2.5c0-.2-.2-.3-.4-.3H22c-.2 0-.4.1-.4.3l-1 2.5-1.9 2.3H13l-1.8-2.7v-5h22.7v5.1z"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBE900",
    d: "M23 14.2h-1V9.6h-2v6.7h-1.1v-4.1c-4.6 1.5-8 5.5-8.6 10.3 0 .3-.2.5-.5.5H8.1v2H37v-2h-1.7c-.2 0-.4-.2-.5-.5-.6-4.8-4-8.8-8.6-10.3v4.1H25V9.6h-2v4.6z"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M33.8 29.7v-1H11.1v5l1.8 2.7h5.7l1.9-2.3 1-2.5c0-.2.2-.3.4-.3H23c.2 0 .4.1.4.3l1 2.5 1.9 2.3H32l1.8-2.7v-4z"
  }))), _view132 || (_view132 = /*#__PURE__*/React.createElement("view", {
    id: "safety-hazard",
    viewBox: "495 405 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 495,
    y: 405,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8 38 35.5H7z",
    fill: "#fc0",
    stroke: "#fc0",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9,
    y: 15.5,
    width: 3.2,
    height: 11.5,
    rx: 1.6,
    fill: "#1e242b"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 31.3,
    r: 2,
    fill: "#1e242b"
  }))), _view133 || (_view133 = /*#__PURE__*/React.createElement("view", {
    id: "screen_share",
    viewBox: "495 450 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 495,
    y: 450,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    stroke: "#505050",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    d: "M8.4 7.6c-.4 0-.8.4-.8.8v10.5c0 .4.4.8.8.8h4.8l-.7 1.7v.2c0 .1.1.1.2.1h5.2l.2-.1v-.2l-.7-1.7h4.8c.4 0 .8-.4.8-.8V8.4c0-.4-.4-.8-.8-.8H8.4zM22.6 19c0 .2-.1.3-.3.3H8.4c-.2 0-.3-.1-.3-.3v-1.6h14.5V19zm0-2.1H8.1V8.4c0-.2.1-.3.3-.3h13.9c.2 0 .3.1.3.3v8.5z"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22.4 8.1h-14c-.2 0-.3.1-.3.3v8.3h14.5V8.4c0-.1-.1-.3-.2-.3zM8.1 17.4V19c0 .2.1.3.3.3h13.9c.2 0 .3-.1.3-.3v-1.6H8.1zm1.3.7h1.1l.2.2c0 .1-.1.2-.2.2H9.4c-.1 0-.2-.1-.2-.2l.2-.2z"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    stroke: "#505050",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    d: "M31.7 35.3h4.8c.4 0 .8-.4.8-.8V24.1c0-.4-.4-.8-.8-.8H22.7c-.2 0-.4.1-.6.2-.1.1-.2.3-.2.6v10.5c0 .4.4.8.8.8h4.8l-.7 1.7v.2h5.6v-.2l-.7-1.8zm-9.3-11.2V24c0-.2.1-.3.3-.3h13.9c.2 0 .3.1.3.3v8.6H22.4v-8.5zm0 9h14.5v1.5c0 .2-.1.3-.3.3H22.7c-.2 0-.3-.1-.3-.3v-1.5z"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M36.9 32.4V24c0-.2-.1-.3-.3-.3H22.7c-.2 0-.3.1-.3.3v8.3h14.5zM22.4 34.5c0 .2.1.3.3.3h13.9c.2 0 .3-.1.3-.3V33H22.4v1.5zm1.3-.9h1.1c.2 0 .3.1.3.3 0 .1-.1.2-.3.2h-1.1c-.1 0-.2-.1-.2-.2.1-.1.1-.3.2-.3z"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M23.7 34.1h1.1c.2 0 .3-.1.3-.2 0-.2-.1-.3-.3-.3h-1.1c-.1 0-.2.1-.2.3.1.2.1.2.2.2z"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    stroke: "#505050",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    d: "M12.1 32.8h5.1c.2 0 .3-.1.3-.2 0-.2-.1-.3-.3-.3h-4.8v-5.1l.8.7H13.5s.1 0 .1-.1 0-.1-.1-.2l-1.1-1.1c-.2-.1-.1-.2-.3-.2-.1 0 0 0-.2.2l-1.2 1.1c-.1.1-.1.2 0 .3l.1.1h.2c.1 0 .1-.1.1-.1l.8-.8v5.5c0 .1 0 .2.2.2zM32.8 12.3h-5.1c-.2 0-.3.1-.3.2 0 .2.1.3.3.3h4.8v5.1l-.8-.7H31.4s-.1 0-.1.1 0 .1.1.2l1.1 1.1c.2.1.1.2.3.2.1 0 0 0 .2-.2l1.2-1.1c.1-.1.1-.2 0-.3l-.1-.1h-.2c-.1 0-.1.1-.1.1l-.8.8v-5.5c0-.1-.1-.2-.2-.2z"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M9.4 18.6h1.1c.2 0 .3-.1.3-.2 0-.2-.1-.3-.3-.3H9.4c-.1 0-.2.1-.2.3 0 .2.1.2.2.2z"
  }))), _view134 || (_view134 = /*#__PURE__*/React.createElement("view", {
    id: "security",
    viewBox: "0 495 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    y: 495,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M25.5 10.2c-1-.8-2-1.7-2.9-2.7 0 0-3.6 4.6-12.7 8 0 2.3.3 4.7 1 6.9 1.6 5.2 4.8 9.8 9 13.2.9.7 1.8 1.3 2.7 1.9 5.5-3.5 9.6-8.8 11.6-15 .8-2.3 1.1-4.6 1-7-3.5-1.3-6.8-3-9.7-5.3zm-13.7 6.6c4-1.5 7.6-3.8 10.8-6.6v12.2h-9.7c-.7-1.8-1.1-3.7-1.1-5.6zm10.7 18.4V22.5h9.7c-1.8 5.2-5.2 9.6-9.7 12.7z"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22.5 22.5v12.7c4.5-3.1 7.9-7.5 9.7-12.7h-9.7zM22.5 22.4V10.2c-3.2 2.8-6.8 5.1-10.8 6.6.1 1.9.5 3.8 1.1 5.6h9.7z"
  }))), _view135 || (_view135 = /*#__PURE__*/React.createElement("view", {
    id: "security-van-escort",
    viewBox: "45 495 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 45,
    y: 495,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 31.3,
    width: 38,
    height: 1.4,
    rx: 0.7,
    fill: "#c3ccd2"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8,
    y: 12.9,
    width: 7.6,
    height: 2,
    rx: 1,
    fill: "#3f4a54"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 13.4,
    y: 13.3,
    width: 3,
    height: 1.2,
    rx: 0.4,
    fill: "#f2c14e"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 16.8,
    y: 13.3,
    width: 3,
    height: 1.2,
    rx: 0.4,
    fill: "#5a8fd8"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 14.5,
    width: 27,
    height: 13.5,
    rx: 2.5,
    fill: "#dfe6ec"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f4a54",
    d: "M9.5 23h27v2h-27z"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 16.5,
    width: 6,
    height: 5,
    rx: 1,
    fill: "#8fb6c9"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 16.5,
    width: 5.5,
    height: 5,
    rx: 1,
    fill: "#8fb6c9"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15.8c1.8.7 2.9.7 2.9.7v2.7c0 2-1.3 3.3-2.9 4-1.6-.7-2.9-2-2.9-4v-2.7s1.1 0 2.9-.7z",
    fill: "#23967f"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "m28.8 19 .9.9 1.7-1.7",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 28.5,
    r: 3,
    fill: "#333a40"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 28.5,
    r: 1.2,
    fill: "#9aa7b0"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 28.5,
    r: 3,
    fill: "#333a40"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 28.5,
    r: 1.2,
    fill: "#9aa7b0"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 17.5h4M39.5 21.5h4M38.5 25.5h4",
    fill: "none",
    stroke: "#9fb3c8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _view136 || (_view136 = /*#__PURE__*/React.createElement("view", {
    id: "shared-technology",
    viewBox: "90 495 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 90,
    y: 495,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 37.2,
    width: 36,
    height: 1.6,
    rx: 0.8,
    fill: "#c3ccd2"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 12.5,
    width: 19,
    height: 13.5,
    rx: 1.4,
    fill: "#3c4652"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfe8ee",
    d: "M8 14h16v10.5H8z"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c4652",
    d: "M15 26h2.5v9.5H15z"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 35.5,
    width: 10.5,
    height: 1.7,
    rx: 0.85,
    fill: "#3c4652"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(8 24.85 15.2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 16.5,
    width: 10.5,
    height: 19,
    rx: 1.6,
    fill: "#3c4652"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7,
    y: 17.9,
    width: 8.1,
    height: 16.2,
    rx: 0.6,
    fill: "#dfe8ee"
  }))), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 27.5,
    width: 6.2,
    height: 9.7,
    rx: 1.3,
    fill: "#3c4652"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9,
    y: 28.6,
    width: 4.4,
    height: 7.5,
    rx: 0.5,
    fill: "#dfe8ee"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.8,
    cy: 8.8,
    r: 6.6,
    fill: "#23967f"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "m34 8.8 5.3-3m-5.3 3 5.3 3",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 8.8,
    r: 1.5,
    fill: "#fff"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.3,
    cy: 5.8,
    r: 1.5,
    fill: "#fff"
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.3,
    cy: 11.8,
    r: 1.5,
    fill: "#fff"
  }))), _view137 || (_view137 = /*#__PURE__*/React.createElement("view", {
    id: "shredder",
    viewBox: "135 495 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 135,
    y: 495,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M4.4 14.8c-.2 0-.5.2-.5.4v17c0 .3.2.5.5.5h9.2v1.9c0 .3.2.5.5.5h2.4c.3 0 .5-.2.5-.5v-1.9h1.4V37c0 .3.2.5.5.5h2.4c.3 0 .5-.2.5-.5v-4.3h1.5v3.1c0 .2.2.5.4.5h2.5c.2 0 .4-.3.4-.5v-3.1h1.5V37c0 .3.2.5.5.5H31c.3 0 .5-.2.5-.5v-4.3h9.2c.3 0 .5-.2.5-.5v-17c0-.2-.3-.4-.5-.4h-9.2V8c0-.3-.2-.5-.5-.5H14.1c-.3 0-.5.2-.5.5v6.8H4.4zM13.6 28h-2.7v-1.5h2.7V28zm.8 6.1v-7.5h1.5v7.5h-1.5zm2.5-2.4V29h1.5v2.7h-1.5zm0-3.7v-1.5h1.5V28h-1.5zm3.9.1V36.5h-1.4v-9.9h1.4v1.5zm1 3.6V29h1.5v2.7h-1.5zm0-3.7v-1.5h1.5V28h-1.5zm2.3 7.3V26.6h1.5v8.7h-1.5zm2.5-3.6V29h1.5v2.7h-1.5zm0-3.7v-1.5h1.5V28h-1.5zm3.8.1V36.5H29v-9.9h1.4v1.5zm-16-19.6h16v6.3h-16V8.5zm25.7 7.2v16h-8.7V29h3.1c.3 0 .5-.2.5-.5v-2.4c0-.3-.2-.5-.5-.5H10.4c-.3 0-.5.2-.5.5v2.4c0 .3.2.5.5.5h3.2v2.7H4.9v-16h35.2zM31.4 28v-1.5h2.7V28h-2.7z"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M16.9 29h1.5v2.7h-1.5zM21.8 29h1.5v2.7h-1.5zM26.6 29h1.5v2.7h-1.5z"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.9 32.7V26.6h-1.5v7.5h1.5zM19.4 28.1V36.5h1.4v-9.9h-1.4zM25.6 32.7V26.6h-1.5v8.7h1.5zM29.1 28.1V36.5h1.3v-9.9h-1.3z"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M10.9 26.6h2.7v1.5h-2.7zM16.9 26.6h1.5v1.5h-1.5zM21.8 26.6h1.5v1.5h-1.5zM26.6 26.6h1.5v1.5h-1.5zM31.4 26.6h2.7v1.5h-2.7z"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    d: "M4.9 15.7v16h8.7V29h-3.2c-.3 0-.5-.2-.5-.5v-2.4c0-.3.2-.5.5-.5h24.2c.3 0 .5.2.5.5v2.4c0 .3-.2.5-.5.5h-3.1v2.7h8.7v-16H4.9zm26 1.5c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7.1-.9.8-1.7 1.7-1.7zm7.4 0c.9 0 1.7.8 1.7 1.7 0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7 0-.9.7-1.7 1.7-1.7zm-2 1.7c0 .9-.8 1.7-1.7 1.7s-1.7-.8-1.7-1.7c0-.9.8-1.7 1.7-1.7s1.7.8 1.7 1.7z"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M30.4 14.8V8.5h-16v6.3h16zm-1.8-1.5H16.4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h12.1c.3 0 .5.2.5.5.1.3-.2.5-.4.5zM16.4 9.9h12.1c.3 0 .5.2.5.5s-.2.5-.5.5H16.4c-.3 0-.5-.2-.5-.5s.3-.5.5-.5z"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M16.4 10.9h12.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H16.4c-.3 0-.5.2-.5.5s.3.5.5.5zM28.6 12.3H16.4c-.3 0-.5.2-.5.5s.2.5.5.5h12.1c.3 0 .5-.2.5-.5s-.2-.5-.4-.5z"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M29.3 18.9c0 .9.8 1.7 1.7 1.7.9 0 1.7-.8 1.7-1.7 0-.9-.8-1.7-1.7-1.7-1 0-1.7.8-1.7 1.7z"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M32.8 18.9c0 .9.8 1.7 1.7 1.7s1.7-.8 1.7-1.7c0-.9-.8-1.7-1.7-1.7s-1.7.8-1.7 1.7z"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M38.3 20.6c.9 0 1.7-.8 1.7-1.7 0-.9-.8-1.7-1.7-1.7-.9 0-1.7.8-1.7 1.7 0 .9.7 1.7 1.7 1.7z"
  }))), _view138 || (_view138 = /*#__PURE__*/React.createElement("view", {
    id: "snacks",
    viewBox: "180 495 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 180,
    y: 495,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "m12.3 32.7-.6 4.6h21.6l-.7-4.6c1-6.7 1-13.6 0-20.3l.7-4.7H11.7l.6 4.7c-.9 6.7-.9 13.6 0 20.3zm17.7 2v1.6h-1.7v-1.6h-1v1.6h-1.6v-1.6h-1.1v1.6H23v-1.6h-1v1.6h-1.7v-1.6h-1v1.6h-1.6v-1.6h-1.1v1.6H15v-1.6h-1.1v1.6h-1l.4-3.1h18.3l.5 3.1H31v-1.6h-1zm1.6-2.5H13.3c-.9-6.4-.9-12.9 0-19.3h18.3c.9 6.4.9 12.9 0 19.3zM15 10.3V8.8h1.6v1.5h1.1V8.8h1.6v1.5h1V8.8H22v1.5h1V8.8h1.6v1.5h1.1V8.8h1.6v1.5h1V8.8H30v1.5h1V8.8h1.1l-.5 3H13.3l-.4-3h1v1.5H15z"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "m32.1 36.3-.5-3.1H13.3l-.4 3.1h1v-1.6H15v1.6h1.6v-1.6h1.1v1.6h1.6v-1.6h1v1.6H22v-1.6h1v1.6h1.6v-1.6h1.1v1.6h1.6v-1.6h1v1.6H30v-1.6h1v1.6zM12.9 8.8l.4 3h18.3l.5-3H31v1.5h-1V8.8h-1.7v1.5h-1V8.8h-1.6v1.5h-1.1V8.8H23v1.5h-1V8.8h-1.7v1.5h-1V8.8h-1.6v1.5h-1.1V8.8H15v1.5h-1.1V8.8zM13.3 12.9c-.9 6.4-.9 12.9 0 19.3h18.3c.9-6.4.9-12.9 0-19.3H13.3zm3.5 11.6c-4-3 2.3-7.3 5-4 .7-1 2-2.7 4-2.7 4.4 0 5.1 6 .5 8.4-1.2.7-2.5 1-3.9 1-2.2 0-4.2-1-5.6-2.7z"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M25.8 17.8c-2 0-3.3 1.7-4 2.7-2.7-3.3-9 1-5 4 1.4 1.7 3.4 2.7 5.6 2.7 1.4 0 2.7-.3 3.9-1 4.6-2.4 3.9-8.4-.5-8.4zm-8.5 5.8c-.5-.4-.8-.8-.7-1.2.1-.6.5-1.2 1-1.5 1.8-1 3-.5 3.6.6-1 1.2-2.4 1.9-3.9 2.1zm1 .9c1.6-.4 3.1-1.4 4-2.8.8-1.7 2.5-3.4 4.4-2.7 1.4.5 2.1 2 1.6 3.4-.9 3.1-6.1 5.5-10 2.1z"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M28.3 22.4c.5-1.4-.2-2.9-1.6-3.4-1.9-.7-3.6 1-4.4 2.7-.9 1.4-2.4 2.4-4 2.8 3.9 3.4 9.1 1 10-2.1z"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M17.6 20.9c-.5.3-.9.9-1 1.5-.1.4.2.8.7 1.2 1.5-.2 2.9-.9 3.9-2.1-.6-1.1-1.8-1.6-3.6-.6z"
  }))), _view139 || (_view139 = /*#__PURE__*/React.createElement("view", {
    id: "snow-removal",
    viewBox: "225 495 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 225,
    y: 495,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 35.3,
    width: 41,
    height: 4.2,
    rx: 2.1,
    fill: "#d9e7f0"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 6.5,
    r: 0.9,
    fill: "#b9d2e2"
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 7,
    r: 0.9,
    fill: "#b9d2e2"
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 13.5,
    r: 0.8,
    fill: "#b9d2e2"
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 14.5,
    r: 0.8,
    fill: "#b9d2e2"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 35.6c0-2.4 1.5-4.1 3.3-4.1 1 0 1.8.5 2.4 1.3.6.7 1.4 1.2 2.1 1.5v1.3z",
    fill: "#d9e7f0"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-10 7.8 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.4,
    y: 5.2,
    width: 5,
    height: 1.9,
    rx: 0.95,
    fill: "#9aa7b0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9aa7b0",
    d: "M7 6.5h1.7V26H7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 25.5h7.8c.5 0 .9.45.85.95l-.6 5.3c-.1.75-.7 1.25-1.45 1.25h-5c-.75 0-1.35-.5-1.45-1.25l-.6-5.3c-.05-.5.35-.95.85-.95z",
    fill: "#4a7fa5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.7,
    y: 31.4,
    width: 6.4,
    height: 1.7,
    rx: 0.85,
    fill: "#333a40"
  }))), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    fill: "#333a40",
    d: "M17.8 26.8h4.5v1.9h-4.5z"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.5h4.6V34H15c-2.3-3.9-2.3-8.6 0-12.5z",
    fill: "#f2c14e"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2,
    y: 32.4,
    width: 5.4,
    height: 1.8,
    rx: 0.6,
    fill: "#333a40"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 28.2,
    width: 19.5,
    height: 2.6,
    rx: 0.8,
    fill: "#333a40"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 19.5,
    width: 11,
    height: 9,
    rx: 1,
    fill: "#e58a2f"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 15.5,
    width: 8.5,
    height: 13,
    rx: 1.3,
    fill: "#e58a2f"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 17,
    width: 5.2,
    height: 4.8,
    rx: 0.9,
    fill: "#cfe6f2"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2,
    y: 13.7,
    width: 3,
    height: 1.9,
    rx: 0.9,
    fill: "#f2c14e"
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 31.8,
    r: 3,
    fill: "#333a40"
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 31.8,
    r: 1.2,
    fill: "#9aa7b0"
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 31.8,
    r: 3,
    fill: "#333a40"
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 31.8,
    r: 1.2,
    fill: "#9aa7b0"
  }))), _view140 || (_view140 = /*#__PURE__*/React.createElement("view", {
    id: "soap",
    viewBox: "270 495 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 270,
    y: 495,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m21 19.7-2.2 1.8 3-1.5v-.2l-.1-.1c-.2-.2-.5-.2-.7 0z"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M28.4 37.5h6.9c1.9 0 3.4-1.5 3.4-3.4v-14c0-1.9-1.5-3.4-3.4-3.5h-.5v-2.3c-.1-.9-.8-1.6-1.7-1.6h-.3v-1.3h.3V7.5h-2.6v.7h-9.8v2.2h2v-.6h7.8v1.6h.4v1.3h-.4c-.9 0-1.6.7-1.6 1.6v2.3h-.5c-1.9.1-3.4 1.6-3.4 3.5v14c0 1.9 1.5 3.4 3.4 3.4zm4.1-29.3v2.6h-1.3V8.2h1.3zm-2 .9h-8.4v.7h-.7v-1h9.1v.3zm1 2.3h.7v1.3h-.7v-1.3zm-5.9 8.7c0-1.5 1.3-2.8 2.8-2.8h6.9c1.5 0 2.7 1.2 2.7 2.7v14.1c0 1.5-1.2 2.7-2.7 2.7h-6.9c-1.5 0-2.7-1.2-2.8-2.7v-14z"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M31.2 8.2h1.3v2.6h-1.3z"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.4 8.8v1h.7v-.7h8.4v-.3z"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M31.5 11.4h.7v1.3h-.7z"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M28.4 36.8h6.9c1.5 0 2.7-1.2 2.7-2.7V20c0-1.5-1.2-2.7-2.7-2.7h-6.9c-1.5 0-2.8 1.3-2.8 2.8v14c.1 1.5 1.3 2.7 2.8 2.7zm8.7-3.2c-.1 1.2-1.1 2.2-2.3 2.3h-2.3v-.7h2.3c.9 0 1.6-.7 1.6-1.6v-5.9h.7v5.9zm0-11.1h-.7v-2c0-.9-.7-1.6-1.6-1.6h-5.2v-.6h5.2c1.2 0 2.2 1 2.3 2.2v2z"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M21.5 10.9c-.8 0-2.4 4.1-2.4 5.1.3 1.4 1.6 2.2 2.9 2 1-.2 1.8-1 2-2 0-1-1.7-5.1-2.5-5.1z"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "m6.3 25.7.2.7c1.5-.5 3-.8 4.5-.8 1.1-.1 2.3.1 3.4.4.6.1 1.2.1 1.7-.2 2-.9 5.3-2.6 7.2-3.7 1.9-1.1 1.2-1.4.9-1.9-.4-.5-1.1-.8-1.7-.5l-.2-.3c-.2-.3-.6-.5-1-.5-.3 0-.5.1-.7.3L18.3 21c-.2-.3-.6-.4-.9-.4h-2.3c-.6 0-1.2-.2-1.8-.4-.7-.2-1.4-.4-2.1-.4-1 0-2 .3-2.8.8l-2.1.9.2.6c.8-.3 1.5-.6 2.2-.9.7-.5 1.6-.7 2.5-.7.6 0 1.3.1 1.9.3.6.2 1.3.4 2 .4h2.3c.3 0 .5.3.6.6-.1.4-.4.7-.8.7h-5.4v.7h5.4c.6 0 1.1-.4 1.3-.9l4.3-2c.3-.2.6-.1.8.2.2.4 0 .7-.6 1.1-2.3 1.3-4.7 2.5-7.1 3.6-.4.2-.9.3-1.4.1-1.2-.2-2.3-.3-3.5-.3-1.6 0-3.2.2-4.7.7zM21.8 20l-3 1.5 2.2-1.8c.2-.2.5-.2.7 0l.1.1v.2z"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M36.4 33.6c0 .9-.7 1.6-1.6 1.6h-2.3v.7h2.3c1.2-.1 2.2-1.1 2.3-2.3v-5.9h-.7v5.9zM34.8 18.3h-5.2v.6h5.2c.9 0 1.6.7 1.6 1.6v2h.7v-2c-.1-1.2-1.1-2.2-2.3-2.2z"
  }))), _view141 || (_view141 = /*#__PURE__*/React.createElement("view", {
    id: "spot_cooler",
    viewBox: "315 495 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 315,
    y: 495,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M39.5 40c.3 0 .5-.2.5-.5v-34c0-.3-.2-.5-.5-.5h-34c-.3 0-.5.2-.5.5v34c0 .3.2.5.5.5h34zm-.6-33.9v32.8H6.1V6.1h32.8z"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.1 38.9h32.8V6.1H6.1v32.8zM22.5 7.2c8.4 0 15.3 6.9 15.3 15.3s-6.9 15.3-15.3 15.3S7.2 30.9 7.2 22.5 14.1 7.2 22.5 7.2z"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M7.2 22.5c0 8.4 6.9 15.3 15.3 15.3s15.3-6.9 15.3-15.3S30.9 7.2 22.5 7.2 7.2 14.1 7.2 22.5zM22.5 8.3c7.8 0 14.2 6.4 14.2 14.2s-6.4 14.2-14.2 14.2S8.3 30.3 8.3 22.5 14.7 8.3 22.5 8.3z"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.3 22.5c0 7.8 6.4 14.2 14.2 14.2s14.2-6.4 14.2-14.2S30.3 8.3 22.5 8.3 8.3 14.7 8.3 22.5zM20.6 9.7c.5-.2 1.1-.3 1.6-.3h2.1l2.2.1c.5 0 1.1.1 1.6.3.2.1.3.3.4.5 0 .2 0 .4-.1.5-.1.3-.2.5-.4.7l-1.6 1.7c-.6.6-1.1 1.3-1.5 2.1-.3.6-.5 1.4-.3 2.1 1.3.6 2.3 1.6 2.9 2.9 1.5-.6 3-.9 4.6-1 1.2-.1 2.4.5 3.1 1.5.2.5.3 1 .3 1.5.1.7.1 1.4.1 2.1 0 .7 0 1.5-.1 2.2 0 .5-.1 1.1-.3 1.6-.1.2-.3.4-.5.4h-.5l-.7-.5-1.7-1.6c-.6-.6-1.3-1.1-2.1-1.5-.7-.3-1.5-.4-2.2-.3-.6 1.2-1.5 2.2-2.7 2.8.6 1.5 1 3 1 4.6.1 1.2-.4 2.4-1.4 3.1-.5.2-1 .3-1.5.3h-4.4c-.5 0-1.1-.1-1.6-.3l-.4-.5c0-.2 0-.4.1-.5.1-.3.3-.5.5-.7l1.5-1.7c.6-.6 1.1-1.3 1.5-2.1.4-.6.5-1.4.3-2.1-1.2-.6-2.2-1.5-2.8-2.7-1.5.6-3.1 1-4.7 1-1.2.1-2.4-.4-3.1-1.4-.2-.5-.3-1-.3-1.5-.1-.8-.1-1.6-.1-2.4 0-.7 0-1.4.1-2.1 0-.5.1-1.1.3-1.6h.2l.3-.3c.3-.1.7 0 .9.3l.6.5 1.6 1.5c1.2 1 2.6 1.8 4 1.5.5-1.3 1.5-2.4 2.8-3-.6-1.5-.9-3-1-4.6-.1-1.2.5-2.4 1.4-3.1z"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M20.2 17.4c-1.3.6-2.3 1.7-2.8 3-1.4.3-2.8-.5-4-1.5l-1.6-1.5-.6-.5c-.2-.3-.6-.4-.9-.3l-.3.3h-.2c-.2.5-.3 1.1-.3 1.6-.1.7-.1 1.4-.1 2.1 0 .8 0 1.6.1 2.4 0 .5.1 1 .3 1.5.7 1 1.9 1.5 3.1 1.4 1.6 0 3.2-.4 4.7-1 .6 1.2 1.6 2.1 2.8 2.7.2.7.1 1.5-.3 2.1-.4.8-.9 1.5-1.5 2.1l-1.5 1.7c-.2.2-.4.4-.5.7-.1.1-.1.3-.1.5l.4.5c.5.2 1.1.3 1.6.3h4.4c.5 0 1-.1 1.5-.3 1-.7 1.5-1.9 1.4-3.1 0-1.6-.4-3.1-1-4.6 1.2-.6 2.1-1.6 2.7-2.8.7-.1 1.5 0 2.2.3.8.4 1.5.9 2.1 1.5l1.7 1.6.7.5h.5c.2 0 .4-.2.5-.4.2-.5.3-1.1.3-1.6.1-.7.1-1.5.1-2.2 0-.7 0-1.4-.1-2.1 0-.5-.1-1-.3-1.5-.7-1-1.9-1.6-3.1-1.5-1.6.1-3.1.4-4.6 1-.6-1.3-1.6-2.3-2.9-2.9-.2-.7 0-1.5.3-2.1.4-.8.9-1.5 1.5-2.1l1.6-1.7c.2-.2.3-.4.4-.7.1-.1.1-.3.1-.5-.1-.2-.2-.4-.4-.5-.5-.2-1.1-.3-1.6-.3l-2.2-.1h-2.1c-.5 0-1.1.1-1.6.3-.9.7-1.5 1.9-1.4 3.1.1 1.6.4 3.1 1 4.6zm6.7 5.1c-.1 2.4-2 4.3-4.4 4.4-2.4 0-4.4-2-4.4-4.4s2-4.4 4.4-4.4c2.4.1 4.3 2 4.4 4.4z"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22.5 18.1c-2.4 0-4.4 2-4.4 4.4s2 4.4 4.4 4.4c2.4-.1 4.3-2 4.4-4.4-.1-2.4-2-4.3-4.4-4.4zm3.3 4.4c0 1.8-1.5 3.3-3.3 3.3-1.8 0-3.3-1.5-3.3-3.3s1.5-3.3 3.3-3.3c1.8 0 3.3 1.5 3.3 3.3z"
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    fill: "#28B557",
    cx: 22.5,
    cy: 22.5,
    r: 3.3
  }))), _view142 || (_view142 = /*#__PURE__*/React.createElement("view", {
    id: "spray_bottle",
    viewBox: "360 495 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 360,
    y: 495,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M16.3 12.2c0 .2.1.3.3.3 2 .1 3.6 1.6 4 3.5-3 5.6-8.6 13.8-6.9 19.8.2 1 1.1 1.6 2.1 1.6h13.5c1 0 1.9-.6 2.1-1.6 1.7-6.1-3.9-14.2-6.9-19.8 0-1 .3-1.9.9-2.7.4 1.1 1.1 2 2.1 2.5h.4c.3 0 .6-.2.8-.4.3-.4.2-1-.2-1.3-.6-.6-.8-1.4-.7-2.2.7-.2 1.5-.3 2.2-.3.4 0 .7-.3.7-.7V8.4c.1-.4-.2-.7-.6-.8h-9.2c-2.6 0-4.6 2.1-4.6 4.6zm14.3 23.4c-.1.7-.7 1.1-1.4 1.1H15.8c-.7 0-1.3-.4-1.4-1.1-1.6-5.7 3.9-13.7 6.8-19.2h2.7c2.9 5.4 8.4 13.5 6.7 19.2zM29.1 8.3h.8c.1 0 .1 0 .1.1v2.5c0 .1 0 .1-.1.1h-.8V8.3zm-8.2 0h7.6v2.8c-2.8.4-4.5 1.9-4.7 4.6h-2.6c-.4-2-2.1-3.6-4.2-3.8.1-2 1.8-3.6 3.9-3.6z"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M30.1 10.9V8.4c0-.1 0-.1-.1-.1h-.8V11h.8s.1 0 .1-.1z"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.9 11.9c2.1.2 3.8 1.8 4.2 3.8h2.6c.2-2.7 1.9-4.2 4.7-4.6V8.3h-7.6c-2 0-3.7 1.6-3.9 3.6zM21.1 16.4c-2.9 5.5-8.4 13.5-6.8 19.2.1.7.7 1.1 1.4 1.1h13.5c.7 0 1.3-.4 1.4-1.1 1.6-5.7-3.9-13.8-6.8-19.2h-2.7zm1.5 15.9c-2.3 0-4.2-1.9-4.2-4.2s1.9-4.2 4.2-4.2 4.2 1.9 4.2 4.2-1.9 4.2-4.2 4.2z"
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    fill: "#4AB8DC",
    cx: 22.6,
    cy: 28.1,
    r: 4.2
  }))), _view143 || (_view143 = /*#__PURE__*/React.createElement("view", {
    id: "standing_desk",
    viewBox: "405 495 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 405,
    y: 495,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    fill: "#505050"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6 24.4c0 1.5.7 2.9 2.1 2.9v8.2c0 .8.6 1.6 1.4 1.8 1.1.3 2.3-.3 2.6-1.4 0-.2.1-.3.1-.5l.1-15.9-2.3-.8v-.4l4.7 1.5h5.1c.2-.1.5-.2.6-.4 0 .2-.1.3-.1.5h2.8c0-.7-.6-1.3-1.3-1.3-.3 0-.7.1-.9.3.1-.2.1-.5.1-.7 0-.8-.6-1.4-1.4-1.4H20l-5.6-2.3c-.8-.2-1.7-.2-2.5.1-1.4.6-1.2 2-1.3 3.4v6.4zM33.7 18.6l1.4-5.8.8-3.5h-.8l-2.4 9.6.9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1 34.3v.5c.1 1 1 1.8 2 1.8.8 0 1.5-.6 1.7-1.3l.7-2.5v-5.1c-1.1-.1-2-1.1-2-2.2l-2.4 8.8zM15.4 13.3c1.4-.9 1.9-2.7 1.1-4.2-.9-1.4-2.7-1.9-4.2-1.1 0 0-.1 0-.1.1-1.4.9-1.8 2.7-1 4.1.8 1.4 2.7 1.9 4.2 1.1zM29.1 20.2H21c-.2 0-.4.3-.4.5s.2.4.4.4h3.5l-.2.6h-5.2c-.2 0-.4.2-.4.4s.2.5.4.5H25l.4-1.5h2.9v12.2c-1.9.1-3.5 1.7-3.4 3.7h7.6c.1-2-1.4-3.6-3.4-3.8V21h7.4c.2 0 .4-.2.4-.4s-.2-.4-.4-.4h-3.6v-.1c.7 0 1.3-.5 1.4-1.2l1.1-4.8h-.3L33.9 19c-.1.5-.6.9-1.1.9H29v.3z"
  })))), _view144 || (_view144 = /*#__PURE__*/React.createElement("view", {
    id: "suggestion_box",
    viewBox: "450 495 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 450,
    y: 495,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M10.2 37.5h24.7c.2 0 .4-.2.4-.4v-3c0-.2-.2-.4-.4-.4h-.5V18.3h.5c.2 0 .4-.2.4-.4v-3.1c0-.2-.2-.3-.4-.3h-4.1V7.9c0-.2-.1-.4-.3-.4h-16c-.2 0-.4.2-.4.4v6.6h-4c-.2 0-.4.1-.4.3v3.1c0 .2.2.4.4.4h.4v15.4h-.4c-.2 0-.4.2-.4.4v3c.1.2.2.4.5.4zM15 8.3h15v6.2H15V8.3zm-4.5 6.9h24v2.3h-24v-2.3zm.8 3.1h22.3v15.4H11.3V18.3zm-.8 16.1h24v2.3h-24v-2.3z"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M10.5 15.2h24v2.3h-24z"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M33.7 33.7V18.3H11.3v15.4h22.4zm-6.9-12c2.3 2.2 2.3 5.9.1 8.2h-.1c-.2.2-.1 0-.1.3s.4.5.6.6c.2.1.2.4.2.5 0 .1 0 .2-.2.3-.5.3-1 .4-1.5.4-.6 0-1.1-.2-1.6-.6-2.1.6-4.3.1-5.8-1.5-.3-.3-.6-.5-.8-.9-2-2.6-1.6-6.3.9-8.3 2.5-2 6.2-1.6 8.3 1z"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M10.5 34.4h24v2.3h-24z"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M30 14.5V8.3H15v6.2h15zm-12.8-1.9c0-.2.2-.4.4-.4h1.5c.2 0 .4.2.4.4s-.2.3-.4.3h-1.5c-.1 0-.4-.1-.4-.3zm4 0c0-.2.2-.4.4-.4h5.7c.2 0 .3.2.3.4s-.1.3-.3.3h-5.7c-.1 0-.4-.1-.4-.3zm.5-2.6h5.7c.2 0 .3.1.3.3 0 .2-.1.4-.3.4h-5.7c-.2 0-.4-.2-.4-.4-.1-.2.2-.3.4-.3zm-4 0h1.5c.2 0 .4.1.4.3 0 .2-.2.4-.4.4h-1.5c-.2 0-.4-.2-.4-.4-.1-.2.2-.3.4-.3z"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M19.2 12.9c.2 0 .4-.1.4-.3 0-.2-.2-.4-.4-.4h-1.5c-.2 0-.4.2-.4.4s.2.3.4.3h1.5zM27.3 12.9c.2 0 .3-.1.3-.3 0-.2-.1-.4-.3-.4h-5.7c-.2 0-.4.2-.4.4s.2.3.4.3h5.7zM17.2 10.3c0 .2.2.4.4.4h1.5c.2 0 .4-.2.4-.4s-.2-.3-.4-.3h-1.5c-.1 0-.4.1-.4.3zM21.2 10.3c0 .2.2.4.4.4h5.7c.2 0 .3-.2.3-.4s-.1-.3-.3-.3h-5.7c-.1 0-.4.1-.4.3z"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M18.5 20.8c-2.6 2-3 5.7-.9 8.3.2.3.5.6.8.9 1.5 1.6 3.7 2.1 5.8 1.5.5.4 1 .6 1.6.6.5 0 1-.1 1.5-.4.2-.1.2-.2.2-.3 0-.1 0-.4-.2-.5-.2-.1-.6-.3-.6-.6s-.1-.1.1-.3h.1c2.2-2.3 2.2-6-.1-8.2-2.1-2.7-5.8-3.1-8.3-1z"
  }))), _view145 || (_view145 = /*#__PURE__*/React.createElement("view", {
    id: "supplies",
    viewBox: "495 495 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 495,
    y: 495,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M9.4 7.5c-1-.1-1.8.6-1.9 1.6v22.5l2.5 5.5c.2.2.5.3.8.3.3 0 .7-.1.9-.3l2.4-5.5c.1-.1.1-.1.1-.2V9.1c-.1-1-1-1.7-2-1.6H9.4zm2.8.8c.7 0 1.2.4 1.2.8v3H8.3v-3c0-.4.5-.8 1.1-.8h2.8zm-3.9 4.6h2.2v18H8.3v-18zM12 34.5H9.7l-1.3-2.9h4.9L12 34.5zm1.4-3.6h-2.2v-18h2.2v18z"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m8.4 31.6 1.3 2.9H12l1.3-2.9z"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDEAF",
    d: "M11.2 12.9h2.2v18h-2.2zM8.3 12.9h2.2v18H8.3z"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    fill: "#FA908A",
    d: "M8.3 9.1v3h5.1v-3c0-.4-.5-.8-1.2-.8H9.4c-.6 0-1.1.4-1.1.8z"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M37.1 7.5H16.6c-.2 0-.4.2-.4.4v29.2c0 .2.2.4.4.4h20.5c.2 0 .4-.2.4-.4V7.9c0-.2-.2-.4-.4-.4zm-.4 29.2H16.9V8.3h19.8v28.4z"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.9 8.3v28.4h19.8V8.3H16.9zm3.9 22.4c0-.2.1-.4.3-.4h11.4c.2 0 .4.2.4.4s-.2.4-.4.4H21.1c-.2 0-.3-.2-.3-.4zm0-4.1c0-.2.1-.4.3-.4h11.4c.2 0 .4.2.4.4s-.2.4-.4.4H21.1c-.2 0-.3-.2-.3-.4zm0-4.1c0-.2.1-.4.3-.4h11.4c.2 0 .4.2.4.4s-.2.4-.4.4H21.1c-.2 0-.3-.2-.3-.4zm0-4.1c0-.2.1-.4.3-.4h11.4c.2 0 .4.2.4.4s-.2.4-.4.4H21.1c-.2 0-.3-.2-.3-.4zm0-4.1c0-.2.1-.4.3-.4h11.4c.2 0 .4.2.4.4s-.2.4-.4.4H21.1c-.2 0-.3-.2-.3-.4z"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32.5 31.1c.2 0 .4-.2.4-.4s-.2-.4-.4-.4H21.1c-.2 0-.3.2-.3.4s.1.4.3.4h11.4zM32.5 27c.2 0 .4-.2.4-.4s-.2-.4-.4-.4H21.1c-.2 0-.3.2-.3.4s.1.4.3.4h11.4zM32.5 22.9c.2 0 .4-.2.4-.4s-.2-.4-.4-.4H21.1c-.2 0-.3.2-.3.4s.1.4.3.4h11.4zM32.5 18.8c.2 0 .4-.2.4-.4s-.2-.4-.4-.4H21.1c-.2 0-.3.2-.3.4s.1.4.3.4h11.4zM32.5 14.7c.2 0 .4-.2.4-.4s-.2-.4-.4-.4H21.1c-.2 0-.3.2-.3.4s.1.4.3.4h11.4z"
  }))), _view146 || (_view146 = /*#__PURE__*/React.createElement("view", {
    id: "tech-support",
    viewBox: "540 0 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 540,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 15c0-11 30.2-11 30.2 0",
    fill: "none",
    stroke: "#333a45",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 5.4,
    y: 13.5,
    width: 4,
    height: 7,
    rx: 1.8,
    fill: "#333a45"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 6.2,
    y: 14.5,
    width: 2.4,
    height: 5,
    rx: 1.2,
    fill: "#4fb3c6"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 35.6,
    y: 13.5,
    width: 4,
    height: 7,
    rx: 1.8,
    fill: "#333a45"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 36.4,
    y: 14.5,
    width: 2.4,
    height: 5,
    rx: 1.2,
    fill: "#4fb3c6"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 20.5c0 3.5 3 5.5 6.5 5.5",
    fill: "none",
    stroke: "#333a45",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.2,
    cy: 26,
    r: 1.1,
    fill: "#4fb3c6"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12,
    width: 15,
    height: 10,
    rx: 3.2,
    fill: "#5a8fd8"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 21.3h5.2l-6.9 5z",
    fill: "#5a8fd8"
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 17,
    r: 1.1,
    fill: "#fff"
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 17,
    r: 1.1,
    fill: "#fff"
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 17,
    r: 1.1,
    fill: "#fff"
  }))), _view147 || (_view147 = /*#__PURE__*/React.createElement("view", {
    id: "telephony",
    viewBox: "540 45 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 540,
    y: 45,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M34.2 31.5h-.7c-.6.4-1 1.1-1 1.8.6 0 1.3-.2 1.7-.7.4-.3.3-.7 0-1.1z"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M20.4 19.1h13.3c1.5 0 2.8-1.3 2.8-2.8v-5.7c-.1-1.5-1.3-2.7-2.8-2.8h-9.4c-1.6 0-2.8 1.2-2.9 2.8v5l-1.7 1.7c-.4.3-.5.8-.3 1.2.2.4.6.6 1 .6zm0-1.1 2-2v-5.4c.1-1 .9-1.8 1.9-1.8h9.4c1 0 1.8.8 1.8 1.8v5.7c0 1-.8 1.8-1.8 1.8H20.3c0-.1 0-.1.1-.1z"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M35.5 16.3v-5.7c0-1-.8-1.8-1.8-1.8h-9.4c-1 0-1.8.8-1.9 1.8V16l-2 2c-.1 0-.1 0-.1.1h13.4c1 0 1.8-.8 1.8-1.8zm-9.7-1.7c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4 1.4.6 1.4 1.4-.6 1.4-1.4 1.4zm3.5 0c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4 1.4.6 1.4 1.4-.6 1.4-1.4 1.4zm2.1-1.4c0-.8.6-1.4 1.4-1.4s1.4.6 1.4 1.4-.6 1.4-1.4 1.4-1.4-.6-1.4-1.4z"
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 25.8,
    cy: 13.2,
    r: 1.4
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 29.3,
    cy: 13.2,
    r: 1.4
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 32.8,
    cy: 13.2,
    r: 1.4
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32.6 34.3c.9 0 1.8-.4 2.4-1 .6-.7.6-1.8-.1-2.5-.5-.5-1.3-.6-1.9-.2-.9.6-1.4 1.6-1.5 2.7-.8-.1-1.6-.5-2.2-1l-1.9-2 .5-.4.3-.3c.2.2.5.3.8.3.4 0 .7-.2 1-.4.6-.5.6-1.4 0-2l-5.8-5.7c-.2-.3-.6-.4-.9-.4-.4 0-.7.1-1 .4-.5.4-.5 1.2-.1 1.7-.4.4-1.1.5-1.6.2-1-.6-1.9-1.4-2.7-2.2-1-1-1.8-2.1-2.5-3.3-.3-.4-.2-1 .1-1.4.2.2.5.3.8.3.3 0 .7-.1.9-.4.3-.3.4-.6.4-1 0-.3-.1-.7-.4-.9L11.5 9c-.3-.3-.6-.4-1-.4s-.7.1-1 .4c-.5.5-.5 1.3-.1 1.8h-.1C8 12.2 7.5 14.2 8 16c1.2 3.6 3.2 6.8 5.9 9.5 2.4 2.5 5.4 4.4 8.7 5.6.5.2 1.1.3 1.7.3.8 0 1.5-.2 2.2-.5l2.2 2.1c.8.7 1.8 1.2 2.8 1.3.3 1.1 1.4 2.8 5.7 2.8v-1c-2.6.1-4.2-.5-4.6-1.8zM23 22.5h.5l5.8 5.7c.1.2.1.4 0 .6-.2.1-.3.1-.5 0l-3.9-3.9L23 23c-.1-.1-.1-.4 0-.5zM10.2 9.7h.6l5.7 5.8c.2.1.2.3 0 .5-.2.1-.3.1-.5 0l-5.8-5.8V10c-.1-.1 0-.2 0-.3zm12.7 20.4c-3.1-1.1-6-2.9-8.3-5.3-2.6-2.5-4.5-5.7-5.6-9.1-.5-1.4-.1-3 1-4.1h.1l4.6 4.5c-.6.7-.7 1.8-.2 2.6.7 1.3 1.6 2.5 2.7 3.5.9.9 1.8 1.7 2.9 2.3.3.3.8.4 1.2.4.6 0 1.2-.2 1.6-.6l2.3 2.3 2.3 2.3-.3.3c-1.1 1.1-2.8 1.5-4.3.9zm10.6 1.4h.7c.3.4.4.8 0 1.1-.4.5-1.1.7-1.7.7 0-.7.4-1.4 1-1.8z"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "m25.2 26.6-2.3-2.3c-.4.4-1 .6-1.6.6-.4 0-.9-.1-1.2-.4-1.1-.6-2-1.4-2.9-2.3-1.1-1-2-2.2-2.7-3.5-.5-.8-.4-1.9.2-2.6l-4.6-4.5H10c-1.1 1.1-1.5 2.7-1 4.1 1.1 3.4 3 6.6 5.6 9.1 2.3 2.4 5.2 4.2 8.3 5.3 1.5.6 3.2.2 4.3-.9l.3-.3-2.3-2.3z"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "m24.9 24.9 3.9 3.9c.2.1.3.1.5 0 .1-.2.1-.4 0-.6l-5.8-5.7H23c-.1.1-.1.4 0 .5l1.9 1.9zM10.2 10.2 16 16c.2.1.3.1.5 0 .2-.2.2-.4 0-.5l-5.7-5.8h-.6c0 .1-.1.2 0 .3v.2z"
  }))), _view148 || (_view148 = /*#__PURE__*/React.createElement("view", {
    id: "test-field",
    viewBox: "540 90 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 540,
    y: 90,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "sprout"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3f8f4f",
    d: "M-.45-3.6h.9V0h-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-3.2c-2.6-.3-4-2-4-4.4 2.6.3 4 2 4 4.4zM0-3.2c2.6-.3 4-2 4-4.4-2.6.3-4 2-4 4.4z",
    fill: "#57b368"
  })))), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 39.5c-.8 0-1.4-.8-1.2-1.6l5.1-17c.2-.5.6-.9 1.2-.9h15.6c.6 0 1 .4 1.2.9l5.1 17c.2.8-.4 1.6-1.2 1.6z",
    fill: "#a9713d"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 39.5 19.2 20M27.4 39.5 25.8 20",
    fill: "none",
    stroke: "#8a5a2e",
    strokeWidth: 1.1
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#sprout",
    transform: "matrix(1.1 0 0 1.1 13.6 36.8)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#sprout",
    transform: "matrix(1.1 0 0 1.1 22.5 36.8)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    href: "#sprout",
    transform: "matrix(1.1 0 0 1.1 31.4 36.8)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    href: "#sprout",
    transform: "matrix(.85 0 0 .85 15.2 31)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    href: "#sprout",
    transform: "matrix(.85 0 0 .85 22.5 31)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    href: "#sprout",
    transform: "matrix(.85 0 0 .85 29.8 31)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    href: "#sprout",
    transform: "matrix(.65 0 0 .65 16.6 25.6)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    href: "#sprout",
    transform: "matrix(.65 0 0 .65 22.5 25.6)"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    href: "#sprout",
    transform: "matrix(.65 0 0 .65 28.4 25.6)"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2,
    y: 11,
    width: 1.3,
    height: 13.5,
    rx: 0.65,
    fill: "#6b4a2b"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "m31.5 11 6.6 2.5-6.6 2.5z",
    fill: "#e8923a"
  }))), _view149 || (_view149 = /*#__PURE__*/React.createElement("view", {
    id: "thermal",
    viewBox: "540 135 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 540,
    y: 135,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24.2 11c0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3v13.4c0 .2-.1.5-.3.6-2.9 1.4-4.1 5-2.7 7.9s5 4.1 7.9 2.7c2.9-1.4 4.1-5 2.7-7.9-.6-1.2-1.5-2.1-2.7-2.7-.2-.1-.3-.4-.3-.6V11zm1.7 19.3c0 2.2-1.8 3.9-3.9 3.9s-3.9-1.8-3.9-3.9c0-1.9 1.4-3.5 3.3-3.8v-9.6c0-.3.3-.6.6-.6s.6.3.6.6v9.6c1.9.2 3.3 1.9 3.3 3.8z"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M25.4 11c0-1.9-1.5-3.4-3.4-3.4s-3.4 1.5-3.5 3.4v13.1c-3.4 1.9-4.6 6.3-2.7 9.7 1.9 3.4 6.3 4.6 9.7 2.7 2.2-1.3 3.6-3.6 3.6-6.2s-1.4-5-3.7-6.2V11zm-.9 14c2.9 1.4 4.1 5 2.7 7.9s-5 4.1-7.9 2.7c-2.9-1.4-4.1-5-2.7-7.9.6-1.2 1.5-2.1 2.7-2.7.2-.1.3-.4.3-.6V11c0-1.3 1-2.3 2.3-2.3 1.3 0 2.3 1 2.3 2.3v13.4c0 .2.1.5.3.6z"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M22.5 16.8c0-.3-.3-.6-.6-.6s-.6.3-.6.6v9.6c-2.1.3-3.6 2.3-3.3 4.5s2.3 3.6 4.5 3.3 3.6-2.3 3.3-4.5c-.3-1.7-1.6-3-3.3-3.3v-9.6z"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M29.5 9.7H27c-.3 0-.6.3-.6.6s.3.6.6.6h2.6c.3 0 .6-.3.6-.6s-.3-.6-.7-.6zM27 13.8h1.4c.3 0 .6-.3.6-.6s-.3-.6-.6-.6H27c-.3 0-.6.3-.6.6s.2.6.6.6zM27 16.6h2.6c.3 0 .6-.3.6-.6s-.3-.6-.6-.6H27c-.3 0-.6.3-.6.6s.2.6.6.6zM27 19.5h1.4c.3 0 .6-.3.6-.6s-.3-.6-.6-.6H27c-.3 0-.6.3-.6.6s.2.6.6.6zM29.5 21.1H27c-.3 0-.6.3-.6.6s.3.6.6.6h2.6c.3 0 .6-.3.6-.6-.1-.3-.3-.6-.7-.6z"
  }))), _view150 || (_view150 = /*#__PURE__*/React.createElement("view", {
    id: "tissues",
    viewBox: "540 180 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 540,
    y: 180,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M6.6 37.2h31.7c.2 0 .4-.2.4-.4v-8.3h-.1v-.2l-3.2-5.6c0-.1-.1-.2-.2-.2h-5.1c.9-2.9 2.2-6.3 3.1-8.4.3-.7.6-1.4.8-2.1 0-2.9-6.1-4.2-10.2-4.2-1.7 0-3.4.3-5 .8-1.4.5-2.2 1-2.2 1.9v1.8h-1.7c-1.3-.2-2.5-.2-3.8 0-.9.1-1.7.7-2 1.5-.1.9.2 1.7.8 2.3.5.6 1.4 3.3 2.3 6.4H9.1c-.2 0-.3.1-.3.2l-2.4 5.5c-.1.1-.1.1-.1.2v8.4c0 .2.1.4.3.4zM19.1 9.1c1.5-.5 3.1-.7 4.7-.7 4.5 0 9.5 1.5 9.5 3.6-.2.7-.4 1.3-.7 1.9-1.2 2.9-2.2 5.8-3.1 8.8h-.1c-.4 1.2-.5 2.5-.5 3.8l-6.3.2h-3.5c.4-5 .6-10 .4-15 0-.1-.1-.1-.1-.2-.1-.4-.5-.8-.9-1l-1-.5 1.6-.9zm-.9 1.8c.4.2.6.4.6.7.1.1.1.4 0 .5-.4.2-.9.3-1.4.2l-.2-1.8 1 .4zm-7.9 4.8c-.5-.5-.7-1.1-.6-1.8.3-.6.8-1 1.5-1.1 1.2-.2 2.5-.2 3.7 0H17c.6.1 1.3.1 1.9-.2.2 4.7.1 9.3-.4 14l-4.3-.4H14c-.3-.6-.5-1.3-.6-2-.2-.4-.3-.9-.5-1.4-.8-2.9-1.9-6.3-2.6-7.1zm-1 7.4h3.1l.3.9c-1.9.3-2.7.7-2.7 1.3 0 .6.5 1.1 3.9 1.6l4.7.4h4c6.2.1 10.7-.5 11.6-1.4.2-.1.3-.3.3-.5 0-.5-1-1-1.5-1.1-1-.4-2.1-.6-3.2-.6.1-.2.1-.5.2-.7h5l2.8 5H7.1l2.2-4.9zm-2.4 5.7H38v7.7H6.9v-7.7z"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M18.8 12.1c.1-.1.1-.4 0-.5 0-.3-.2-.5-.6-.7l-1-.4.2 1.8c.5.1 1 0 1.4-.2z"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19.4 11.5c0 .1.1.1.1.2.2 5 0 10-.4 15h3.5l6.3-.2c0-1.3.1-2.6.5-3.8h.1c.9-3 1.9-5.9 3.1-8.8.3-.6.5-1.2.7-1.9 0-2.1-5-3.6-9.5-3.6-1.6 0-3.2.2-4.7.7l-1.6.9 1 .5c.4.2.8.6.9 1z"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.9 22.8c.2.5.3 1 .5 1.4.1.7.3 1.4.6 2h.2l4.3.4c.5-4.7.6-9.3.4-14-.6.3-1.3.3-1.9.2h-2.1c-1.2-.2-2.5-.2-3.7 0-.7.1-1.2.5-1.5 1.1-.1.7.1 1.3.6 1.8.7.8 1.8 4.2 2.6 7.1z"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M37.8 28 35 23h-5c-.1.2-.1.5-.2.7 1.1 0 2.2.2 3.2.6.5.1 1.5.6 1.5 1.1 0 .2-.1.4-.3.5-.9.9-5.4 1.5-11.6 1.4h-4l-4.7-.4c-3.4-.5-3.9-1-3.9-1.6 0-.6.8-1 2.7-1.3l-.3-.9H9.3L7.1 28h30.7z"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.9 28.8H38v7.7H6.9z"
  }))), _view151 || (_view151 = /*#__PURE__*/React.createElement("view", {
    id: "too_cold",
    viewBox: "540 225 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 540,
    y: 225,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24.2 11c0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3v13.4c0 .2-.1.5-.3.6-2.9 1.4-4.1 5-2.7 7.9s5 4.1 7.9 2.7c2.9-1.4 4.1-5 2.7-7.9-.6-1.2-1.5-2.1-2.7-2.7-.2-.1-.3-.4-.3-.6V11zm1.7 19.3c0 2.2-1.8 3.9-3.9 3.9s-3.9-1.8-3.9-3.9c0-1.9 1.4-3.5 3.3-3.8v-3.6c0-.3.3-.6.6-.6s.6.3.6.6v3.6c1.9.2 3.3 1.9 3.3 3.8z"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M25.4 11c0-1.9-1.5-3.4-3.4-3.4s-3.4 1.5-3.5 3.4v13.1c-3.4 1.9-4.6 6.3-2.7 9.7 1.9 3.4 6.3 4.6 9.7 2.7 2.2-1.3 3.6-3.6 3.6-6.2s-1.4-5-3.7-6.2V11zm-.9 14c2.9 1.4 4.1 5 2.7 7.9s-5 4.1-7.9 2.7c-2.9-1.4-4.1-5-2.7-7.9.6-1.2 1.5-2.1 2.7-2.7.2-.1.3-.4.3-.6V11c0-1.3 1-2.3 2.3-2.3 1.3 0 2.3 1 2.3 2.3v13.4c0 .2.1.5.3.6z"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M22.5 22.8c0-.3-.3-.6-.6-.6s-.6.3-.6.6v3.6c-2.1.3-3.6 2.3-3.3 4.5s2.3 3.6 4.5 3.3 3.6-2.3 3.3-4.5c-.3-1.7-1.6-3-3.3-3.3v-3.6z"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M29.5 9.7H27c-.3 0-.6.3-.6.6s.3.6.6.6h2.6c.3 0 .6-.3.6-.6s-.3-.6-.7-.6zM28.4 12.6H27c-.3 0-.6.3-.6.6s.3.6.6.6h1.4c.3 0 .6-.3.6-.6s-.3-.6-.6-.6zM29.5 15.4H27c-.3 0-.6.3-.6.6s.3.6.6.6h2.6c.3 0 .6-.3.6-.6s-.3-.6-.7-.6c.1 0 .1 0 0 0zM27 19.5h1.4c.3 0 .6-.3.6-.6s-.3-.6-.6-.6H27c-.3 0-.6.3-.6.6s.2.6.6.6zM29.5 21.1H27c-.3 0-.6.3-.6.6s.3.6.6.6h2.6c.3 0 .6-.3.6-.6-.1-.3-.3-.6-.7-.6z"
  }))), _view152 || (_view152 = /*#__PURE__*/React.createElement("view", {
    id: "tools",
    viewBox: "540 270 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 540,
    y: 270,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M14.8 22.9c-.7.1-1.1.7-1.1 1.4v.7c-.6.3-1 .9-1 1.6v9.1c0 1 .8 1.8 1.8 1.8h3.1c1 0 1.8-.8 1.8-1.8v-9.1c0-.7-.4-1.3-1-1.6v-.7c0-.7-.5-1.2-1.1-1.4v-10l.9-.8c.2-.1.2-.3.2-.5l-1.1-3.7c0-.2-.3-.4-.5-.4h-1.5c-.3 0-.5.1-.5.4l-1.1 3.7c-.1.2 0 .4.2.5l.9.8v10zm.7 13.6v-8.3c0-.3.2-.5.5-.5s.5.2.5.5v8.3h-1zm3-9.9v9.1c0 .4-.4.8-.8.8h-.1v-8.3c-.1-.8-.7-1.4-1.5-1.4s-1.4.6-1.5 1.4v8.3c-.4.1-.7-.2-.8-.6V26.6c-.1-.4.2-.7.6-.8H17.7c.4 0 .8.4.8.8zm-1-2.3v.5h-2.7v-.5c0-.2.2-.4.4-.4H17c.3 0 .5.2.5.4zM15.7 8.5h.8l.9 3.1-.8.7c-.1 0-.1 0-.1.1h-.1v10.5h-.5V12.7c0-.1 0-.1-.1-.1h-.1l-.8-1 .8-3.1z"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M17 23.9h-1.9c-.2 0-.4.2-.4.4v.5h2.7v-.5c.1-.2-.1-.4-.4-.4z"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M16.5 28.2c0-.3-.2-.5-.5-.5s-.5.2-.5.5v8.3h1v-8.3z"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M14.5 25.8h-.2c-.4.1-.6.4-.6.8V35.9c.1.4.4.6.8.6v-8.3c.1-.8.7-1.4 1.5-1.4s1.4.6 1.5 1.4v8.3h.1c.4 0 .8-.4.8-.8v-9.1c0-.4-.4-.8-.8-.8h-3.1z"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M15.8 12.6c.1 0 .1 0 .1.1v10.2h.5V12.4h.1c0-.1 0-.1.1-.1l.8-.7-.9-3.1h-.8l-.8 3.1.9 1z"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M25 8c-1.6.8-2.6 2.3-2.7 4 0 1.9 1 3.6 2.7 4.4v12.2c-1.7.8-2.7 2.5-2.7 4.4 0 1.9 1 3.6 2.7 4.4h.6c.1 0 .1 0 .1-.1v-3c.1-.5.4-.8.9-.8H28c.5 0 .8.3.9.8V37c0 .1 0 .1.1.1 0 .1 0 .1.1.1h.4c1.7-.8 2.7-2.5 2.7-4.4 0-1.9-1-3.6-2.7-4.4v-12c1.7-.8 2.7-2.5 2.7-4.4 0-1.9-1-3.6-2.7-4.4h-.7v3.1c-.1.5-.4.8-.9.8h-1.3c-.5 0-.8-.3-.9-.8V8H25zm1.7 4.5H28c1 0 1.8-.8 1.9-1.8V8.9c.9.8 1.4 1.9 1.4 3.1 0 1.6-1 3-2.4 3.6h-.7c-.3 0-.5.2-.5.5s.2.5.5.5h.4v12.3h.3c1.4.6 2.4 2 2.4 3.6 0 1.2-.5 2.3-1.4 3.1v-1.3c-.1-1-.9-1.8-1.9-1.8h-1.3c-1 0-1.8.8-1.9 1.8v1.8a4.1 4.1 0 0 1-1.4-3.1c0-1.6.9-3 2.4-3.6h.8c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H26V16.1h-.3c-1.5-.6-2.4-2-2.4-3.6-.2-1.4.4-2.7 1.4-3.6v1.8c.1 1 .9 1.8 2 1.8z"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M24.8 10.7V8.9c-1 .9-1.6 2.2-1.4 3.6 0 1.6.9 3 2.4 3.6h.2v12.3h.5c.3 0 .5.2.5.5s-.2.5-.5.5h-.8c-1.5.6-2.4 2-2.4 3.6 0 1.2.5 2.3 1.4 3.1v-1.8c.1-1 .9-1.8 1.9-1.8H28c1 0 1.8.8 1.9 1.8v1.3c.9-.8 1.4-1.9 1.4-3.1 0-1.6-1-3-2.4-3.6h-.3V16.6h-.4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h.7c1.4-.6 2.4-2 2.4-3.6 0-1.2-.5-2.3-1.4-3.1v1.8c-.1 1-.9 1.8-1.9 1.8h-1.3c-1.1 0-1.9-.8-1.9-1.8z"
  }))), _view153 || (_view153 = /*#__PURE__*/React.createElement("view", {
    id: "tools_tech",
    viewBox: "540 315 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 540,
    y: 315,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M9 20.8c-.5-.4-1.1-.7-1.8-.6-.6 0-1.2.3-1.6.8-.4.5-.7 1.1-.6 1.8 0 .7.4 1.3.9 1.7.5.4 1.1.5 1.7.5.7 0 1.3-.3 1.7-.8.2-.3.4-.7.5-1.1h14.7l-5 4.1h-3.6c-.1-.5-.4-1-.8-1.3-.5-.4-1.1-.6-1.8-.6-.6.1-1.2.4-1.6.9-.4.5-.6 1.1-.6 1.7.1.7.4 1.3.9 1.7.5.4 1.1.6 1.8.6.6-.1 1.2-.4 1.6-.9.2-.3.4-.6.5-1h4l6.3-5.2h10.7l-11.3 9.3H22c-.1-.5-.4-1-.8-1.4-.5-.4-1.1-.6-1.7-.5-.7 0-1.3.3-1.7.8-.4.5-.6 1.2-.5 1.8 0 .6.3 1.2.8 1.6.1.1.1.1.2.1 1 .8 2.5.6 3.2-.4.3-.2.5-.6.5-1h4L38.7 23H40v-1h-4.4L24.3 11.7h-4c-.1-.4-.2-.7-.5-1-.4-.5-1-.8-1.6-.9-.7-.1-1.3.2-1.8.6-.5.4-.8 1-.8 1.6-.1.6.1 1.3.5 1.8.9 1 2.4 1.1 3.4.3.4-.3.7-.8.8-1.3h3.6L34 22H23.2l-5-5.2h-3.4c-.1-.4-.3-.7-.5-1-.9-1-2.4-1.1-3.4-.3-.5.4-.8 1-.9 1.7 0 .6.2 1.2.6 1.7.9 1 2.4 1.1 3.4.3.4-.3.7-.8.8-1.3h3l3.8 4.2H9.8c-.1-.6-.4-1-.8-1.3z"
  }))), _view154 || (_view154 = /*#__PURE__*/React.createElement("view", {
    id: "townhall-room-setup",
    viewBox: "540 360 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 540,
    y: 360,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 36,
    width: 39,
    height: 1.5,
    rx: 0.75,
    fill: "#c3ccd2"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "m5.5 18 8-1.4v3.9h-8z",
    fill: "#a9713d"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    fill: "#8a6238",
    d: "M6.2 20.5h6.6V36H6.2z"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16.9v-2.6",
    fill: "none",
    stroke: "#5c6870"
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 13.6,
    r: 1,
    fill: "#5c6870"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    fill: "#3c4652"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 27.6,
    width: 5,
    height: 1.8,
    rx: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.3,
    y: 20.5,
    width: 1.8,
    height: 7.6,
    rx: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9 29.4h1.2V36h-1.2zM21.4 29.4h1.2V36h-1.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 27.6,
    width: 5,
    height: 1.8,
    rx: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.3,
    y: 20.5,
    width: 1.8,
    height: 7.6,
    rx: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9 29.4h1.2V36h-1.2zM29.4 29.4h1.2V36h-1.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 27.6,
    width: 5,
    height: 1.8,
    rx: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 20.5,
    width: 1.8,
    height: 7.6,
    rx: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9 29.4h1.2V36h-1.2zM37.4 29.4h1.2V36h-1.2z"
  })))), _view155 || (_view155 = /*#__PURE__*/React.createElement("view", {
    id: "trashcan",
    viewBox: "540 405 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 540,
    y: 405,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M10 10.6c-.9 0-1.7.8-1.7 1.7v1.6c0 .9.8 1.7 1.7 1.7h.4l2.2 18.5c.2 1.8 1.7 3.3 3.6 3.3h12.5c1.9 0 3.5-1.4 3.7-3.3l2.2-18.5h.4c.9 0 1.7-.8 1.7-1.7v-1.6c0-.9-.8-1.7-1.7-1.7h-7.2l-1.3-2.7c0-.2-.2-.3-.4-.3h-7.2c-.2 0-.4.1-.5.3l-1.2 2.7H10zM31.5 34c-.1 1.5-1.3 2.6-2.8 2.5H16.2c-1.4 0-2.6-1.1-2.8-2.5l-2.1-18.4h22.4L31.5 34zM19.1 8.5h6.7l1 2.1h-8.6l.9-2.1zm15.9 3c.4 0 .8.4.8.8v1.6c0 .4-.4.8-.8.8H10c-.4 0-.8-.4-.8-.8v-1.6c0-.4.4-.8.8-.8h25z"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M25.8 8.5h-6.7l-.9 2.1h8.6z"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    d: "M10 11.5c-.4 0-.8.4-.8.8v1.6c0 .4.4.8.8.8h25c.4 0 .8-.4.8-.8v-1.6c0-.4-.4-.8-.8-.8H10z"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M11.3 15.6 13.4 34c.2 1.4 1.4 2.5 2.8 2.5h12.5c1.5.1 2.7-1 2.8-2.5l2.2-18.4H11.3zm5.9 18.3c-.2 0-.4-.3-.4-.5V18c0-.2.2-.5.4-.5.3 0 .5.2.5.5v15.4c0 .3-.2.5-.5.5zm5.3 0c-.3 0-.5-.2-.5-.5V18c0-.3.2-.5.5-.5.2 0 .4.3.4.5v15.4c0 .2-.2.5-.4.5zm5.3 0c-.3 0-.5-.2-.5-.5V18c0-.3.2-.5.5-.5.2 0 .4.3.4.5v15.4c0 .2-.2.5-.4.5z"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M17.7 18c0-.3-.2-.5-.5-.5-.2 0-.4.3-.4.5v15.4c0 .2.2.5.4.5.3 0 .5-.2.5-.5V18zM22.9 18c0-.2-.2-.5-.4-.5-.3 0-.5.2-.5.5v15.4c0 .3.2.5.5.5.2 0 .4-.3.4-.5V18zM28.2 18c0-.2-.2-.5-.4-.5-.3 0-.5.2-.5.5v15.4c0 .3.2.5.5.5.2 0 .4-.3.4-.5V18z"
  }))), _view156 || (_view156 = /*#__PURE__*/React.createElement("view", {
    id: "vendor-escort",
    viewBox: "540 450 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 540,
    y: 450,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5.2c-2.4 0-4.3 1.9-4.3 4.3s1.9 4.3 4.3 4.3 4.3-1.9 4.3-4.3-1.9-4.3-4.3-4.3zM14.5 15.5C11.5 15.5 9 18 9 21v2.5H4c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4h5v3.2h2V40c0 .8.7 1.5 1.5 1.5S14 40.8 14 40v-9.5h1V40c0 .8.7 1.5 1.5 1.5S18 40.8 18 40V21c0-3-2.5-5.5-5.5-5.5z",
    fill: "#505050"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 18.7,
    width: 3,
    height: 4.2,
    rx: 0.6,
    fill: "#fc0"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M32 9.2c-2.1 0-3.9 1.7-3.9 3.9S29.8 17 32 17s3.9-1.7 3.9-3.9-1.8-3.9-3.9-3.9z",
    fill: "#c9c9c9"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M32 6.8c-2.4 0-4.4 1.8-4.6 4.2h9.2c-.2-2.4-2.2-4.2-4.6-4.2z",
    fill: "#fc0"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 26.2,
    y: 10.6,
    width: 11.6,
    height: 1.7,
    rx: 0.85,
    fill: "#fc0"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M32 18c-2.8 0-5 2.2-5 5v7.5h1.9v9c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-8h.6v8c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-9H37V23c0-2.8-2.2-5-5-5z",
    fill: "#fc0"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    fill: "#c9c9c9",
    d: "M27 23.4h10v1.9H27z"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4 29.6v-1c0-1 .8-1.8 1.8-1.8s1.8.8 1.8 1.8v1h1.2c.6 0 1 .4 1 1v4.2c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1v-4.2c0-.6.4-1 1-1zm1.2 0h1.2v-1c0-.3-.3-.6-.6-.6s-.6.3-.6.6z",
    fill: "#505050"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 38.9,
    y: 31.4,
    width: 2.6,
    height: 1.6,
    rx: 0.4,
    fill: "#c9c9c9"
  }))), _view157 || (_view157 = /*#__PURE__*/React.createElement("view", {
    id: "video",
    viewBox: "540 495 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 540,
    y: 495,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M17 33.6h11.1V36H17z"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M38 33.6c1.1 0 1.9-.8 2-1.9v-22c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v22c.1 1.1.9 1.9 2 1.9h8.6V36h-3v1.3h19.2V36h-2.5v-2.4H38zm-31.7-2V9.7c0-.4.4-.7.7-.7h30.8c.4 0 .7.3.7.7v21.9c0 .4-.3.7-.7.7H7c-.3 0-.7-.3-.7-.7zM28 36H17v-2.4h11V36z"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M37.8 32.3c.4 0 .7-.3.7-.7V9.7c0-.4-.3-.7-.7-.7H7c-.3 0-.7.3-.7.7v21.9c0 .4.3.7.7.7h30.8zM12.3 13.9c0-.4.3-.7.7-.7h19c.4 0 .7.3.7.7v13.6c0 .4-.3.7-.7.7H13c-.4 0-.7-.3-.7-.7V13.9z"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M13 28.2h19c.4 0 .7-.3.7-.7V13.9c0-.4-.3-.7-.7-.7H13c-.4 0-.7.3-.7.7v13.6c0 .4.3.7.7.7zm.5-13.7h17.9v12.4H13.5V14.5z"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M31.5 26.9V14.5h-18v12.4h18zM19.8 16.7c0-.3.2-.5.4-.6h.8l5.2 4c.2.2.3.4.3.6 0 .2-.1.4-.3.5l-5.2 4h-.7c-.2-.1-.4-.3-.4-.5v-8z"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M20.3 25.2h.7l5.2-4c.2-.1.3-.3.3-.5s-.1-.4-.3-.6l-5.2-4h-.7c-.2.1-.4.3-.4.6v8c0 .2.1.4.4.5z"
  }))), _view158 || (_view158 = /*#__PURE__*/React.createElement("view", {
    id: "warehouse",
    viewBox: "0 540 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    y: 540,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M4.5 37.2h36.1c.3 0 .5-.3.5-.6v-2.8c0-.3-.2-.6-.5-.6h-1.5V11.7h1.5c.3 0 .5-.3.5-.6V8.3c0-.4-.2-.6-.5-.6H4.5c-.3 0-.5.2-.6.4V11c0 .3.3.6.6.6h1.4v21.6H4.5c-.3 0-.6.3-.6.6v2.8c0 .4.3.6.6.6zM5 10.5V8.8h35v1.6H5zm2.1 1.2H38v21.6h-3.8V20.5c0-.3-.3-.6-.6-.6H11.4c-.3 0-.5.3-.5.6v12.8H7.1V11.7zM29 29.3h2.5v3.9H29v-3.9zm3.6-.5c0-.3-.3-.5-.6-.5h-3.6c-.3 0-.5.2-.5.5v4.5h-1.6v-2.6c0-.3-.3-.6-.6-.6h-3.3V25c0-.3-.3-.5-.6-.5h-3.3v-2.2c0-.3-.2-.5-.5-.5h-4.2c-.3 0-.5.2-.5.5v10.9H12V21h21.1v12.2h-.5v-4.4zm-11.4-1h-2.7v-2.1h2.7v2.1zm-6.8-.8h3v2.8h-3V27zm3-1.1h-3V23h3v2.9zm-3 4.9h3v2.4h-3v-2.4zm4.1-2h2.7v4.4h-2.7v-4.4zm3.9 2.4h2.8v2.1h-2.8v-2.1zM5 34.3h35v1.8H5v-1.8z"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M33.1 21H12v12.2h1.3V22.3c0-.3.2-.5.5-.5H18c.3 0 .5.2.5.5v2.2h3.3c.3 0 .6.2.6.5v5h3.3c.3 0 .6.3.6.6v2.6h1.6v-4.5c0-.3.2-.5.5-.5H32c.3 0 .6.2.6.5v4.5h.5V21z"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M29 29.3h2.5v3.9H29zM22.4 31.2h2.8v2.1h-2.8zM18.5 25.7h2.7v2.1h-2.7zM18.5 28.8h2.7v4.4h-2.7zM14.4 27h3v2.8h-3zM14.4 30.8h3v2.4h-3zM14.4 23h3v2.9h-3z"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.1 33.2h3.8V20.5c0-.3.2-.6.5-.6h22.2c.3 0 .6.3.6.6v12.8H38V11.7H7.1v21.5zm23.7-15.9H14.2c-.3 0-.6-.3-.6-.6s.3-.5.6-.5h16.6c.4 0 .6.2.6.5 0 .4-.3.6-.6.6zm-16.6-3.5h16.6c.4 0 .6.2.6.5s-.3.6-.6.6H14.2c-.3 0-.6-.3-.6-.6 0-.2.3-.5.6-.5z"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M5 34.3h35v1.8H5zM40 10.5V8.8H5v1.7z"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M30.8 16.2H14.2c-.3 0-.6.2-.6.5s.3.6.6.6h16.6c.3 0 .6-.3.6-.6 0-.2-.2-.5-.6-.5zM14.2 15h16.6c.3 0 .6-.3.6-.6s-.2-.5-.6-.5H14.2c-.3 0-.6.2-.6.5s.3.6.6.6z"
  }))), _view159 || (_view159 = /*#__PURE__*/React.createElement("view", {
    id: "water",
    viewBox: "45 540 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 45,
    y: 540,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M17.1 16.7c-.4.1-.6.4-.6.8 0 .8.7 1.5 1.5 1.5.6 0 1.1.4 1.2 1-.8.1-1.4.6-1.7 1.4h-1c-.8.1-1.5.8-1.5 1.6v14.5h15V23c0-.8-.7-1.5-1.5-1.6h-1c-.3-.8-.9-1.3-1.7-1.4.1-.6.6-1 1.2-1 .8 0 1.5-.7 1.5-1.5 0-.4-.2-.7-.6-.9v-2.3c.4-.2.6-.6.6-1 0-.5-.2-.9-.6-1.1V9.9c.4-.2.6-.5.6-.9 0-.8-.7-1.5-1.5-1.5h-9c-.8 0-1.5.7-1.5 1.5 0 .4.2.7.6.9v2.3c-.4.2-.6.6-.6 1.1 0 .4.2.8.6 1v2.4zm0 20.2v-1.2h10.8v1.2H17.1zm0-10.3c0-.8.7-1.5 1.5-1.5h7.8c.8 0 1.5.7 1.5 1.5v8.5H17.1v-8.5zm12.3 10.3h-.9V26.6c0-1.2-.9-2.1-2.1-2.1h-7.8c-1.2 0-2.1.9-2.1 2.1v10.3h-.9V23c0-.5.4-.9.9-1h12c.5.1.9.5.9 1v13.9zm-2.5-15.5h-8.8c.3-.5.8-.9 1.4-.9h6c.6 0 1.1.4 1.4.9zm.1-3h-6v.6h4.7c-.2.3-.4.6-.5.9h-5.4c-.1-.3-.3-.6-.5-.9h1.1v-.6H18c-.5 0-.9-.4-.9-.9 0-.2.1-.3.3-.3h10.2c.2 0 .3.1.3.3 0 .5-.4.9-.9.9zm.3-1.8h-9.6v-2.1h9.6v2.1zM18 8.1h9c.5 0 .9.4.9.9 0 .2-.1.3-.3.3H17.4c-.2 0-.3-.1-.3-.3 0-.5.4-.9.9-.9zm-.5 4.6h6.8V12h-6.6V9.9h9.6V12h-2.4v.7h2.6c.2.1.4.3.4.6 0 .2-.2.4-.4.5h-10c-.2-.1-.4-.3-.4-.5 0-.3.2-.5.4-.6z"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.1 35.7h10.8v1.2H17.1z"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M17.1 35.1h10.8v-8.5c0-.8-.7-1.5-1.5-1.5h-7.8c-.8 0-1.5.7-1.5 1.5v8.5zm8.3-5.5c0 .5-.4.9-.9.9v1.2h-.6v-1.2c-.5-.1-.8-.4-.8-.9V28c0-.5.3-.8.8-.9h.6c.5 0 .9.4.9.9v1.6zm-4.9-2.5h.6c.5.1.8.4.8.9v1.6c0 .5-.3.8-.8.9v1.2h-.6v-1.2c-.5 0-.9-.4-.9-.9V28c0-.5.4-.9.9-.9zM19.5 20.5c-.6 0-1.1.4-1.4.9h8.8c-.3-.5-.8-.9-1.4-.9h-6z"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M29.4 23c0-.5-.4-.9-.9-1h-12c-.5.1-.9.5-.9 1v13.9h.9V26.6c0-1.2.9-2.1 2.1-2.1h7.8c1.2 0 2.1.9 2.1 2.1v10.3h.9V23zm-6.3.7H20.8v-1.2h3.5v1.2h-1.2z"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M17.4 9.3h10.2c.2 0 .3-.1.3-.3 0-.5-.4-.9-.9-.9h-9c-.5 0-.9.4-.9.9 0 .2.1.3.3.3zM17.7 14.5h9.6v2.1h-9.6zM17.5 13.8h10c.2-.1.4-.3.4-.5 0-.3-.2-.5-.4-.6h-2.6V12h2.4V9.9h-9.6V12h6.6v.7h-6.8c-.2.1-.4.3-.4.6 0 .2.2.4.4.5zM27.6 17.2H17.4c-.2 0-.3.1-.3.3 0 .5.4.9.9.9h2.4v.6h-1.1c.2.3.4.6.5.9h5.4c.1-.3.3-.6.5-.9H21v-.6h6c.5 0 .9-.4.9-.9 0-.2-.1-.3-.3-.3z"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M19.6 29.6c0 .5.4.9.9.9v1.2h.6v-1.2c.5-.1.8-.4.8-.9V28c0-.5-.3-.8-.8-.9h-.6c-.5 0-.9.4-.9.9v1.6zm1.7 0c0 .1-.1.3-.2.3h-.6c-.2 0-.3-.1-.3-.3v-.9h1.1v.9zm-.8-1.9h.6c.1 0 .2.2.2.3h-1.1c0-.2.1-.3.3-.3z"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M21.1 27.7h-.6c-.2 0-.3.1-.3.3h1.1c0-.1-.1-.3-.2-.3zM20.2 29.6c0 .2.1.3.3.3h.6c.1 0 .2-.2.2-.3v-.9h-1.1v.9z"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M24.5 27.1h-.6c-.5.1-.8.4-.8.9v1.6c0 .5.3.8.8.9v1.2h.6v-1.2c.5 0 .9-.4.9-.9V28c0-.5-.4-.9-.9-.9zm.3 2.5c0 .2-.1.3-.3.3h-.6c-.1 0-.2-.2-.2-.3v-.9h1.1v.9zm-.9-1.9h.6c.2 0 .3.1.3.3h-1.1c0-.1.1-.3.2-.3z"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M24.5 27.7h-.6c-.1 0-.2.2-.2.3h1.1c0-.2-.1-.3-.3-.3zM23.7 29.6c0 .1.1.3.2.3h.6c.2 0 .3-.1.3-.3v-.9h-1.1v.9z"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M20.8 22.5h1.1v1.2h-1.1z"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M23.1 22.5H21.9v1.2H23.1z"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M23.1 22.5h1.2v1.2h-1.2z"
  }))), _view160 || (_view160 = /*#__PURE__*/React.createElement("view", {
    id: "water_bottle",
    viewBox: "90 540 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 90,
    y: 540,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M18.2 37.3h8.6c1.3 0 2.3-1 2.3-2.3v-3.8c0-.7-.3-1.4-.9-1.9.6-.4.9-1 .9-1.7s-.3-1.3-.9-1.7c.6-.4.9-1 .9-1.7s-.3-1.3-.9-1.7c.6-.5.9-1.2.9-1.9v-4.4L25.2 11h.9V7.6h-7.2V11h.9l-3.9 5.2v4.4c0 .8.4 1.5 1 1.9-.6.3-1 1-1 1.7s.3 1.3.9 1.7c-.6.4-.9 1-.9 1.7s.4 1.4 1 1.7c-.6.4-1 1.1-1 1.9V35c0 1.3 1 2.3 2.3 2.3zm1.4-27V8.4h5.8v1.9h-5.8zm-3 10.3v-4.2l4.1-5.4h3.6l4.1 5.4v4.2c0 .9-.7 1.6-1.6 1.6h-8.6c-.9.1-1.6-.7-1.6-1.6zm0 3.7c0-.7.6-1.3 1.3-1.3h9.2c.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3h-9.2c-.7 0-1.3-.6-1.3-1.3zm0 3.3c0-.7.6-1.3 1.3-1.3h9.2c.7 0 1.3.6 1.3 1.3s-.6 1.3-1.3 1.3h-9.2c-.7 0-1.3-.5-1.3-1.3zm0 3.7c0-.8.6-1.5 1.4-1.6h9c.8.1 1.4.8 1.4 1.6v3.8c0 .9-.7 1.6-1.6 1.6h-8.6c-.9 0-1.6-.7-1.6-1.6v-3.8z"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M24.7 10.3h.7V8.4h-5.8v1.9h.8z"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.2 22.3h8.6c.9 0 1.6-.7 1.6-1.6v-4.2l-4.1-5.4h-3.6l-4.1 5.4v4.2c0 .8.7 1.6 1.6 1.6z"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M17.9 28.9h9.2c.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3h-9.2c-.7 0-1.3.6-1.3 1.3s.6 1.3 1.3 1.3zM17.9 25.6h9.2c.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3h-9.2c-.7 0-1.3.6-1.3 1.3 0 .7.6 1.3 1.3 1.3zM18.2 36.6h8.6c.9 0 1.6-.7 1.6-1.6v-3.8c0-.8-.6-1.5-1.4-1.6h-9c-.8.1-1.4.8-1.4 1.6V35c0 .9.7 1.6 1.6 1.6z"
  }))), _view161 || (_view161 = /*#__PURE__*/React.createElement("view", {
    id: "whiteboard",
    viewBox: "135 540 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 135,
    y: 540,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M33.1 28.1h-5l5 5zM11.9 33.1l4.9-5h-4.9z"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M34.1 27.9h3.1c.1-.1.1-.3.1-.4V8.1c0-.2 0-.3-.1-.4l-.4-.1h-29c-.2.2-.2.3-.2.5v19.5c0 .1 0 .3.1.4h3.1v8.2H8.1c-.2 0-.5.2-.5.4 0 .3.2.5.5.5h6.5c.3 0 .5-.2.5-.5 0-.2-.3-.4-.5-.4h-2.8v-2L18 28h8.8l6.2 6.2v2h-2.8c-.2 0-.5.2-.5.4 0 .3.2.5.5.5h6.5c.3 0 .5-.2.5-.5 0-.2-.3-.4-.5-.4H34v-8.3zm-22.2 5.2v-4.9h4.9l-4.9 4.9zm-3.3-6V8.6h27.7v18.6H8.6zm19.5 1H33V33l-4.9-4.9z"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.6 8.6h27.7v18.6H8.6z"
  }))), _view162 || (_view162 = /*#__PURE__*/React.createElement("view", {
    id: "wifi",
    viewBox: "180 540 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 180,
    y: 540,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    fill: "#505050"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7 16.7c.3.6.9 1.1 1.6 1 1 0 2-.3 2.7-1 7.8-7 19.7-6.8 27.3.5l.9.7c1.2.8 2.5.6 3.1-.2.6-.8.4-1.9-.6-2.9-4.7-4.7-11-7.3-17.5-7.3C16 7.6 10.1 9.9 5.5 14l-.5.7c-.6.5-.7 1.3-.3 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9 21.7c-.2-.5-.5-1-1-1.4-3.4-3-7.7-4.7-12.2-4.8-4.5.1-8.7 1.9-11.9 5.1-.5.4-.8.9-1 1.5 0 .1-.1.3-.1.4-.1.9.6 1.8 1.6 1.8.9 0 1.7-.3 2.3-.9l1.3-1.1c5-3.9 12.1-3.6 16.8.7.6.5 1.2 1 2 1.2.7.3 1.5.1 2-.5.4-.5.4-1.3.2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9 29c.2-.8-.2-1.7-.8-2.2C28.4 25 26 24 23.5 24c-2.7-.1-5.4.7-7.6 2.3l-1.1 1.2c-.5.8-.3 1.9.4 2.5.8.6 1.4.5 2.3-.2 3-2.7 7.6-2.7 10.6.1.2.2.5.4.8.4.9.2 1.8-.4 2-1.3zM22.9 37.5c.8 0 1.5-.3 2.1-.8.5-.6.9-1.4.9-2.2v-.1c0-1.7-1.3-3-3-3s-3.1 1.4-3.1 3.1v.1c0 1.6 1.4 2.9 3.1 2.9z"
  })))), _view163 || (_view163 = /*#__PURE__*/React.createElement("view", {
    id: "window",
    viewBox: "225 540 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 225,
    y: 540,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M9.6 37.4h25.8c.2 0 .4-.2.4-.4V8c0-.2-.2-.4-.4-.4H9.6c-.2 0-.4.2-.4.4v29c0 .2.2.4.4.4zm2.5-27.3h10.1v12H12.1v-12zm20.8 11.4v.6H22.8v-12h10.1v11.4zM22.8 25v-2.1h10.1V35H22.8V25zm-.6-2.1v12H12.1v-12h10.1z"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.1 22.9h10.1v12H12.1zM12.1 22.1h10.1v-12H12.1v12zm3-2.7 2.1-2.2h.5c.2.2.2.4 0 .5l-2.1 2.2h-.5c-.2-.2-.2-.4 0-.5zm-.8-2.9 2.2-2.2c.2-.1.3-.1.5 0 .1.2.1.4 0 .6l-2.2 2.2h-.2l-.3-.1c-.1-.2-.1-.3 0-.5zm5.6-1.4c.1.1.1.4 0 .5L18.4 17h-.5c-.1-.2-.1-.3 0-.5l1.5-1.4c.1-.2.3-.2.5 0zm-.8-2.9s.1.1 0 0c.2.2.1.4 0 .5l-1.4 1.5h-.2l-.3-.1c-.1-.1-.1-.4 0-.5l1.4-1.4c.2-.2.4-.2.5 0zM32.9 34.9v-12H22.8V35h10.1zM28 29.4c.1-.1.2-.1.2-.1.2.1.3.3.3.5L26.3 32c0 .1-.1.1-.2.1h-.3c-.1-.2-.1-.3 0-.5l2.2-2.2zm.7-.7 1.4-1.4c.2-.2.3-.1.5 0s.2.3 0 .5l-1.4 1.4h-.5c-.1-.1-.1-.4 0-.5zm-.9-1.5-2.2 2.1h-.5c-.1-.1-.1-.4 0-.5l2.2-2.1c.1-.2.3-.2.5 0 .1.1.1.4 0 .5zm.2-1.3 1.4-1.4c.1-.1.4-.1.5 0l.1.1c.1.1.1.3-.1.4l-1.4 1.5H28c-.2-.2-.2-.5 0-.6zM22.8 10.1v12h10.1v-12z"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M14.6 17.1h.2l2.2-2.2c.1-.2.1-.4 0-.6-.2-.1-.3-.1-.5 0l-2.2 2.2c-.1.2-.1.3 0 .5l.3.1zM18.6 12.2l-1.4 1.4c-.1.1-.1.4 0 .5l.3.1h.2l1.4-1.5c.1-.1.2-.3.1-.4l-.1-.1c-.1-.2-.3-.2-.5 0zM15.6 19.9l2.1-2.2c.2-.1.2-.3 0-.5h-.5l-2.1 2.2c-.2.1-.2.3 0 .5h.5zM17.9 17h.5l1.5-1.4c.1-.1.1-.4 0-.5-.2-.2-.4-.2-.5 0l-1.5 1.4c-.1.2-.1.3 0 .5zM27.8 26.7c-.2-.2-.4-.2-.5 0l-2.2 2.1c-.1.1-.1.4 0 .5h.5l2.2-2.1c.1-.1.1-.4 0-.5zM28 26.5h.5l1.4-1.5c.1-.1.2-.3.1-.4l-.1-.1c-.1-.1-.4-.1-.5 0L28 25.9c-.2.1-.2.4 0 .6zM25.8 32.1h.3c.1 0 .2 0 .2-.1l2.2-2.2c.1-.2-.1-.4-.3-.5H28v.1l-2.2 2.2c-.1.2-.1.3 0 .5zM30.6 27.8c.2-.2.2-.4 0-.5-.2-.1-.3-.2-.5 0l-1.4 1.4c-.1.1-.1.4 0 .5h.5l1.4-1.4z"
  }))), _view164 || (_view164 = /*#__PURE__*/React.createElement("view", {
    id: "window-shades",
    viewBox: "270 540 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: 45,
    height: 45,
    x: 270,
    y: 540,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 38.5,
    width: 39,
    height: 1.5,
    rx: 0.75,
    fill: "#c3ccd2"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 4,
    width: 23,
    height: 34.5,
    rx: 1.2,
    fill: "#7a6a55"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    fill: "#cfe6f2",
    d: "M12.6 5.6h19.8V37H12.6z"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    fill: "#9fc4d8",
    d: "M14.5 31.5h4V37h-4zM20 29.5h4.5V37H20zM26 32.5h4V37h-4z"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    fill: "#7a6a55",
    d: "M12.6 5.6h19.8v1.6H12.6z"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8ddc8",
    d: "M12.6 7.8h19.8v1.5H12.6zM12.6 10h19.8v1.5H12.6zM12.6 12.2h19.8v1.5H12.6zM12.6 14.4h19.8v1.5H12.6zM12.6 16.6h19.8v1.5H12.6zM12.6 18.8h19.8v1.5H12.6zM12.6 21h19.8v1.5H12.6zM12.6 23.2h19.8v1.5H12.6z"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9c9a8",
    d: "M12.6 25.4h19.8v1.8H12.6z"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 27.2v2.6",
    fill: "none",
    stroke: "#7a6a55",
    strokeWidth: 0.8
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.4,
    r: 0.7,
    fill: "#7a6a55"
  }))), _view165 || (_view165 = /*#__PURE__*/React.createElement("view", {
    id: "workstation_equip",
    viewBox: "315 540 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 315,
    y: 540,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M30.7 15.2s-.1 0-.1.1c0-.1 0-.1.1-.1zM30.4 15.4h-.1.1zM30.9 15s0-.1 0 0zM30 15.5s-.1 0 0 0c-.1 0 0 0 0 0zM31.1 14.7s0 .1-.1.1l.1-.1zM31.3 13.7v.3-.3zM31 13.1c0 .1.1.1.1.2 0-.1 0-.2-.1-.2zM31.2 14.4c0 .1 0 .1-.1.1.1 0 .1-.1.1-.1zM31.3 14.1v.2-.2zM30.7 12.7c.1.1.2.2.2.3 0-.1-.1-.2-.2-.3zM31.2 13.4c0 .1 0 .1.1.2-.1-.1-.1-.1-.1-.2z"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M16.4 22.1c.3.3.8.5 1.2.5h3.8c.9 0 1.7-.8 1.7-1.7.1-.9-.7-1.7-1.6-1.8h-3.1l-4.5-4.2c-1.2-.7-2.7-.2-3.4 1-.2.4-.3.8-.3 1.2v8.3c0 1.3 1.1 2.4 2.4 2.5h6.6v7.9c0 .9.8 1.7 1.7 1.7.9 0 1.7-.8 1.7-1.7v-9.6c0-.9-.8-1.7-1.7-1.7H15v-3.6l1.4 1.2z"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M17.7 29.7H9.9c-.6 0-1.1-.5-1.1-1.1V15.4c0-.2-.2-.4-.4-.4-.3 0-.5.1-.5.4v13.2c0 1.1.9 2 2 2h2.8v3.8l-2 1.4c-.2.1-.3.3-.2.5v.1c.2.2.4.3.7.2l1.9-1.4 2 1.4c.3.1.5 0 .7-.2.1-.2.1-.4-.1-.6h-.1l-2-1.4v-3.8h3.9c.2 0 .4-.3.4-.5.1-.2 0-.4-.2-.4zM12.4 13.5c1.7 0 3-1.3 3-3s-1.3-3-3-3c-1.6.1-2.9 1.4-3 3 .1 1.6 1.4 2.9 3 3zM36.7 21.1H24c-.3 0-.4.2-.4.5v2.2c0 .2.2.4.4.4h9.7v10.2h-5.2c-.3 0-.5.2-.5.5V37c0 .3.2.5.5.5h8.2c.3 0 .4-.2.4-.5V21.6c-.1-.3-.1-.5-.4-.5zm-.5 15.5h-7.3v-1.3h5.3c.3 0 .5-.2.5-.5V24.2h1.5v12.4zm0-13.3H24.4V22h11.8v1.3z"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M24.5 23.3h11.7V22H24.5zM34.7 34.8c0 .3-.2.5-.5.5h-5.3v1.3h7.3V24.2h-1.5v10.6z"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "m26 18.5 1.2.5c.5.2 1-.1 1.2-.5l.8-2.1c.7.1 1.3 0 1.9-.4v3.7h-.6c-.2 0-.4.3-.4.5s.2.4.4.4h2.2c.2 0 .5-.2.5-.4 0-.3-.2-.5-.5-.5H32v-4.8c.5-1.1.1-2.5-1-3.1l1-2.1V9c-.1-.3-.2-.5-.5-.6l-1.1-.5c-.5-.2-1 0-1.3.5l-3.6 8.8c-.3.5 0 1.1.5 1.3zm5.3-4.5c0 .1 0 .1 0 0v.4s0 .1-.1.1c0 0 0 .1-.1.1 0 0 0 .1-.1.1 0 .1-.1.1-.1.2h-.1l-.2.2s-.1 0-.1.1c-.1 0-.1.1-.2.1h-.1c-.1 0-.2 0-.2.1h-.5l1.2-2.8c.1.1.2.2.2.3 0 0 0 .1.1.1 0 .1.1.1.1.2v.1c0 .1 0 .1.1.2v.1c.1.2.1.3.1.4zM30 8.8l1 .5-3.6 8.8-1.2-.5L30 8.8z"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M31.2 13.4v-.1c0-.1-.1-.1-.1-.2 0 0 0-.1-.1-.1-.1-.1-.1-.2-.2-.3l-1.2 2.8h.5c.1 0 .2 0 .2-.1h.1c.1 0 .1-.1.2-.1 0 0 .1 0 .1-.1l.2-.2.1-.1s.1-.1.1-.2c0 0 0-.1.1-.1 0 0 0-.1.1-.1 0 0 0-.1.1-.1V13.6c-.2-.1-.2-.1-.2-.2z"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "m31 9.3-1-.5-3.8 8.8 1.3.5z"
  }))), _view166 || (_view166 = /*#__PURE__*/React.createElement("view", {
    id: "wrench",
    viewBox: "360 540 45 45"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 360,
    y: 540,
    width: 45,
    height: 45,
    xmlSpace: "preserve",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "m12.3 17.6-4.1-4.2c-.1 0-.2-.1-.3 0l-.2.2c-.6 2.8.4 5.7 2.7 7.5 1.3 1.1 3 1.7 4.7 1.7 1 0 2-.2 2.9-.6l14.4 14.4c1.3 1 3.2.7 4.2-.6.8-1.1.8-2.5 0-3.6L22.2 18c.3-.8.5-1.6.5-2.4.2-2.2-.6-4.4-2.2-5.9-1.8-1.8-4.4-2.6-6.9-2-.1 0-.2.1-.2.2-.1.1 0 .2 0 .3l4.2 4.1c.3.4.3.9 0 1.3l-4 4c-.4.3-.9.3-1.3 0zm23.9 15.2c.8 1 .8 2.4 0 3.4-1 .9-2.4.9-3.4 0L18.6 21.9l1.3-.8c.8-.7 1.5-1.5 2-2.5l14.3 14.2zM14.1 18l3.9-3.9c.6-.6.6-1.6 0-2.2l-3.6-3.7c2.1-.2 4.2.5 5.7 2 1.4 1.4 2.1 3.3 2 5.3s-1.1 3.8-2.6 5.1c-2.6 2-6.1 2-8.7 0-1.9-1.5-2.9-3.8-2.6-6.2l3.7 3.6c.6.6 1.6.6 2.2 0z"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M8.2 14.4c-.3 2.4.7 4.7 2.6 6.2 2.6 2 6.1 2 8.7 0 1.5-1.3 2.5-3.1 2.6-5.1s-.6-3.9-2-5.3c-1.5-1.5-3.6-2.2-5.7-2l3.6 3.7c.6.6.6 1.6 0 2.2L14.1 18c-.6.6-1.6.6-2.2 0l-3.7-3.6zM19.9 21.1l-1.3.8 14.2 14.3c1 .9 2.4.9 3.4 0 .8-1 .8-2.4 0-3.4L21.9 18.6c-.5 1-1.2 1.8-2 2.5zm12.3 11.1c.5-.5 1.2-.5 1.7 0l1.4 1.3c.4.5.4 1.2 0 1.7-.2.2-.5.3-.8.3s-.6-.1-.9-.3l-1.4-1.4c-.4-.5-.4-1.1 0-1.6zm-8.8-10.8 8.2 8.2c.3.3.4.7.4 1.1s-.1.7-.4 1-.6.4-1 .4-.7-.1-1-.4l-8.3-8.2c-.2-.3-.4-.7-.4-1.1s.2-.7.4-1c.3-.3.7-.4 1.1-.4s.7.1 1 .4z"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "m32.2 33.8 1.4 1.4c.3.2.6.3.9.3.3 0 .6-.1.8-.3.4-.5.4-1.2 0-1.7l-1.4-1.3c-.5-.5-1.2-.5-1.7 0-.4.5-.4 1.1 0 1.6zM20.9 22.4c0 .4.2.8.4 1.1l8.3 8.2c.3.3.6.4 1 .4s.7-.1 1-.4c.3-.3.4-.6.4-1s-.1-.8-.4-1.1l-8.2-8.2c-.3-.3-.6-.4-1-.4s-.8.1-1.1.4c-.2.3-.4.6-.4 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.50a4da070ddf49fcec3c3dd0df55cfa9.svg";
export { ForwardRef as ReactComponent };